(function() {
  'use strict';

  angular
    .module('storeLocator', [ 'ngSanitize','ngAria', 'restangular', 'ui.router', 'ui.bootstrap',
    'underscore.string', 'ngRetina', 'cloudinary', 'angulartics', 'angulartics.google.analytics', 'angulartics.facebook.pixel', 'mgcrea.ngStrap', 'smoothScroll', 'ngAnimate', 'mj.scrollingTabs', 'ui.date']).config(function ($analyticsProvider) {
    $analyticsProvider.firstPageview(true); /* Records pages that don't use $state or $route */
    $analyticsProvider.withAutoBase(false);  /* Records full path */
        });
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('visionworksResults', visionworksResults);

  function visionworksResults () {
    return {
      templateUrl: 'app/custom/clients/visionworks/directives/visionworksResults.directive.html',
      restrict: 'E',
      scope: {},
      controller: visionworksResultsController,
      controllerAs: 'visionworksResultsCtrl',
      bindToController: {
        locatorStates: '=',
        mapObj: '='
      }
    };

    function visionworksResultsController(storeLocatorDictionary, customFieldFactory, FORCE_GEOLOCATION ) {
        var $ctrl = this;
        var val = 0;
        var search = $ctrl.locatorStates.current.name;
        
        $ctrl.showMessage = true;

        $ctrl.GetMessage = function()
        {
            var message = '';
            if(FORCE_GEOLOCATION && !$ctrl.locatorStates.locations.length) {
              message = "Search For a Location in Your Area";
            }
            else if ($ctrl.locatorStates.selectedFilters.length > 0)
            {
                if ($ctrl.locatorStates.locations.length > 0)
                {
                    message = storeLocatorDictionary.messages.resultsWithFilters;
                }
                else {
                    message = storeLocatorDictionary.messages.noResultsWithFilters;
                }
                message = message.replace('{filters}', $ctrl.locatorStates.selectedFilters.replace(',', ', '));
            }
            else {
                if ($ctrl.locatorStates.locations.length > 0) {
                    message = storeLocatorDictionary.messages.results;
                }
                else {
                    message = storeLocatorDictionary.messages.noResults;
                }
            }

            $ctrl.locatorStates.current.name == undefined ? message = message.replace('{location}', $ctrl.locatorStates.current) : message = message.replace('{location}', $ctrl.locatorStates.current.name)

            $ctrl.showMessage = message !== '';
            return message;
        }

        // Hide/show sort radio buttons and resize `results-list` where needed
        $ctrl.resultsHaveAppts = function() { 
          // Create an array of locations that have appointments
          var appointments = $ctrl.locatorStates.locations.filter(function(l) { 
            return l.nextAppt;
          })

          var hasResults = appointments.length > 0; 

          // Reset height of `results-li` to accomodate the height of the filter/advanced search features at different screen widths
          var width = window.screen.width; 
          var maxHeight = 0;

          if (hasResults) {
            var pickerCarousel = document.getElementById('picker') && document.getElementById('picker').style.display == 'block';
            var pickerCalendar = document.getElementById('calendar-picker') && document.getElementById('calendar-picker').style.display == 'flex';

            if (width >= 768 && width < 865) {
              if (pickerCarousel) {
                maxHeight = 59;
              } else if (pickerCalendar) {
                maxHeight = 0;
              } else {
                maxHeight = 230;
              }
            } else if (width >= 865 && width < 1106) {
              if (pickerCarousel) {
                maxHeight = 98;
              } else if (pickerCalendar) {
                maxHeight = 19;
              } else {
                maxHeight = 269;
              }
            } else if (width >= 1106 && width < 1117) {
              if (pickerCarousel) {
                maxHeight = 141;
              } else if (pickerCalendar) {
                maxHeight = 61;
              } else {
                maxHeight = 312;
              }
            } else {
              if (pickerCarousel) {
                maxHeight = 159;
              } else if (pickerCalendar) {
                maxHeight = 79;
              } else {
                maxHeight = 330;
              }
            }
          } else {
            if (width >= 768 && width < 865) { 
              maxHeight = 309;
            } else if(width >= 865 && width < 1106) {
              maxHeight = 328;
            } else if(width >= 1106 && width < 1117) {
              maxHeight = 371;
            } else {
              maxHeight = 388;
            }
          }

          // Check to see if a new search has been made
          checkIfSearchHasChanged();

          document.getElementsByClassName('results-list')[0].setAttribute('style', 'max-height: ' + maxHeight + 'px !important;');

          return hasResults;
        }

        // Sort the results list by the soonest appointment, by day/time
        $ctrl.sortByNextAppt = function() {
          //Swap the active radio button
          document.getElementById('customRadioInline2').checked = true;
          document.getElementById('customRadioInline1').checked = false;

          var locsToSort = [];
          var locsToAddToEnd = [];

          // If the advanced search (filter by day) functionality is in use, create an array of locations to sort that only includes those with appointments on the selected day
          if($ctrl.locatorStates.selectedDate) {
            $ctrl.locatorStates.locations.forEach(function(l) {
              if(l.appointments) {
                l.appointments.forEach(function(x) {
                  if(x.date == $ctrl.locatorStates.selectedDate) {
                    l.selectedDateNextTime = x.time[0];
                    locsToSort.push(l);
                  }
                })
              }
            })
            
            // Also create an array of the locations that don't have appoitments on the selected day
            locsToAddToEnd = $ctrl.locatorStates.locations.filter(function(loc) {
              return !locsToSort.includes(loc);
            })
          } else {
            // If all of the results are being sorted (none filtered out), create an array of all locations that have appointments
            locsToSort = $ctrl.locatorStates.locations.filter(function(loc) {
              return loc.nextAppt;
            })
            
            // Also create an array of locations that don't have appointments to add to end of results
            locsToAddToEnd = $ctrl.locatorStates.locations.filter(function(loc) {
              return !loc.nextAppt;
            })
          }

          // Function used to sort by time
          function compareTime(a, b) {
            var comparison = 0;
            // If the results are already filtered by a date, we'll compare the soonest appointment time on the selected date, otherwise we'll compare the soonest appointment time overall
            var ax = $ctrl.locatorStates.selectedDate ? a.selectedDateNextTime : a.nextAppt.time;
            var bx = $ctrl.locatorStates.selectedDate ? b.selectedDateNextTime : b.nextAppt.time;
         
            if (ax > bx) { comparison = 1; } 
            else if (ax < bx) { comparison = -1; }
            return comparison;
          }

          // Function used to sort by date - since using the advanced search will filter to a single date, the results will not need to be sorted by date when filters are in use
          function compareDate(a, b) {
            var comparison = 0;
            if (a.nextAppt.date > b.nextAppt.date) { comparison = 1; } 
            else if (a.nextAppt.date < b.nextAppt.date) { comparison = -1; }
            return comparison;
          }
          
          // First, sort the results by the location with an appointment at the earliest time, regardless of the date of that appointment (to ensure that the times are in order)
          var sortedByTime = locsToSort.sort(compareTime);
          // Then sort by date - the resulting array will have the results sorted by each location's soonest available appointment
          var sortedByDate = sortedByTime.sort(compareDate);
          // Then add the remaining locations to the end of the list
          var byAppt = sortedByDate.concat(locsToAddToEnd);
          
          // Set the sorted list as the locations array within locatorStates
          $ctrl.locatorStates.locations = byAppt;
        }

        // Sort the results by the closest location to the search lat/lng
        $ctrl.sortByDistance = function() {
          //Swap active radio buttonn
          document.getElementById('customRadioInline2').checked = false; 
          document.getElementById('customRadioInline1').checked = true;

          // Function used to compare distance between locations
          function compareDistance(a,b) {
            var comparison = 0;
            if (a.distance > b.distance) { comparison = 1; } 
            else if (a.distance < b.distance) { comparison = -1; }
            return comparison;
          }

          var byDistance = $ctrl.locatorStates.locations.sort(compareDistance);
          // Set the sorted list as the locations array within locatorStates
          $ctrl.locatorStates.locations = byDistance;
        }

        // Determines whether any of the locations in the results have advanced search availability turned on (so clients can roll out the feature separately from the appoitment information)
        // Note: If any of the locations have advanced search availability turned on, all locations will behave as if they have it turned on, even if the custom field is set to false
        $ctrl.anyLocationsHaveAdvancedSearchActive = function() {
          var advancedSearchAvail = $ctrl.locatorStates.locations.filter(function(l) {
            return customFieldFactory.getValueByName(l.entire_location.custom_fields,'advanced_search_available') == "TRUE";
          })
          return advancedSearchAvail.length > 0; 
        }

        // Show/hide the advanced search
        $ctrl.showHideAdvancedSearch = function() {
          var picker = document.getElementById('picker');
          var calendar = document.getElementById('calendar-picker');
          var pickerInactive = picker.style.display == 'none';
          var calendarInactive = calendar.style.display == 'none';
          var icons = document.getElementById('icons');

          // Show/hide advanced features
          if(pickerInactive && calendarInactive) {
            picker.style.display = 'block';
          } else if(!pickerInactive || !calendarInactive || (search != $ctrl.locatorStates.current.name)) {
            picker.style.display = 'none';
            calendar.style.display = 'none';
          } 

          // Show/hide calendar/carousel icons to align with the active feature
          !pickerInactive || !calendarInactive ? icons.style.display = 'none' : icons.style.display = 'block';

          // Toggle +/- in "Advanced Search" heading (+ to indicate it can be expanded, - to indicate it can be collapsed)
          var plusMinus = document.getElementById('plus-minus');
          pickerInactive ? plusMinus.innerHTML = '-' : plusMinus.innerHTML = '+';

          // If on click of the "Advanced Search" toggle either of the features is active, reset a bunch of stuff when collapsing
          if(!pickerInactive || !calendarInactive || (search != $ctrl.locatorStates.current.name)) {
            // Remove no-appt-message if visible
            resetNoApptMsg();
            // Return results list to original order, sorted by distance
            $ctrl.sortByDistance(); 
            // Return datepicker cards to index 0 and reset style on prev arrow (since it's at the beginning of the carousel, prev arrow is disabled)
            resetDateCarouselToStart(); 
            // Show all results - if any have been filtered out, reset to show the whole list
            resetVisibleResults(); 
            // Remove selected class from calendar - so that when the calendar is reopened, it doesn't show a date selected when the results are not filtered
            resetCalendarSelected();
          }
        }

        // Toggle which feature is active (carousel or calendar datepicker)
        $ctrl.toggleAdvancedSearch = function(el) {
          var picker = document.getElementById('picker');
          var calendar = document.getElementById('calendar-picker');
          var calendarIcon = document.getElementById('calendar-icon');
          var carouselIcon = document.getElementById('carousel-icon');     

          // Toggle view - if carousel is active, on click switch to calendar
          if(picker.style.display == 'block') {
            picker.style.display = 'none';
            calendar.style.display = 'flex';
            // Also, run this function to apply bolding for dates with appointments
            styleCalendar();
            // And add event listeners to the calendar nav arrows so that when the month is switched, we can run styleCalendar again to apply to the new month
            addEventListenerToCalNav();

            // If calendar is active, on click switch to carousel
          } else {
            picker.style.display = 'block';
            calendar.style.display = 'none';
          }

          // Toggle icon - if carousel icon is visible, on click switch to calendar icon
          if(carouselIcon.style.display == 'block') {
            carouselIcon.style.display = 'none';
            calendarIcon.style.display = 'block';

            // If calendar icon is visible, on click switch to carousel icon
          } else {
            carouselIcon.style.display = 'block';
            calendarIcon.style.display = 'none';
          }

          // Reset all filters/sorts when switching view, back to original result list
          // Remove no-appt-message if visible
          resetNoApptMsg();
          // Return results list to original order, sorted by distance
          $ctrl.sortByDistance(); 
          // Return datepicker cards to index 0 and reset style on prev arrow (since it's at the beginning of the carousel, prev arrow is disabled)
          resetDateCarouselToStart(); 
          // Show all results - if any have been filtered out, reset to show the whole list
          resetVisibleResults(); 
          // Remove selected class from calendar - so that when the calendar is reopened, it doesn't show a date selected when the results are not filtered
          resetCalendarSelected();
        }

        // Advanced search functionality - filter results list by selected day
        $ctrl.filterResultsByDay = function(el, newDate) {
          var resultsListLi = Array.from(document.getElementsByClassName('location-li'));
          // Set all results to not display
          resultsListLi.forEach(function(li) { li.style.display = "none"; })
          // The structure of data that we get from the carousel elements and calendar elements differs, so set the selected date based on which feature the date was selected on
          $ctrl.locatorStates.selectedDate = el.appts ? el.appts.date : newDate;

          // If there aren't any appointments at any location in the results list on the day selected, show the no-appt-msg
          if(el.appts && el.appts.count == 0 && !document.getElementById('no-appt-msg') || !el.appts && !el.firstChild.classList.contains('bold')) {
            var resultsUl = document.getElementById('js-results');
            var noApptMsgTopBtmPadding = document.getElementById('picker').style.display == 'block' ? '50' : '28';
            var noApptMsg = document.createElement('div');
            noApptMsg.id = "no-appt-msg";
            noApptMsg.style = "padding:" + noApptMsgTopBtmPadding + "px 87px";
            noApptMsg.innerText = "Sorry. There are no appointments in this area on this day. Please choose another area or day.";
            resultsUl.appendChild(noApptMsg);
            
          // If there are appointments on the date selected, show only the locations that have appointments on this day
          } else if(el.appts && el.appts.count > 0 || !el.appts && el.firstChild.classList.contains('bold')) {
            // Remove the no-appt-msg
            resetNoApptMsg();

            $ctrl.locatorStates.locations.forEach(function(loc) { 
              if(loc.appointments) {
                for(var i = 0; i < loc.appointments.length; i++) {
                  // For each appointment at a location, if any of the apointment dates match the selected date, find the result in the results list and set it to be visible
                  if(loc.appointments[i].date == $ctrl.locatorStates.selectedDate) {
                    resultsListLi.forEach(function(li) {
                      if(li.id == loc.id) {
                        li.style.display = "block"; 
                        // And update the appointment header on the result to show the number of appointments on the selected day (rather than the number of appointments on the first day they have appointmennts)
                        var appointmentHeading = Array.from(li.getElementsByClassName('sl-appointments'))[0];
                        var exam = loc.appointments[i].time.length > 1 ? "Exams" : "Exam";
                        appointmentHeading.innerHTML = '<span class="red-bold">' + loc.appointments[i].time.length + ' ' + exam + '</span> - ' + loc.appointments[i].formattedDate;
                      }
                    })
                  } 
                }
              } 
            })
          }
        }

        // Scroll through the carousel
        $ctrl.scroll = function(direction) {
          // Don't scroll past the first/last date card in the carousel
          if(direction == 'next' && val > -999) { val = val - 100; } 
          else if(direction == 'prev' && val < 0) { val = val + 100; }
          document.getElementById('datepicker-carousel').style.transform = 'translate(' + val + 'px)';

          var nextArrow = document.getElementById('next-arrow');
          var prevArrow = document.getElementById('prev-arrow');

          // If the first/last date card in the carousel is in view, change the prev/next arrow styling to indicate that its disabled
          if(val < -999) {
            nextArrow.classList.remove('arrow-active');
            nextArrow.classList.add('arrow-inactive');
          } else {
            nextArrow.classList.add('arrow-active');
            nextArrow.classList.remove('arrow-inactive');
          }
          if(val >= 0) {
            prevArrow.classList.remove('arrow-active');
            prevArrow.classList.add('arrow-inactive');
          } else {
            prevArrow.classList.add('arrow-active');
            prevArrow.classList.remove('arrow-inactive');
          }

          // Set the month heading on the carousel section
          $ctrl.getMonth();
        }

        // Set the month for the carousel header
        $ctrl.getMonth = function() {
          // Set the header to be the month of the first date card in the carousel (if the carousel shows one date in Nov, then three in Dec, the heading will be NOVEMBER)
          if($ctrl.locatorStates.apptsByDay) {
            var index = val/-100;
            var firstCard = $ctrl.locatorStates.apptsByDay[index];
            var monthNum = new Date(firstCard.date).getMonth()
            var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
            return months[monthNum]
          }
        }
        
        // Remove the no-appt-msg
        function resetNoApptMsg() {
          // If the no-appt-msg is visible, remove it
          var noApptMsg = document.getElementById('no-appt-msg');    
          if(noApptMsg) { noApptMsg.parentNode.removeChild(noApptMsg); }
        }

        // Show all results in results list
        function resetVisibleResults() {
          var resultsListLi = Array.from(document.getElementsByClassName('location-li'));
          $ctrl.locatorStates.locations.forEach(function(loc) { 
            // Set visibility for each result to be visible
            resultsListLi.forEach(function(li) {
              li.style.display = "block";

              // Reset the appointment header on each location with appointments to show the first availble appointment overall
              if(loc.appointments) {
                for(var i = 0; i < loc.appointments.length; i++) {
                  if(li.id == loc.id) {
                    var appointmentHeading = Array.from(li.getElementsByClassName('sl-appointments'))[0];
                    var exam = loc.appointments[i].time.length > 1 ? "Exams" : "Exam";
                    if(appointmentHeading) {
                      appointmentHeading.innerHTML = '<span class="red-bold">' + loc.appointments[0].time.length + ' ' + exam + '</span> - ' + loc.appointments[0].formattedDate;
                    }
                  }
                }
              }
            })
          })
        }

        // Reset carousel to first date card
        function resetDateCarouselToStart() {
          val = 0; 
          document.getElementById('datepicker-carousel').style.transform = 'translate(' + val + 'px)';
          document.getElementById('prev-arrow').classList.remove('arrow-active');
          document.getElementById('prev-arrow').classList.add('arrow-inactive');
        }

        // Reset formatting that is applied to date when it is clicked
        function resetCalendarSelected() {
          var calendar = Array.from(document.getElementsByClassName('ui-datepicker-calendar')[0].getElementsByTagName('tbody')[0].getElementsByTagName('td'))
          calendar.forEach(function(date) {
            if(date.firstChild.classList && date.firstChild.classList.contains('ui-state-active')) {
              date.firstChild.classList.remove('ui-state-active');
            }
          })
        }

        // Style dates in calendar to indicate which have appointments 
        function styleCalendar() {
          var calendar = Array.from(document.getElementsByClassName('ui-datepicker-calendar')[0].getElementsByTagName('tbody')[0].getElementsByTagName('td'))
          calendar.forEach(function(date) {
            var month = parseInt(date.getAttribute('data-month')) + 1;
            var year = date.getAttribute('data-year');
            var day = date.firstChild.innerText && date.firstChild.innerText.length > 1 ? date.firstChild.innerText : 0 + date.firstChild.innerText;
            var newDate = year + '-' + month + '-' + day

            if(newDate) {
              $ctrl.locatorStates.apptsByDay.forEach(function(a) {
                if(a.date == newDate && a.count > 0) {
                  date.firstChild.classList.add('bold');
                } 
              })
              
              // Also add an event listener so that when a date is clicked, the styles are retained (overriding the removal of styles on next clicks) and the results are filtered by the date clicked
              date.addEventListener('click', function() {
                styleCalendar();
                $ctrl.filterResultsByDay(date, newDate);  
              })
            }

          })
          // Reset no-appts-msg
          resetNoApptMsg();
          // The calendar package defaults to removing styling and event listeners on clicks, so re-adding listeners to the nav arrows on every click
          addEventListenerToCalNav();
        }

        // Add event listenrs to calendar navigation arrows
        function addEventListenerToCalNav() {
          var nextArrow = Array.from(document.getElementsByClassName('ui-datepicker-next'));
          var prevArrow = Array.from(document.getElementsByClassName('ui-datepicker-prev'));
          var navArrows = nextArrow.concat(prevArrow);

          // Replace the package's arrow images for icons
          prevArrow[0].firstChild.remove()
          prevArrow[0].innerHTML = '<i class="fa fa-chevron-left"></i>';

          nextArrow[0].firstChild.remove()
          nextArrow[0].innerHTML = '<i class="fa fa-chevron-right"></i>';

          // When clicked, the nav arrows will restyle the calendar for the visible month (add bold to dates with appointments, which also makes the filtering possible)
          navArrows.forEach(function(a) {
            a.addEventListener('click', function() {
              styleCalendar(); 
            })
          })
        }

        // Check to see if a new search has been performed to trigger a reset of advanced search functionality
        function checkIfSearchHasChanged() {
          if(search != $ctrl.locatorStates.current.name) {
            // $ctrl.showHideAdvancedSearch();
            document.getElementById('picker').style.display = 'none';
            document.getElementById('calendar-picker').style.display = 'none';
            document.getElementById('icons').style.display = 'none';
            document.getElementById('plus-minus').innerHTML = '+';

            document.getElementById('calendar-icon').style.display = 'block';
            document.getElementById('carousel-icon').style.display = 'none';

            // Remove no-appt-message if visible
            resetNoApptMsg();
            // Return results list to original order, sorted by distance
            $ctrl.sortByDistance(); 
            // Return datepicker cards to index 0 and reset style on prev arrow (since it's at the beginning of the carousel, prev arrow is disabled)
            resetDateCarouselToStart(); 
            // Show all results - if any have been filtered out, reset to show the whole list
            resetVisibleResults(); 
            // Remove selected class from calendar - so that when the calendar is reopened, it doesn't show a date selected when the results are not filtered
            resetCalendarSelected();
            // Reset search variable to current location
            search = $ctrl.locatorStates.current.name;
          }
        }
    }
  }
})();

(function () {
    'use strict';
  
    angular
      .module('storeLocator')
      .directive('storeImage', storeImage);
  
    function storeImage() {
  
      return {
        scope: {
          location: '='
        },
        templateUrl: 'app/custom/clients/visionworks/directives/storeImage.directive.html',
        restrict: 'AE',
        controller: storeImageController,
        controllerAs: 'storeImageController',
        bindToController: true
      };
      
      function storeImageController(customFieldFactory, $sce) {
        var $ctrl = this;
        $ctrl.hasCustomFieldValue = hasCustomFieldValue;
        $ctrl.getCustomFieldValueByName = getCustomFieldValueByName;

        function hasCustomFieldValue(customFields, name) {
          return customFieldFactory.getValueByName(customFields, name) ? true : false;
        }

        function getCustomFieldValueByName(customFields, name) {
          var value = customFieldFactory.getValueByName(customFields, name);
          return $sce.trustAsHtml(value);
        }
      }
      
    }
  })();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('showMoreLess', showMoreLess);

  function showMoreLess() {
    return {
      scope: {
        txt: '@',
        strLimit: '@',
        arrowToggle:'@'
      },
      restrict: 'AE',
      templateUrl: 'app/custom/clients/visionworks/directives/showMoreLess.directive.html',
      controller: showMoreLessController,
      controllerAs: 'showMoreLessC',
      bindToController: {}

    };

    function showMoreLessController($scope) {
      var vm = this;
      vm.arrowToggle = $scope.arrowToggle || false;
      vm.txt = $scope.txt;
      vm.strLimit = $scope.strLimit ? $scope.strLimit : 140;

      var trimmedString = vm.txt.substr(0, vm.strLimit);
      //re-trim if we are in the middle of a word
      var newLen = Math.min(trimmedString.length, trimmedString.lastIndexOf(" "));

      // Initial 140 characters will be displayed.
      vm.strLimit = newLen;
      vm.strLen = vm.txt.length;

      // Event trigger on click of the Show more button.
      vm.showMore = function() {
        vm.strLimit = vm.txt.length + 1;
      };

      // Event trigger on click on the Show less button.
      vm.showLess = function() {
        vm.strLimit = newLen;
      };
    }
  }
})();

(function () {
'use strict';

angular
    .module('storeLocator')
    .directive('servicesSection', servicesSection);

function servicesSection() {

    return {
    replace: true,
    scope: {
        location: '='
    },
    templateUrl: 'app/custom/clients/visionworks/directives/servicesSection.directive.html',
    restrict: 'AE',
    controller: servicesSectionController,
    controllerAs: 'servicesSectionController',
    bindToController: true
    };
    
    function servicesSectionController(customFieldFactory) {
        var $ctrl = this;
        $ctrl.hasCustomFieldValue = hasCustomFieldValue;

        function hasCustomFieldValue(customFields, name) {
            return customFieldFactory.getValueByName(customFields, name) ? true : false;
        }
    }
}
})();
  

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('scheduleEyeExamCard', scheduleEyeExamCard);

  function scheduleEyeExamCard() {

    return {
      replace: true,
      scope: {
        location: '=',
        examLink: '@',
        buttonText: '='
      },
      templateUrl: 'app/custom/clients/visionworks/directives/scheduleEyeExamCard.directive.html',
      restrict: 'AE',
      controller: scheduleEyeExamController,
      controllerAs: 'scheduleEyeExamC',
      bindToController: {}
    };

    function scheduleEyeExamController($modal, $scope,$location, customFieldFactory) {
      var vm = this;
      vm.employed = false;
      vm.location = $scope.location;
      vm.examLink = $scope.examLink;
      vm.buttonText = $scope.buttonText || "Schedule Appointment"
      vm.getCustomFieldValue = getCustomFieldValue;
      function getCustomFieldValue(name) {
        return customFieldFactory.getValueByName(vm.location.custom_fields, name);
      }
      vm.pageCategory = $location.path() === '/' ? 'Store Locator' : 'LLP';
      vm.sublease = getCustomFieldValue('doctor_type') ? getCustomFieldValue('doctor_type').toLowerCase() === 'sublease' : false;
      vm.showMyModal = function () {
        redirectModal.$promise.then(redirectModal.show);
      };
      var redirectModal = $modal(
        {
          templateUrl: 'app/custom/clients/visionworks/directives/scheduleEyeExam.modal.html',
          placement: "top",
          windowClass: "center",
          show: false,
          animation: "am-fade-and-scale",
          scope: $scope
        });
    }
  }
})();


(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('promotionsSection', promotionsSection);

  function promotionsSection() {

    return {
      replace: true,
      scope: {
        customFields: '='
        /*
        configurable options include:

        promo_n_standard_title

        promo_n_standard_text

        promo_n_standard_disclaimer

        promo_n_banner_text

        promo_n_banner_image

        promo_n_banner_link

        promo_n_coupon_title

        promo_n_coupon_price

        promo_n_coupon_code

        promo_n_coupon_text

        promo_n_coupon_expiration

        Where indexing starts at 1 and coupon promos take precedence over banner images over standard

        (coupon > banner > standard) || (standard < banner < coupon)
         */
      },
      templateUrl: 'app/custom/clients/visionworks/directives/promotionsSection.directive.html',
      restrict: 'AE',
      controller: promotionsSectionController,
      controllerAs: 'promotionsSectionC',
      bindToController: true
    };

    function promotionsSectionController() {
      var vm = this;
      vm.printCoupon = printCoupon;
      vm.generatePromoTypes = generatePromoTypes(vm.customFields);

      function isPromoField(field) {
        return field.name.split('_').length > 0 ? field.name.split('_')[0] === 'promo' : null;
      }

      function addToPromoObject(field) {
        var split = field.name.split('_');
        if (split.length > 3) {
          var index = parseInt(split[1]);
          var type = split[2];
          var attr = split[3];
          if (!_.isUndefined(vm.promoObject[index - 1]) && !_.isEmpty(vm.promoObject[index - 1])) {
            vm.promoObject[index - 1][type + '_' + attr] = field.data;
          } else {
            var object = {};
            object[type + '_' + attr] = field.data;
            vm.promoObject[index - 1] = object;
          }
        }
      }

      function generatePromoTypes(customFields) {
        vm.promoObject = [{}];
        _.each(customFields, function (field) {
          if (isPromoField(field, 'promo')) {
            addToPromoObject(field)
          }
        });
        pickPromoTypes();
      }

      function pickPromoTypes() {
        _.each(vm.promoObject, function (object,index) {
          if (angular.isDefined(object)) {
            if (object.hasOwnProperty('coupon_code') && object.hasOwnProperty('coupon_text') && object.hasOwnProperty('coupon_expiration') && object.hasOwnProperty('coupon_price') && object.hasOwnProperty('coupon_title')) {
              vm.promoObject[index].type = 'coupon';
            } else if (object.hasOwnProperty('banner_image')) {
              if (object.hasOwnProperty('banner_text')){
                vm.promoObject[index].addText = true;
              }
              vm.promoObject[index].type = 'banner';
            } else if (object.hasOwnProperty('standard_title') && (object.hasOwnProperty('standard_disclaimer') || object.hasOwnProperty('standard_text'))) {
              if (object.hasOwnProperty('standard_disclaimer')){
              vm.promoObject[index].addText = true;
              }
              vm.promoObject[index].type = 'standard';

              /* Logic to truncate string */

              // vm.strLimit = vm.strLimit ? vm.strLimit : 210;
              // var trimmedString = vm.promoObject[index].standard_text.substr(0, vm.strLimit);
              //
              // //re-trim if we are in the middle of a word
              // var newLen = Math.min(trimmedString.length, trimmedString.lastIndexOf(" "));
              //
              // // Initial 250 characters will be displayed.
              // vm.strLimit = newLen;
              // vm.strLen = vm.promoObject[index].standard_text.replace(/\s/g, "").length;
              // vm.promoObject[index].standard_text_overflow =  vm.promoObject[index].standard_text.substr(newLen);
              // vm.promoObject[index].standard_text = vm.promoObject[index].standard_text.substr(0, newLen);

            } else {
              vm.promoObject[index].type = 'hidden';
            }
          }
        });
      }

      function printCoupon() {
        var newWindow = window.open();
        var couponContent = document.getElementById('coupon');
        var newCouponContent = couponContent.cloneNode(true);
        newWindow.document.body.appendChild(newCouponContent);
        newWindow.document.getElementById('coupon').setAttribute('style', 'border: dashed 2px #434747; padding: 10px; margin-top: 10px; display: flex; flex-direction: row; font-family: Spartan, sans-serif;');
        newWindow.document.getElementsByClassName('coupon-left')[0].setAttribute('style', 'padding: 10px; min-width: 35%;');
        newWindow.document.getElementsByClassName('coupon-title')[0].setAttribute('style', 'color: #FF4539; font-weight: 600; font-size: 44px; text-transform: uppercase; text-align: center;');
        newWindow.document.getElementsByClassName('coupon-code-title')[0].setAttribute('style', 'background-color: #FFB648; font-size: 12px; text-align: center; font-weight: 700; text-transform: uppercase; padding: 5px; display: inline-block;');
        newWindow.document.getElementsByClassName('coupon-code')[0].setAttribute('style', 'display: inline-block; text-align: center;');
        newWindow.document.getElementsByClassName('coupon-right')[0].setAttribute('style', 'display: flex; flex-direction: column; justify-content: flex-start; align-items: center; padding: 10px; border-left: 1px solid #DDE4EC;');
        newWindow.document.getElementsByClassName('print')[0].setAttribute('style', 'display: none;');
        newWindow.document.getElementsByClassName('expiration')[0].setAttribute('style', 'background: #FF4539; color: white; font-weight: 600; font-size: 12px; padding: 5px; display: block; margin-top: 15px;');
        newWindow.document.getElementsByClassName('coupon-text')[0].setAttribute('style', 'font-family: @secondary-font; font-size: 10px;');

        newWindow.print();
      }
    }
  }
})();



(function () {
    'use strict';
    
    angular
        .module('storeLocator')
        .directive('paymentSection', paymentSection);
    
    function paymentSection() {
    
        return {
        replace: true,
        scope: {
            location: '='
        },
        templateUrl: 'app/custom/clients/visionworks/directives/paymentSection.directive.html',
        restrict: 'AE',
        controller: paymentSectionController,
        controllerAs: 'paymentSectionController',
        bindToController: true
        };
        
        function paymentSectionController(customFieldFactory) {
            var $ctrl = this;
            $ctrl.hasCustomFieldValue = hasCustomFieldValue;
    
            function hasCustomFieldValue(customFields, name) {
                return customFieldFactory.getValueByName(customFields, name) ? true : false;
            }
        }
    }
    })();
      
    
(function () {
'use strict';

angular
    .module('storeLocator')
    .directive('insurance', insurance);

function insurance() {

    return {
    replace: true,
    scope: {
        location: '='
    },
    templateUrl: 'app/custom/clients/visionworks/directives/insurance.directive.html',
    restrict: 'AE',
    controller: insuranceController,
    controllerAs: 'insuranceController',
    bindToController: true
    };
    
    function insuranceController(customFieldFactory) {
        var $ctrl = this;
        $ctrl.hasCustomFieldValue = hasCustomFieldValue;

        function hasCustomFieldValue(customFields, name) {
            return customFieldFactory.getValueByName(customFields, name) ? true : false;
        }
    }
}
})();
      
    
(function () {
    'use strict';
    
    angular
        .module('storeLocator')
        .directive('featuredBrands', featuredBrands);
    
    function featuredBrands() {
    
        return {
        replace: true,
        scope: {
            location: '='
        },
        templateUrl: 'app/custom/clients/visionworks/directives/featuredBrands.directive.html',
        restrict: 'AE',
        controller: featuredBrandsController,
        controllerAs: 'featuredBrandsController',
        bindToController: true
        };
        
        function featuredBrandsController(customFieldFactory) {
            var $ctrl = this;
            $ctrl.hasCustomFieldValue = hasCustomFieldValue;
    
            function hasCustomFieldValue(customFields, name) {
                return customFieldFactory.getValueByName(customFields, name) ? true : false;
            }
        }
    }
    })();
      
    
(function () {
    'use strict';
  
    angular
      .module('storeLocator')
      .directive('directions', directions);
  
    function directions() {
  
      return {
        replace: true,
        scope: {
          location: '='
        },
        templateUrl: 'app/custom/clients/visionworks/directives/directions.directive.html',
        restrict: 'AE',
        controller: directionsController,
        controllerAs: 'directionsController',
        bindToController: true
      };
      
      function directionsController($window) {
        var vm=this;
        vm.url = '';
        vm.text = 'Current Location';
        vm.submit = function() {
          if (vm.text) {
            vm.url= "https://www.google.com/maps/dir/" + this.text.replace(" ","+")+ "/" +vm.location.store_info.latitude+ "," +vm.location.store_info.longitude;
            vm.text = '';
            $window.location.href = vm.url;
          }
        };
      }
      
    }
  })();
  

(function () {
    'use strict';
  
    angular
      .module('storeLocator')
      .directive('customLandingButtons', customLandingButtons);
  
    function customLandingButtons() {
  
      return {
        replace: true,
        scope: {
          location: '='
        },
        templateUrl: 'app/custom/clients/visionworks/directives/customLandingButtons.directive.html',
        restrict: 'AE',
        controller: customLandingButtonsController,
        controllerAs: 'customLandingButtonsController',
        bindToController: true
      };
      
      function customLandingButtonsController($modal, $scope,$location, customFieldFactory) {
        var $ctrl = this;

        $ctrl.getCustomButtonCount = getCustomButtonCount;
        function getCustomButtonCount(customFields) {
          var buttonCount = 1;
          if($ctrl.examLink) buttonCount += 1;
          if($ctrl.hasInStoreServices) buttonCount += 1;
          if($ctrl.pageCategory === 'LLP' && ($ctrl.meetDoctorLink || $ctrl.isEmployed)) buttonCount += 1;
          if($ctrl.pageCategory === 'Store Locator') buttonCount += 1;
          return buttonCount
        }

        var examLink = customFieldFactory.getValueByName($ctrl.location.custom_fields, 'schedule_exam_link');
        var meetDoctorLink = customFieldFactory.getValueByName($ctrl.location.custom_fields, 'meet_the_doctor');
        var storePromotionsLink = customFieldFactory.getValueByName($ctrl.location.custom_fields, 'store_promotions_link');
        var isEmployed = customFieldFactory.getValueByName($ctrl.location.custom_fields, 'doctor_type') ? customFieldFactory.getValueByName($ctrl.location.custom_fields, 'doctor_type').toLowerCase() === 'employed' : false;
        var hasEmployedDoc = hasCustomFieldValue($ctrl.location.custom_fields, 'doctor_name_1');
        var sublease = customFieldFactory.getValueByName($ctrl.location.custom_fields, 'doctor_type') ? customFieldFactory.getValueByName($ctrl.location.custom_fields, 'doctor_type').toLowerCase() === 'sublease' : false;
        var pageCategory = $location.$$path === '/' ? 'Store Locator' : 'LLP';
        var ostBannerLink = customFieldFactory.getValueByName($ctrl.location.custom_fields, 'ost_banner_link');
        var ostBannerText = customFieldFactory.getValueByName($ctrl.location.custom_fields, 'ost_banner_text');
        var ostBannerImage = customFieldFactory.getValueByName($ctrl.location.custom_fields, 'ost_banner_image');
        $ctrl.isEmployed = isEmployed && hasEmployedDoc;
        $ctrl.examLink = examLink;
        $ctrl.meetDoctorLink = meetDoctorLink;
        $ctrl.storePromotionsLink = storePromotionsLink;
        $ctrl.pageCategory = pageCategory;
        $ctrl.sublease = sublease;
        $ctrl.ostBannerLink = ostBannerLink;
        $ctrl.ostBannerText = ostBannerText;
        $ctrl.ostBannerImage = ostBannerImage;
        $ctrl.hasCustomFieldValue = hasCustomFieldValue;
        $ctrl.getCustomFieldValue = getCustomFieldValue;
        $ctrl.hasInStoreServices = hasCustomFieldValue($ctrl.location.custom_fields, 'in_store_services');
        $ctrl.inStoreServices = customFieldFactory.getValueByName($ctrl.location.custom_fields, 'in_store_services')

        function hasCustomFieldValue(customFields, name) {
          return customFieldFactory.getValueByName(customFields, name) ? true : false;
        }
        
        function getCustomFieldValue(name) {
          return customFieldFactory.getValueByName($ctrl.location.custom_fields, name);
        }
        
        $ctrl.showMyModal = function () {
          redirectModal.$promise.then(redirectModal.show);
        };
        var redirectModal = $modal(
          {
            templateUrl: 'app/custom/clients/visionworks/directives/scheduleEyeExamLanding.modal.html',
            placement: "top",
            windowClass: "center",
            show: false,
            animation: "am-fade-and-scale",
            scope: $scope
          });
      }
      
    }
  })();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('customButtons', customButtons);

  function customButtons() {

    return {
      replace: true,
      scope: {
        location: '='
      },
      templateUrl: 'app/custom/clients/visionworks/directives/customButtons.directive.html',
      restrict: 'AE',
      controller: customButtonsController,
      controllerAs: 'customButtonsController',
      bindToController: true
    };
    
    function customButtonsController(customFieldFactory) {
      var $ctrl = this;
      var examLink = customFieldFactory.getValueByName($ctrl.location.custom_fields, 'schedule_exam_link');
      var meetDoctorLink = customFieldFactory.getValueByName($ctrl.location.custom_fields, 'meet_the_doctor');
      var storePromotionsLink = customFieldFactory.getValueByName($ctrl.location.custom_fields, 'store_promotions_link');
      var isEmployed = customFieldFactory.getValueByName($ctrl.location.custom_fields, 'doctor_type') === 'employed';
      var hasEmployedDoc = hasCustomFieldValue($ctrl.location.custom_fields, 'doctor_name_1');

      $ctrl.isEmployed = isEmployed && hasEmployedDoc;
      $ctrl.examLink = examLink;
      $ctrl.meetDoctorLink = meetDoctorLink;
      $ctrl.storePromotionsLink = storePromotionsLink;
      $ctrl.hasCustomFieldValue = hasCustomFieldValue;
      $ctrl.hasCustomFieldValue = hasCustomFieldValue;

      function hasCustomFieldValue(customFields, name) {
          return customFieldFactory.getValueByName(customFields, name) ? true : false;
      }
    }
    
  }
})();

(function() {
  'use strict';

  angular
      .module('storeLocator')
      .directive('appointmentStoreLocator', appointmentStoreLocator);

  function appointmentStoreLocator() {
    return {
        templateUrl: 'app/custom/clients/visionworks/directives/appointmentStoreLocator.directive.html',
        restrict: 'E',
        scope: {},
        controller: appointmentStoreLocatorController,
        controllerAs: 'appointmentStoreLocatorC',
        bindToController: {
            location: '=',
            locatorStates: '='
        }
    };

    function appointmentStoreLocatorController($http, customFieldFactory) {
      var $ctrl = this;
      // Get PMID for location (custom field specific to use so the rollout can be phased)
      var pmid = customFieldFactory.getValueByName($ctrl.location.custom_fields,'PMID_appts') 
      // The number of days to retrieve appointment data for (including the current day)
      var numOfDaysOut = 14; 

      // Tf there is a PMID available, fetch the appoitments from 3rd party API
      if(pmid) { getAppointmentsForLoc(pmid, $ctrl.numOfDaysOut); } 

      // Fetch appointment data from 3rd party API
      function getAppointmentsForLoc(pmid) {
        // Upon new search, reset the active radio button to "Distance"
        document.getElementById('customRadioInline2').checked = false;
        document.getElementById('customRadioInline1').checked = true; 

        $http({
          method: 'GET',
          url: 'https://oas.visionworks.com/easyappt2/index.php/' + pmid + '/appointments/ajax_get_open_times/1/1/' + numOfDaysOut // prod endpoint
        })
        .success(function (response) {
          // If results were returned for a location, add the appointments (organized by day) to the locatorStates.locations object for this location
          if(response.length > 0) { addApptsToLocatorStatesLocation(response); }  
        })
        .error(function() {
            console.log('An error occurred while retreiving content.');
        });
      }

      // Add appointments list to locatorStates.locations for each location
      function addApptsToLocatorStatesLocation(response) {
         // Create an array to hold all of the dates that there are appoitments on for this location
        var datesWithApptsForLoc = [response[0].date];
        // If the date is not yet included in the array, add it to that array
        response.forEach(function(r) {
          if(!datesWithApptsForLoc.includes(r.date)) { datesWithApptsForLoc.push(r.date); }
        })

        // Sort the list of dates and create a new array with an object for each date that will store an array of times and the formatted date
        datesWithApptsForLoc = datesWithApptsForLoc.sort();
        var allApptsByDayForLoc = [];
        datesWithApptsForLoc.forEach(function(d) { allApptsByDayForLoc.push({date: d, time: [], formattedDate: dateFormat(d)});  })
          
        // Go through all of the appointments and add the time to the correct day in the datesWithApptsForLoc array
        response.forEach(function(r) { 
          allApptsByDayForLoc.forEach(function(a) { 
            if(r.date == a.date) { a.time.push(r.time); }
          })
        })

        // Set the sorted data to be used by the HTML
        $ctrl.appointments = allApptsByDayForLoc;
        // Set the first appointment date for the location to this variable
        var nextApptDate = allApptsByDayForLoc[0].date;

        // This translates AM/PM times provided by 3rd party into 24-hr time for sorting
        for(var i = 0; i < allApptsByDayForLoc.length; i++) {
          for(var j = 0; j < allApptsByDayForLoc[i].time.length; j++) {
            if(allApptsByDayForLoc[i].time[j].includes('pm')) { // if the time is PM
              allApptsByDayForLoc[i].time[j] = allApptsByDayForLoc[i].time[j].includes("12:") // and if the time is 12 noon
                                            ? allApptsByDayForLoc[i].time[j].slice(0, allApptsByDayForLoc[i].time[j].indexOf('p')) // leave the hour as 12
                                            : parseInt(allApptsByDayForLoc[i].time[j].slice(0, allApptsByDayForLoc[i].time[j].indexOf(':'))) + 12 + allApptsByDayForLoc[i].time[j].slice(allApptsByDayForLoc[i].time[j].indexOf(':'), allApptsByDayForLoc[i].time[j].indexOf('p')); // otherwise add 12 to get to 24-hr format and ditch the 'pm'
            } else if(allApptsByDayForLoc[i].time[j].includes('am')) { // if the time is AM
              allApptsByDayForLoc[i].time[j] = allApptsByDayForLoc[i].time[j].includes('12:') // and if the time is 12 midnight
                                            ? allApptsByDayForLoc[i].time[j].replace('12', '0').slice(0, allApptsByDayForLoc[i].time[j].indexOf('a')) // change the hour to 0
                                            : allApptsByDayForLoc[i].time[j].slice(0, allApptsByDayForLoc[i].time[j].indexOf('a')); // and if not, just chop off the 'am'
            } 
          }
        }

        // Set the first appointment time for the first appointment for location to this variable
        var nextApptTime = allApptsByDayForLoc[0].time.sort()[0]

        // Add the nextAppt to the locatorStates.location object for use sorting by next available appointment
        // Add the appointments array to the locatorStates.location object for use in the advanced search functionality
        $ctrl.locatorStates.locations.forEach(function(l) {
          if($ctrl.location.momentfeed_venue_id == l.id) {
            l.nextAppt = {date: nextApptDate, time: nextApptTime};
            l.appointments = allApptsByDayForLoc; 
          }
        })
        // Create an array of all appointments by date, regardless of location (for advanced search functionality)
        apptsByDayAllLocsInclusive(); 
      }

      // Format the date for display within appointment header
      function dateFormat(date) {
         date = new Date(date.replace(/-/g, "/") + " 00:00").toDateString().slice(0,-5);
         date = date.substr(0,3) + ',' + date.substr(3);
         return date;
      }

      // Create an array of all appointments by date, regardless of location (for advanced search functionality)
      function apptsByDayAllLocsInclusive() {
        // Create an array with an object for the current day that'll hold all info we'll need for the advanced search functionality (filtering by day)
        // Note: different date formats are needed for display and functionality
        var all = [];
        var today = new Date();
        var todayUTC = today.getTime();
        var todayDisplay = today.toUTCString(); // Format for display
        today = today.toISOString(); // Format to use for comparison later
        today = today.slice(0, today.indexOf('T'))
        all.push({date: today, count: 0, displayDay: todayDisplay.slice(0, 3), displayDate: todayDisplay.slice(5, 7)});
        
        // Add to array with each date through the above specified number of days we're getting appointments for
        for(var i = 1; i < numOfDaysOut; i++) {
          var date = new Date(todayUTC + (86400000 * i))
          var dateDisplay = date.toUTCString(); // Format the display
          date = date.toISOString(); // Format to use for comparison later
          date = date.slice(0, date.indexOf('T')) 
          all.push({date: date, count: 0, displayDay: dateDisplay.slice(0, 3), displayDate: dateDisplay.slice(5, 7)}); // add each day to the 'all' array
        }

        // Go through each appointment (all location inclusive) and add to the count per day
        $ctrl.locatorStates.locations.forEach(function(l) {
          if(l.appointments) {
            l.appointments.forEach(function(x) { 
              all.forEach(function(d) {
                if(x.date == d.date) {
                  d.count = d.count + x.time.length;
                }
              })
            })
          }
        })
        // Add apptsByDay to the locatorStates to be accessed by the HTML to display each date and the number of appointments across locations
        $ctrl.locatorStates.apptsByDay = all;
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('addressCardVision', addressCardVision);

  function addressCardVision () {

    return {
      replace: true,
      scope: {
        location: '=',
        collapseAddress: '@',
        nameExtended: '@',
        customStoreName: '@',
        customButtonField: '@',
        customButtonText: '@',
        addressLink: '@',
        addressLinkTitle: '@',
        hideGetDirections: '=?', // Optional param for whether to show the "Get Directions" button.
        gtmOnClick: '=',
        deliveryModalExtendedDelivery: '=',
        altPhone: '@'
      },
      templateUrl: 'app/custom/clients/visionworks/directives/addressCardVision.directive.html',
      restrict: 'AE',
      controller:addressCardVisionController,
      controllerAs:'addressCardVisionC',
      bindToController: {altPhoneTitle: '=', mainPhoneTitle: '='}
      }
  }
      function addressCardVisionController($scope) {
        var vm = this;

        vm.showGetDirections = true;
        vm.storeSEOName = $scope.location.store_info.name;
        if ($scope.hideGetDirections) {
          vm.showGetDirections = false;
        }

        vm.statusFlag = '';

        if ($scope.location.status == "coming soon"){
          vm.statusFlag = "This Location is Coming Soon."
        }
        else if ($scope.location.status == "temp closed"){
          vm.statusFlag = "This Location is Temporarily Closed."
        }

        vm.directionsUrl = $scope.location.store_info.directionsUrl;

        if ($scope.customStoreName) {
            var findName = _.find($scope.location.custom_fields, { "name": $scope.customStoreName });
            vm.storeName = findName ? findName.data : findName ;
        } else {
            vm.storeName = $scope.location.store_info.name;
        }

        if ($scope.nameExtended && $scope.nameExtended.includes('[')) {
          var arr = $scope.nameExtended.substr(1, $scope.nameExtended.length - 2).split(',');
          var nameExtendedConfig = [];
          arr.forEach(function(item) {
            item = _.find($scope.location.custom_fields, { "name": item });
            if(item && item.data) nameExtendedConfig.push(item.data);
          })
          nameExtendedConfig.length > 0 ? vm.nameExtendedConfig = nameExtendedConfig : vm.nameExtended = (_.find($scope.location.custom_fields, { "name": "name_extended" })).data
        } else if ($scope.nameExtended && !$scope.nameExtended.includes('[')) {
          vm.nameExtendedConfig = (_.find($scope.location.custom_fields, { "name": $scope.nameExtended })).data
        } else if(!$scope.nameExtended) {
          var name = _.find($scope.location.custom_fields, { "name": "name_extended" })
          if(name) vm.nameExtended = name.data;
        }

        vm.menuLink = _.find($scope.location.custom_fields, {"name": "menulink"});
        if (_.find($scope.location.custom_fields, {"name": "online_order_link"})) {
          vm.onlineOrderLink = _.find($scope.location.custom_fields, {"name": "online_order_link"});
        } else if (_.find($scope.location.custom_fields, {"name": "order_online_link"})) {
          vm.onlineOrderLink = _.find($scope.location.custom_fields, {"name": "order_online_link"}); }
        vm.customButtonLink = _.find($scope.location.custom_fields, { "name": $scope.customButtonField });
        var customButtonText = _.find($scope.location.custom_fields, { "name": $scope.customButtonText })
        vm.customButtonText = customButtonText ? customButtonText.data : $scope.customButtonText;
        if($scope.collapseAddress){
        vm.addressExtended = $scope.location.store_info.address+" "+$scope.location.store_info.address_extended;
        }
        
        //Populating alternatie phone number
        if($scope.location.custom_fields) {
          var findAltPhone = _.find($scope.location.custom_fields, { "name": $scope.altPhone });
          if(findAltPhone) {
            vm.altPhone = findAltPhone ? findAltPhone.data : findAltPhone ;
          }
        }
        
        if($scope.gtmOnClick == true) {
          window.onload = function() {
            var getDirectionsBtn = document.getElementsByClassName('get-directions')
            var deliveryModal = document.getElementsByClassName('delivery-modal')
            if(getDirectionsBtn[0]) {
              getDirectionsBtn[0].addEventListener('click', function() {
                getDirectionsLLP($scope.location.store_info.corporate_id)
              })
            }
            if(deliveryModal[0]) {
              deliveryModal[0].addEventListener('click', function() {
                deliveryModalLLP($scope.location.store_info.corporate_id)
              })
            }
          }
        }

      }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('addressCardLedo', addressCardLedo);

  function addressCardLedo () {

    return {
      replace: true,
      scope: {
        location: '=',
        collapseAddress: '@',
        nameExtended: '@',
        customStoreName: '@',
        customButtonField: '@',
        customButtonText: '@',
        addressLink: '@',
        addressLinkTitle: '@',
        hideGetDirections: '=?', // Optional param for whether to show the "Get Directions" button.
        gtmOnClick: '=',
        deliveryModalExtendedDelivery: '=',
        altPhone: '@'
      },
      templateUrl: 'app/custom/clients/ledopizza/directives/addressCardLedo.directive.html',
      restrict: 'AE',
      controller:addressCardLedoController,
      controllerAs:'addressCardLedoC',
      bindToController: {altPhoneTitle: '=', mainPhoneTitle: '='}
      }
  }
      function addressCardLedoController($scope) {
        var vm = this;

        vm.showGetDirections = true;
        vm.storeSEOName = $scope.location.store_info.name;
        if ($scope.hideGetDirections) {
          vm.showGetDirections = false;
        }

        // Find orderLink custom field
        vm.orderLink = _.find($scope.location.custom_fields, {"name": "orderLink"});

        vm.statusFlag = '';

        if ($scope.location.status == "coming soon"){
          vm.statusFlag = "This Location is Coming Soon."
        }
        else if ($scope.location.status == "temp closed"){
          vm.statusFlag = "This Location is Temporarily Closed."
        }

        vm.directionsUrl = $scope.location.store_info.directionsUrl;

        if ($scope.customStoreName) {
            var findName = _.find($scope.location.custom_fields, { "name": $scope.customStoreName });
            vm.storeName = findName ? findName.data : findName ;
        } else {
            vm.storeName = $scope.location.store_info.name;
        }

        if ($scope.nameExtended && $scope.nameExtended.includes('[')) {
          var arr = $scope.nameExtended.substr(1, $scope.nameExtended.length - 2).split(',');
          var nameExtendedConfig = [];
          arr.forEach(function(item) {
            item = _.find($scope.location.custom_fields, { "name": item });
            if(item && item.data) nameExtendedConfig.push(item.data);
          })
          nameExtendedConfig.length > 0 ? vm.nameExtendedConfig = nameExtendedConfig : vm.nameExtended = (_.find($scope.location.custom_fields, { "name": "name_extended" })).data
        } else if ($scope.nameExtended && !$scope.nameExtended.includes('[')) {
          vm.nameExtendedConfig = (_.find($scope.location.custom_fields, { "name": $scope.nameExtended })).data
        } else if(!$scope.nameExtended) {
          var name = _.find($scope.location.custom_fields, { "name": "name_extended" })
          if(name) vm.nameExtended = name.data;
        }

        vm.menuLink = _.find($scope.location.custom_fields, {"name": "menulink"});
        if (_.find($scope.location.custom_fields, {"name": "online_order_link"})) {
          vm.onlineOrderLink = _.find($scope.location.custom_fields, {"name": "online_order_link"});
        } else if (_.find($scope.location.custom_fields, {"name": "order_online_link"})) {
          vm.onlineOrderLink = _.find($scope.location.custom_fields, {"name": "order_online_link"}); }
        vm.customButtonLink = _.find($scope.location.custom_fields, { "name": $scope.customButtonField });
        var customButtonText = _.find($scope.location.custom_fields, { "name": $scope.customButtonText })
        vm.customButtonText = customButtonText ? customButtonText.data : $scope.customButtonText;
        if($scope.collapseAddress){
        vm.addressExtended = $scope.location.store_info.address+" "+$scope.location.store_info.address_extended;
        }
        
        //Populating alternatie phone number
        if($scope.location.custom_fields) {
          var findAltPhone = _.find($scope.location.custom_fields, { "name": $scope.altPhone });
          if(findAltPhone) {
            vm.altPhone = findAltPhone ? findAltPhone.data : findAltPhone ;
          }
        }
        
        if($scope.gtmOnClick == true) {
          window.onload = function() {
            var getDirectionsBtn = document.getElementsByClassName('get-directions')
            var deliveryModal = document.getElementsByClassName('delivery-modal')
            if(getDirectionsBtn[0]) {
              getDirectionsBtn[0].addEventListener('click', function() {
                getDirectionsLLP($scope.location.store_info.corporate_id)
              })
            }
            if(deliveryModal[0]) {
              deliveryModal[0].addEventListener('click', function() {
                deliveryModalLLP($scope.location.store_info.corporate_id)
              })
            }
          }
        }

      }
})();

(function() {
    'use strict';

    angular
        .module('storeLocator')
        .directive('storeDetails', storeDetails);

    function storeDetails(CLIENT_ROUTE) {
        return {
            templateUrl: 'app/custom/clients/cricketwireless/directives/storeDetails.directive.html',
            restrict: 'E',
            replace: true,
            controller: storeDetailsController,
            controllerAs: 'storeDetailsCtrl',
            bindToController: {
                location: '='
            }
        };

        function storeDetailsController(customFieldFactory, mapService) {
            var $ctrl = this;
            $ctrl.client_route = CLIENT_ROUTE;

            $ctrl.location.products = [];
            var products = customFieldFactory.getValueByName($ctrl.location.entire_location.custom_fields, 'c_products');
            if (products) {
                products.split(",").forEach(function (product) {
                    $ctrl.location.products.push(product);
                });
            }

            $ctrl.hideLocationDetails = function(location_number) {
                $ctrl.location.detailsOpen = false;
                mapService.scrollToItem($ctrl.location.id);
                var showDesktop = document.getElementsByClassName('clearfix show-desktop')[location_number - 1]
                setTimeout(function(){
                    showDesktop.focus()
                })
            };

            $ctrl.showDetails = function(location_number) {
                var locationDetails = document.getElementsByClassName('location-details')[location_number - 1]
                setTimeout(function() {
                    locationDetails.focus()
                }, 0)
                
            }
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('listHoursCard', listHoursCard);

  function listHoursCard() {
    return {
      replace: true,
      scope: {
        location: '=',
        onlyToday: '=',
        customText: '@'
      },
      templateUrl: 'app/custom/clients/arvestbank/directives/listHoursCard.directive.html',
      restrict: 'AE',
      controller: ListHoursController,
      controllerAs: 'listHoursCardCtrl',
      bindToController: true
    };
  }

  function ListHoursController(_, s, moment) {
    var listHoursCardCtrl = this;
    listHoursCardCtrl.closedNow = true;
    listHoursCardCtrl.open24 = false;
    listHoursCardCtrl.tempClosed = false;
    listHoursCardCtrl.openingHours = '';

    // if temp closed, set listHoursCardCtrl.tempClosed
    if(listHoursCardCtrl.location.status == "temp closed") {
      listHoursCardCtrl.tempClosed = true;
    }

    // returns the hour fragment for the day depending on the passed key value
    listHoursCardCtrl.getOpenTimePeriodDisplayMessage = function(regularHours, index) {
      var key = '';
      if (angular.isDefined(index)) {
        key = 'openTimePeriodDisplayMessage_' + index;
      } else {
        key = 'openTimePeriodDisplayMessage';
      }
      return regularHours[key];
    };

    /**
     * function returns true if passed value is null, undefined and legth is zero, else false
     * @param {string} storeTimeZone
     */
    function checkObj(storeTimeZone) {
      return ( _.isNull(storeTimeZone) || _.isUndefined(storeTimeZone) || storeTimeZone.length === 0 )
    }

    /**
     * function to check if the store is open or closed and set
     * the corresponding 'closedNow' value on the directive object
     * @param {object} hourObj hour object which has all the details about the timings/days
     */
    function updateTodaysHours(hourObj) {
      if (hourObj.closed) {
        listHoursCardCtrl.closed24 = true;
        return;
      }
      // check for today's special hours. start
      var isTodaySpecial = isTodaySpecialHours();
      //check for today's special hours. end
      //counter to loop through the number of fragments
      var counter = 0;
      while (counter < hourObj.numberOfTimeFragments.length) {
        var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
        var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;

        if (hourObj[openTimePeriodKey] && hourObj[closeTimePeriodKey]) {
          listHoursCardCtrl[openTimePeriodKey] = moment(hourObj[openTimePeriodKey], "hh:mm A").format("h:mm a")
          listHoursCardCtrl[closeTimePeriodKey] = moment(hourObj[closeTimePeriodKey], "hh:mm A").format("h:mm a");
        }

        if (moment(hourObj[closeTimePeriodKey], "hh:mm A").isBefore(moment(hourObj[openTimePeriodKey], "hh:mm A")) || moment(hourObj[closeTimePeriodKey], "HH:mm A").format('HHmm') === '0000') {
          hourObj[closeTimePeriodKey] = moment(hourObj[closeTimePeriodKey], "hh:mm A").add(1, 'days');
        }

        var amIBetweenGroupKey = 'amIBetweenGroup' + '_' + counter;
        var now = moment();
        // store timezone code start
        var storeTimeZone = listHoursCardCtrl.location.store_info.timezone; // store timezone from api
        var storeCurrentDateTime = null;
        var convertedStoreHour = null;
        var isInvalidObj = checkObj(storeTimeZone);
        if (!isInvalidObj) {
          storeCurrentDateTime = getStoreCurrentTime(storeTimeZone);
          convertedStoreHour = moment(getConvertedStoreHours(storeCurrentDateTime), "hh:mm A");
        }
        // store timezone code end
        // instead of now object the comparison is made with convertedStoreHour object
        var startTime = moment(hourObj[openTimePeriodKey], "hh:mm A");
        var endTime = moment(hourObj[closeTimePeriodKey], "hh:mm A");
        if(!isInvalidObj){
          if (endTime.format('HHmm') < (startTime.format('HHmm'))) {
            if (convertedStoreHour.format('HHmm') < endTime.format('HHmm')) {
              startTime = startTime.subtract(1, 'days');
            } else {
              endTime = endTime.add(1, 'days');
            }
          }
          amIBetweenGroupKey = convertedStoreHour.isBetween(startTime, endTime);
        } else {
          if (endTime.format('HHmm') < (startTime.format('HHmm'))) {
            if (now.format('HHmm') < endTime.format('HHmm')) {
              startTime = startTime.subtract(1, 'days');
            } else {
              endTime = endTime.add(1, 'days');
            }
          }
          amIBetweenGroupKey = now.isBetween(startTime, endTime);
        }

        if (amIBetweenGroupKey) {
          listHoursCardCtrl.closeToday = endTime.format("h:mm a");
          if (amIBetweenGroupKey || hourObj.open24) {
            listHoursCardCtrl.closedNow = false;
          } else {
            listHoursCardCtrl.closedNow = true;
          }
        } else if(isTodaySpecial && !amIBetweenGroupKey){
          listHoursCardCtrl.closeToday = endTime.format("h:mm a");
          listHoursCardCtrl.closedNow = true;
        }
        counter++;
      }

      listHoursCardCtrl.openToday = hourObj.openDisplayTime;
      listHoursCardCtrl.open24 = hourObj.open24;
    }

    function isTodaySpecialHours(){
      var isTodaySpecial = false;
      var specialHours = (listHoursCardCtrl.location &&
        listHoursCardCtrl.location.store_info &&
        listHoursCardCtrl.location.store_info.special_hours) ?
        s(listHoursCardCtrl.location.store_info.special_hours).trim(";").value() : null;

      if (specialHours !== null) {
        // Check if any special hours are coming up.
        var validSpHours = checkSpecialHours(specialHours);
        if (!_.isEmpty(validSpHours)) {
          isTodaySpecial=true;
        }
      }
      return isTodaySpecial;
    }

    function parseDateStrings(dateStrs) {
      var intDateStrs = dateStrs.split(";");
      return _.map(intDateStrs, function(dateStr) {
        var info = dateStr.split(",");
        if (angular.isDefined(info[1]) && info[1].toUpperCase() === "CLOSED") {
          // return just the day. This way we can use it to determine if today == which hour obj.
          return {
            day: info[0]
          };
        }
        else {
          // Else add open and close times based on the strings.
          // Will moment parse these to more readable strings later.
          return {
            day: info[0],
            openTime: info[1],
            closeTime: info[2]
          };
        }
      });
    }

    /**
     * function generates hours object for each day
     * @param {string} dateStrs open and close times for the week
     * @param {string} closeLabel close label for the location
     */
    function generateHours(dateStrs, closeLabel, isFromCustom) {
      // Split up the dateStrs and generate objects for each one
      var parsedDateStrs = parseDateStrings(dateStrs);
      var locHours = {};
      _.range(1, 8).forEach(function(day) {
        // Generate base objects per day
        var newHoursObj = {
          day: day.toString(),
          dayName: moment().isoWeekday(day).format("dddd"),
          dayNameShort: moment().isoWeekday(day).format("dd"),
          dayNameShortNext: moment().isoWeekday(day).add(1, 'd').format("dd"),
          closedLabel: closeLabel
        };
        // filter method gets all the matching objects for a certain day of the week
        var parsedData = _.filter(parsedDateStrs, function(obj) {
          return obj['day'] === day.toString();
        });

        // all the open and close time for the store location in an array
        var openTime = _.map(parsedData, 'openTime');
        var closeTime = _.map(parsedData, 'closeTime');
        // adding the values to the object we will need to display all the times
        // and proper messaging for the store hours
        parsedData = {};
        _.forEach(openTime, function(value, key) {
          //moment js doesn't recognize 2400 hrs
          if (closeTime[key] === '2400') {
            closeTime[key] = '0000';
          }
          parsedData['openTime' + 'PeriodDisplayMessage' + '_' + key] = displayOpenAndClosedTime(openTime[key], closeTime[key]);
          parsedData['openTime' + 'Period' + '_' + key] = openTime[key] ? moment(openTime[key],"hmm").format("hh:mm A") : "";
          parsedData['closeTime' + 'Period' + '_' + key] = closeTime[key] ? moment(closeTime[key],"hmm").format("hh:mm A") : "";
          parsedData['openTime'] = openTime[0];
          parsedData['closeTime'] = closeTime[0];
          parsedData['numberOfTimeFragments'] = new Array(_.keys(openTime).length);
        });

        //we need the numberOfTimeFragments to display the correct message when clients pass empty store hours for the day
        if (openTime.length === 0) {
          parsedData['numberOfTimeFragments'] = new Array(1);
        }

        _.assign(newHoursObj, parsedData);
        locHours[day] = createHoursObj(newHoursObj);
        // Check if Today. If so, apply highlighting and modify
        // some controller level variables in a separate function.
        if (day.toString() === moment().format("E")) {
          locHours[day].highlightClass = "bold-700";
          //initialize the open and close time empty arrays
          openTime = [];
          closeTime = [];
          var counter = 0;
          while (counter < locHours[day]['numberOfTimeFragments'].length) {
            var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
            var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;
            if (locHours[day][openTimePeriodKey] && locHours[day][openTimePeriodKey].length > 0 && locHours[day][closeTimePeriodKey].length > 0) {
              openTime.push(locHours[day][openTimePeriodKey]);
              closeTime.push(locHours[day][closeTimePeriodKey]);
            }
            counter++;
          }

          // when the location does not have hours for the day we
          // assume that it is closed
          if (openTime.length > 0 && closeTime.length > 0) {
            locHours[day].openTimePeriodDisplayMessage = isTheLocationOpen(openTime, closeTime);
          } else {
            locHours[day].closed = true;
          }
          if (!isFromCustom) {
            updateTodaysHours(locHours[day]);
          }
        }
      });

      return locHours;
    }

    /**
     * function generates the display time message for the different
     * periods/times for which the store is open
     * @param {string} openTime open time for the store
     * @param {string} closeTime close time for the store
     */
    function displayOpenAndClosedTime(openTime, closeTime) {
      var displayTime = "";
      if (openTime && closeTime) {
        displayTime = moment(openTime, "hmm").format("h:mm a") + " " + "-" + " " + moment(closeTime, "hmm").format("h:mm a");
      }
      return displayTime;
    }

    /**
     * function is used to get the current time in the store timezone
     * @param {string} actualStoreTimeZone
     */
    function getStoreCurrentTime(actualStoreTimeZone){
      var currentStoreDateTime = null;
      var isInvalidObj = checkObj(actualStoreTimeZone);
      if (!isInvalidObj) {
        currentStoreDateTime = angular.isDefined((moment.tz.zone(actualStoreTimeZone))) ? moment.tz(actualStoreTimeZone).format('YYYY-MM-DD hh:mm A') : moment().format('YYYY-MM-DD hh:mm A');//
      }
      return currentStoreDateTime;
    }

    /**
     * function is used to get the time part from the converted store timezone
     * @param {moment} storeCurrentDateTime
     */
    function getConvertedStoreHours(storeCurrentDateTime){
      var convertedStoreHours = null;
      var currTimeArr = storeCurrentDateTime.split(" ");
      var isInvalidObj = checkObj(currTimeArr);
      if (!isInvalidObj){
        var isInvalidObj1 = checkObj(currTimeArr[1]);
        if(!isInvalidObj1 && currTimeArr.length > 1){
          convertedStoreHours = currTimeArr[1].trim().concat(" ").concat(currTimeArr[2].trim()) ;
        }
      }
      return convertedStoreHours;
    }

    /**
     * function is used to generate the appropriate messaging for the
     * current day including store open/close times.
     * @param {array} openTime open time for the store for the current day
     * @param {array} closeTime close time for the store for the current day
     */
    function isTheLocationOpen(openTime, closeTime) {
      var amIBetweenFirstGroup = false;
      var amIBetweenSecondGroup = false;
      var amIBetweenThirdGroup = false;
      var storeOpenOrCloseMessage = '';
      var currentTime = moment();
      var displayMessage = '';
      var startTimeFirstGroup = openTime[0] ? moment(openTime[0].trim(), "HH:mm A") : "Closed Today";
      var endTimeFirstGroup = closeTime[0] ? moment(closeTime[0].trim(), "HH:mm A") : "Closed Today";

      var openTwentyFourHours = false;
      // store timezone code start
      var storeTimeZone = listHoursCardCtrl.location.store_info.timezone; // store timezone from api
      var storeCurrentDateTime = null;
      var convertedLocStoreHour = null;
      var isInvalidObj = checkObj(storeTimeZone);
      if (!isInvalidObj) {
        storeCurrentDateTime = getStoreCurrentTime(storeTimeZone);
        convertedLocStoreHour = moment(getConvertedStoreHours(storeCurrentDateTime), "hh:mm A");
      } else {
        convertedLocStoreHour = currentTime;
      }
      // store timezone code end

      if (openTime.length === 2) {
        var startTimeSecondGroup = moment(openTime[1], "HH:mm A");
        var endTimeSecondGroup = moment(closeTime[1], "HH:mm A");
      } else if (openTime.length === 3) {
        var startTimeThirdGroup = moment(openTime[2], "HH:mm A");
        var endTimeThirdGroup = moment(closeTime[2], "HH:mm A");
        startTimeSecondGroup = moment(openTime[1], "HH:mm A");
        endTimeSecondGroup = moment(closeTime[1], "HH:mm A");
      }
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      // check if the close time is on the next date in the A.M.
      if (endTimeFirstGroup.format('HHmm') < (startTimeFirstGroup.format('HHmm')) || moment(closeTime[0], "HH:mm A").format('HHmm') === '0000') {
        //open 24 message if the store is open for 24hrs
        if (endTimeFirstGroup.format('HHmm') - (startTimeFirstGroup.format('HHmm')) === 0) {
          openTwentyFourHours = true;
        }
        // Check the user currentime is before shop close time then subtract 1 day from start date
        // as the shop has started in previous day
        // else add 1 day to end date as the shop will be closing on next day
        if (convertedLocStoreHour.format('HHmm') < (endTimeFirstGroup.format('HHmm'))) {
          startTimeFirstGroup = startTimeFirstGroup.subtract(1, 'days');
        } else {
          endTimeFirstGroup = endTimeFirstGroup.add(1, 'days');
        }
      }
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      if (openTime.length === 2 && closeTime.length === 2) {
        // check if the close time is on the next date in the A.M.
        if (endTimeSecondGroup.isBefore(startTimeSecondGroup) || moment(closeTime[1], "HH:mm A").format('HHmm') === '0000') {
          endTimeSecondGroup = endTimeFirstGroup.add(1, 'days');
        }
        displayMessage = moment(openTime[0], "hh:mm A").format("h:mm a") + ' - '  + moment(closeTime[0], "hh:mm A").format("h:mm a") + ', ' +
          moment(openTime[1], "hh:mm A").format("h:mm a") + ' - ' + moment(closeTime[1], "hh:mm A").format("h:mm a");
        // instead of currentTime object the comparison is made with convertedLocStoreHour object
        if (!isInvalidObj) {
          amIBetweenFirstGroup = convertedLocStoreHour.isBetween(startTimeFirstGroup, endTimeFirstGroup);
          amIBetweenSecondGroup = convertedLocStoreHour.isBetween(startTimeSecondGroup, endTimeSecondGroup);
        } else {
          // earlier implementation
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
          amIBetweenSecondGroup = currentTime.isBetween(startTimeSecondGroup, endTimeSecondGroup);
        }

        if (amIBetweenFirstGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[0], "hh:mm A").format("h:mm a") + ', ' + displayMessage;
        } else if (amIBetweenSecondGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[1], "hh:mm A").format("h:mm a") + ', ' + displayMessage;
        } else {
          storeOpenOrCloseMessage = "Closed Now. Today's Hours: " + displayMessage;
        }
      } else if (openTime.length === 3 && closeTime.length === 3) {
        // if there are three fragments for store hours
        // check if the second fragment close time is on the next date in the A.M.
        if (endTimeSecondGroup.isBefore(startTimeSecondGroup) || moment(closeTime[1], "HH:mm A").format('HHmm') === '0000') {
          endTimeSecondGroup = endTimeFirstGroup.add(1, 'days');
        }
        // check if the third fragment close time is on the next date in the A.M.
        if (endTimeThirdGroup.isBefore(startTimeThirdGroup) || moment(closeTime[2], "HH:mm A").format('HHmm') === '0000') {
          endTimeThirdGroup = endTimeSecondGroup.add(1, 'days');
        }
        displayMessage = moment(openTime[0], "hh:mm A").format("h:mm a") + ' - ' + moment(closeTime[0], "hh:mm A").format("h:mm a") + ', ' +
          moment(openTime[1], "hh:mm A").format("h:mm a") + ' - ' + moment(closeTime[1], "hh:mm A").format("h:mm a") + ', ' +
          moment(openTime[2], "hh:mm A").format("h:mm a") + ' - ' + moment(closeTime[2], "hh:mm A").format("h:mm a");

        // time fragment flags
        // instead of currentTime object the comparison is made with convertedLocStoreHour object
        if (!isInvalidObj) {
          amIBetweenFirstGroup = convertedLocStoreHour.isBetween(startTimeFirstGroup, endTimeFirstGroup); // currentTime is replaced with convertedStoreHrs
          amIBetweenSecondGroup = convertedLocStoreHour.isBetween(startTimeSecondGroup, endTimeSecondGroup); // currentTime is replaced with convertedStoreHrs
          amIBetweenThirdGroup = convertedLocStoreHour.isBetween(startTimeThirdGroup, endTimeThirdGroup); // currentTime is replaced with convertedStoreHrs
        } else {
          // earlier implementation
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup); // currentTime is replaced with convertedStoreHrs
          amIBetweenSecondGroup = currentTime.isBetween(startTimeSecondGroup, endTimeSecondGroup); // currentTime is replaced with convertedStoreHrs
          amIBetweenThirdGroup = currentTime.isBetween(startTimeThirdGroup, endTimeThirdGroup); // currentTime is replaced with convertedStoreHrs
        }
        if (amIBetweenFirstGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[0], "hh:mm A").format("h:mm a") + ', ' + displayMessage;
        } else if (amIBetweenSecondGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[1], "hh:mm A").format("h:mm a") + ', ' + displayMessage;

        } else if (amIBetweenThirdGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[2], "hh:mm A").format("h:mm a") + ', ' + displayMessage;
        } else {
          storeOpenOrCloseMessage = "Closed Now. Today's Hours: " + displayMessage;
        }
      } else {
        // below line is commented to implement the store timezone changes
        //amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
        // instead of currentTime object the comparison is made with convertedLocStoreHour object
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        if (!isInvalidObj) {
          /* if (endTimeFirstGroup.format('HHmm') < (startTimeFirstGroup.format('HHmm')) || moment(closeTime[0], "HH:mm A").format('HHmm') === '0000') {
            //open 24 message if the store is open for 24hrs
            if (endTimeFirstGroup.format('HHmm') - (startTimeFirstGroup.format('HHmm')) === 0) {
              openTwentyFourHours = true;
            }
            // Check the user currentime is before shop close time then subtract 1 day from start date
            // as the shop has started in previous day
            // else add 1 day to end date as the shop will be closing on next day
            if (convertedLocStoreHour.format('HHmm') < (endTimeFirstGroup.format('HHmm'))) {
              startTimeFirstGroup = startTimeFirstGroup.subtract(1, 'days');
            } else {
              endTimeFirstGroup = endTimeFirstGroup.add(1, 'days');
            }
          } */
          amIBetweenFirstGroup = convertedLocStoreHour.isBetween(startTimeFirstGroup, endTimeFirstGroup);
        } else { // in case if timezone is not populated in timezone variable then it should display as earlier
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
        }
        if (openTwentyFourHours) {
          storeOpenOrCloseMessage = 'Open 24 Hours';
        } else {
          if (amIBetweenFirstGroup) {
            storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[0], "hh:mm A").format("h:mm a");
          } else {
            storeOpenOrCloseMessage = "Closed Now. Today's Hours: " + moment(openTime[0], "hh:mm A").format("h:mm a") + ' - ' + moment(closeTime[0], "hh:mm A").format("h:mm a");
          }
        }
      }
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      return storeOpenOrCloseMessage;
    }

    function generateSpecialHours(dateStrs) {
      // Split up the dateStrs and generate objects for each one
      var parsedDateStrs = parseDateStrings(dateStrs);
      var dates = _.uniq(_.map(parsedDateStrs, 'day'));
      var spHours = [];

      _.forEach(dates, function(date) {
        // Generate base objects per day
        var newHoursObj = {
          closedLabel: "Closed",
          dayNameShort: date,
          dayOfTheWeek: moment(date, "YYYY-MM-DD").format("E")
        };

        var parsedData = _.filter(parsedDateStrs, function(obj) {
          return obj['day'] === date.toString();
        });

        // all the open and close time for the store location in an array
        var openTime = _.map(parsedData, 'openTime');
        var closeTime = _.map(parsedData, 'closeTime');
        parsedData = {};
        _.forEach(openTime, function(value, key) {
          //moment js doesn't recognize 2400 hrs
          if (angular.isDefined(value)) {
            if (closeTime[key] === '2400') {
              closeTime[key] = '0000';
            }
            parsedData['openTime' + 'PeriodDisplayMessage' + '_' + key] = displayOpenAndClosedTime(openTime[key], closeTime[key]);
            parsedData['openTime' + 'Period' + '_' + key] = openTime[key] ? moment(openTime[key],"hmm").format("hh:mm A") : "";
            parsedData['closeTime' + 'Period' + '_' + key] = closeTime[key] ? moment(closeTime[key],"hmm").format("hh:mm A") : "";
            parsedData['openTime'] = openTime[0];
            parsedData['closeTime'] = closeTime[0];
            parsedData['numberOfTimeFragments'] = new Array(_.keys(openTime).length);
          } else {
            //we need the numberOfTimeFragments to display the correct message for the store hours in the directive.html
            parsedData['numberOfTimeFragments'] = new Array(_.keys(openTime).length);
          }
        });

        _.assign(newHoursObj, parsedData);
        var completeHoursObj = createHoursObj(newHoursObj);
        if(completeHoursObj.dayNameShort === moment().format("YYYY-MM-DD")) {
          completeHoursObj.highlightClass = "bold-700";

          //initialize the open and close time empty arrays
          openTime = [];
          closeTime = [];
          var counter = 0;
          while (counter < completeHoursObj['numberOfTimeFragments'].length) {
            var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
            var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;
            if (completeHoursObj[openTimePeriodKey] && completeHoursObj[openTimePeriodKey].length > 0 && completeHoursObj[closeTimePeriodKey].length > 0) {
              openTime.push(completeHoursObj[openTimePeriodKey]);
              closeTime.push(completeHoursObj[closeTimePeriodKey]);
            }
            counter++;
          }

          // Remove all highlighting on regular hours
          _.forEach(listHoursCardCtrl.locHours, function (hourObj) {
            hourObj.highlightClass = "";
          });

          if (openTime.length > 0) {
            completeHoursObj.openTimePeriodDisplayMessage = isTheLocationOpen(openTime, closeTime);
          }
          updateTodaysHours(completeHoursObj);
        }
        spHours.push(completeHoursObj);
      });

      return spHours;
    }

    /* Things I removed:
     * location.status === 'coming soon' moving to directive.html
     */
    function createHoursObj(hourObj) {
      if (listHoursCardCtrl.location.status == "temp closed") {
        return _.assign(hourObj, {"closed": true, "closedLabel": "Temporarily Closed"})
      }
      if (!hourObj.hasOwnProperty("openTime")) {
        return _.assign(hourObj, {"closed": true});
      }
      hourObj.openTime = moment(hourObj.openTime, "HHmm");
      // If close is earlier than openM, then add 1 day to it
      hourObj.closeTime = moment(hourObj.closeTime, "HHmm");
      if (hourObj.closeTime.diff(hourObj.openTime) < 0) {
        hourObj.closeTime.add(1, 'd');
      }

      // Convenience vars so we only need to format or call moment on these once
      hourObj.openDisplayTime = hourObj.openTime.format("h:mm a");
      hourObj.closeDisplayTime = hourObj.closeTime.format("h:mm a");
      // Check if open 24/7 by comparing if diff of open and close time is 0
      hourObj.open24 = hourObj.openTime.diff(hourObj.closeTime) === 0;

      // Augment openingHours on controller
      listHoursCardCtrl.openingHours = listHoursCardCtrl.openingHours +
        hourObj.dayNameShort +
        ' ' +
        hourObj.openDisplayTime +
        ' - ' +
        hourObj.closeDisplayTime +
        ' ';

      return hourObj;
    }

    // Takes a datestring and checks if any special days are within 7 days of today
    // Return a list of dates + times that are within 7 days of today
    function checkSpecialHours(dates) {
      //For each date with special hours
      var intNearbyDates = _.filter(dates.trim().split(";"), function(el){
        return angular.isDefined(el) && el!=="";
      });

      var nearbyDates = _.map(intNearbyDates, function(specialDay) {
        //Split on the entry
        var dayData = specialDay.split(",");
        //Check today - specialDay < 7, if matched, return this date!
        var specialDateMoment = moment(dayData[0], "YYYY-M-D");
        var today = moment();
        if (specialDateMoment.diff(today, "days") < 7 &&
          specialDateMoment.diff(today, "days") >= 0) {
          return specialDay;
        }
      });
      return _.compact(nearbyDates).join(";");
    }
    if(listHoursCardCtrl.location.status == "coming soon"){
      listHoursCardCtrl.comingSoon = "Coming Soon"

    }
    else if (listHoursCardCtrl.location.status == "temp closed"){
      listHoursCardCtrl.comingSoon = "Temporarily Closed"
    }

    // If there's custom text, set it.
    if (listHoursCardCtrl.customText) {
      var str = listHoursCardCtrl.customText;
      str = str.replace(/\[(.*?[^.])\]/g, function (s, key) {
        return listHoursCardCtrl[key];
      });
      listHoursCardCtrl.customTextShow = str;
    }

    var checkHoursFormat = /^[0-9;,closedCLOSED]+$/;

    var sh = listHoursCardCtrl.location && listHoursCardCtrl.location.store_info ? s(listHoursCardCtrl.location.store_info.store_hours).trim(";").value() : null;
    // Replace anything that isn't number, ';', ',', or the letters c, l, o, s, e, d in their lower and capital forms
    sh = sh.replace(/[^0-9;,closedCLOSED]/g,'');
    sh = sh.trim();

    var h_itm = listHoursCardCtrl.location ? _.find(listHoursCardCtrl.location.custom_fields, {'name': 'hours_itm'}) : null;
    var h_drive = listHoursCardCtrl.location ? _.find(listHoursCardCtrl.location.custom_fields, {'name': 'hours_additional'}) : null;
    if (h_itm) {
      generateCustomHours('hoursItm', h_itm.data);
    }
    if (h_drive) {
      generateCustomHours('hoursDrive', h_drive.data);
    }

    function generateCustomHours(type, data) {
      var currentStoreTime = moment(getStoreCurrentTime(listHoursCardCtrl.location.store_info.timezone), 'MM-DD-YYYY hh:mm A');
      var formattedStoreTime = '' + currentStoreTime.hour() + currentStoreTime.minute();

      listHoursCardCtrl[type] = generateHours(data, "Closed", true);
      listHoursCardCtrl[type + 'Today'] = listHoursCardCtrl[type][moment().day()];
      listHoursCardCtrl[type + 'OpenNow'] = listHoursCardCtrl[type + 'Today'].openTime._i > formattedStoreTime < listHoursCardCtrl[type + 'Today'].closeTime._i;
    }

    // Check if there are store hours listed. If not, show all days as "Closed"
    if (listHoursCardCtrl.location.store_info.store_hours == '') {
      listHoursCardCtrl.locHours = generateHours(sh, "Closed", false);
    }

    // Check if store is coming soon, if so, init all days to coming soon
    if (listHoursCardCtrl.location.status == "coming soon") {
      listHoursCardCtrl.locHours = generateHours(sh, "Coming Soon", false);
    }

    // Check if time returned is valid
    if (sh && checkHoursFormat.test(sh)) {
      listHoursCardCtrl.locHours = generateHours(sh, "Closed", false);
    }

    // Check for special hours
    var specialHours = (listHoursCardCtrl.location &&
      listHoursCardCtrl.location.store_info &&
      listHoursCardCtrl.location.store_info.special_hours) ?
      s(listHoursCardCtrl.location.store_info.special_hours).trim(";").value() : null;
    //specialHours = '2018-12-24,0000,1800;2018-12-25,CLOSED;2018-12-31,0000,2200;2019-01-01,0600,0000;2019-05-15,CLOSED';

    if (specialHours !== null) {
      // Check if any special hours are coming up.
      var validSpHours = checkSpecialHours(specialHours);
      if (!_.isEmpty(validSpHours)) {
        // For each special day, format it for display like normal hours.
        listHoursCardCtrl.specialHours = generateSpecialHours(validSpHours);
      }
    }
    listHoursCardCtrl.hoursNote = _.find(listHoursCardCtrl.location.custom_fields, {'name': 'hours_note'});
  }

})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .controller('templateController', templateController);

  function templateController(customFieldFactory, socialMediaService, $sce, $window, $scope, HAM_NAV_DATA, HAM_NAV_TOGGLE) {
    var vm = this;
    vm.currentDate = new Date();
    vm.hasYelp = hasYelp;
    vm.hasFoursquare = hasFoursquare;
    vm.getCustomFieldValueByName = getCustomFieldValueByName;
    vm.hasCustomFieldValue = hasCustomFieldValue;
    vm.getCustomButtonCount = getCustomButtonCount;
    vm.getCustomImageCount = getCustomImageCount;
    vm.openNav = openNav;
    vm.closeNav = closeNav;
    vm.baseUrl = $window.location.href;
    vm.hamNavData = HAM_NAV_DATA;
    vm.hamNavToggle = HAM_NAV_TOGGLE;

    function hasYelp(data) {
      var yelp = socialMediaService.storeHasYelp(data);
      return yelp;
    }

    function hasFoursquare(data) {
      var foursquare = socialMediaService.storeHasFoursquare(data);
      return foursquare;
    }

    function getCustomButtonCount(customFields) {
      return customFieldFactory.getButtonCount(customFields);
    }

    function getCustomImageCount(customFields) {
      return customFieldFactory.getImageCount(customFields);
    }

    function getCustomFieldValueByName(customFields, name) {
      var value = customFieldFactory.getValueByName(customFields, name);
      return $sce.trustAsHtml(value);
    }

    function hasCustomFieldValue(customFields, name) {
      return customFieldFactory.getValueByName(customFields, name) ? true : false;
    }

    //Fix for svg href from header
    $scope.$on('$locationChangeStart', function (event, next, current) {
      if (current !== next) {
        vm.baseUrl = $sce.trustAsResourceUrl(next);
      }
    });
  }

})();

// Javascript for hamburger menu
function openNav() {
  document.getElementById("sideNav").style.width = "250px";
  document.getElementById("main").style.marginRight = "250px";
  document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
}

function closeNav() {
  document.getElementById("sideNav").style.width = "0";
  document.getElementById("main").style.marginRight = "0";
  document.body.style.backgroundColor = "white";
}



(function() {
  'use strict';
  angular.module('storeLocator')
    .constant('BASE_URL', 'http://locations.losaltosranchmarket.com/')
    .constant('MULTI_ACCOUNT', false)
    .constant('LOCAL_LANDING_PAGE', "app/custom/clients/losaltosranchmarket/localLanding.html")
    .constant('STORE_LOCATOR', "app/storeLocator/storeLocator.html")
    .constant('STORE_LOCATOR_RESULTS_TEMPLATE', "app/custom/clients/losaltosranchmarket/templates/resultsLi.template.html")
    .constant('STORE_LOCATOR_MAP_POPUP_TEMPLATE', 'app/storeLocator/templates/mapPopup.template.html')
    .constant('STORE_LOCATOR_SEARCH_COUNTRY', 'US,CA') //Default
    .constant('STORE_LOCATOR_SEARCH_TYPE', 'postcode,region,place') //Default
    .constant('STORE_LOCATOR_ZOOM_LEVELS', '{ "initial": "7" }')
    .constant('STORE_LOCATOR_LOCATIONS_NO', 30)
    .constant('STORE_LOCATOR_LATITUDE', 33.581787)
    .constant('STORE_LOCATOR_LONGITUDE', -112.077059)
    .constant('ROOT_PAGE', "app/custom/clients/losaltosranchmarket/layout.html")
    .constant('SITE_MAP_PAGE', "app/siteMap/siteMap.html")
    .constant('CLIENT_NAME', "Los Altos Ranch Market")
    .constant("API_TOKEN", "FFRREQIBWLRAKDGX")
    .constant('INSTAGRAM_BUSINESS_ACCOUNT_ID', "17841400255711968")
    .constant('INSTAGRAM_HANDLE', "losaltosranchmarket")
    .constant("GOOGLE_ANALYTICS", "UA-109481959-19")
    .constant("GOOGLE_ANALYTICS_CLIENT", null)
    .constant("GOOGLE_TAG_MANAGER", null)
    .constant("GOOGLE_AD_WORDS", null)
    .constant("FACEBOOK_PIXEL", null)
    .constant("SIGNAL_TAG", null)
    .constant("TEALIUM_HEAD_INJECTIONS", null)
    .constant("TEALIUM_BODY_INJECTIONS", null)
    .constant("STORE_LOCATOR_PIN", "#C32032")
    .constant("STORE_LOCATOR_PIN_ICON", null)
    .constant("STORE_LOCATOR_MAP_ZOOM_ON_SCROLL", true)
    .constant("STORE_LOCATOR_FILTERS", "")
    .constant("STORE_LOCATOR_PIN_ICON_NO_NR", false)
    .constant("STORE_LOCATOR_TABS", '')
    .constant("STORE_LOCATOR_MESSAGES", null)
    .constant("SHOW_ICONS", false)
    .constant("META",
      {
        "description": "Find your nearest Los Altos Ranch Market.",
        "google-site-verification": "",
        "title": "Locations | Los Altos Ranch Market",
        "keywords": "Landing Page, Locator, Store Locator",
        "favicon": "https://s3-us-west-1.amazonaws.com/mfeed-store-locator.momentfeed.com/Los%20Altos%20Ranch%20Markets/larm-fav-icon_CardenasMarket.jpg",
        "location_finder_title": "Locations | Los Altos Ranch Market",
        "location_finder_description": "Find your nearest Los Altos Ranch Market.",
        "location_finder_keywords": ""
      })
    .constant("SHOW_LIST_DEFAULT", false) //default - mobile toggle between map/list view

    //HAMBURGER MENU CONSTANTS
    .constant("HAM_NAV_DATA", [{
      "text" : "Our Stores",
      "link" : "https://www.losaltosranchmarket.com/en-us/our-stores/",
      "sub"  : [{
        "text": "Our Departments",
        "link": "https://www.losaltosranchmarket.com/en-us/our-stores/our-departments/"
      },{
        "text": "Recipes",
        "link": "https://www.losaltosranchmarket.com/en-us/our-stores/recipes/"
      }]
    },{
      "text" : "Promotions/Weekly Ad",
      "link" : "https://www.losaltosranchmarket.com/en-us/promotions-weekly-ad/",
      "sub"  : [{
        "text": "Weekly Ad & Shopping List",
        "link": "http://weeklyads.losaltosranchmarket.com/en-us/store/south-central-ave-phoenix"
      }]
    },{
      "text" : "Catering",
      "link" : "https://www.losaltosranchmarket.com/en-us/catering/"
    },{
      "text" : "Financial Services",
      "link" : "https://www.losaltosranchmarket.com/en-us/financial-services/"
    },{
      "text" : "About Us",
      "link" : "https://www.losaltosranchmarket.com/en-us/about-us/",
      "sub"  : [{
        "text": "Los Altos Ranch Market In The News",
        "link": "https://www.losaltosranchmarket.com/en-us/about-us/los-altos-ranch-market-in-the-news/"
      },{
        "text": "Contact Us",
        "link": "https://www.losaltosranchmarket.com/en-us/about-us/contact-us/"
      },{
        "text": "Donation Requests",
        "link": "https://www.losaltosranchmarket.com/en-us/about-us/donation-requests/"
      }]
    }])
    .constant("HAM_NAV_TOGGLE", true);
})();




(function () {
    'use strict';

    angular
      .module('storeLocator')
      .service('tabsService', tabsService);

    function tabsService(STORE_LOCATOR_TABS) {
        var tabs = null;

        setTabs();

        function setTabs() {
            tabs = STORE_LOCATOR_TABS ? JSON.parse(STORE_LOCATOR_TABS) : null;
        }

        this.showTabs = function () {
            return tabs && tabs.tabs && tabs.tabs.length > 0;
        };

        this.getTabs = function () {
            return tabs.tabs;
        };

        this.getActiveTab = function () {
            var activeTab = null;
            if (tabs && tabs.tabs) {
                activeTab = _.find(tabs.tabs, function (tab) {
                    return tab.active;
                });
            }
            return activeTab;
        };

        this.setActiveTab = function (tab) {
            if (tabs && tabs.tabs) {
                _.each(tabs.tabs, function (t) {
                    if (t.type === tab.type) {
                        t.active = true;
                    } else {
                        t.active = false;
                    }
                });
            }
        };

        this.isCollapsedForMobile = function () {
            return tabs.collapseForMobile;
        };

        this.getCollapsedText = function () {
            return tabs.collapsedText;
        };
    }
})();

(function () {
    'use strict';
    angular
      .module("storeLocator")
      .service('storeLocatorCache', storeLocatorCache);

    function storeLocatorCache() {
        var storeLocator = {};

        this.save = function save(key, value) {
            storeLocator[key] = value;
        }

        this.get = function get(key) {
            return storeLocator[key];
        }

        this.clear = function clear() {
            storeLocator = {};
        }
    }
}());

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .service('markersUtils', markersUtils);

  markersUtils.$inject = [
    'MAPBOX_KEY',
    'MAPBOX_GEOCODE_URL',
    'Restangular',
    'localLandingData',
    's',
    'STORE_LOCATOR_SEARCH_COUNTRY',
    'STORE_LOCATOR_SEARCH_TYPE',
    'mapHelper',
    'geocodeService'];
  function markersUtils(MAPBOX_KEY,
    MAPBOX_GEOCODE_URL,
    Restangular,
    localLandingData,
    s,
    STORE_LOCATOR_SEARCH_COUNTRY,
    STORE_LOCATOR_SEARCH_TYPE,
    mapHelper,
    geocodeService) {

    this.getAutoCompleteLocations = function (address, latitude, longitude) {
      var url = s(MAPBOX_GEOCODE_URL).sprintf(encodeURIComponent(address)).value();
      var params = {
        "access_token": MAPBOX_KEY,
        "country": STORE_LOCATOR_SEARCH_COUNTRY,
        "types": STORE_LOCATOR_SEARCH_TYPE,
        "limit": 10
      };
      if (latitude && longitude) params.proximity = longitude + "," + latitude;

      return Restangular.oneUrl('geocode', url).get(params);
    };

    this.getLatLogFromAddress = function (address, latitude, longitude, bounds) {
      if (mapHelper.isGoogleMapsEnabled()) {
        return geocodeService.geocodeGoogle(address, bounds);
      }
      else {
        return geocodeService.geocodeMapbox(address, latitude, longitude);
      }
    };

    this.getLocation = function (center, bounds, filters, limit, type) {
      var geo_string = bounds.southWest.lat + "," + bounds.northEast.lng + "," + bounds.northEast.lat + "," + bounds.southWest.lng;
      var center_point_string = center;

      return localLandingData.getLocationsForSearch(center_point_string, geo_string, filters, limit, type);
    };

  }
})();

/**
 * Created by angie on 3/28/17.
 */
(function () {
  'use strict';

  angular
    .module('storeLocator')
    .factory('mapHelper', mapHelper);

  mapHelper.$inject = ['_', 'filtersService', 'storeLocatorDictionary', 'STORE_LOCATOR_MAP_TYPE', 'MFeedMap', 'geocodeService'];
  function mapHelper(_, filtersService, storeLocatorDictionary, STORE_LOCATOR_MAP_TYPE, MFeedMap, geocodeService) {

    return {
      geoLocationError: geoLocationError,
      setGeoStates: setGeoStates,
      setCoordinates: setCoordinates,
      setCoordinatesAndPlace: setCoordinatesAndPlace,
      setSearchCoordinates: setSearchCoordinates,
      loadList: loadList,
      setPlace: setPlace,
      isGoogleMapsEnabled: isGoogleMapsEnabled
    };

    function geoLocationError(locatorStates) {
      locatorStates.message = 'Share your location or type a location in the search box';
      locatorStates.zoom = storeLocatorDictionary.zoomLevels.initial;
      locatorStates.geoEnabled = false;
      locatorStates.geoPermission = true;
      loadList(locatorStates);
    }

    function setGeoStates(locatorStates) {
      locatorStates.message = 'Fetching your location';
      locatorStates.geoEnabled = true;
      locatorStates.geoPermission = true;
      locatorStates.isRadius = true;
    }

    function setCoordinates(position, locatorStates, mfMap, callback) {
      if (position) {
        locatorStates.current = 'Current Location';
        locatorStates.position = position;
        locatorStates.currentLocationMarker = makeLocationMarker(position);

        var mfLatLng = new MFeedMap.LatLng(position.coords);
        mfMap.setView(mfLatLng, locatorStates.zoom)
        callback();

      } else {
        locatorStates.message = 'No available coordinates. Please type a location in the search box';
      }
    }

    function setCoordinatesAndPlace(position, locatorStates, mfMap, callback) {
      if (position) {
        locatorStates.current = 'Current Location';
        locatorStates.position = position;
        locatorStates.currentLocationMarker = makeLocationMarker(position);

        geocodeService.reverseGeocodeGoogle(position.coords.latitude, position.coords.longitude).then(function (results) {
          if (results && results.length > 0) {
            var place = getPreferredPlaceMatch(results);
            setPlace(place, locatorStates, mfMap.map);
            if (typeof callback === 'function') {
              callback();
            }
          } else {
            console.log('No results found');
          }
        });

      } else {
        locatorStates.message = 'No available coordinates. Please type a location in the search box';
      }
    }



    function setSearchCoordinates(latitude, longitude, locatorStates, mfMap) {
      locatorStates.message = storeLocatorDictionary.messages.loading;

      if (latitude && longitude) {
        var mfLatLng = new MFeedMap.LatLng({ latitude: latitude, longitude: longitude });

        mfMap.setView(mfLatLng, locatorStates.zoom);

        loadList(locatorStates);
      } else {
        locatorStates.message = 'No available coordinates. Please type a location in the search box';
      }
    }

    /**
     * Sets the map's view to the latitude/longitude and zoom level.
     * @param {google.maps.places.PlaceGeometry} place Zoom level
     * @param {Object} locatorStates Locator states object
     * @param {google.maps.Map} googleMapObj Map object
     * @todo This function contains google-specific code. It should be moved to mfeed_map.service.js.
     */
    function setPlace(place, locatorStates, googleMapObj) {
      if (place.geometry) {
        locatorStates.message = storeLocatorDictionary.messages.loading;
        // Note: The fallback to locatorStates.current is necessary when navigating back to the locator via the breadcrumb on the sitemap or llp
        // since we create a fake place object that only contains the 'geometry' property when loading from the storeLocatorCache.
        locatorStates.current = place.formatted_address || place.name || locatorStates.current;
        // set viewport
        googleMapObj.fitBounds(place.geometry.viewport);
        if (locatorStates.zoom) googleMapObj.setZoom(parseInt(locatorStates.zoom));

        googleMapObj.setCenter(place.geometry.location);
        loadList(locatorStates);
      }

    }

    function loadList(locatorStates) {
      locatorStates.reloadMap = true;
      locatorStates.locations = [];
      locatorStates.isLoading = true;
      locatorStates.selectedFilters = filtersService.getSelectedFilters();
    }

    function isGoogleMapsEnabled() {
      return STORE_LOCATOR_MAP_TYPE.toLowerCase() === 'google';
    }

    function makeLocationMarker(position) {
      return {
        "type": "Feature",
        "geometry": {
          "type": "Point",
          "coordinates": [position.coords.longitude, position.coords.latitude]
        },
        "properties": {
          "icon": {
            "className": "current-location-icon",
            "iconSize": null,
            "iconPath": "/assets/images/current_location_marker.png"
          }
        }
      };
    }

    /**
     * Gets the preferred place match from a reverse geocoding result set.
     * @param {google.maps.GeocoderResult[]} results List of GeocoderResult objects returned from Google geocoding service.
     * @returns {google.maps.GeocoderResult}
     */
    function getPreferredPlaceMatch(results) {

      // Look for zipcode first
      var preferred = _.find(results, function (obj) {
        return _.contains(obj.types, 'postal_code');
      });

      // Fallback to 'incorporated city or town political entity'
      if (!preferred) {
        preferred = _.find(results, function (obj) {
          return _.contains(obj.types, 'locality');
        });
      }

      // Fallback to 'county'. Note: This may need to be adjusted for non-US locations.
      if (!preferred) {
        preferred = _.find(results, function (obj) {
          return _.contains(obj.types, 'administrative_area_level_2');
        });
      }

      // Fallback to 'neighborhood'
      if (!preferred) {
        preferred = _.find(results, function (obj) {
          return _.contains(obj.types, 'neighborhood');
        });
      }

      // Fallback to 'state'
      if (!preferred) {
        preferred = _.find(results, function (obj) {
          return _.contains(obj.types, 'administrative_area_level_1');
        });
      }

      // Fallback to the first item in the collection
      if (!preferred) {
        preferred = results[0];
      }

      return preferred;
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .service('mapService', mapService);

  function mapService(markersUtils, $document, $window, smoothScroll, STORE_LOCATOR_LATITUDE, STORE_LOCATOR_LONGITUDE, storeLocatorDictionary, STORE_LOCATOR_LOCATIONS_NO, storeLocatorCache, urlBuilderFactory) {

    //radius function used in sortMarkersByDistance
    var radius = function (lat1, lon1, lat2, lon2) {
      var radlat1 = Math.PI * lat1 / 180;
      var radlat2 = Math.PI * lat2 / 180;
      var theta = lon1 - lon2;
      var radtheta = Math.PI * theta / 180;
      var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      dist = Math.acos(dist);
      dist = dist * 180 / Math.PI;
      dist = dist * 60 * 1.1515;
      return dist
    };

    //sort the results by distance
    this.sortMarkersByDistance = function (data, mapLat, mapLng) {
      return _.sortBy(data, function (store) {
        return radius(
          store.store_info.latitude,
          store.store_info.longitude,
          mapLat,
          mapLng)
      });
    };

    //create the marker data
    this.createMarker = function (location, counter) {
      var extendedName = _.find(location.custom_fields, {'name': 'name_extended'});
      //get search bound offset for marker pin accuracy
      var newStoreLng;
      var offset = storeLocatorCache.get('offset')
      var currBounds = storeLocatorCache.get('currentBounds')

      if(offset!== undefined && storeLocatorCache.get('change')) {
        if (currBounds>180) {
          newStoreLng = parseFloat(location.store_info.longitude) + (offset * 360);
          console.log("offset: "+ offset);
        }
        else if(currBounds<-180) {
          newStoreLng = -(offset * 360) + parseFloat(location.store_info.longitude);
          console.log("neg offset: "+ offset);
        }
      }
      else{
         newStoreLng = location.store_info.longitude;
      }

      this.getDirectionsUrl = function() {
        return urlBuilderFactory.getDirectionsUrl(location.store_info);
      }

      //location object for resultsLi and mapPopup
      var ret = {
        id: location.momentfeed_venue_id,
        number: this.getLocationTag(counter),
        latitude: location.store_info.latitude,
        longitude: newStoreLng,
        distance: location.distance,
        name: location.store_info.name,
        extendedName: extendedName ? extendedName.data : '',
        address: location.store_info.address,
        region: location.store_info.region,
        description: location.description,
        address_extended: location.store_info.address_extended,
        postcode: location.store_info.postcode,
        locality: location.store_info.locality,
        phone: location.store_info.phone,
        website: location.store_info.website,
        hours: location.store_info.store_hours,
        order_url: location.store_info.order_url,
        additional_info: false,
        manager_name: location.manager_name,
        special_hours: location.store_info.special_hours,
        country: location.store_info.country,
        link: location.llp_url,
        local_landing_page: location.local_landing_page,
        icon: "/assets/images/poi_icon.png",
        directionsUrl: this.getDirectionsUrl(),
        entire_location: location
      };
      ret["id"] = location.momentfeed_venue_id;
      return ret;
    };

    //geo search of coord search
    this.searchMethod = function (locatorStates, bounds) {

      var center = STORE_LOCATOR_LATITUDE + ',' + STORE_LOCATOR_LONGITUDE;
      var type = locatorStates.activeTab ? locatorStates.activeTab.type : null;
      // set number of return locations as following order, if null move to next:
      // locatorStates.pageSize -> LOCATIONS NO -> 30
      var noOfLocations = locatorStates.pageSize ? locatorStates.pageSize :
        (STORE_LOCATOR_LOCATIONS_NO ? STORE_LOCATOR_LOCATIONS_NO : 30);

      // LLPS-433 Fix
      // This logic should probably be moved to filters.service.js though that service does not appear to currently
      // account for multiple tabs
      var useFilters = true;
      // if the locator page has tabs, only apply filters for the active tab.
      if (locatorStates.tabs) {
        useFilters = locatorStates.activeTab && locatorStates.activeTab.hasFilters;
      }
      var selectedFilters = useFilters ? locatorStates.selectedFilters : null;

      var geo_string;
      if (locatorStates.position.coords) {
        geo_string = locatorStates.position.coords.latitude + ',' + locatorStates.position.coords.longitude;
      }

      // if the user has allowed geo targeting
      if (locatorStates.geoEnabled) {
        storeLocatorCache.save('geoFlag', true);
        // if the user has moved the map around or used search input
        if (locatorStates.showSearchAreaBtn || locatorStates.searchInput || locatorStates.areaSearched) {
          geo_string = bounds.center.lat + ',' + bounds.center.lng;

          // I'm applying the same rule of line 166 when geo location is disabled
          // So we'll use the center coordinates from the search input when the user search for a specific location
          if (locatorStates.searchInput && locatorStates.searchInputData) {
            geo_string = locatorStates.searchInputData.center[1] + ',' + locatorStates.searchInputData.center[0];
          }
        }

        // we dont need to refresh list when user has the same input as last time (when back from llp)
        // however, when user drag map and click search area button, the text field will be empty, which is same
        // as last value. so we dont want to use old data
        if (storeLocatorCache.get('input') !== null && !locatorStates.showSearchAreaBtn) {
          if (storeLocatorCache.get('input') === locatorStates.searchInput) {
            if (storeLocatorCache.get('currentLocationsList' && (storeLocatorCache.get('selectedFilters') === selectedFilters))) {
              return storeLocatorCache.get('currentLocationsList');
            }
          }
        }
        storeLocatorCache.save('input', locatorStates.searchInput);
        storeLocatorCache.save('selectedFilters', selectedFilters);

        return markersUtils.getLocation(
          geo_string,
          bounds,
          selectedFilters,
          noOfLocations,
          type
        );

      } else {
        // else the user has not allowed geotargeting

        // if the user has moved the map around or used search input
        if (locatorStates.showSearchAreaBtn || locatorStates.searchInput || locatorStates.areaSearched) {
          geo_string = bounds.center.lat + ',' + bounds.center.lng;
          if (storeLocatorCache.get('input') !== null && !locatorStates.showSearchAreaBtn) {
            if (storeLocatorCache.get('input') === locatorStates.searchInput && storeLocatorCache.get('selectedFilters') === storeLocatorCache.selectedFilters) {
              if (storeLocatorCache.get('locationsList')) {
                return storeLocatorCache.get('locationsList');
              }
            }
          }
          if(locatorStates.searchInput && locatorStates.searchInputData){
            geo_string = locatorStates.searchInputData.center[1] + ',' + locatorStates.searchInputData.center[0];
          }

          // 'input' and 'selectedFilters' together determine a cached locationsList
          storeLocatorCache.save('input', locatorStates.searchInput);
          storeLocatorCache.save('selectedFilters', locatorStates.selectedFilters);

          return markersUtils.getLocation(
            geo_string,
            bounds,
            selectedFilters,
            noOfLocations,
            type
          );
        } else {
          storeLocatorCache.save('geoFlag', false);
          if (storeLocatorCache.get('locationsList') && (storeLocatorCache.get('selectedFilters') === selectedFilters)) {
            return storeLocatorCache.get('locationsList');
          }
          else {
            // 'input' and 'selectedFilters' together determine a cached locationsList
            storeLocatorCache.save('input', locatorStates.searchInput);
            storeLocatorCache.save('selectedFilters', selectedFilters);
            return markersUtils.getLocation(
              center,
              bounds,
              selectedFilters,
              noOfLocations,
              type
            );
          }
        }
      }
    };

    //scroll to results item from map
    this.scrollToItem = function (locationId) {
      var element = document.getElementById(locationId);
      //set active on li
      var activeRemove = $document.find('.location-li.active')[0];
      if (activeRemove) activeRemove.classList.remove('active');
      $document.find('#' + locationId)[0].classList.add('active');

      //scroll to
      if ($window.location.href.indexOf('visionworks') > -1) {
        options = {
          duration: 700,
          easing: 'easeInQuad',
          offset: 575,
          containerId: 'js-results'
        };
        return smoothScroll(element, options);

      } else {
        var options = {
          duration: 700,
          easing: 'easeInQuad',
          offset: 380,
          containerId: 'js-results'
        };
        return smoothScroll(element, options);

      }
    };

    this.getLocationTag = function (number) {
      var pinUseLetters = storeLocatorDictionary.mapConfigs.pinUseLetters;

      if (Boolean(pinUseLetters)) {
        return this.convertNumberToLetter(number);
      } 

      return number;
    }

    // Example:
    // 1 => A | 26 =>  Z | 27 =>  AA | 28 => AB
    this.convertNumberToLetter = function (number) {
      var letter = '';
      var remainder;
      
      while (number > 0) {
          remainder = (number - 1) % 26;
          letter = String.fromCharCode(65 + remainder) + letter;
          number = (number - remainder)/26 | 0;
      }
      return letter || undefined;
    }

    // set current location marker.
    // Note: This is only used by CricketWireless. See setCurrentLocationMarker() in mfeed_map.service.js
    this.setCurrentLocationMarker = function (locatorStates, map) {
      var currentLocationLayer = L.mapbox.featureLayer().addTo(map);

      currentLocationLayer.on('layeradd', function (e) {
        var marker = e.layer,
          feature = marker.feature;
        marker.setIcon(L.divIcon(feature.properties.icon));
      });

      return currentLocationLayer.setGeoJSON(locatorStates.currentLocationMarker);
    };

    //show new tab pins
    this.showNewMarkers = function (locatorStates, mfMap) {
      return mfMap.map.addLayer(locatorStates.locationMarkers);
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .service('filtersService', filtersService);

  function filtersService(STORE_LOCATOR_FILTERS) {
      var filters = null,
          filterTypes = null,
          selectedFilters = [];

      setFilters();

      this.hasFilters = function () {
          return filters !== null;
      };

      this.getFilterTypes = function() {
          return filterTypes;
      }
      this.getFilters = function () {
          return filters;
      };

      this.getSelectedFilters = function () {
          return selectedFilters.join(',');
      };

      this.addFilter = function (filter) {
          selectedFilters = [];
          _.forEach(filters, function (f) {
              if (f.label === filter) {
                  f.active = !f.active;
              }
              if (f.active) {
                  selectedFilters.push(f.value);
              }
          });
      };

      function setFilters() {
          if (STORE_LOCATOR_FILTERS && STORE_LOCATOR_FILTERS !== "") {
              filters = JSON.parse(STORE_LOCATOR_FILTERS);
              filterTypes = _.uniq(_.pluck(filters, "type"));
              _.forEach(filters, function (f) {
                  if (f.active) {
                      selectedFilters.push(f.value);
                  }
              });
          }
      }
  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('tabs', tabs);

  function tabs() {
    return {
      templateUrl: 'app/storeLocator/directives/tabs.directive.html',
      restrict: 'E',
      scope: {},
      controller: tabsController,
      controllerAs: 'tabsCtrl',
      bindToController: {
          locatorStates: '=',
          mapObj: '='
      }
    };

    function tabsController(tabsService) {
        var $ctrl = this;

        $ctrl.collapseForMobile = tabsService.isCollapsedForMobile();
        $ctrl.collapse = $ctrl.collapseForMobile;
        $ctrl.collapsedText = tabsService.getCollapsedText();

        $ctrl.loadData =  function(tab) {
            $ctrl.locatorStates.activeTab = tab;
            tabsService.setActiveTab(tab);
            $ctrl.locatorStates.reloadMap = true;
        }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('search', search);

  function search() {
    return {
      templateUrl: 'app/storeLocator/directives/search.directive.html',
      restrict: 'E',
      scope: {
        isGoogleMapsApiLoaded: '='
      },
      controller: searchController,
      controllerAs: 'searchCtrl',
      bindToController: {
        locatorStates: '=',
        mapObj: '='
      }
    };

    function searchController(_, mapHelper, $location, markersUtils, filtersService, $analytics, storeLocatorDictionary, CUSTOM_DICTIONARY) {
      var $ctrl = this;

      $ctrl.placeholder = CUSTOM_DICTIONARY && CUSTOM_DICTIONARY.placeholder;
      $ctrl.showFilters = false;
      $ctrl.hasFilters = filtersService.hasFilters();
      $ctrl.availableFilters = filtersService.getFilters();
      $ctrl.availableFilterTypes = filtersService.getFilterTypes();
      $ctrl.addFilter = addFilter;
      $ctrl.isGoogleMapsEnabled = mapHelper.isGoogleMapsEnabled();
      $ctrl.places =[];

      var selectedFilters = []

      function addFilter(filter) {
        $ctrl.locatorStates.message = 'Filtering locations...';
        filtersService.addFilter(filter);
        $ctrl.locatorStates.selectedFilters = filtersService.getSelectedFilters();
        $ctrl.performSearch(searchField); // Added call to performSearch function to kickoff search
        mapHelper.loadList($ctrl.locatorStates);
      }

      $ctrl.showFiltersForActiveTab = function () {
        return ($ctrl.locatorStates.activeTab && $ctrl.locatorStates.activeTab.hasFilters) || !$ctrl.locatorStates.activeTab;
      }

      $ctrl.userLatLngSearch = function () {
        $ctrl.locatorStates.reloadMap = true;
        $ctrl.locatorStates.zoom = storeLocatorDictionary.zoomLevels.nearMe;
        $ctrl.locatorStates.searchInput = "";
        $ctrl.locatorStates.areaSearched = false;
        mapHelper.setGeoStates($ctrl.locatorStates);

        if (!_.isUndefined($ctrl.locatorStates.position)) {
          if ($ctrl.isGoogleMapsEnabled) {
            mapHelper.setCoordinatesAndPlace($ctrl.locatorStates.position, $ctrl.locatorStates, $ctrl.mapObj);
          }
          else {
            mapHelper.setCoordinates($ctrl.locatorStates.position, $ctrl.locatorStates, $ctrl.mapObj);
          }
        } else {
          navigator.geolocation.getCurrentPosition(successFunction, mapHelper.geoLocationError($ctrl.locatorStates))
        }
      };

      var successFunction = function (position) {
        if ($ctrl.isGoogleMapsEnabled) {
          mapHelper.setCoordinatesAndPlace(position, $ctrl.locatorStates, $ctrl.mapObj.map);
        }
        else {
          mapHelper.setCoordinates(position, $ctrl.locatorStates, $ctrl.mapObj.map);
        }
        locatorStates.reloadMap = false;
      };

      $ctrl.performSearch = function (searchField) {
        if (searchField.name) {

          // Changes input field from "Search Results" to current location name
          window.setTimeout(function() {
            var locationName = $ctrl.locatorStates.current
            if (searchField.name === "") {searchField.name = locationName}
            $ctrl.locatorStates.searchInput = searchField.name
          }, 1000)

          $analytics.eventTrack("Searched: " + $ctrl.locatorStates.searchInput, { category: "Store Locator", label: "Store Locator" });

          $ctrl.locatorStates.zoom = searchField.type ? storeLocatorDictionary.zoomLevels[searchField.type] : storeLocatorDictionary.zoomLevels.fallback;
          $ctrl.locatorStates.areaSearched = false;

          var data = searchField.feature;
          $ctrl.locatorStates.current = $ctrl.locatorStates.searchInput;
          if (data) {
            var currentLocation = data;
            $ctrl.locatorStates.searchInputData = data;
            if (mapHelper.isGoogleMapsEnabled()) {
              var lat = $ctrl.locatorStates.position.coords ? $ctrl.locatorStates.position.coords.latitude : $ctrl.locatorStates.mapCenter.latitude;
              var lon = $ctrl.locatorStates.position.coords ? $ctrl.locatorStates.position.coords.longitude : $ctrl.locatorStates.mapCenter.longitude;

              markersUtils.getLatLogFromAddress($ctrl.locatorStates.searchInput, lat, lon, $ctrl.mapObj.getBounds()).then(function (data) {
                $ctrl.updatePlace(data);
              })
            }
            else {
              mapHelper.setSearchCoordinates(currentLocation.center[1], currentLocation.center[0], $ctrl.locatorStates, $ctrl.mapObj);
            }
          } else {
            _.each($ctrl.locatorStates.locationMarkersArray, function (mfMarker) {
              $ctrl.mapObj.removeMarker(mfMarker);
            });
            $ctrl.locatorStates.locations = [];
          }
        }
      };

      $ctrl.autoCompleteLocations = function (viewValue) {
        var lat = $ctrl.locatorStates.position.coords ? $ctrl.locatorStates.position.coords.latitude : $ctrl.locatorStates.mapCenter.latitude;
        var lon = $ctrl.locatorStates.position.coords ? $ctrl.locatorStates.position.coords.longitude : $ctrl.locatorStates.mapCenter.longitude;

        if (typeof viewValue === 'string' && viewValue.trim() === '') {
          return [];
        }
        $ctrl.places = markersUtils.getAutoCompleteLocations(viewValue, lat, lon)
          .then(function (data) {
            return _.map(data.features, function (feature) {
              return { name: feature.place_name, type: feature.place_type[0], feature: feature };
            });
          }, function (error) {
            if(error.status == 404){
              $location.path('/404')
            }
            else if(error.status == 400){
              $location.path('/400')
            }
            else if(error.status == 500){
              $location.path('/500')
            }
            else {
              locatorStates.errors = 'An error occurred. Please try again.';
            }
            document.querySelectorAll('.mf-loader').forEach(function (value) { value.classList.add('ng-hide') })
          });
        $ctrl.places.then(function (thing) {
          $ctrl.places = thing;
        });
        return $ctrl.places;
      };

      $ctrl.autoCompleteSelect = function (searchField) {
        $ctrl.performSearch(searchField);
      };

      $ctrl.googlePlaceChanged = function (place) {
        // The autocomplete box triggers this callback even when the user hits the 'enter' key without selecting an option
        // from the autocomplete list. In that case, the autocomplete box returns a object without a 'geometry' property.
        // We'll attempt to geocode the search string if 'geometry' is undefined.
        if (place.geometry) {
          $ctrl.updatePlace(place);
        }
        else {
          $ctrl.completeLocationAndSearch(place.name)
        }
      };

      $ctrl.updatePlace = function (place) {
        $ctrl.locatorStates.zoom = storeLocatorDictionary.zoomLevels[place.types[0]] ?
          storeLocatorDictionary.zoomLevels[place.types[0]] :
          storeLocatorDictionary.zoomLevels.fallback;
        mapHelper.setPlace(place, $ctrl.locatorStates, $ctrl.mapObj.map);
      };

      $ctrl.hitSearchBtn = function () {
        if($ctrl.locatorStates.searchInput){
          if(mapHelper.isGoogleMapsEnabled){
            $ctrl.completeLocationAndSearch($ctrl.locatorStates.searchInput)
          }
          else if($ctrl.places[0]){
            $ctrl.locatorStates.searchInput = $ctrl.places[0];
          }else {
            $ctrl.locatorStates.searchInput = {
              name: $ctrl.locatorStates.searchInput,
              type: '',
              feature:{}
            }
          }
          $ctrl.performSearch($ctrl.locatorStates.searchInput);
        }
      };

      $ctrl.completeLocationAndSearch = function (name) {
        $ctrl.autoCompleteLocations(name).then(function () {
          if($ctrl.places.length === 0){
            $ctrl.places[0]= {
              name: $ctrl.locatorStates.searchInput,
              type: $ctrl.places[0].type ? $ctrl.places[0].type : '',
              feature:{}
            }
          }
          $ctrl.performSearch($ctrl.places[0])
        })
      }
    }
  }

})();


(function() {
    'use strict';

    angular
        .module('storeLocator')
        .directive('resultsLi', resultsLi);

    function resultsLi(STORE_LOCATOR_RESULTS_TEMPLATE,CLIENT_ROUTE, USES_METRIC) {
        return {
            templateUrl: STORE_LOCATOR_RESULTS_TEMPLATE,
            restrict: 'E',
            replace: true,
            scope: {},
            controller: resultsLiController,
            controllerAs: 'resultsLiCtrl',
            bindToController: {
                locatorStates: '=',
                mapObj: '=',
                location: '='
            }
        };

        function resultsLiController($document, customFieldFactory, urlBuilderFactory,pubSub,storeLocatorCache, USES_METRIC) {
            var $ctrl = this;
            $ctrl.client_route = CLIENT_ROUTE;
            $ctrl.uses_metric = USES_METRIC;
            
            $ctrl.hasCustomFieldValue = function (name){
              return customFieldFactory.getValueByName($ctrl.location.entire_location.custom_fields, name) ? true : false;
            };
            $ctrl.getCustomFieldValue = function (customFieldName) {
                return customFieldFactory.getValueByName($ctrl.location.entire_location.custom_fields, customFieldName);
            };
            $ctrl.getFieldCountByRegex = function (regEx){
              return customFieldFactory.getFieldCountByRegex($ctrl.location.entire_location.custom_fields, regEx);
            };
            $ctrl.showLocationPopup = function(location_number) {
                var selectedMarker = _.find($ctrl.locatorStates.locationMarkersArray,
                    function(mfMarker) { return mfMarker.number == location_number });
                var activeRemove = $document.find('.location-li.active')[0];
                if (activeRemove) activeRemove.classList.remove('active');

                if (selectedMarker) {
                    // close other markers
                    $ctrl.locatorStates.locationMarkersArray.forEach(function(m){
                        m.closePopup();
                    });

                    // zoom in on selected marker
                    selectedMarker.zoomTo();

                    // open selected marker popup
                    selectedMarker.openPopup();

                    pubSub.publish({
                      msg: 'mapMarkerOnClick',
                      data: $ctrl.location
                    });

                    storeLocatorCache.save('location', $ctrl.location);
                }
            };
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('results', results);

  function results () {
    return {
      templateUrl: 'app/storeLocator/directives/results.directive.html',
      restrict: 'E',
      scope: {},
      controller: resultsController,
      controllerAs: 'resultsCtrl',
      bindToController: {
        locatorStates: '=',
        mapObj: '='
      }
    };

    function resultsController(storeLocatorDictionary, FORCE_GEOLOCATION) {
        var $ctrl = this;
        
        $ctrl.showMessage = true;

        $ctrl.GetMessage = function()
        {
            var message = '';
            if(FORCE_GEOLOCATION && !$ctrl.locatorStates.locations.length) {
              message = "Search For a Location in Your Area";
            }
            else if ($ctrl.locatorStates.selectedFilters.length > 0)
            {
                if ($ctrl.locatorStates.locations.length > 0)
                {
                    message = storeLocatorDictionary.messages.resultsWithFilters;
                }
                else {
                    message = storeLocatorDictionary.messages.noResultsWithFilters;
                }
                message = message.replace('{filters}', $ctrl.locatorStates.selectedFilters.replace(',', ', '));
            }
            else {
                if ($ctrl.locatorStates.locations.length > 0) {
                    message = storeLocatorDictionary.messages.results;
                }
                else {
                    message = storeLocatorDictionary.messages.noResults;
                }
            }

            $ctrl.locatorStates.current.name == undefined ? message = message.replace('{location}', $ctrl.locatorStates.current) : message = message.replace('{location}', $ctrl.locatorStates.current.name)

            $ctrl.showMessage = message !== '';

            return message;
        }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('mapPopup', mapPopup);

  function mapPopup (STORE_LOCATOR_MAP_POPUP_TEMPLATE, CLIENT_ROUTE) {
    return {
      templateUrl: STORE_LOCATOR_MAP_POPUP_TEMPLATE,
      restrict: 'E',
      scope: {},
      controller: mapPopupController,
      controllerAs: 'mapPopupCtrl'
    };

    function mapPopupController($scope, customFieldFactory, urlBuilderFactory) {
        var $ctrl = this;
        $ctrl.client_route = CLIENT_ROUTE;
        $ctrl.location = $scope.$parent.location;

        $ctrl.getCustomFieldValue = function (customFieldName) {
            return customFieldFactory.getValueByName($ctrl.location.entire_location.custom_fields, customFieldName);
        }
    }
  }

})();

(function() {
    'use strict';

    angular
        .module('storeLocator')
        .directive('map', map);

    function map() {
        return {
            templateUrl: 'app/storeLocator/directives/map.directive.html',
            restrict: 'E',
            scope: {
                isGoogleMapsApiLoaded: '='
            },
            controller: mapController,
            controllerAs: 'mapCtrl',
            bindToController: {
                locatorStates: '=',
                mapObj: '='
            }
        };

        function mapController($scope,
            mapHelper,
            $location,
            $window,
            STORE_LOCATOR_PIN,
            FORCE_GEOLOCATION,
            $compile,
            mapService,
            $timeout,
            STORE_LOCATOR_MAP_ZOOM_ON_SCROLL,
            MFeedMarkerService,
            geocodeService,
            storeLocatorCache,
            storeLocatorDictionary,
            filtersService) {

            var $ctrl = this;

            $ctrl.isGoogleMapsEnabled = mapHelper.isGoogleMapsEnabled();

            $ctrl.initialLoadOver = false;

            //show map on inital load
            $ctrl.showMap = function(mfMap) {
                $ctrl.mapObj = mfMap; //save map in the controller object for future manipulation

                // set initial lat/lng
                if (!$ctrl.isGoogleMapsEnabled) {
                  navigator.geolocation.getCurrentPosition(successFunction, mapHelper.geoLocationError($ctrl.locatorStates));

                  if (!$ctrl.locatorStates.current !== 'Current Location') {
                    var coordinates = $ctrl.locatorStates.mapCenter;
                    $ctrl.mapObj.setView(
                      { 
                        lng:  coordinates.longitude,  
                        lat:  coordinates.latitude 
                      }, 
                      $ctrl.locatorStates.zoom
                    );
                  }
                }

                if (!STORE_LOCATOR_MAP_ZOOM_ON_SCROLL) {
                    $ctrl.mapObj.setScrollWheelZoom(false);
                }

                $ctrl.mapObj.buildMap($scope, $ctrl.locatorStates, initMapFn);
            };

            //search this area function
            $ctrl.searchArea = function() {
                $ctrl.locatorStates.searchInput = '';
                $ctrl.locatorStates.current = 'Current Location';
                $ctrl.locatorStates.areaSearched = true;
                mapHelper.loadList($ctrl.locatorStates);
            };

            function initMapFn() {
                // if geolocation is available, set the location accordingly
                var urlQueryParams = $location.search();

                var mapBounds = storeLocatorCache.get('map_bounds');
                storeLocatorCache.save('selectedFilters', $ctrl.locatorStates.selectedFilters);
                var loadFromCache = !angular.isUndefined(mapBounds);

                if (!angular.equals(urlQueryParams,{}) && urlQueryParams.loc_q) {
                    loadBySearchParameter(urlQueryParams);
                } else if (loadFromCache) {
                    loadCachedValues(mapBounds);
                } else {
                    $ctrl.locatorStates.message = 'Share your location or type a location in the search box';

                    if (navigator.geolocation) {
                        try {
                          navigator.geolocation.getCurrentPosition(
                            successFunction,
                            mapHelper.geoLocationError($ctrl.locatorStates));
                        } catch (evt) {
                            $ctrl.locatorStates
                                .notifications = "Geolocation is not supported for this Browser/OS version yet.";
                        }
                    }
                }
            }

            function loadBySearchParameter(searchedValue) {
                $ctrl.locatorStates.searchInput = searchedValue.loc_q;
                if (searchedValue.filter && searchedValue.filter.constructor === Array) {
                  searchedValue.filter.forEach(function (e) {
                    filtersService.addFilter(e);
                  })
                }else {
                  filtersService.addFilter(searchedValue.filter);
                }
                if (searchedValue.pageSize){
                  $ctrl.locatorStates.pageSize = searchedValue.pageSize;
                }
                // geocode loc_q param and set the viewport using results before loading the map
                if ($ctrl.isGoogleMapsEnabled) {
                    geocodeService.geocodeGoogle($ctrl.locatorStates.searchInput)
                        .then(function (place) {
                            $ctrl.locatorStates.current = $ctrl.locatorStates.searchInput;
                            $ctrl.locatorStates.zoom = storeLocatorDictionary.zoomLevels[place.types[0]] ?
                            storeLocatorDictionary.zoomLevels[place.types[0]] :
                            storeLocatorDictionary.zoomLevels.fallback;
                           mapHelper.setPlace(place, $ctrl.locatorStates, $ctrl.mapObj.map);
                        });
                } else {
                    geocodeService.geocodeMapbox($ctrl.locatorStates.searchInput)
                        .then(function (result) {
                          $ctrl.locatorStates.zoom = result.place_type[0] ?
                            storeLocatorDictionary.zoomLevels[result.place_type[0]] :
                            storeLocatorDictionary.zoomLevels.fallback;
                           $ctrl.locatorStates.current = $ctrl.locatorStates.searchInput;
                            mapHelper.setSearchCoordinates(result.geometry.coordinates[1],
                                result.geometry.coordinates[0],
                                $ctrl.locatorStates,
                                $ctrl.mapObj);
                        });
                }
            }

            function loadCachedValues(bounds) {
                if ($ctrl.isGoogleMapsEnabled) {
                    var place = buildGeometry(bounds);
                    mapHelper.setPlace(place, $ctrl.locatorStates, $ctrl.mapObj.map);
                } else {
                    mapHelper.setSearchCoordinates(bounds.center.lat,
                        bounds.center.lng,
                        $ctrl.locatorStates,
                        $ctrl.mapObj);
                }

                function buildGeometry(bounds) {
                    var ne = new google.maps.LatLng(bounds.northEast.lat, bounds.northEast.lng);
                    var sw = new google.maps.LatLng(bounds.southWest.lat, bounds.southWest.lng);

                    var mapGeometry = {
                        geometry: {
                            location: {
                                lat: bounds.center.lat,
                                lng: bounds.center.lng
                            },
                            viewport: new google.maps.LatLngBounds(sw, ne)
                        }
                    }

                    return mapGeometry;
                }
            }

            var successFunction = function(position) {
              var loadMapCallback = function() {
                    $ctrl.userLat = position.coords.latitude;
                    $ctrl.userLng = position.coords.longitude;
                    $ctrl.initialLoadOver = true;
                    loadMap($ctrl.locatorStates, $ctrl.mapObj);
                }

                mapHelper.setGeoStates($ctrl.locatorStates);

                if ($ctrl.isGoogleMapsEnabled) {
                  mapHelper.setCoordinatesAndPlace(position, $ctrl.locatorStates, $ctrl.mapObj, loadMapCallback);
                } else {
                  mapHelper.setCoordinates(position, $ctrl.locatorStates, $ctrl.mapObj, loadMapCallback);
                }
            };

            //Necessary checks for the mapBox obj to return bounds within -180 & 180
            function mapBoxBoundsChecker (checkBounds){

              if(checkBounds.center.lng>180){
                var offset =0;

                while(checkBounds.center.lng>180) {
                  checkBounds.center.lng -= 360;
                  checkBounds.northEast.lng -= 360;
                  checkBounds.southWest.lng -= 360;
                  offset+=1;
                }

                //caching original Bounds offset to display pins correctly on map
                storeLocatorCache.save('offset', offset);
                storeLocatorCache.save('change', true);
              }
              else if(checkBounds.center.lng<-180){
                var offset =0;

                while(checkBounds.center.lng<-180){
                  checkBounds.center.lng += 360;
                  checkBounds.northEast.lng +=360;
                  checkBounds.southWest.lng +=360;
                  offset+=1;
                }

                //caching original Bounds offset to display pins correctly on map
                storeLocatorCache.save('offset', offset);
                storeLocatorCache.save('change', true);
              }
              else{
                storeLocatorCache.save('change', false);
              }
              return checkBounds;
            }
            

            function loadMap(locatorStates, mfMap) {
                var locations = [];
                var bounds = mfMap.getBounds();
                storeLocatorCache.save('currentBounds', bounds.center.lng);

                bounds = mapBoxBoundsChecker(bounds);

                storeLocatorCache.save('map_bounds', bounds);

                locatorStates.zoom = mfMap.getZoom();

                if($ctrl.locatorStates.searchInput){
                locatorStates.mapCenter.latitude = bounds.center.lat;
                locatorStates.mapCenter.longitude = bounds.center.lng;
                }
                storeLocatorCache.save('state', locatorStates);


                locatorStates.isLoading = true;
                locatorStates.message = storeLocatorDictionary.messages.loading;
                locatorStates.locations = [];
                
                if (locatorStates.currentLocationMarker && 
                    locatorStates.current === 'Current Location'
                    && !locatorStates.areaSearched) {
                    mfMap.setCurrentLocationMarker(locatorStates.currentLocationMarker);
                }

                // On initial load, the bounds may be undefined. Don't hit the llp endpoint
                // if we don't have the proper bounds parameter(s).
                if (bounds.center.lat && bounds.center.lng) {
                    if ((FORCE_GEOLOCATION && ($ctrl.locatorStates.geoEnabled || $ctrl.locatorStates.searchInput || $ctrl.locatorStates.areaSearched)) ||
                      !FORCE_GEOLOCATION) {
                        mapService.searchMethod(locatorStates, bounds).then(function (data) {

                        processSearchResult(data);
                      }, function (error) {
                        if(error.status === 404){
                          $location.path('/404')
                        }
                        else if(error.status === 400){
                          $location.path('/400')
                        }
                        else if(error.status === 500){
                          $location.path('/500')
                        }
                        else if(error.status === 503){
                          $location.path('/500')
                        }
                        else {
                          locatorStates.errors = 'An error occurred. Please try again.';
                        }
                        document.querySelectorAll('.mf-loader').forEach(function (value) { value.classList.add('ng-hide') })
                      });
                    } else {
                      processSearchResult({data:[]});
                    }
                }
                function processSearchResult(data) {
                  var counter = 1;
                  var response = data.data;

                  locatorStates.locationMarkersArray.forEach(function(mfMarker) {
                    mfMap.removeMarker(mfMarker);
                  });
                  locatorStates.locationMarkersArray = [];

                  if (response.length) {

                    response.forEach(function(_location) {
                      var location = mapService.createMarker(_location, counter);

                      var mfMarker = MFeedMarkerService
                        .createMFMarker(mfMap, location, locatorStates, $scope);
                      
                      locatorStates.locationMarkersArray.push(mfMarker);
                      locations.push(location);
                      counter++;
                    });

                    locatorStates.locations = locations;

                    locatorStates.locationMarkersArray.forEach(function(mfMarker) {
                      mfMarker.addToMap();
                    });
                  }

                  locatorStates.current = locatorStates
                    .current
                    ? locatorStates.current
                    : 'Current Location';
                  locatorStates.message = '';
                  locatorStates.isLoading = false;
                  locatorStates.isRadius = false;
                  locatorStates.reloadMap = false;
                  locatorStates.showSearchAreaBtn = false;
                  locatorStates.errors = "";
                  $scope.safeApply();
                }
            }

            // watch for the reloadMap field to change
            // wrap in debounce so that reloadMap = false doesn't prevent the previous
            // reloadMap = true from triggering the loadMap function.
            $scope.$watch(angular.bind(this,
                function() {
                    return this.locatorStates.reloadMap;
                }),
                _.debounce(
                  function() {
                    if ($ctrl.locatorStates.reloadMap)
                        loadMap($ctrl.locatorStates, $ctrl.mapObj);
                },500),
                true);


          $scope.safeApply = function(fn) {
            var phase = this.$root.$$phase;
            if(phase == '$apply' || phase == '$digest') {
              if(fn && (typeof(fn) === 'function')) {
                fn();
              }
            } else {
              this.$apply(fn);
            }
          };
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('clientCss', clientCSS);

  function clientCSS(CLIENT_NAME,s) {
    return function (scope, elem, attr) {
      attr.$addClass(s(CLIENT_NAME).trim().slugify().value());
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('starRating', starRating);

  function starRating () {
    return {
        restrict: 'A',
        template: '<ul class="rating">' +
            '<li ng-repeat="star in stars" ng-class="star">' +
            '\u2605' +
            '</li>' +
            '</ul>',
        scope: {
            ratingValue: '=',
            max: '='
        },
        link: function (scope) {
            scope.stars = [];
            for (var i = 0; i < scope.max; i++) {
                scope.stars.push({
                    filled: i < scope.ratingValue
                });
            }
        }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('yelpCard', yelpCard);

  function yelpCard () {

    return {
      replace: true,
      scope: {'location': '='},
      templateUrl: 'app/localLanding/cards/yelpCard.directive.html',
      restrict: 'AE',
      controller: function ($scope) {
          var vm = this,
              yelp;
          vm.title = $scope.location.store_info.name ? $scope.location.store_info.name : 'Find us';

          if ($scope.location && $scope.location.store_info) {
              yelp = _.findWhere($scope.location.store_info.providers, { _type: 'Yelp' });
              vm.yelpData = false;
              if (yelp) {
                  vm.yelpData = {};
                  // vm.yelpData.id = yelp.venue_id;
                  vm.yelpData = yelp;
                  // getWidget(vm.yelpData.id, "300", "RED", "y", "y", "0");
              }
          }

          function getWidget(id, width, color, image, styled, reviewnum) {
              if ('withCredentials' in new XMLHttpRequest()) {
                  var xmlHttp = new XMLHttpRequest();
                  xmlHttp.onreadystatechange = function () {
                      if (xmlHttp.readyState === 4 && xmlHttp.status === 200) {
                          document.getElementById('yelpwidget').innerHTML = xmlHttp.responseText;
                          $('#yelpbutton').attr('src', 'https://chrisawren.com/widgets/yelp/yelp/reviewsFromYelpRED.gif');
                      }
                  };
                  xmlHttp.open("GET", 'https://chrisawren.com/widgets/yelp/yelpv2.php?id=' + id + '&width=' + width + '&color=' + color + '&styled=' + styled + '&image=' + image + '&reviewnum=' + reviewnum, true);
                  xmlHttp.send();
              }
              else {
                  if (typeof XDomainRequest !== "undefined") {
                      // 1. Create XDR object
                      var xdr = new XDomainRequest();
                      xdr.onload = function () {
                          document.getElementById('yelpwidget').innerHTML = xdr.responseText;
                          $('#yelpbutton').attr('src', 'https://chrisawren.com/widgets/yelp/yelp/reviewsFromYelpRED.gif');
                      };
                      // 2. Open connection with server using GET method
                      xdr.open("GET", 'https://chrisawren.com/widgets/yelp/yelpv2.php?id=' + id + '&width=' + width + '&color=' + color + '&styled=' + styled + '&image=' + image + '&reviewnum=' + reviewnum, true);
                      // 3. Send string data to server
                      xdr.send();
                  }
              }
          }
      },
      controllerAs: 'yelpCardc'
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('weatherCard', weatherCard);

  function weatherCard () {

    return {
      replace: true,
      scope: {location: '='},
      templateUrl: 'app/localLanding/cards/weatherCard.directive.html',
      restrict: 'AE',
      controllerAs: 'weatherCardC',
      controller: function ($scope, $http) {
        var vm = this;

        vm.location = $scope.location;

        var getWeather = function(){
          $http.jsonp('https://api.forecast.io/forecast/8f2758eb4e1241a07563e22b3c40b0b5/' + vm.location.store_info.latitude + ',' + vm.location.store_info.longitude +'?callback=JSON_CALLBACK')
            .success(function(data) {
              if (data) {
                vm.weather = {
                  temperature: Math.ceil(data.currently.temperature),
                  feelsLike: Math.ceil(data.currently.apparentTemperature),
                  summary: data.currently.summary,
                  icon: data.currently.icon,
                  precipPercent: data.currently.precipProbability * 100,
                  precipType: data.currently.precipType || 'precipitation'

                }
              }
            });
        };

        getWeather();

      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('videoEmbedCard', videoEmbedCard);

  function videoEmbedCard() {

    return {
      replace: true,
      scope: {
        customFields: '=',
        customFieldName: "@",
        customHeaderText: "@"
      },
      templateUrl: 'app/localLanding/cards/videoEmbedCard.directive.html',
      restrict: 'AE',
      controller: videoEmbedCardController,
      controllerAs: 'videoEmbedCardC',
      bindToController: true
    };
  }

  function videoEmbedCardController(_, $sce, $timeout, $document) {
    var videoEmbedCardC = this;

    videoEmbedCardC.customHeaderText = videoEmbedCardC.customHeaderText ? videoEmbedCardC.customHeaderText : 'Featured Video';
    videoEmbedCardC.findLink = _.find(videoEmbedCardC.customFields, {'name': videoEmbedCardC.customFieldName});
    var findChannel = _.find(videoEmbedCardC.customFields, {'name': 'youtube_channel'});

    if (!_.isUndefined(findChannel)) {
      videoEmbedCardC.channel = findChannel.data;
    }

    if (!_.isUndefined(videoEmbedCardC.findLink)) {
      var element = angular.element($document[0].getElementById('video_url'));
      //build the embed url
      videoEmbedCardC.link = $sce.trustAsResourceUrl(videoEmbedCardC.findLink.data);

      videoEmbedCardC.onLoad = function () {
        if (!_.isUndefined(videoEmbedCardC.findLink) && element[0]) setHeight(element)
      };
    }

    function setHeight(element) {
      //set the height of the iframe
      element[0].height = element[0].clientWidth / 1.78125;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('tweetsCard', tweetsCard);

  function tweetsCard() {

    return {
      replace: true,
      scope: {
        username: '=',
        clientName: '=',
        linkColor: '@',
        height: '@'
      },
      templateUrl: 'app/localLanding/cards/tweetsCard.directive.html',
      restrict: 'AE',
      controller: function () {
        var vm = this;
        $.getScript('https://platform.twitter.com/widgets.js');

      },
      controllerAs: 'tweetsCardC'
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('trumpetWidgetCard', trumpetWidgetCard);

  function trumpetWidgetCard() {

    return {
      replace: true,
      scope: {
          corporateId: '=',
          apiKey: '@',
          clientId: '@',
          no: '@'
      },
      templateUrl: 'app/localLanding/cards/trumpetWidgetCard.directive.html',
      restrict: 'AE',
      controller: trumpetWidgetCardController,
      controllerAs: 'trumpetWidgetCardCtrl',
      bindToController: true
    };
  }

  function trumpetWidgetCardController(_,$http, $sce) {
      var trumpetWidgetCardCtrl = this;
      $http({
              method: 'GET',
              url: 'https://api.trumpetratings.com/api/trumpetwidget/all/' +
                  trumpetWidgetCardCtrl.apiKey +
                  '/' +
                  trumpetWidgetCardCtrl.clientId +
                  '/' +
                  trumpetWidgetCardCtrl.corporateId +
                  '/' +
                  trumpetWidgetCardCtrl.no +
                  '/false'
          })
          .success(function (response) {
              trumpetWidgetCardCtrl.widgetHtml = $sce.trustAsHtml(response.CSS + response.Content);
          })
          .error(function() {
              console.log('An error occurred while retreiving trumpet widget content.');
          });

  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('testimonialCard', testimonialCard);

  function testimonialCard() {
    return {
      replace: true,
      scope: {
          customFields: '=',
          title: '@',
          interval: '@'
      },
      templateUrl: 'app/localLanding/cards/testimonialCard.directive.html',
      restrict: 'AE',
      controller: function($scope, _) {
        var vm = this;
        vm.testimonials = [];
        vm.interval = $scope.interval;
        vm.title = $scope.title;

        _.each($scope.customFields, function (field) {
            if (field.name.toLowerCase().indexOf('testimonial_') === 0) {
                vm.testimonials.push(JSON.parse(field.data));
            }
        });

        vm.areTestimonials = vm.testimonials.length > 0;

        var right = document.getElementsByClassName("glyphicon-chevron-right");
        var left = document.getElementsByClassName("glyphicon-chevron-left");
        var mouseEnter = false;

        $('#testimonial').mouseenter(function () {
          mouseEnter = true;
        });

        $('#testimonial').mouseleave(function () {
          mouseEnter = false;
        });

        $(document).keydown(function (e) {

          if (mouseEnter) {
            if (e.keyCode === 37) {
              // Previous
              $(left[0]).click();
              return false;
            }
            if (e.keyCode === 39) {
              // Next
              $(right[0]).click();
              return false;
            }
          }

        });
      },
      controllerAs: 'testimonialCardCtrl'
    };
  }
})();

(function () {
    'use strict';

    angular
      .module('storeLocator')
      .directive('storeLocatorBreadcrumbCard', storeLocatorBreadcrumbCard);

    function storeLocatorBreadcrumbCard() {

        return {
            replace: true,
            scope: { text: '@' },
            templateUrl: 'app/localLanding/cards/storeLocatorBreadcrumbCard.directive.html',
            restrict: 'AE'
        };
    }
})();

(function () {
    'use strict';

    angular.module('storeLocator').directive('storeLocatorAmenitiesCard', storeLocatorAmenitiesCard);

    function storeLocatorAmenitiesCard() {
        return {
            replace: true,
            scope: {
                customFields: '=',
                title: '@',
                client: '@'
            },
            templateUrl: 'app/localLanding/cards/storeLocatorAmenitiesCard.directive.html',
            restrict: 'AE',
            controller: storeLocatorAmenitiesCardController,
            controllerAs: 'storeLocatorAmenitiesCardController',
            bindToController: true
        };
    }

    function storeLocatorAmenitiesCardController(amenitiesService) {
        var storeLocatorAmenitiesCardController = this;
        storeLocatorAmenitiesCardController.amenities = [];

        if (typeof storeLocatorAmenitiesCardController.title === 'undefined') {
            storeLocatorAmenitiesCardController.title = 'Amenities';
        }

        if (storeLocatorAmenitiesCardController.customFields) {
            storeLocatorAmenitiesCardController.amenities = amenitiesService.getAmenities(storeLocatorAmenitiesCardController.customFields);
        }

        storeLocatorAmenitiesCardController.showTooltip = function(amenity) {
            amenity.showTooltip = true;
        };

        storeLocatorAmenitiesCardController.hideTooltip = function (amenity) {
            amenity.showTooltip = false;
        };
    }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('starRatingCard', function () {
      return {
        restrict: 'A',
        template: '<ul class="rating">' +
          '<li ng-repeat="star in stars" ng-class="star">' +
          '\u2605' +
          '</li>' +
          '</ul>',
        scope: {
          ratingValue: '=',
          max: '='
        },
        link: function (scope, elem, attrs) {
          scope.stars = [];
          for (var i = 0; i < scope.max; i++) {
            scope.stars.push({
              filled: i < scope.ratingValue
            });
          }
        }
      }
    })
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('socialCard', socialCard);

  function socialCard() {

    return {
      replace: true,
      scope: {
        location: '='
      },
      templateUrl: 'app/localLanding/cards/socialCard.directive.html',
      restrict: 'AE',
      controller: function ($scope, INSTAGRAM_HANDLE) {
          var socialCardC = this;
          var hasTwitterProvider = _.filter($scope.location.store_info.providers, function (p) { return p._type == 'Twitter'; }).length > 0;

          socialCardC.providers = _.filter($scope.location.store_info.providers, function (p) {
              return (p.master == true && p._type !== 'Instagram');
          });

          // In case the providers array do not return Twitter, but the handle exists, we will push to the providers array
          if (!hasTwitterProvider && $scope.location.twitter_handle) {
            socialCardC.providers.push({ _type: "Twitter"})
          }

          socialCardC.instagramURL='https://www.instagram.com/' + INSTAGRAM_HANDLE;
          socialCardC.instagramHandle=INSTAGRAM_HANDLE;
      },
      controllerAs: 'socialCardC'
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('storeLocator')
    .directive('sitemapErrorCard', sitemapErrorCard);

  function sitemapErrorCard() {
    return {
      replace: true,
      scope: {},
      controller: sitemapErrorCardController,
      controllerAs: 'sitemapErrorCtrl',
      templateUrl: 'app/localLanding/cards/sitemapErrorCard.directive.html',
      restrict: 'AE',
      bindToController: {}
    };

    function sitemapErrorCardController($stateParams, $state) {
      setTimeout(function () {
        if ($stateParams.locality) {
          $state.go('root.siteMapRegion', {country: $stateParams.country, region: $stateParams.region})
        } else if ($stateParams.region) {
          $state.go('root.siteMapCountry', {country: $stateParams.country})
        } else {
          $state.go('root.siteMap')
        }
      }, 3500)
    }
  }

})();

(function () {
    'use strict';

    angular
      .module('storeLocator')
      .directive('singleRolloverImageCard', singleRolloverImageCard);

    function singleRolloverImageCard() {

        return {
            replace: true,
            scope: {
                location: '=',
                singleImageNumber: '=',
                singleImageTitle: '@'
            },
            templateUrl: 'app/localLanding/cards/singleRolloverImageCard.directive.html',
            restrict: 'AE',
            controller: singleRolloverImageCardController,
            controllerAs: 'singleRolloverImageCardC',
            bindToController: true
        };
    }

    function singleRolloverImageCardController(_) {
        var singleRolloverCtrl = this;

        singleRolloverCtrl.src = _.find(singleRolloverCtrl.location.custom_fields, { 'name': 'single_image' + singleRolloverCtrl.singleImageNumber }).data;
        singleRolloverCtrl.name = _.find(singleRolloverCtrl.location.custom_fields, { 'name': 'single_image' + singleRolloverCtrl.singleImageNumber }).name;

        singleRolloverCtrl.title = singleRolloverCtrl.singleImageTitle || "Image";

        singleRolloverCtrl.findHoverSrc = _.find(singleRolloverCtrl.location.custom_fields, { 'name': 'single_image_hover' + singleRolloverCtrl.singleImageNumber });
        if (!_.isUndefined(singleRolloverCtrl.findHoverSrc)) singleRolloverCtrl.hoverSrc = singleRolloverCtrl.findHoverSrc.data;

        singleRolloverCtrl.findLink = _.find(singleRolloverCtrl.location.custom_fields, { 'name': 'single_url' + singleRolloverCtrl.singleImageNumber });
        if (!_.isUndefined(singleRolloverCtrl.findLink)) singleRolloverCtrl.link = singleRolloverCtrl.findLink.data;
    }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('singlePromoCard', singlePromoCard);

  function singlePromoCard() {

    return {
      replace: true,
      scope: {
        location: '='
      },
      templateUrl: 'app/localLanding/cards/singlePromoCard.directive.html',
      restrict: 'AE',
      controller: singlePromoCardController,
      controllerAs: 'singlePromoCardC',
      bindToController: true
    };
  }

  function singlePromoCardController(_) {
    var vm = this;
    vm.image_url = getData(_.find(vm.location.custom_fields, {'name': 'single_promo_image_url'}));
    vm.title = getData(_.find(vm.location.custom_fields, {'name': 'single_promo_title'}));
    vm.text = getData(_.find(vm.location.custom_fields, {'name': 'single_promo_text'}));
    vm.btn_url = getData(_.find(vm.location.custom_fields, {'name': 'single_promo_btn_url'}));
    vm.btn_text = getData(_.find(vm.location.custom_fields, {'name': 'single_promo_btn_text'}));

    function getData(Obj) {
      return Obj ? Obj.data : '';
    }
  }
})();

(function () {
    'use strict';
  
    angular
      .module('storeLocator')
      .directive('singleImageCardWithCaption', singleImageCardWithCaption);
  
    function singleImageCardWithCaption() {
  
      return {
        replace: true,
        scope: {
          location: '=',
          singleImageNumber: '=',
          singleImageTitle: '@',
          customCaptionText: '@?'
        },
        templateUrl: 'app/localLanding/cards/singleImageCardWithCaption.directive.html',
        restrict: 'AE',
        controller: function ($scope) {
            var vm = this;
  
            if ($scope.customCaptionText !== undefined) {
              vm.customCaptionText = $scope.customCaptionText;
            }
  
            vm.hasData = _.find($scope.location.custom_fields, { 'name': 'single_image' + $scope.singleImageNumber });
            if (vm.hasData) {
                vm.src = _.find($scope.location.custom_fields,
                    { 'name': 'single_image' + $scope.singleImageNumber })
                    .data;
                vm.name = _.find($scope.location.custom_fields,
                    { 'name': 'single_image' + $scope.singleImageNumber })
                    .name;
  
                //set naming for title and alt attributes
                var title = _.find($scope.location.custom_fields, { 'name': 'single_image_title' + $scope.singleImageNumber });
                if (!_.isUndefined(title)) {
                    vm.title = title.data;
                }else{
                    vm.title = $scope.singleImageTitle || "Promo image";
                }
  
                // vm.findLink = _.find($scope.location.custom_fields, { 'name': 'single_url' + $scope.singleImageNumber });
                // if (!_.isUndefined(vm.findLink)) {
                //     vm.link = vm.findLink.data;
                // }
            }
        },
        controllerAs: 'singleImageCardC'
      };
    }
  
  
  })();
  
(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('singleImageCardWithButton', singleImageCardWithButton);

  function singleImageCardWithButton() {

    return {
      replace: true,
      scope: {
        location: '=',
        singleImageNumber: '=',
        singleImageTitle: '@',
        customButtonText: '@?'
      },
      templateUrl: 'app/localLanding/cards/singleImageCardWithButton.directive.html',
      restrict: 'AE',
      controller: singleImageCardWithButtonController,
      controllerAs: 'singleImageCardWithButtonC'
    }
  }
      function singleImageCardWithButtonController($scope) {
          var vm = this;

          if ($scope.customButtonText !== undefined) {
            vm.customButtonText = $scope.customButtonText;
          }

          vm.hasData = _.find($scope.location.custom_fields, { 'name': 'single_image' + $scope.singleImageNumber });
          if (vm.hasData) {
              vm.src = _.find($scope.location.custom_fields,
                  { 'name': 'single_image' + $scope.singleImageNumber })
                  .data;
              vm.name = _.find($scope.location.custom_fields,
                  { 'name': 'single_image' + $scope.singleImageNumber })
                  .name;

              //set naming for title and alt attributes
              var title = _.find($scope.location.custom_fields, { 'name': 'single_image_title' + $scope.singleImageNumber });
              if (!_.isUndefined(title)) {
                  vm.title = title.data;
              }else{
                  vm.title = $scope.singleImageTitle || "Promo image";
              }

              vm.findLink = _.find($scope.location.custom_fields, { 'name': 'single_url' + $scope.singleImageNumber });
              if (!_.isUndefined(vm.findLink)) {
                  vm.link = vm.findLink.data;
              }
          }
      }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('singleImageCard', singleImageCard);

  function singleImageCard() {

    return {
      replace: true,
      scope: {
        location: '=',
        singleImageNumber: '=',
        singleImageTitle: '@',
        singleImageTarget: '@'
      },
      templateUrl: 'app/localLanding/cards/singleImageCard.directive.html',
      restrict: 'AE',
      controller: function ($scope) {
          var vm = this;

          vm.hasData = _.find($scope.location.custom_fields, { 'name': 'single_image' + $scope.singleImageNumber });
          if (vm.hasData) {
              vm.src = _.find($scope.location.custom_fields,
                  { 'name': 'single_image' + $scope.singleImageNumber })
                  .data;
              vm.name = _.find($scope.location.custom_fields,
                  { 'name': 'single_image' + $scope.singleImageNumber })
                  .name;
            
              //set naming for title and alt attributes
              var title = _.find($scope.location.custom_fields, { 'name': 'single_image_title' + $scope.singleImageNumber });
              if (!_.isUndefined(title)) {
                  vm.title = title.data;
              }else{
                  vm.title = $scope.singleImageTitle || "Promo image";
              }

              vm.findLink = _.find($scope.location.custom_fields, { 'name': 'single_url' + $scope.singleImageNumber });
              if (!_.isUndefined(vm.findLink)) {
                  vm.link = vm.findLink.data;
              }
          }

          if(_.isUndefined($scope.singleImageTarget)) {
            vm.singleImageTarget = "_blank";
          }
      },
      controllerAs: 'singleImageCardC'
    };
  }

  
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('reservationCard', reservationCard);

  function reservationCard() {

    return {
      replace: true,
      scope: {},
      bindToController: {
        location: '=',
        location1: '=?',
        location2: '=?',
        mappingCallback: '&?',
        locationCallback: '&?',
        locationCallbackResults: '=?',
        requestUrl: '=',
        client: '=?'
      },
      templateUrl: 'app/localLanding/cards/reservationCard.directive.html',
      restrict: 'E',
      controllerAs: 'reservationCardController',
      controller: reservationCardController
    };
  };

  reservationCardController.$inject = ['$scope'];

  function reservationCardController($scope) {
    var vm = this;
    vm.locationSearch = null;

    vm.submitRequest = function () {
      var data = {
        location1: vm.location1 ? vm.location1 : '',
        location2: vm.location2,
        fromDate: vm.fromDate,
        untilDate: vm.untilDate
      };
      window.open(vm.requestUrl + vm.mappingCallback({ input: data }), '_blank');
    };

    vm.setGAEventLabel = function () {
      if (vm.location.llp_url === '') {
        vm.location.llp_url = window.location.pathname;
      };
    };

    $scope.$watch('reservationCardController.locationSearch', function (newVal) {
      if (newVal) {
        vm.locationCallback({ input: newVal });
        vm.location1 = vm.locationSearch.Code;
      };
    });
    vm.setGAEventLabel();

    $scope.$watch('reservationCardController.fromDate', function (newVal) {
      if (newVal) {
        var newDate = new Date(newVal);

        newDate.setDate(newDate.getDate() + 1);

        var dd = newDate.getDate();
        var mm = newDate.getMonth();
        var y = newDate.getFullYear();

        var newUntilDate = new Date(y, mm, dd);
        if (angular.isUndefined(vm.untilDate)) {
          newUntilDate.setHours(0, 0, 0, 0);
        } else {
          newUntilDate.setHours(vm.untilDate.getHours());
          newUntilDate.setMinutes(vm.untilDate.getMinutes());
          newUntilDate.setSeconds(vm.untilDate.getSeconds());
          newUntilDate.setMilliseconds(vm.untilDate.getMilliseconds());
        }
        vm.untilDate = newUntilDate;
        $scope.reservationCardController.untilDate = newUntilDate;
      };
    });
  };
})();

//DEADCODE
(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('promoCustomCard', promoCustomCard);

  function promoCustomCard() {

    return {
      replace: true,
      scope: {
        location: '=',
        customFieldPrefix: '@'
      },
      templateUrl: 'app/localLanding/cards/promoCustomCard.directive.html',
      restrict: 'AE',
      controller: function($scope, _) {
        var vm = this;
        vm.promoObject = {};
        vm.myInterval = 4000;
        vm.location = $scope.location;
        vm.customFieldPrefix = $scope.customFieldPrefix;

        _.each(vm.location.custom_fields, function(field) {
          if (isFieldTypeOf(field, vm.customFieldPrefix + '_image')) {
            addToPromoObject(field, 'image')
          }else if (isFieldTypeOf(field, vm.customFieldPrefix + '_url')) {
              addToPromoObject(field, 'url');
          }
        });

        function isFieldTypeOf(field, type) {
            return field.name.indexOf(type) > -1;
        }

        function addToPromoObject(field, type) {
          var name = field.name.replace(type, '');
          if (!_.isUndefined(vm.promoObject[name])) {
              vm.promoObject[name][type] = field.data;
          } else {
            var object = {};
            object[type] = field.data;
              vm.promoObject[name] = object;
          }
        }

      },
      controllerAs: 'promoCustomCardC'
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('promoCard', promoCard);

  function promoCard() {

    return {
      replace: true,
      scope: {
        location: '='
      },
      templateUrl: 'app/localLanding/cards/promoCard.directive.html',
      restrict: 'AE',
      controller: promoCardController,
      controllerAs: 'promoCardC'
    }
  }

  function promoCardController($scope, _) {
    var vm = this;
    vm.promoObject = {};
    vm.myInterval = 4000;
    vm.location = $scope.location;

    var customFields = vm.location.custom_fields;

    function compare(a, b) {
      var nameA = a.name;
      var nameB = b.name;
    
      var comparison = 0;
      if (nameA > nameB) {
        comparison = 1;
      } else if (nameA < nameB) {
        comparison = -1;
      }
      return comparison;
    }
    
    customFields.sort(compare);

    _.each(customFields, function (field) {
      if (isFieldTypeOf(field, 'promo_image')) { //hack for now
        addToPromoObject(field, 'image');
      } else if (isFieldTypeOf(field, 'promo_url')) {
        addToPromoObject(field, 'url');
      } else if (isFieldTypeOf(field, 'analytics_')) {
        addToPromoObject(field, 'analytics_');
      } else if (field.name == "PhoneNumber") {
        vm.phoneNumber = field.data;
      }
    });

    function isFieldTypeOf(field, type) {
      return field.name.indexOf(type) > -1;
    }

    function addToPromoObject(field, type) {
      var name = field.name.replace(type, '');
      if (!_.isUndefined(vm.promoObject[name])) {
        vm.promoObject[name][type] = field.data;
      } else {
        var object = {};
        object[type] = field.data;
        vm.promoObject[name] = object;
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('partnerReviewsCard', partnerReviewsCard);

  function partnerReviewsCard(_, $filter, customFieldFactory) {
    return {
      replace: true,
      scope: {
        'location': '=',
        'partnertype': '@'
        //@param partnertype can be network name (html/css styling currently only supports 'Yelp', 'Facebook', 'Foursquare, 'Google'. these are not case sensitive)
        //@param partnertype can also be or 'bestrating'/'best rating', 'mostreviews'/'most reviews'
        //@param supports custom fields review_partner_type (which works when html attribute is 'custom') and 'review_rating_minimum'
      },
      templateUrl: 'app/localLanding/cards/partnerReviewsCard.directive.html',
      restrict: 'AE',
      controllerAs: 'partnerReviewsCardC',
      bindToController: true,
      controller: function () {
        var vm = this;
        function roundUpNearestHalf(value) {
          var remainder = value % 0.5;
          if (remainder > 0 && remainder >= 0.25)
            value = value - remainder + 0.5;
          else
            value = value - remainder;
          return value;
        }

        function getFoursquareColor(rating) {
          if (rating >= 9.0) {
            return '#00B551';
          }
          else if (rating >= 8.0) {
            return '#73CF42';
          }
          else if (rating >= 7.0) {
            return '#C5DE35';
          }
          else if (rating >= 6.0) {
            return '#FFC800';
          }
          else if (rating >= 5.0) {
            return '#FF9600';
          }
          else if (rating >= 4.0) {
            return '#FF6701';
          }
          else {
            return '#E6092C';
          }
        }

        function findBestRatedPartner(partners) {
          var max = 0,
            maxPartner,
            i;
          for (i = 0; i < partners.length; i++) {
            if ('rating' in partners[i] && partners[i].master) {
              if (partners[i]._type === 'Foursquare') {
                if (partners[i].rating / 2.0 > max) {
                  max = partners[i].rating / 2.0;
                  maxPartner = partners[i];
                }
              }
              else {
                if (partners[i].rating > max) {
                  max = partners[i].rating;
                  maxPartner = partners[i];
                }
              }
            }
          }
          return maxPartner;
        }

        function findMostReviewedPartner(partners) {
          var max = 0,
            maxPartner,
            i;
          for (i = 0; i < partners.length; i++) {
            if ('total_reviews' in partners[i] && partners[i].master) {
              if (partners[i].total_reviews > max) {
                max = partners[i].total_reviews;
                maxPartner = partners[i];
              }
            }
          }
          return maxPartner;
        }

        if (vm.partnertype === 'custom') {
          var customPartnerType = customFieldFactory.getValueByName(vm.location.custom_fields, "review_partner_type");
          if (customPartnerType != null) {
            vm.partnertype = customPartnerType;
          }
          else {
            vm.partnertype = 'bestrating';
          }
        }
        if (vm.partnertype === 'bestrating' || vm.partnertype === 'best rating') {
          var partner = findBestRatedPartner(vm.location.store_info.providers);
        }
        else if (vm.partnertype === 'mostreviews' || vm.partnertype === 'most reviews') {
          var partner = findMostReviewedPartner(vm.location.store_info.providers);
        }
        else {
          var partner = _.find(vm.location.store_info.providers, function (item) {
            return item._type === vm.partnertype.charAt(0).toUpperCase() + vm.partnertype.substr(1).toLowerCase() && item.master;
          });
        }

        vm.pData = false;
        vm.title = vm.location.store_info.name ? vm.location.store_info.name : 'Find us';
        if (partner) {
          vm.partnerName = partner._type;
          vm.minRating = 0.75;
          var minRating = customFieldFactory.getValueByName(vm.location.custom_fields, "review_rating_minimum");
          if (minRating != null) {
            vm.minRating = minRating;
          }
          vm.pData = {};
          vm.pData.itemReviewed = vm.location.store_info.name + ' ' + vm.location.store_info.address;
          vm.pData.url = partner.url;
          vm.pData.rating = parseFloat(partner.rating).toFixed(1);
          vm.pData.ratingCount = partner.total_ratings;
          vm.pData.ratingFraction = vm.partnerName !== 'Foursquare' ? partner.rating / 5.0 : partner.rating / 10.0;
          vm.pData.reviewCount = partner.total_reviews;
          vm.pData.roundedRating = roundUpNearestHalf(vm.pData.rating, 0.5);
          vm.pData.roundedRatingAsPercentage = (vm.pData.roundedRating / 5.0) * 100 + '%';
          if (vm.partnerName === 'Foursquare') {
            vm.ratingColor = getFoursquareColor(vm.pData.rating);
          }
          if (vm.partnerName === 'Yelp') {
            vm.pData.yelpRoundedRatingString = vm.pData.roundedRating.toString().replace('.', '_');
            vm.pData.yelpStarUrl = 'https://s3-us-west-1.amazonaws.com/mfeed-store-locator.momentfeed.com/momentfeed/cards/partner_reviews/yelp_stars/regular_'
              + vm.pData.yelpRoundedRatingString + '@3x.png';
          }
          if (vm.partnerName === 'Google'){
            vm.pData.roundedRating = Math.round(vm.pData.rating);
          }
        }
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('nearbyCard', nearbyCard);

  function nearbyCard () {

    return {
      replace: true,
      scope: {locations: '=', includeLocality: "@"},
      templateUrl: 'app/localLanding/cards/nearbyCard.directive.html',
      restrict: 'AE',
      bindToController: {title: '=', localPageBtn: '=', personNotLocation: '='},
      controller: function ($scope, localLandingData, urlBuilderFactory, customFieldFactory) {
        var vm = this;
        var for_geo_search;
        var near = $scope.locations[0];
        vm.getDirectionsUrl = getDirectionsUrl;
        vm.getCustomFieldValueByName = getCustomFieldValueByName;
        vm.includeLocality = $scope.includeLocality == "false" ? false : true;

        localLandingData.getLocationsForGeoSearch(near.store_info.latitude, near.store_info.longitude, 20, 4).then(function (response) {
          if (response.data.length > 1) {

            $scope.locations = _.filter(response.data, function (loc) {
              return near.momentfeed_venue_id != loc.momentfeed_venue_id;
            });

          }else{
            $scope.locations = [];
          }
        })

        function getDirectionsUrl(data) {
          return urlBuilderFactory.getDirectionsUrl(data);
        }

        function getCustomFieldValueByName(customFields, name) {
          if (hasCustomFieldValue(customFields, name)) {
            var value = customFieldFactory.getValueByName(customFields, name);
          }
          return value;
        }

        function hasCustomFieldValue(customFields, name) {
          return customFieldFactory.getValueByName(customFields, name) ? true : false;
        }

      },
      controllerAs: 'nearbyCardC'
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('storeLocator')
    .directive('mfReviewsCard', mfReviewsCard);

  function mfReviewsCard() {
    return {
      replace: true,
      scope: {
        location: '=',
        disable: '@',
        pageSize: '@'
      },
      controller: RatingController,
      controllerAs: 'RatingCtrl',
      templateUrl: 'app/localLanding/cards/mfReviewsCard.directive.html',
      restrict: 'AE',
      bindToController: {}
    };

    function RatingController(_, $scope, mfReviewFactory) {
      var $ctrl = this;

      $ctrl.enableForm = true;
      $ctrl.enableReviews = true;
      if ($scope.disable) {
        if ($scope.disable.indexOf('form') != -1) {
          $ctrl.enableForm = false;
        }
        if ($scope.disable.indexOf('reviews') != -1) {
          $ctrl.enableReviews = false;
        }
      }

      $ctrl.stars = _.range(0, 5);
      if ($ctrl.max == undefined) {
        $ctrl.max = 5;
      }
      $ctrl.toggle = function (index) {
        $ctrl.activeIndex = index;
      };

      $ctrl.loadText = "Load More Reviews";

      $ctrl.pageNumber = 1;
      mfReviewFactory.getMfReviewFromLocation($scope.location.momentfeed_venue_id, $ctrl.pageNumber, $scope.pageSize, true)
        .then(function (res) {
          $ctrl.reviews = res.data.plain();
        });

      var params = {
        location_id: $scope.location.momentfeed_venue_id,
        rating: null,
        text: "",
        title: "",
        last_name: "",
        first_name: "",
        email: ""
      };
      $scope.formData = params;

      $ctrl.onSubmitClick = function () {
        if ($ctrl.activeIndex) {
          $scope.formData.rating = $ctrl.activeIndex + 1;
          $ctrl.isFormActive = true;
          if ($ctrl.isInfoValid()) {
            mfReviewFactory.postMfReviewOnLocation($scope.formData).then(function (res) {
              $ctrl.postMessage = res.status == 200 ? "Thank you for your review! 🎉" : "Service currently unavailable";
            })
          }
        }
      };

      $ctrl.isInfoValid = function () {
        for (var key in $scope.formData) {
          if ($scope.formData[key] == null || $scope.formData[key] == "") {
            return false;
          }
        }
        return true;
      };

      $ctrl.loadMore = function () {
        $ctrl.toggleExpand = true;
        $ctrl.pageNumber += 1;
        if ($ctrl.loadText != "No More Reviews") {
          mfReviewFactory.getMfReviewFromLocation($scope.location.momentfeed_venue_id, $ctrl.pageNumber, $scope.pageSize, true)
            .then(function (res) {
              $ctrl.reviews = $ctrl.reviews.concat(res.data.plain());
              if (res.data.plain().length == 0) {
                $ctrl.loadText = "No More Reviews";
              }
            });
        }
      }
    }
  }

})();

(function() {
    'use strict';

    angular.module('storeLocator').directive('menuCard2', menuCard2);

    function menuCard2() {
        return {
            replace: true,
            scope: {
                name: '=',
                storeInfo: '=',
                locationId: '=',
                link: '@',
                linkText: '@',
                languageCode: '@'
            },
            templateUrl: 'app/localLanding/cards/menuCard2.directive.html',
            restrict: 'AE',
            controller: menuCard2Controller,
            controllerAs: 'menuCard2Controller',
            bindToController: true
        };
    }

    function menuCard2Controller(menuService) {
        var menuCard2Controller = this;
        var defaultLanguageCode = "EN";

        menuCard2Controller.showMenu = false;


        if (!menuCard2Controller.languageCode) {
            menuCard2Controller.languageCode = defaultLanguageCode;
        }

        function mapCategoryOptions(categoryOptions) {
          var options = new Array();

          for (var marker = 0; marker < categoryOptions.length; marker++) {
            var option = {
              "@type":"MenuItem",
              "name": categoryOptions[marker].name,
              "description":categoryOptions[marker].description.text,
              "offers": {
                "@type": "Offer",
                "price": categoryOptions[marker].price.amount,
                "priceCurrency": categoryOptions[marker].price.currencyCode}
            }
            options.push(option)
          }
          return options
        }

        menuService.getMenu(menuCard2Controller.languageCode, menuCard2Controller.locationId).then(function (menu) {
            menuCard2Controller.menu = menu;
            menuCard2Controller.schema = {'@context':'http://schema.org', '@type':'Menu','url': menuCard2Controller.storeInfo.website,'name':menuCard2Controller.storeInfo.brand_name,'hasMenuSection': [] };
            for (var i = 0; i < menuCard2Controller.menu.length; i++) {
              var menuCategory = {'@type':'MenuSection', 'name': menuCard2Controller.menu[i].categoryName,'hasMenuItem': mapCategoryOptions(menuCard2Controller.menu[i].options)}
              menuCard2Controller.schema.hasMenuSection.push(menuCategory)
            }

            var head = document.getElementsByTagName('head')[0];
            var script = document.createElement('script');
            script.type = 'application/ld+json';
            script.text = JSON.stringify(menuCard2Controller.schema)
            head.appendChild(script);


            if (menuCard2Controller.menu !== null && menuCard2Controller.menu.length > 0) {

                  menuCard2Controller.showMenu = true;
                  menuCard2Controller.address = menuCard2Controller.storeInfo.address +
                      ", " +
                      menuCard2Controller.storeInfo.locality +
                      ", " +
                      menuCard2Controller.storeInfo.region +
                      " " +
                      menuCard2Controller.storeInfo.postcode;
                  menuCard2Controller.menu[0].active = true;
              }
        });
    }
})();


(function() {
    'use strict';

    angular.module('storeLocator').directive('menuCard', menuCard);

    function menuCard() {
        return {
            replace: true,
            scope: {
                name: '=',
                storeInfo: '=',
                locationId: '=',
                link: '@',
                linkText: '@',
                languageCode: '@'
            },
            templateUrl: 'app/localLanding/cards/menuCard.directive.html',
            restrict: 'AE',
            controller: menuCardController,
            controllerAs: 'menuCardController',
            bindToController: true
        };
    }

    function menuCardController(menuService) {
        var menuCardController = this;
        var defaultLanguageCode = "EN";

        menuCardController.showMenu = false;


        if (!menuCardController.languageCode) {
            menuCardController.languageCode = defaultLanguageCode;
        }

        function mapCategoryOptions(categoryOptions) {
          var options = new Array();

          for (var marker = 0; marker < categoryOptions.length; marker++) {
            var option = {
              "@type":"MenuItem",
              "name": categoryOptions[marker].name,
              "description":categoryOptions[marker].description.text,
              "offers": {
                "@type": "Offer",
                "price": parseFloat(categoryOptions[marker].price.amount).toFixed(2),
                "priceCurrency": categoryOptions[marker].price.currencyCode}
            }
            options.push(option)
          }
          return options
        }

        menuService.getMenu(menuCardController.languageCode, menuCardController.locationId).then(function (menu) {
            for(var x = 0; x < menu.length; x++) {
              for(var y = 0; y < menu[x].options.length; y++) {
                var amount = menu[x].options[y].price.amount
               if(amount) menu[x].options[y].price.amount = parseFloat(amount).toFixed(2)
              }
            }
            menuCardController.menu = menu;
            menuCardController.schema = {'@context':'http://schema.org', '@type':'Menu','url': menuCardController.storeInfo.website,'name':menuCardController.storeInfo.brand_name,'hasMenuSection': [] };

            for (var i = 0; i < menuCardController.menu.length; i++) {
              var menuCategory = {'@type':'MenuSection', 'name': menuCardController.menu[i].categoryName,'hasMenuItem': mapCategoryOptions(menuCardController.menu[i].options)}
              menuCardController.schema.hasMenuSection.push(menuCategory)
            }

            var head = document.getElementsByTagName('head')[0];
            var script = document.createElement('script');
            script.type = 'application/ld+json';
            script.text = JSON.stringify(menuCardController.schema)
            head.appendChild(script);


            if (menuCardController.menu !== null && menuCardController.menu.length > 0) {

                  menuCardController.showMenu = true;
                  menuCardController.address = menuCardController.storeInfo.address +
                      ", " +
                      menuCardController.storeInfo.locality +
                      ", " +
                      menuCardController.storeInfo.region +
                      " " +
                      menuCardController.storeInfo.postcode;
                  menuCardController.menu[0].active = true;
              }
        });

        menuCardController.menuLoaded = function() { // When the menu has loaded
          var menu = Array.from(document.getElementsByClassName('menu-content'))[0]
          var nav = Array.from(menu.getElementsByClassName('nav-tabs'))[0]

          setTimeout(function() {
            makeOptionsAccessible() // Add tab indicies to menu items to make them accessible via tabbing
            navigateMenu(nav) // Change focus and tab indicies on category tabs when navigating via arrow keys
          },300)
        }

        function makeOptionsAccessible() {
          var menuOptions = Array.from(document.getElementsByClassName('menu-option'))
          menuOptions.forEach(function(el) {
            el.setAttribute('tabindex', '0');
          })
        }

        function navigateMenu(nav) {
          var tabs = Array.from(nav.children);
          tabs.forEach(function(tab, i) {
            if(i > 0) focusAndSetTabIndicies({negativeOne: tab}) // Set tabindex for category tabs to disable tabbing between

            tab.addEventListener('keydown', function(e){
              var currentTab = this;
              var navtabsLI = Array.from(currentTab.parentNode.children);
  
              if(e.keyCode == 39) { // When right arrow key is pressed,
                e.preventDefault();
                for(var i = 0; i < navtabsLI.length; i++) {
                  if(navtabsLI[i] == currentTab) {
                    var nextTab = navtabsLI[i + 1]
                    var previousTab = navtabsLI[i]
                    focusAndSetTabIndicies({negativeOne: previousTab, zero: nextTab, focus: nextTab}) // make tab before current inaccessible via tab, make next tab accessible via tab (so you can get back to it by reverse tabbing through the options) and focus on next tab
                  } 
                }
              } else if (e.keyCode == 37) { // When left arrow key is pressed,
                e.preventDefault();
                for(var i = 0; i < navtabsLI.length; i++) {
                  if(navtabsLI[i] == currentTab) {
                    var previousTab = navtabsLI[i - 1]
                    focusAndSetTabIndicies({negativeOne: currentTab, zero: previousTab, focus: previousTab}) // make current tab inaccessible via tab, make tab before accessible via tab, put focus on previous tab
                  } 
                }
              }
            })
          })
        }

        function focusAndSetTabIndicies(obj) {
          var a;
          for(var key in obj) {
            a = Array.from(obj[key].getElementsByTagName('a'))[0];
            if(key == 'negativeOne') a.setAttribute('tabindex', '-1');
            if(key == 'zero') a.setAttribute('tabindex', '0');
            if(key == 'focus') a.focus();
          }
        }
    }
})();


(function () {
  'use strict';
  angular
    .module('storeLocator')
    .directive('mapCardLocality', mapCardLocality);

  function mapCardLocality(MAPBOX_KEY, STORE_LOCATOR_PIN_ICON, STORE_LOCATOR_PIN, $filter, _, mapHelper, GOOGLE_API_KEY) {
    return {
      replace: true,
      scope: {
        locations: '=',
        height: '=',
        windowWidth: '='
      },
      templateUrl: 'app/localLanding/cards/mapCardLocality.directive.html',
      restrict: 'AE',
      bindToController: true,
      controllerAs: 'mapCardLocalityC',
      controller: function () {
        var vm = this;
        vm.isGoogleMapsEnabled = mapHelper.isGoogleMapsEnabled();
        vm.MAPBOX_KEY = MAPBOX_KEY;
        vm.windowWidth = window.innerWidth;
        vm.zoom = 9;
        vm.index = 1;
        var pinTextArray = [];
        var locationCount = 0;
        var latTotal = 0;
        var lngTotal = 0;
        var latNumber = 0;
        var lngNumber = 0;
        var neLat = -999;
        var neLng = -999;
        var swLat = 999;
        var swLng = 999;
        angular.forEach(vm.locations, function (location) {
          for (var i =0; i<location.length; i++) {
            pinTextArray.push(generatePinText(vm.index++, location[i], STORE_LOCATOR_PIN_ICON, STORE_LOCATOR_PIN, $filter));
            latNumber = parseFloat(location[i].store_info.latitude);
            lngNumber = parseFloat(location[i].store_info.longitude);

            latTotal = latTotal + latNumber;
            lngTotal = lngTotal + lngNumber;
            locationCount++;

            if (latNumber > neLat) {
              neLat = latNumber;
            }
            if (lngNumber > neLng) {
              neLng = lngNumber;
            }
            if (latNumber < swLat) {
              swLat = latNumber;
            }
            if (lngNumber < swLng) {
              swLng = lngNumber;
            }
          }
        });
        vm.mapPins = pinTextArray.join();
        var newOriginLat = latTotal / locationCount;
        var newOriginLong = lngTotal / locationCount;
        vm.origin = {
          'latitude': newOriginLat,
          'longitude': newOriginLong
        };
        if (locationCount == 1) {
          vm.zoom = 9;
        } else if ((Math.log(360 / (neLat - swLat)) / Math.log(2)) > 9 && (Math.log(360 / (neLng - swLng)) / Math.log(2)) > 9) {
          vm.zoom = 9;
        } else if ((neLat - swLat) > (neLng - swLng)) {
          vm.zoom = Math.log(360 / (neLat - swLat)) / Math.log(2);
        } else {
          vm.zoom = Math.log(360 / (neLng - swLng)) / Math.log(2);
        }

        if (vm.isGoogleMapsEnabled) {
          var src = 'https://www.gstatic.com/charts/loader.js';
          var script = document.createElement('script');
          script.onload = function () {
            google.charts.load('current', {'packages': ['map']}, {mapsApiKey: GOOGLE_API_KEY});
            google.charts.setOnLoadCallback(function () {
              drawMap(vm.locations.map(function (e, i) {
                return [
                  parseFloat(e.store_info.latitude),
                  parseFloat(e.store_info.longitude),
                  i + 1 + ": " + e.store_info.name + " | " + e.store_info.address
                ]
              }))
            });
          };
          script.src = src;
          document.getElementsByTagName('head')[0].appendChild(script);
        }
      }
    };
  }

  function generatePinText(index, location, pin_icon, locator_pin, $filter) {
    var pinText = '';
    if (pin_icon) {
      pinText = 'url-' + $filter('urlCleaner')(pin_icon);
    } else {
      pinText = 'pin-l-' + index + '+' + $filter('removeHash')(locator_pin);
    }
    pinText += "(" + location.store_info.longitude + "," + location.store_info.latitude + ")";
    return pinText;
  }

  function drawMap(locs) {
    var data = google.visualization.arrayToDataTable([
      ['Lat', 'Long', 'Location']
    ].concat(locs));
    var options = {
      // showTooltip: true,
      mapType: 'normal',
      showInfoWindow: true,
    };

    var map = new google.visualization.Map(document.getElementById('google_chart_map'));

    map.draw(data, options);

  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('mapCard', mapCard);

  function mapCard(MAPBOX_KEY, STORE_LOCATOR_PIN_ICON, STORE_LOCATOR_PIN, mapHelper, GOOGLE_API_KEY, $filter, _) {

    return {
      replace: true,
      scope: {
        location: '=',
        height: '=',
        windowWidth: '='
      },
      templateUrl: 'app/localLanding/cards/mapCard.directive.html',
      restrict: 'AE',
      bindToController: true,
      controllerAs: 'mapCardC',
      controller: function () {
        var vm = this;
        vm.isGoogleMapsEnabled = mapHelper.isGoogleMapsEnabled();
        if (vm.isGoogleMapsEnabled) {
          vm.MAP_KEY = GOOGLE_API_KEY;
          if (STORE_LOCATOR_PIN_ICON) {
            vm.mapPin = "icon:" + $filter('urlCleaner')(STORE_LOCATOR_PIN_ICON) + "|"
          } else {
            vm.mapPin = "color:" + $filter('removeHash')(STORE_LOCATOR_PIN) + "|"
          }
        } else {
          vm.MAP_KEY = MAPBOX_KEY;
          if (STORE_LOCATOR_PIN_ICON) {
            vm.mapPin = 'url-' + $filter('urlCleaner')(STORE_LOCATOR_PIN_ICON)
          } else {
            vm.mapPin = 'pin-l-1+' + $filter('removeHash')(STORE_LOCATOR_PIN)
          }
        }
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('managerCard', managerCard);

  function managerCard() {

    return {
      replace: true,
      scope: {
        location: '='
      },
      templateUrl: 'app/localLanding/cards/managerCard.directive.html',
      restrict: 'AE'
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('llpContentCard', llpContentCard);

  function llpContentCard() {

    return {
      replace: true,
      scope: {
        publishedContent: '='
      },
      templateUrl: 'app/localLanding/cards/llpContentCard.directive.html',
      restrict: 'AE',
      controller: function(moment, $filter) {
        var vm = this;

        if(vm.publishedContent.link_url) {
          vm.filteredLink = $filter('hasHttp')(vm.publishedContent.link_url);
        } else {
          vm.filteredLink = '';
        }

        vm.published_date_tz = moment.utc(moment(vm.publishedContent.published_on)).local().format('MMM DD, YYYY [at] h:mm A');

      },
      controllerAs: 'llpContentCardC',
      bindToController: true
    };
  }
})();


(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('instagramCard', instagramCard);

  function instagramCard() {

    return {
      replace: true,
      scope: {
        photos: '=',
        location: '='
      },
      templateUrl: 'app/localLanding/cards/instagramCard.directive.html',
      restrict: 'AE',
      controller: function ($q, $scope, INSTAGRAM_HANDLE, localLandingData) {
        var vm = this;

        $q.when(localLandingData.getPhotosForLocation()).then(function (v) {
          $scope.photos = _.filter(v.data, function(d){
            return d.media_type !== 'VIDEO'
          });
        });

        vm.igData = {};
        vm.llp_url = $scope.location.llp_url;
        vm.igData.url = 'https://www.instagram.com/' + INSTAGRAM_HANDLE;
        vm.title = $scope.location.store_info.name ? $scope.location.store_info.name : 'Find us';
      },
      controllerAs: 'instagramCardC'
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('instagram9Card', instagram9Card);

  function instagram9Card ($sce) {

    return {
      replace: true,
      scope: { photos: '=',location: '='},
      templateUrl: 'app/localLanding/cards/instagram9Card.directive.html',
      restrict: 'AE',
      controller: function ($q,$scope,INSTAGRAM_HANDLE,localLandingData) {
        var vm = this;
        $q.when(localLandingData.getPhotosForLocation()).then(function (v) {
          var fallback = "";
          var foundValidPicture = _.filter(v.data, function(o) {
            return o.owner.hasOwnProperty('profile_picture_url');
          });
          if (!_.isEmpty(foundValidPicture)) {
            fallback = foundValidPicture[0]['owner']['profile_picture_url'];
          }

          v.data.map(function (o) {
            o.fallback_url = $sce.trustAsResourceUrl(fallback);
            if (o.thumbnail_url) {
              o.trust_url = $sce.trustAsResourceUrl(o.thumbnail_url);
            } else {
              o.trust_url = $sce.trustAsResourceUrl(o.media_url);
            }
          });
          $scope.photos = v.data;
        });

        vm.igData = {};
        vm.llp_url = $scope.location.llp_url;
        vm.igData.url = 'https://www.instagram.com/' + INSTAGRAM_HANDLE;
        vm.title = $scope.location.store_info.name ? $scope.location.store_info.name : 'Find us';

      },
      controllerAs: 'instagram9CardC'
    };
  }
})();


(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('htmlCard', htmlCard);

  function htmlCard() {

    return {
      replace: true,
      scope: {
        location: '=',
        htmlContent: '@'
      },
      templateUrl: 'app/localLanding/cards/htmlCard.directive.html',
      restrict: 'AE',
      controller: htmlCardController,
      controllerAs: 'htmlCardC',
      bindToController: true
    };
  }

  function htmlCardController(_) {
    var htmlCardC = this;
    htmlCardC.content = _.find((htmlCardC.location.custom_fields || htmlCardC.location.customFields), {'name': htmlCardC.htmlContent});
  }
})();


(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('hoursCollapseCard', hoursCollapseCard);

  function hoursCollapseCard() {
    return {
      replace: true,
      scope: {
        location: '=',
        onlyToday: '='
      },
      templateUrl: 'app/localLanding/cards/hoursCollapseCard.directive.html',
      restrict: 'AE',
      controller: HoursController,
      controllerAs: 'hoursCardC',
      bindToController: true
    };
  }

  function HoursController(_, s, moment) {
    var hoursCardC = this;

    var days = _.range(1, 8),
      todayNum = moment().format("E"),
      sh = hoursCardC.location && hoursCardC.location.store_info ? s(hoursCardC.location.store_info.store_hours).trim(";").value() : null,
      formatTime = function (t) {
        return moment(t, "HHmm").format("h:mm a");
      };

    hoursCardC.locHours = false;
    hoursCardC.closedNow = true;
    hoursCardC.openingHours = '';

    if (sh) {
      hoursCardC.locHours = {};
      //Initialize all days as closed
      days.forEach(function (d) {
        hoursCardC.locHours[d + ""] = {
          dayName: moment().isoWeekday(d).format("dddd"),
          dayNameShort: moment().isoWeekday(d).format("dd"),
          dayNameShortNext: moment().isoWeekday(d).add(1, 'd').format("dd"),
          closedLabel: "Closed"
        }
      });

      sh.split(";").forEach(function (dh) {
        var info = dh.split(",").map(function (i) {
            return s(i).trim().value();
        });
        if (info.length) {
          var dayNum = info[0] + "",
            v = hoursCardC.locHours[dayNum];
          v.openTime = formatTime(info[1]);
          v.closeTime = formatTime(info[2]);
          v.openMoment = moment(info[1], "HHmm");
          v.openMoment24 = v.dayNameShort + ' ' + v.openMoment.format("H:mm");

          if(_.startsWith(info[2], '0')) {
            v.closeMoment = moment(info[2], "HHmm").add(1, 'd');
            v.closeMoment24 = v.dayNameShortNext + ' ' + v.closeMoment.format("H:mm");
          } else {
            v.closeMoment = moment(info[2], "HHmm");
            v.closeMoment24 = v.closeMoment.format("H:mm");
          }

          v.openingHours = v.openMoment24 + '-' + v.closeMoment24;
          hoursCardC.openingHours = hoursCardC.openingHours + v.dayNameShort + ' ' + v.openTime + ' - ' + v.closeTime + ' ';

          v.closedLabel = false;
          if(todayNum == dayNum){
            v.highlightClass = 'bold-700';
            var now = moment();
            hoursCardC.openToday = v.openTime;
            hoursCardC.closeToday = v.closeTime;
            if(now.isAfter(v.openMoment) && now.isBefore(v.closeMoment)){
              hoursCardC.closedNow = false;
            }
          }
        }
      });
    }

    hoursCardC.hoursNote = _.find(hoursCardC.location.custom_fields, {'name': 'hours_note'});

  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('hoursCard', hoursCard);

  function hoursCard() {
    return {
      replace: true,
      scope: {
        location: '=',
        onlyToday: '=',
        customText: '@',
        hideEmptyHours: '='
      },
      templateUrl: 'app/localLanding/cards/hoursCard.directive.html',
      restrict: 'AE',
      controller: HoursController,
      controllerAs: 'hoursCardC',
      bindToController: true
    };
  }

  function HoursController(_, s, moment) {
    var hoursCardC = this;
    hoursCardC.closedNow = true;
    hoursCardC.open24 = false;
    hoursCardC.tempClosed = false;
    hoursCardC.openingHours = '';

    // if temp closed, set hoursCardC.tempClosed
    if(hoursCardC.location.status == "temp closed") {
      hoursCardC.tempClosed = true;
    }

    // returns the hour fragment for the day depending on the passed key value
    hoursCardC.getOpenTimePeriodDisplayMessage = function(regularHours, index) {
      var key = '';
      if (angular.isDefined(index)) {
        key = 'openTimePeriodDisplayMessage_' + index;
      } else {
        key = 'openTimePeriodDisplayMessage';
      }
      return regularHours[key];
    };

    /**
     * function returns true if passed value is null, undefined and legth is zero, else false
     * @param {string} storeTimeZone 
     */
    function checkObj(storeTimeZone) {
      return ( _.isNull(storeTimeZone) || _.isUndefined(storeTimeZone) || storeTimeZone.length === 0 )
    }

    /**
     * function to check if the store is open or closed and set
     * the corresponding 'closedNow' value on the directive object
     * @param {object} hourObj hour object which has all the details about the timings/days
    */
    function updateTodaysHours(hourObj) {
      if (hourObj.closed) {
        hoursCardC.closed24 = true;
        return;
      }
      // check for today's special hours. start
      var isTodaySpecial = isTodaySpecialHours();
      //check for today's special hours. end
      //counter to loop through the number of fragments
      var counter = 0;
      while (counter < hourObj.numberOfTimeFragments.length) {
        var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
        var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;

        if (hourObj[openTimePeriodKey] && hourObj[closeTimePeriodKey]) {
          hoursCardC[openTimePeriodKey] = moment(hourObj[openTimePeriodKey], "hh:mm A").format("h:mm a")
          hoursCardC[closeTimePeriodKey] = moment(hourObj[closeTimePeriodKey], "hh:mm A").format("h:mm a");
        }

        if (moment(hourObj[closeTimePeriodKey], "hh:mm A").isBefore(moment(hourObj[openTimePeriodKey], "hh:mm A")) || moment(hourObj[closeTimePeriodKey], "HH:mm A").format('HHmm') === '0000') {
          hourObj[closeTimePeriodKey] = moment(hourObj[closeTimePeriodKey], "hh:mm A").add(1, 'days');
        }

        var amIBetweenGroupKey = 'amIBetweenGroup' + '_' + counter;
        var now = moment();
        // store timezone code start
        var storeTimeZone = hoursCardC.location.store_info.timezone; // store timezone from api
        var storeCurrentDateTime = null;
        var convertedStoreHour = null;
        var isInvalidObj = checkObj(storeTimeZone);
        if (!isInvalidObj) {
          storeCurrentDateTime = getStoreCurrentTime(storeTimeZone);
          convertedStoreHour = moment(getConvertedStoreHours(storeCurrentDateTime), "hh:mm A");
        }
        // store timezone code end
        // instead of now object the comparison is made with convertedStoreHour object
        var startTime = moment(hourObj[openTimePeriodKey], "hh:mm A");
        var endTime = moment(hourObj[closeTimePeriodKey], "hh:mm A");
        if(!isInvalidObj){
          if (endTime.format('HHmm') < (startTime.format('HHmm'))) {
            if (convertedStoreHour.format('HHmm') < endTime.format('HHmm')) {
              startTime = startTime.subtract(1, 'days');
            } else {
              endTime = endTime.add(1, 'days');
            }
          }
          amIBetweenGroupKey = convertedStoreHour.isBetween(startTime, endTime);
        } else {
          if (endTime.format('HHmm') < (startTime.format('HHmm'))) {
            if (now.format('HHmm') < endTime.format('HHmm')) {
              startTime = startTime.subtract(1, 'days');
            } else {
              endTime = endTime.add(1, 'days');
            }
          }
          amIBetweenGroupKey = now.isBetween(startTime, endTime);
        }

        if (amIBetweenGroupKey) {
          hoursCardC.closeToday = endTime.format("h:mm a");
          if (amIBetweenGroupKey || hourObj.open24) {
            hoursCardC.closedNow = false;
          } else {
            hoursCardC.closedNow = true;
          }
        } else if(isTodaySpecial && !amIBetweenGroupKey){
          hoursCardC.closeToday = endTime.format("h:mm a");
          hoursCardC.closedNow = true;
        }
        counter++;
      }

      hoursCardC.openToday = hourObj.openDisplayTime;
      hoursCardC.open24 = hourObj.open24;
    }

    function isTodaySpecialHours(){
      var isTodaySpecial = false;
      var specialHours = (hoursCardC.location &&
        hoursCardC.location.store_info &&
        hoursCardC.location.store_info.special_hours) ?
        s(hoursCardC.location.store_info.special_hours).trim(";").value() : null;
          
      if (specialHours !== null) {
        // Check if any special hours are coming up.
        var validSpHours = checkSpecialHours(specialHours);
        if (!_.isEmpty(validSpHours)) {
          isTodaySpecial=true;
        }
      } 
      return isTodaySpecial;
    }

    function parseDateStrings(dateStrs) {
      var intDateStrs = dateStrs.split(";");
      return _.map(intDateStrs, function(dateStr) {
        var info = dateStr.split(",");
        if (angular.isDefined(info[1]) && info[1].toUpperCase() === "CLOSED") {
          // return just the day. This way we can use it to determine if today == which hour obj.
          return {
            day: info[0]
          };
        }
        else {
          // Else add open and close times based on the strings.
          // Will moment parse these to more readable strings later.
          return {
            day: info[0],
            openTime: info[1],
            closeTime: info[2]
          };
        }
      });
    }

    /**
     * function generates hours object for each day
     * @param {string} dateStrs open and close times for the week
     * @param {string} closeLabel close label for the location
    */
    function generateHours(dateStrs, closeLabel) {
      // Split up the dateStrs and generate objects for each one
      var parsedDateStrs = parseDateStrings(dateStrs);
      var locHours = {};
      _.range(1, 8).forEach(function(day) {
        // Generate base objects per day
        var newHoursObj = {
          day: day.toString(),
          dayName: moment().isoWeekday(day).format("dddd"),
          dayNameShort: moment().isoWeekday(day).format("dd"),
          dayNameShortNext: moment().isoWeekday(day).add(1, 'd').format("dd"),
          closedLabel: closeLabel
        };
        // filter method gets all the matching objects for a certain day of the week
        var parsedData = _.filter(parsedDateStrs, function(obj) {
          return obj['day'] === day.toString();
        });

        // all the open and close time for the store location in an array
        var openTime = _.map(parsedData, 'openTime');
        var closeTime = _.map(parsedData, 'closeTime');
        // adding the values to the object we will need to display all the times
        // and proper messaging for the store hours
        parsedData = {};
        _.forEach(openTime, function(value, key) {
          //moment js doesn't recognize 2400 hrs
          if (closeTime[key] === '2400') {
            closeTime[key] = '0000';
          }
          parsedData['openTime' + 'PeriodDisplayMessage' + '_' + key] = displayOpenAndClosedTime(openTime[key], closeTime[key]);
          parsedData['openTime' + 'Period' + '_' + key] = openTime[key] ? moment(openTime[key],"hmm").format("hh:mm A") : "";
          parsedData['closeTime' + 'Period' + '_' + key] = closeTime[key] ? moment(closeTime[key],"hmm").format("hh:mm A") : "";
          parsedData['openTime'] = openTime[0];
          parsedData['closeTime'] = closeTime[0];
          parsedData['numberOfTimeFragments'] = new Array(_.keys(openTime).length);
        });

        //we need the numberOfTimeFragments to display the correct message when clients pass empty store hours for the day
        if (openTime.length === 0) {
          parsedData['numberOfTimeFragments'] = new Array(1);
        }

        _.assign(newHoursObj, parsedData);
        locHours[day] = createHoursObj(newHoursObj);
        // Check if Today. If so, apply highlighting and modify
        // some controller level variables in a separate function.
        if (day.toString() === moment().format("E")) {
          locHours[day].highlightClass = "bold-700";
          //initialize the open and close time empty arrays
          openTime = [];
          closeTime = [];
          var counter = 0;
          while (counter < locHours[day]['numberOfTimeFragments'].length) {
            var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
            var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;
            if (locHours[day][openTimePeriodKey] && locHours[day][openTimePeriodKey].length > 0 && locHours[day][closeTimePeriodKey].length > 0) {
              openTime.push(locHours[day][openTimePeriodKey]);
              closeTime.push(locHours[day][closeTimePeriodKey]);
            }
            counter++;
          }

          // when the location does not have hours for the day we
          // assume that it is closed
          if (openTime.length > 0 && closeTime.length > 0) {
            locHours[day].openTimePeriodDisplayMessage = isTheLocationOpen(openTime, closeTime);
          } else {
            locHours[day].closed = true;
          }
          updateTodaysHours(locHours[day]);
        }
      });

      return locHours;
    }

    /**
     * function generates the display time message for the different
     * periods/times for which the store is open
     * @param {string} openTime open time for the store
     * @param {string} closeTime close time for the store
    */
    function displayOpenAndClosedTime(openTime, closeTime) {
      var displayTime = "";
      if (openTime && closeTime) {
        displayTime = moment(openTime, "hmm").format("h:mm a") + " " + "-" + " " + moment(closeTime, "hmm").format("h:mm a");
      }
      return displayTime;
    }

    /**
     * function is used to get the current time in the store timezone
     * @param {string} actualStoreTimeZone 
     */
    function getStoreCurrentTime(actualStoreTimeZone){
      var currentStoreDateTime = null;
      var isInvalidObj = checkObj(actualStoreTimeZone);
      if (!isInvalidObj) {
        currentStoreDateTime = angular.isDefined((moment.tz.zone(actualStoreTimeZone))) ? moment.tz(actualStoreTimeZone).format('YYYY-MM-DD hh:mm A') : moment().format('YYYY-MM-DD hh:mm A');//
      }
      return currentStoreDateTime;
    }

    /**
     * function is used to get the time part from the converted store timezone
     * @param {moment} storeCurrentDateTime 
     */
    function getConvertedStoreHours(storeCurrentDateTime){
      var convertedStoreHours = null;
      var currTimeArr = storeCurrentDateTime.split(" ");
      var isInvalidObj = checkObj(currTimeArr);
      if (!isInvalidObj){ 
        var isInvalidObj1 = checkObj(currTimeArr[1]);
        if(!isInvalidObj1 && currTimeArr.length > 1){
          convertedStoreHours = currTimeArr[1].trim().concat(" ").concat(currTimeArr[2].trim()) ;
        }
      }
      return convertedStoreHours;
    }
    
    /**
     * function is used to generate the appropriate messaging for the
     * current day including store open/close times.
     * @param {array} openTime open time for the store for the current day
     * @param {array} closeTime close time for the store for the current day
    */
    function isTheLocationOpen(openTime, closeTime) {
      var amIBetweenFirstGroup = false;
      var amIBetweenSecondGroup = false;
      var amIBetweenThirdGroup = false;
      var storeOpenOrCloseMessage = '';
      var currentTime = moment();
      var displayMessage = '';
      var startTimeFirstGroup = openTime[0] ? moment(openTime[0].trim(), "HH:mm A") : "Closed Today";
      var endTimeFirstGroup = closeTime[0] ? moment(closeTime[0].trim(), "HH:mm A") : "Closed Today";

      var openTwentyFourHours = false;
      // store timezone code start
      var storeTimeZone = hoursCardC.location.store_info.timezone; // store timezone from api
      var storeCurrentDateTime = null;
      var convertedLocStoreHour = null;
      var isInvalidObj = checkObj(storeTimeZone);
      if (!isInvalidObj) {
        storeCurrentDateTime = getStoreCurrentTime(storeTimeZone);
        convertedLocStoreHour = moment(getConvertedStoreHours(storeCurrentDateTime), "hh:mm A");
      } else {
        convertedLocStoreHour = currentTime;
      }
      // store timezone code end
      
      if (openTime.length === 2) {
        var startTimeSecondGroup = moment(openTime[1], "HH:mm A");
        var endTimeSecondGroup = moment(closeTime[1], "HH:mm A");
      } else if (openTime.length === 3) {
        var startTimeThirdGroup = moment(openTime[2], "HH:mm A");
        var endTimeThirdGroup = moment(closeTime[2], "HH:mm A");
        startTimeSecondGroup = moment(openTime[1], "HH:mm A");
        endTimeSecondGroup = moment(closeTime[1], "HH:mm A");
      }
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
       // check if the close time is on the next date in the A.M.
        if (endTimeFirstGroup.format('HHmm') < (startTimeFirstGroup.format('HHmm')) || moment(closeTime[0], "HH:mm A").format('HHmm') === '0000') {
          //open 24 message if the store is open for 24hrs
          if (endTimeFirstGroup.format('HHmm') - (startTimeFirstGroup.format('HHmm')) === 0) {
            openTwentyFourHours = true;
          }
          // Check the user currentime is before shop close time then subtract 1 day from start date
          // as the shop has started in previous day
          // else add 1 day to end date as the shop will be closing on next day
          if (convertedLocStoreHour.format('HHmm') < (endTimeFirstGroup.format('HHmm'))) {
            startTimeFirstGroup = startTimeFirstGroup.subtract(1, 'days');
          } else {
            endTimeFirstGroup = endTimeFirstGroup.add(1, 'days');
          }
        }
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      if (openTime.length === 2 && closeTime.length === 2) {
        // check if the close time is on the next date in the A.M.
        if (endTimeSecondGroup.isBefore(startTimeSecondGroup) || moment(closeTime[1], "HH:mm A").format('HHmm') === '0000') {
          endTimeSecondGroup = endTimeFirstGroup.add(1, 'days');
        }
        displayMessage = moment(openTime[0], "hh:mm A").format("h:mm a") + ' - '  + moment(closeTime[0], "hh:mm A").format("h:mm a") + ', ' +
                         moment(openTime[1], "hh:mm A").format("h:mm a") + ' - ' + moment(closeTime[1], "hh:mm A").format("h:mm a");
        // instead of currentTime object the comparison is made with convertedLocStoreHour object
        if (!isInvalidObj) {
          amIBetweenFirstGroup = convertedLocStoreHour.isBetween(startTimeFirstGroup, endTimeFirstGroup);
          amIBetweenSecondGroup = convertedLocStoreHour.isBetween(startTimeSecondGroup, endTimeSecondGroup);
        } else {
          // earlier implementation
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
          amIBetweenSecondGroup = currentTime.isBetween(startTimeSecondGroup, endTimeSecondGroup);
        }

        if (amIBetweenFirstGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[0], "hh:mm A").format("h:mm a") + ', ' + displayMessage;
        } else if (amIBetweenSecondGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[1], "hh:mm A").format("h:mm a") + ', ' + displayMessage;
        } else {
          storeOpenOrCloseMessage = "Closed Now. Today's Hours: " + displayMessage;
        }
      } else if (openTime.length === 3 && closeTime.length === 3) {
        // if there are three fragments for store hours
        // check if the second fragment close time is on the next date in the A.M.
        if (endTimeSecondGroup.isBefore(startTimeSecondGroup) || moment(closeTime[1], "HH:mm A").format('HHmm') === '0000') {
          endTimeSecondGroup = endTimeFirstGroup.add(1, 'days');
        }
        // check if the third fragment close time is on the next date in the A.M.
        if (endTimeThirdGroup.isBefore(startTimeThirdGroup) || moment(closeTime[2], "HH:mm A").format('HHmm') === '0000') {
          endTimeThirdGroup = endTimeSecondGroup.add(1, 'days');
        }
        displayMessage = moment(openTime[0], "hh:mm A").format("h:mm a") + ' - ' + moment(closeTime[0], "hh:mm A").format("h:mm a") + ', ' +
                         moment(openTime[1], "hh:mm A").format("h:mm a") + ' - ' + moment(closeTime[1], "hh:mm A").format("h:mm a") + ', ' +
                         moment(openTime[2], "hh:mm A").format("h:mm a") + ' - ' + moment(closeTime[2], "hh:mm A").format("h:mm a");

        // time fragment flags
        // instead of currentTime object the comparison is made with convertedLocStoreHour object
        if (!isInvalidObj) {
          amIBetweenFirstGroup = convertedLocStoreHour.isBetween(startTimeFirstGroup, endTimeFirstGroup); // currentTime is replaced with convertedStoreHrs
          amIBetweenSecondGroup = convertedLocStoreHour.isBetween(startTimeSecondGroup, endTimeSecondGroup); // currentTime is replaced with convertedStoreHrs
          amIBetweenThirdGroup = convertedLocStoreHour.isBetween(startTimeThirdGroup, endTimeThirdGroup); // currentTime is replaced with convertedStoreHrs
        } else {
          // earlier implementation
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup); // currentTime is replaced with convertedStoreHrs
          amIBetweenSecondGroup = currentTime.isBetween(startTimeSecondGroup, endTimeSecondGroup); // currentTime is replaced with convertedStoreHrs
          amIBetweenThirdGroup = currentTime.isBetween(startTimeThirdGroup, endTimeThirdGroup); // currentTime is replaced with convertedStoreHrs
        }
        if (amIBetweenFirstGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[0], "hh:mm A").format("h:mm a") + ', ' + displayMessage;
        } else if (amIBetweenSecondGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[1], "hh:mm A").format("h:mm a") + ', ' + displayMessage;

        } else if (amIBetweenThirdGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[2], "hh:mm A").format("h:mm a") + ', ' + displayMessage;
        } else {
          storeOpenOrCloseMessage = "Closed Now. Today's Hours: " + displayMessage;
        }
      } else {
        // below line is commented to implement the store timezone changes
        //amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
        // instead of currentTime object the comparison is made with convertedLocStoreHour object
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        if (!isInvalidObj) {
          /* if (endTimeFirstGroup.format('HHmm') < (startTimeFirstGroup.format('HHmm')) || moment(closeTime[0], "HH:mm A").format('HHmm') === '0000') {
            //open 24 message if the store is open for 24hrs
            if (endTimeFirstGroup.format('HHmm') - (startTimeFirstGroup.format('HHmm')) === 0) {
              openTwentyFourHours = true;
            }
            // Check the user currentime is before shop close time then subtract 1 day from start date
            // as the shop has started in previous day
            // else add 1 day to end date as the shop will be closing on next day
            if (convertedLocStoreHour.format('HHmm') < (endTimeFirstGroup.format('HHmm'))) {
              startTimeFirstGroup = startTimeFirstGroup.subtract(1, 'days');
            } else {
              endTimeFirstGroup = endTimeFirstGroup.add(1, 'days');
            }
          } */
            amIBetweenFirstGroup = convertedLocStoreHour.isBetween(startTimeFirstGroup, endTimeFirstGroup);
        } else { // in case if timezone is not populated in timezone variable then it should display as earlier
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
        }
        if (openTwentyFourHours) {
          storeOpenOrCloseMessage = 'Open 24 Hours';
        } else {
          if (amIBetweenFirstGroup) {
            storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[0], "hh:mm A").format("h:mm a");
          } else {
            storeOpenOrCloseMessage = "Closed Now. Today's Hours: " + moment(openTime[0], "hh:mm A").format("h:mm a") + ' - ' + moment(closeTime[0], "hh:mm A").format("h:mm a");
          }
        }
      }
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      return storeOpenOrCloseMessage;
    }

    function generateSpecialHours(dateStrs) {
      // Split up the dateStrs and generate objects for each one
      var parsedDateStrs = parseDateStrings(dateStrs);
      var dates = _.uniq(_.map(parsedDateStrs, 'day'));
      var spHours = [];

      _.forEach(dates, function(date) {
        // Generate base objects per day
        var newHoursObj = {
          closedLabel: "Closed",
          dayNameShort: date,
          dayOfTheWeek: moment(date, "YYYY-MM-DD").format("E")
        };

        var parsedData = _.filter(parsedDateStrs, function(obj) {
          return obj['day'] === date.toString();
        });
        
        // all the open and close time for the store location in an array
        var openTime = _.map(parsedData, 'openTime');
        var closeTime = _.map(parsedData, 'closeTime');
        parsedData = {};
        _.forEach(openTime, function(value, key) {
          //moment js doesn't recognize 2400 hrs
          if (angular.isDefined(value)) {
            if (closeTime[key] === '2400') {
              closeTime[key] = '0000';
            }
            parsedData['openTime' + 'PeriodDisplayMessage' + '_' + key] = displayOpenAndClosedTime(openTime[key], closeTime[key]);
            parsedData['openTime' + 'Period' + '_' + key] = openTime[key] ? moment(openTime[key],"hmm").format("hh:mm A") : "";
            parsedData['closeTime' + 'Period' + '_' + key] = closeTime[key] ? moment(closeTime[key],"hmm").format("hh:mm A") : "";
            parsedData['openTime'] = openTime[0];
            parsedData['closeTime'] = closeTime[0];
            parsedData['numberOfTimeFragments'] = new Array(_.keys(openTime).length);
          } else {
            //we need the numberOfTimeFragments to display the correct message for the store hours in the directive.html
            parsedData['numberOfTimeFragments'] = new Array(_.keys(openTime).length);
          }
        });

        _.assign(newHoursObj, parsedData);
        var completeHoursObj = createHoursObj(newHoursObj);
        if(completeHoursObj.dayNameShort === moment().format("YYYY-MM-DD")) {
          completeHoursObj.highlightClass = "bold-700";

          //initialize the open and close time empty arrays
          openTime = [];
          closeTime = [];
          var counter = 0;
          while (counter < completeHoursObj['numberOfTimeFragments'].length) {
            var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
            var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;
            if (completeHoursObj[openTimePeriodKey] && completeHoursObj[openTimePeriodKey].length > 0 && completeHoursObj[closeTimePeriodKey].length > 0) {
              openTime.push(completeHoursObj[openTimePeriodKey]);
              closeTime.push(completeHoursObj[closeTimePeriodKey]);
            }
            counter++;
          }

          // Remove all highlighting on regular hours
          _.forEach(hoursCardC.locHours, function (hourObj) {
            hourObj.highlightClass = "";
          });

          if (openTime.length > 0) {
            completeHoursObj.openTimePeriodDisplayMessage = isTheLocationOpen(openTime, closeTime);
          }
          updateTodaysHours(completeHoursObj);
        }
        spHours.push(completeHoursObj);
      });

      return spHours;
    }

    /* Things I removed:
     * location.status === 'coming soon' moving to directive.html
     */
    function createHoursObj(hourObj) {
      if (hoursCardC.location.status == "temp closed") {
        return _.assign(hourObj, {"closed": true, "closedLabel": "Temporarily Closed"})
      }
      if (!hourObj.hasOwnProperty("openTime")) {
        return _.assign(hourObj, {"closed": true});
      }
      hourObj.openTime = moment(hourObj.openTime, "HHmm");
      // If close is earlier than openM, then add 1 day to it
      hourObj.closeTime = moment(hourObj.closeTime, "HHmm");
      if (hourObj.closeTime.diff(hourObj.openTime) < 0) {
        hourObj.closeTime.add(1, 'd');
      }

      // Convenience vars so we only need to format or call moment on these once
      hourObj.openDisplayTime = hourObj.openTime.format("h:mm a");
      hourObj.closeDisplayTime = hourObj.closeTime.format("h:mm a");
      // Check if open 24/7 by comparing if diff of open and close time is 0
      hourObj.open24 = hourObj.openTime.diff(hourObj.closeTime) === 0;

      // Augment openingHours on controller
      hoursCardC.openingHours = hoursCardC.openingHours +
        hourObj.dayNameShort +
        ' ' +
        hourObj.openDisplayTime +
        ' - ' +
        hourObj.closeDisplayTime +
        ' ';

      return hourObj;
    }

    // Takes a datestring and checks if any special days are within 7 days of today
    // Return a list of dates + times that are within 7 days of today
    function checkSpecialHours(dates) {
      //For each date with special hours
      var intNearbyDates = _.filter(dates.trim().split(";"), function(el){
        return angular.isDefined(el) && el!=="";
      });

      var nearbyDates = _.map(intNearbyDates, function(specialDay) {
        //Split on the entry
        var dayData = specialDay.split(",");
        //Check today - specialDay < 7, if matched, return this date!
        var specialDateMoment = moment(dayData[0], "YYYY-M-D");
        var today = moment();
        if (specialDateMoment.diff(today, "days") < 7 &&
            specialDateMoment.diff(today, "days") >= 0) {
          return specialDay;
        }
      });
      return _.compact(nearbyDates).join(";");
    }
    if(hoursCardC.location.status == "coming soon"){
      hoursCardC.comingSoon = "Coming Soon"

    }
    else if (hoursCardC.location.status == "temp closed"){
      hoursCardC.comingSoon = "Temporarily Closed"
    }

    // If there's custom text, set it.
    if (hoursCardC.customText) {
      var str = hoursCardC.customText;
      str = str.replace(/\[(.*?[^.])\]/g, function (s, key) {
        return hoursCardC[key];
      });
      hoursCardC.customTextShow = str;
    }

    var checkHoursFormat = /^[0-9;,closedCLOSED]+$/;

    var sh = hoursCardC.location && hoursCardC.location.store_info ? s(hoursCardC.location.store_info.store_hours).trim(";").value() : null;
    // Replace anything that isn't number, ';', ',', or the letters c, l, o, s, e, d in their lower and capital forms
    sh = sh.replace(/[^0-9;,closedCLOSED]/g,'');
    sh = sh.trim();

    // Check if there are store hours listed. If not, show all days as "Closed" unless config indicates they should be hidden
    if (hoursCardC.location.store_info.store_hours == '' && (!hoursCardC.hideEmptyHours || hoursCardC.hideEmptyHours != true)) {
      hoursCardC.locHours = generateHours(sh, "Closed");
    }

    // Check if store is coming soon, if so, init all days to coming soon
    if (hoursCardC.location.status == "coming soon") {
      hoursCardC.locHours = generateHours(sh, "Coming Soon");
    }

    // Check if time returned is valid
    if (sh && checkHoursFormat.test(sh)) {
      hoursCardC.locHours = generateHours(sh, "Closed");
    }

    // Check for special hours
    var specialHours = (hoursCardC.location &&
      hoursCardC.location.store_info &&
      hoursCardC.location.store_info.special_hours) ?
      s(hoursCardC.location.store_info.special_hours).trim(";").value() : null;
      //specialHours = '2018-12-24,0000,1800;2018-12-25,CLOSED;2018-12-31,0000,2200;2019-01-01,0600,0000;2019-05-15,CLOSED';

    if (specialHours !== null) {
      // Check if any special hours are coming up.
      var validSpHours = checkSpecialHours(specialHours);
      if (!_.isEmpty(validSpHours)) {
        // For each special day, format it for display like normal hours.
        hoursCardC.specialHours = generateSpecialHours(validSpHours);
      }
    }
    hoursCardC.hoursNote = _.find(hoursCardC.location.custom_fields, {'name': 'hours_note'});
  }

})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('hoursAdditionalCard', hoursAdditionalCard);

  function hoursAdditionalCard() {
    return {
      replace: true,
      scope: {
        location: '=',
        titlePrimary: '=',
        titleAdditional: '=',
        isUsedForPrimaryRegularHours: '='
      },
      templateUrl: 'app/localLanding/cards/hoursAdditionalCard.directive.html',
      restrict: 'AE',
      controller: hoursAddCardController,
      controllerAs: 'hoursAddCardC',
      bindToController: true
    };
  }

  function hoursAddCardController(_, s, moment) {
    var hoursAddCardC = this;

    hoursAddCardC.closed24 = true;
    hoursAddCardC.closed24Additional = true;
    hoursAddCardC.closedNow = true;
    hoursAddCardC.closedNowAdditional = true;
    hoursAddCardC.open24 = false;
    hoursAddCardC.openingHours = '';
    hoursAddCardC.open24Additional = false;
    hoursAddCardC.openingHoursAdditional = '';
    hoursAddCardC.hasPrimary = false;
    hoursAddCardC.hasPrimarySpecial = false;

    // returns the hour fragment for the day depending on the passed key value
    hoursAddCardC.getOpenTimePeriodDisplayMessage = function(regularHours, index) {
      var key = '';
      if (angular.isDefined(index)) {
        key = 'openTimePeriodDisplayMessage_' + index;
      } else {
        key = 'openTimePeriodDisplayMessage';
      }
      return regularHours[key];
    };

    /**
     * function returns true if passed value is null, undefined and legth is zero, else false
     * @param {*} storeTimeZone 
     */
    function checkObj(storeTimeZone) {
      return ( _.isNull(storeTimeZone) || _.isUndefined(storeTimeZone) || storeTimeZone.length === 0 )
    }

    /**
     * function to check if the store is open or closed and set
     * the corresponding 'closedNow' value on the directive object
     * @param {object} hourObj hour object which has all the details about the timings/days
    */
    function updateTodaysHours(hourObj) {
      if (hourObj.closed) {
        hoursAddCardC.closed24 = true;
        return;
      }

      hoursAddCardC.closed24 = false;
       // check for today's special hours. start
       var isTodaySpecial = isTodaySpecialHours();
      //counter to loop through the number of fragments
      var counter = 0;
      if(hourObj && hourObj.numberOfTimeFragments) {
        while (counter < hourObj.numberOfTimeFragments.length) {
          var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
          var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;
          if (hourObj[openTimePeriodKey] && hourObj[closeTimePeriodKey]) {
            hoursAddCardC[openTimePeriodKey] = moment(hourObj[openTimePeriodKey], "hh:mm A").format("h:mm a")
            hoursAddCardC[closeTimePeriodKey] = moment(hourObj[closeTimePeriodKey], "hh:mm A").format("h:mm a");
          }
          if (moment(hourObj[closeTimePeriodKey], "hh:mm A").isBefore(moment(hourObj[openTimePeriodKey], "hh:mm A")) || moment(hourObj[closeTimePeriodKey], "HH:mm A").format('HHmm') === '0000') {
            hourObj[closeTimePeriodKey] = moment(hourObj[closeTimePeriodKey], "hh:mm A").add(1, 'days');
          }
  
          var amIBetweenGroupKey = 'amIBetweenGroup' + '_' + counter;
          var now = moment();
          // store timezone code start
          var storeTimeZone = hoursAddCardC.location.store_info.timezone; // store timezone from api
          var storeCurrDateTime = null;
          var convertedStoreTime = null;
          var isInvalidObj = checkObj(storeTimeZone);
          if (!isInvalidObj) {
            storeCurrDateTime = getStoreCurrentTime(storeTimeZone);
            convertedStoreTime = moment(getConvertedStoreHours(storeCurrDateTime), "hh:mm A");
          }
          // store timezone code end
          // instead of now object the comparison is made with convertedStoreTime object
          var startTime = moment(hourObj[openTimePeriodKey], "hh:mm A");
          var endTime = moment(hourObj[closeTimePeriodKey], "hh:mm A");
          if (now.isBefore(endTime)) {
            startTime = startTime.subtract(1, 'days');
          } else {
            endTime = endTime.add(1, 'days');
          }
          if(!isInvalidObj){
            amIBetweenGroupKey = convertedStoreTime.isBetween(startTime, endTime);
          } else {
            amIBetweenGroupKey = now.isBetween(startTime, endTime);
          }
  
          if (amIBetweenGroupKey) {
            hoursAddCardC.closeToday = endTime.format("h:mm a");
            if (amIBetweenGroupKey || hourObj.open24) {
              hoursAddCardC.closedNow = false;
            } else {
              hoursAddCardC.closedNow = true;
            }
          } else if(isTodaySpecial && !amIBetweenGroupKey){
            hoursAddCardC.closeToday = endTime.format("h:mm a");
            hoursAddCardC.closedNow = true;
          }
  
          counter++;
        }
      }

      hoursAddCardC.openToday = hourObj.openDisplayTime;
      hoursAddCardC.open24 = hourObj.open24;
    }

    function isTodaySpecialHours(){
      var isTodaySpecial = false;
      var specialHours = (hoursAddCardC.location &&
        hoursAddCardC.location.store_info &&
        hoursAddCardC.location.store_info.special_hours) ?
        s(hoursAddCardC.location.store_info.special_hours).trim(";").value() : null;
          
      if (specialHours !== null) {
        // Check if any special hours are coming up.
        var validSpHours = checkSpecialHours(specialHours);
        if (!_.isEmpty(validSpHours)) {
          isTodaySpecial=true;
        }
      } 
      return isTodaySpecial;
    }

    function updateTodaysHoursAdditional(hourObj) {
      if (hourObj.closed) {
        hoursAddCardC.closed24Additional = true;
        return;
      }

      hoursAddCardC.closed24Additional = false;

      var now = moment();
      hoursAddCardC.openTodayAdditional = hourObj.openDisplayTime;
      hoursAddCardC.closeTodayAdditional = hourObj.closeDisplayTime;
      hoursAddCardC.open24Additional = hourObj.open24;
      // store timezone code start
      var storeTimeZone = hoursAddCardC.location.store_info.timezone; // store timezone from api
      var storeCurrentDateTime = null;
      var convertedStoreTodayHrs = null;
      var isInvalidObj = checkObj(storeTimeZone);
      if (!isInvalidObj) {
        storeCurrentDateTime = getStoreCurrentTime(storeTimeZone);
        convertedStoreTodayHrs = moment(getConvertedStoreHours(storeCurrentDateTime), "hh:mm A");
      }
      // store timezone code end
      // instead of now object the comparison is made with convertedStoreTodayHrs object
      if (!isInvalidObj) {
        if ((convertedStoreTodayHrs.isAfter(hourObj.openTime) && convertedStoreTodayHrs.isBefore(hourObj.closeTime)) || hourObj.open24) {
          hoursAddCardC.closedNowAdditional = false;
        } else {
          hoursAddCardC.closedNowAdditional = true;
        }
      } else {
        if ((now.isAfter(hourObj.openTime) && now.isBefore(hourObj.closeTime)) || hourObj.open24) {
          hoursAddCardC.closedNowAdditional = false;
        } else {
          hoursAddCardC.closedNowAdditional = true;
        }
      }
    }

    function parseDateStrings(dateStrs) {
      if(dateStrs) { var intDateStrs = dateStrs.split(";"); }
      return _.map(intDateStrs, function(dateStr) {
        var info = dateStr.split(",");
        if (angular.isDefined(info[1]) && info[1].toUpperCase() === "CLOSED") {
          // return just the day. This way we can use it to determine if today == which hour obj.
          return {
            day: info[0]
          };
        }
        else {
          // Else add open and close times based on the strings.
          // Will moment parse these to more readable strings later.
          return {
            day: info[0],
            openTime: info[1],
            closeTime: info[2]
          };
        }
      });
    }


    /**
     * function generates hours object for each day
     * @param {string} dateStrs open and close times for the week
     * @param {string} closeLabel close label for the location
     * @param {string} isPrimary flag to indicate if the hours are primary/additional
    */
    function generateHours(dateStrs, closeLabel, isPrimary) {
      // Split up the dateStrs and generate objects for each one
      var parsedDateStrs = parseDateStrings(dateStrs);
      var locHours = {};
      _.range(1, 8).forEach(function(day) {
        // Generate base objects per day
        var newHoursObj = {
          day: day.toString(),
          dayName: moment().isoWeekday(day).format("dddd"),
          dayNameShort: moment().isoWeekday(day).format("dd"),
          dayNameShortNext: moment().isoWeekday(day).add(1, 'd').format("dd"),
          closedLabel: closeLabel
        };

        // filter method gets all the matching objects for a certain day of the week
        var parsedData = _.filter(parsedDateStrs, function(obj) {
          return obj['day'] === day.toString();
        });

        // all the open and close time for the store location in an array
        var openTime = _.map(parsedData, 'openTime');
        var closeTime = _.map(parsedData, 'closeTime');
        parsedData = {};
        _.forEach(openTime, function(value, key) {
          //moment js doesn't recognize 2400 hrs
          if (closeTime[key] === '2400') {
            closeTime[key] = '0000';
          }
          parsedData['openTime' + 'PeriodDisplayMessage' + '_' + key] = displayOpenAndClosedTime(openTime[key], closeTime[key]);
          parsedData['openTime' + 'Period' + '_' + key] = openTime[key] ? moment(openTime[key],"hmm").format("hh:mm A") : "";
          parsedData['closeTime' + 'Period' + '_' + key] = closeTime[key] ? moment(closeTime[key],"hmm").format("hh:mm A") : "";
          parsedData['openTime'] = openTime[0];
          parsedData['closeTime'] = closeTime[0];
          parsedData['numberOfTimeFragments'] = new Array(_.keys(openTime).length);
        });

        //we need the numberOfTimeFragments to display the correct message for the store hours in the directive.html
        if (openTime.length === 0) {
          parsedData['numberOfTimeFragments'] = new Array(1);
        }
        _.assign(newHoursObj, parsedData);
        locHours[day] = createHoursObj(newHoursObj, isPrimary);

        // Check if Today. If so, apply highlighting and modify
        // some controller level variables in a separate function.
        if (day.toString() === moment().format("E")) {
          locHours[day].highlightClass = "bold-700";

          //initialize the open and close time empty arrays
          openTime = [];
          closeTime = [];
          var counter = 0;
          while (counter < locHours[day]['numberOfTimeFragments'].length) {
            var openTimePeriodKey = 'openTimePeriod' + '_' + counter;
            var closeTimePeriodKey = 'closeTimePeriod' + '_' + counter;
            if (locHours[day][openTimePeriodKey] && locHours[day][openTimePeriodKey].length > 0 && locHours[day][closeTimePeriodKey].length > 0) {
              openTime.push(locHours[day][openTimePeriodKey]);
              closeTime.push(locHours[day][closeTimePeriodKey]);
            }
            counter++;
          }

          // when the location does not have hours for the day we
          // assume that it is closed
          if (openTime.length > 0 && closeTime.length > 0) {
            // for current day we store the appropriate message for store close/open hours in the first display message element
            locHours[day].openTimePeriodDisplayMessage = isTheLocationOpen(openTime, closeTime);
          } else {
            locHours[day].closed = true;
          }

          // for current day we store the appropriate message for store close/open hours in the first display message element
          if (isPrimary) {
            updateTodaysHours(locHours[day]);
          }
          else {
            updateTodaysHoursAdditional(locHours[day]);
          }
        }
      });

      return locHours;
    }

    /**
     * function generates the display time message for the different
     * periods/times for which the store is open
     * @param {string} openTime open time for the store
     * @param {string} closeTime close time for the store
    */
    function displayOpenAndClosedTime(openTime, closeTime) {
      var displayTime = "";
      if (openTime && closeTime) {
        displayTime = moment(openTime, "hmm").format("h:mm a") + " " + "-" + " " + moment(closeTime, "hmm").format("h:mm a");
      }
      return displayTime;
    }

    /**
     * function is used to get the current time in the store timezone
     * @param {*} actualStoreTimeZone 
     */
    function getStoreCurrentTime(actualStoreTimeZone){
      var currentStoreDateTime = null;
      var isInvalidObj = checkObj(actualStoreTimeZone);
      if (!isInvalidObj) {
        currentStoreDateTime = angular.isDefined((moment.tz.zone(actualStoreTimeZone))) ? moment.tz(actualStoreTimeZone).format('YYYY-MM-DD hh:mm A') : moment().format('YYYY-MM-DD hh:mm A');//
      }
      return currentStoreDateTime;
    }

    /**
     * function is used to get the time part from the converted store timezone
     * @param {moment} storeCurrentDateTime 
     */
    function getConvertedStoreHours(storeCurrentDateTime){
      var convertedStoreHours = null;
      var currTimeArr = storeCurrentDateTime.split(" ");
      var isInvalidObj = checkObj(currTimeArr);
      if(!isInvalidObj){ 
        var isInvalidObj1 = checkObj(currTimeArr[1]);
        if(!isInvalidObj1 && currTimeArr.length > 1){
          convertedStoreHours = currTimeArr[1].trim().concat(" ").concat(currTimeArr[2].trim()) ;
        }
      }
      return convertedStoreHours;
    }

    /**
     * function is used to generate the appropriate messaging for the
     * current day including store open/close times.
     * @param {array} openTime open time for the store for the current day
     * @param {array} closeTime close time for the store for the current day
    */
    function isTheLocationOpen(openTime, closeTime) {
      var amIBetweenFirstGroup = false;
      var amIBetweenSecondGroup = false;
      var amIBetweenThirdGroup = false;
      var storeOpenOrCloseMessage = '';
      var currentTime = moment();
      var displayMessage = '';
      var startTimeFirstGroup = openTime[0] ? moment(openTime[0].trim(), "HH:mm A") : "Closed Today";
      var endTimeFirstGroup = closeTime[0] ? moment(closeTime[0].trim(), "HH:mm A") : "Closed Today";
      var openTwentyFourHours = false;
      // store timezone code start
      var storeTimeZone = hoursAddCardC.location.store_info.timezone; // store timezone from api
      var storeCurrDateTime = null;
      var convertedStoreHrs = null;
      var isInvalidObj = checkObj(storeTimeZone);
      if (!isInvalidObj) {
        storeCurrDateTime = getStoreCurrentTime(storeTimeZone);
        convertedStoreHrs = moment(getConvertedStoreHours(storeCurrDateTime), "hh:mm A");
      } else {
        convertedStoreHrs = currentTime;
      }
      // store timezone code end
      if (openTime.length === 2) {
        var startTimeSecondGroup = moment(openTime[1], "HH:mm A");
        var endTimeSecondGroup = moment(closeTime[1], "HH:mm A");
      } else if (openTime.length === 3) {
        var startTimeThirdGroup = moment(openTime[2], "HH:mm A");
        var endTimeThirdGroup = moment(closeTime[2], "HH:mm A");
        startTimeSecondGroup = moment(openTime[1], "HH:mm A");
        endTimeSecondGroup = moment(closeTime[1], "HH:mm A");
      }


      // check if the close time is on the next date in the A.M.
      if (endTimeFirstGroup.isBefore(startTimeFirstGroup) || moment(closeTime[0], "HH:mm A").format('HHmm') === '0000') {
        //open 24 message if the store is open for 24hrs
        if (endTimeFirstGroup.diff(startTimeFirstGroup) === 0) {
          openTwentyFourHours = true;
        }
        // Check the user currentime is before shop close time then subtract 1 day from start date
        // as the shop has started in previous day
        // else add 1 day to end date as the shop will be closing on next day
        if (convertedStoreHrs.isBefore(endTimeFirstGroup)) {
          startTimeFirstGroup = startTimeFirstGroup.subtract(1, 'days');
        } else {
          endTimeFirstGroup = endTimeFirstGroup.add(1, 'days');
        }
      }

      if (openTime.length === 2 && closeTime.length === 2) {
        // check if the close time is on the next date in the A.M.
        if (endTimeSecondGroup.isBefore(startTimeSecondGroup) || moment(closeTime[1], "HH:mm A").format('HHmm') === '0000') {
          endTimeSecondGroup = endTimeFirstGroup.add(1, 'days');
        }

        displayMessage = moment(openTime[0], "hh:mm A").format("h:mm a") + ' - ' + moment(closeTime[0], "hh:mm A").format("h:mm a") + ', ' +
                         moment(openTime[1], "hh:mm A").format("h:mm a") + ' - ' + moment(closeTime[1], "hh:mm A").format("h:mm a");
        // instead of currentTime object the comparison is made with convertedStoreHrs object
        if (!isInvalidObj) {
          amIBetweenFirstGroup = convertedStoreHrs.isBetween(startTimeFirstGroup, endTimeFirstGroup);
          amIBetweenSecondGroup = convertedStoreHrs.isBetween(startTimeSecondGroup, endTimeSecondGroup);
        } else {
          //earlier implementation
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
          amIBetweenSecondGroup = currentTime.isBetween(startTimeSecondGroup, endTimeSecondGroup);
        }
        if (amIBetweenFirstGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + displayMessage;
        } else if (amIBetweenSecondGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + displayMessage;

        } else {
          storeOpenOrCloseMessage = "Closed Now. Today's Hours: " + displayMessage;
        }
      } else if (openTime.length === 3 && closeTime.length === 3) {
        // if there are three fragments for store hours
        // check if the close time is on the next date in the A.M.
        if (endTimeSecondGroup.isBefore(startTimeSecondGroup) || moment(closeTime[1], "HH:mm A").format('HHmm') === '0000') {
          endTimeSecondGroup = endTimeFirstGroup.add(1, 'days');
        }
        // check if the third fragment close time is on the next date in the A.M.
        if (endTimeThirdGroup.isBefore(startTimeThirdGroup) || moment(closeTime[2], "HH:mm A").format('HHmm') === '0000') {
          endTimeThirdGroup = endTimeSecondGroup.add(1, 'days');
        }

        displayMessage = moment(openTime[0], "hh:mm A").format("h:mm a") + ' - ' + moment(closeTime[0], "hh:mm A").format("h:mm a") + ', ' +
                         moment(openTime[1], "hh:mm A").format("h:mm a") + ' - ' + moment(closeTime[1], "hh:mm A").format("h:mm a") + ', ' +
                         moment(openTime[2], "hh:mm A").format("h:mm a") + ' - ' + moment(closeTime[2], "hh:mm A").format("h:mm a");
        // time fragment flags
        // instead of currentTime object the comparison is made with convertedStoreHrs object
        if (!isInvalidObj) {
          amIBetweenFirstGroup = convertedStoreHrs.isBetween(startTimeFirstGroup, endTimeFirstGroup);
          amIBetweenSecondGroup = convertedStoreHrs.isBetween(startTimeSecondGroup, endTimeSecondGroup);
          amIBetweenThirdGroup = convertedStoreHrs.isBetween(startTimeThirdGroup, endTimeThirdGroup);
        } else {
          //earlier implementation
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
          amIBetweenSecondGroup = currentTime.isBetween(startTimeSecondGroup, endTimeSecondGroup);
          amIBetweenThirdGroup = currentTime.isBetween(startTimeThirdGroup, endTimeThirdGroup);
        }
        if (amIBetweenFirstGroup) {
          storeOpenOrCloseMessage = "Open Now Until " + moment(closeTime[0], "hh:mm A").format("h:mm a") + ", " +
                                     displayMessage;
        } else if (amIBetweenSecondGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[1], "hh:mm A").format("h:mm a") + ', ' +
                                     displayMessage;

        } else if (amIBetweenThirdGroup) {
          storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[2], "hh:mm A").format("h:mm a") + ', ' +
                                     displayMessage;
        } else {
          storeOpenOrCloseMessage = "Closed Now. Today's Hours: " + displayMessage;
        }
      } else {
        // instead of currentTime object the comparison is made with convertedStoreHrs object
        if (!isInvalidObj) {
          amIBetweenFirstGroup = convertedStoreHrs.isBetween(startTimeFirstGroup, endTimeFirstGroup);
        } else {
          // earlier implementation
          amIBetweenFirstGroup = currentTime.isBetween(startTimeFirstGroup, endTimeFirstGroup);
        }

        if (openTwentyFourHours) {
          storeOpenOrCloseMessage = 'Open 24 Hours';
        } else {
          if (amIBetweenFirstGroup) {
            storeOpenOrCloseMessage = 'Open Now Until ' + moment(closeTime[0], "hh:mm A").format("h:mm a");
          } else {
            storeOpenOrCloseMessage = "Closed Now. Today's Hours: " + moment(openTime[0], "hh:mm A").format("h:mm a") + ' - ' + moment(closeTime[0], "hh:mm A").format("h:mm a");
          }
        }
      }

      return storeOpenOrCloseMessage;
    }

    function generateSpecialHours(dateStrs, isPrimary) {
      // Split up the dateStrs and generate objects for each one
      var parsedDateStrs = parseDateStrings(dateStrs);

      var spHours = [];
      parsedDateStrs.forEach(function(parsedData) {
        parsedData.dayNameShort = parsedData.day;
        parsedData.dayOfTheWeek = moment(parsedData.day, "YYYY-MM-DD").format("E");
        parsedData.closedLabel = "Closed";

        var completeHoursObj = createHoursObj(parsedData);

        if(completeHoursObj.day  === moment().format("YYYY-MM-DD")) {
          completeHoursObj.highlightClass = "bold-700";

          if (isPrimary) {
            //Clear Regular hours highlighting
            _.forEach(hoursAddCardC.regularHours, function (hourObj) {
              if (hourObj.hasOwnProperty("regular")) {
                hourObj.regular.highlightClass = "";
              }
            });

            updateTodaysHours(completeHoursObj);
          }
          else {
            //Clear Additional hours highlighting
            _.forEach(hoursAddCardC.regularHours, function (hourObj) {
              if (hourObj.hasOwnProperty("additional")) {
                hourObj.additional.highlightClass = "";
              }
            });

            updateTodaysHoursAdditional(completeHoursObj);
          }
        }

        spHours.push(completeHoursObj);
      });

      return spHours;
    }

    /* removed:
     * location.status === 'coming soon' moving to directive.html
     */
    function createHoursObj(hourObj, isPrimary) {
      if (!hourObj.hasOwnProperty("openTime")) {
        return _.assign(hourObj, {"closed": true});
      }
      hourObj.openTime = moment(hourObj.openTime, "HHmm");
      // If close is earlier than openM, then add 1 day to it
      hourObj.closeTime = moment(hourObj.closeTime, "HHmm");
      if (hourObj.closeTime.diff(hourObj.openTime) < 0) {
        hourObj.closeTime.add(1, 'd');
      }

      // Convenience vars so we only need to format or call moment on these once
      hourObj.openDisplayTime = hourObj.openTime.format("h:mm a");
      hourObj.closeDisplayTime = hourObj.closeTime.format("h:mm a");

      // Check if open 24/7 by comparing if diff of open and close time is 0
      hourObj.open24 = (hourObj.openTime.diff(hourObj.closeTime) === 0 ||
                        Math.abs(hourObj.openTime.diff(hourObj.closeTime, 'hours')) === 24);

      // Augment openingHours on controller
      if (isPrimary) {
        hoursAddCardC.openingHours = hoursAddCardC.openingHours +
          hourObj.dayNameShort +
          ' ' +
          hourObj.openDisplayTime +
          ' - ' +
          hourObj.closeDisplayTime +
          ' ';
      }
      else {
        hoursAddCardC.openingHoursAdditional = hoursAddCardC.openingHoursAdditional +
          hourObj.dayNameShort +
          ' ' +
          hourObj.openDisplayTime +
          ' - ' +
          hourObj.closeDisplayTime +
          ' ';
      }
      return hourObj;
    }

    // Takes a datestring and checks if any special days are within 7 days of today
    // Return a list of dates + times that are within 7 days of today
    function checkSpecialHours(dates) {
      //For each date with special hours
      if(dates) { var intNearbyDates = dates.split(";"); }
      var nearbyDates = _.map(intNearbyDates, function(specialDay) {
        //Split on the entry
        var dayData = specialDay.split(",");
        //Check today - specialDay < 7, if matched, return this date!
        var specialDateMoment = moment(dayData[0], "YYYY-M-D");
        var today = moment();
        if (specialDateMoment.diff(today, "days") < 7 &&
          specialDateMoment.diff(today, "days") >= 0) {
          return specialDay;
        }
      });
      return _.compact(nearbyDates).join(";");
    }

    function combineSpecialHours(regularDates, additionalDates) {
      var combinedSpecialHours = {};

      _.forEach(regularDates, function(hourObj) {
        combinedSpecialHours[hourObj.dayNameShort] = {
          "regular" : hourObj
        }
      });

      _.forEach(additionalDates, function(hourObj) {
        if (combinedSpecialHours[hourObj.dayNameShort]) {
          combinedSpecialHours[hourObj.dayNameShort]["additional"] = hourObj;
        }
        else {
          combinedSpecialHours[hourObj.dayNameShort] = {
            "additional": hourObj
          }
        }
      })
      var orderedSpecialHours = {};
      Object.keys(combinedSpecialHours).sort().forEach(function(key) {
        orderedSpecialHours[key] = combinedSpecialHours[key];
      });

      return orderedSpecialHours;
    }

    function combineRegularHours(regularDates, additionalDates) {
      var combinedRegHours = {};

      _.forEach(regularDates, function(hourObj) {
        combinedRegHours[hourObj.day] = {
          "regular" : hourObj,
          "day" : hourObj.dayName
        }
      });

      _.forEach(additionalDates, function(hourObj) {
        if (combinedRegHours[hourObj.day]) {
          combinedRegHours[hourObj.day]["additional"] = hourObj;
        }
        else {
          combinedRegHours[hourObj.day] = {
            "additional": hourObj,
            "day" : hourObj.dayName
          }
        }
      })
      var orderedRegHours = {};
      Object.keys(combinedRegHours).sort().forEach(function(key) {
        orderedRegHours[combinedRegHours[key]["day"]] = combinedRegHours[key];
      });

      return orderedRegHours;
    }

    // Primary Regular Hours
    var checkHoursFormat = /^[0-9;,closedCLOSED]+$/;
    var sh = (hoursAddCardC.location &&
              hoursAddCardC.location.store_info) ?
      s(hoursAddCardC.location.store_info.store_hours).trim(";").value() : null;
    sh = sh.replace(/[^0-9;,closedCLOSED]/g,'');
    sh = sh.trim();

    var regularHours = null;
    var primaryAdditionalHours = null;
    var regularSpecialHours = null;
    var additionalSpecialHours = null;

    // Primary Regular Hours

    // Check if there are store hours listed. If not, show all days as "Closed"
    if (hoursAddCardC.location.store_info.store_hours == '') {
      regularHours = generateHours(sh, "Closed", true);
      hoursAddCardC.hasPrimary = true;
    }
    if (sh && checkHoursFormat.test(sh)) {
      regularHours = generateHours(sh, "Closed", true);
      hoursAddCardC.hasPrimary = true;
    }
    // Additional Regular Hours
    var findAdditionalHours = _.find(hoursAddCardC.location.custom_fields, {'name': 'hours_additional'});
    if(findAdditionalHours) {
      var additionalHoursStr = findAdditionalHours.data ? s(findAdditionalHours.data).trim(";").value() : null;
      hoursAddCardC.hasAdditional = additionalHoursStr ? true : false;
      if(hoursAddCardC.hasAdditional) { primaryAdditionalHours = generateHours(additionalHoursStr, "Closed", false); }
      
    }

    // Combine Regular Hours
    if (regularHours || primaryAdditionalHours) {
      hoursAddCardC.regularHours = combineRegularHours(regularHours, primaryAdditionalHours);
    }
    // Primary Special Hours
    var primarySpecialHours = (hoursAddCardC.location &&
      hoursAddCardC.location.store_info &&
      hoursAddCardC.location.store_info.special_hours) ?
      s(hoursAddCardC.location.store_info.special_hours).trim(";").value() : null;
    if (primarySpecialHours !== null) {
      // Check if any special hours are coming up.
      var validSpecialHours = checkSpecialHours(primarySpecialHours);
      if (!_.isEmpty(validSpecialHours)) {
        // For each special day, format it for display like normal hours.
        regularSpecialHours = generateSpecialHours(validSpecialHours, true);
        hoursAddCardC.hasPrimarySpecial = true;
      }
    }

    // Additional Special Hours
    var findAdditionalSpecialHours = _.find(hoursAddCardC.location.custom_fields, {'name': 'hours_additional_special'});
    if(findAdditionalSpecialHours) {

      var additionalSpecialHoursStr = findAdditionalSpecialHours.data ? s(findAdditionalSpecialHours.data).trim(";").value() : null;
      var validAdditionalSpecialHours = checkSpecialHours(additionalSpecialHoursStr);
      hoursAddCardC.hasAdditionalSpecial = validAdditionalSpecialHours ? true : false;
      if (!_.isEmpty(validAdditionalSpecialHours)) {
        // For each special day, format it for display like normal hours.
        additionalSpecialHours = generateSpecialHours(validAdditionalSpecialHours, false);
      }
    }

    // Combine Special Hours
    if (regularSpecialHours || additionalSpecialHours) {
      hoursAddCardC.specialHours = combineSpecialHours(regularSpecialHours, additionalSpecialHours);
    }
    hoursAddCardC.hoursNote = _.find(hoursAddCardC.location.custom_fields, {'name': 'hours_note'});

    // If regular hours have special hours but additional hours do not

    hoursAddCardC.getStandardAddtlHours = function(dayOfTheWeek) {
      return generateHours(additionalHoursStr, "Closed", false)[dayOfTheWeek].openTimePeriodDisplayMessage_0 || "Closed"
    }


    hoursAddCardC.getStandardRegHours = function(dayOfTheWeek) {
      var days = Object.entries(hoursAddCardC.regularHours)
      var specialDay = days.filter(function(d) {
        return d[1].regular.day == dayOfTheWeek
      })

      return specialDay[0][1].regular.openTimePeriodDisplayMessage_0
    }
  }
})();

(function () {
    'use strict';
  
    angular
        .module('storeLocator')
        .directive('googleCard', googleCard);
  
    function googleCard() {
      return {
        replace: true,
        scope: {'location': '='},
        templateUrl: 'app/localLanding/cards/googleCard.directive.html',
        restrict: 'AE',
        controller: GoogleCardController,
        controllerAs: 'googleCardC',
        bindToController: true
      };
    }
  
    GoogleCardController.$inject = ['_'];
    function GoogleCardController(_){
      var vm = this,
          google = _.findWhere(vm.location.store_info.providers, {_type:'Google'});
      vm.googleData = false;
      vm.title = vm.location.store_info.name ? vm.location.store_info.name : 'Find us';
  
      if(google){
        vm.googleData = {};
        vm.googleData.url = google.url;
        vm.googleData.rating = google.rating;
        vm.googleData.checkins = google.total_checkins;
      }
    }
  })();
  
(function () {
  'use strict';

  angular
      .module('storeLocator')
      .directive('foursquareCard', foursquareCard);

  function foursquareCard() {
    return {
      replace: true,
      scope: {'location': '='},
      templateUrl: 'app/localLanding/cards/foursquareCard.directive.html',
      restrict: 'AE',
      controller: FoursquareCardController,
      controllerAs: 'foursquareCardC',
      bindToController: true
    };
  }

  FoursquareCardController.$inject = ['_'];
  function FoursquareCardController(_){
    var vm = this,
        foursquare = _.findWhere(vm.location.store_info.providers, {_type:'Foursquare'});
    vm.fsData = false;
    vm.title = vm.location.store_info.name ? vm.location.store_info.name : 'Find us';

    if(foursquare){
      vm.fsData = {};
      vm.fsData.url = foursquare.url;
      vm.fsData.rating = foursquare.rating;
      vm.fsData.checkins = foursquare.total_checkins;
      vm.fsData.tips = foursquare.total_tips;
      vm.fsData.pics = foursquare.total_pics;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('fbWidgetCard', fbWidgetCard);

  function fbWidgetCard() {

    return {
      replace: true,
      scope: {
        location: '=',
        clientName: '=',
        brandUrl: '@',
      },
      templateUrl: 'app/localLanding/cards/fbWidgetCard.directive.html',
      restrict: 'AE',
      controller: function ($filter, $timeout, $scope, $window) {

        var vm = this;

        if ($scope.brandUrl) {
          vm.fbProviderUrl = $scope.brandUrl;
        } else {
          vm.fbProviders = _.filter($scope.location.store_info.providers, function (obj) {
            return obj._type === "Facebook" && obj.master;
          });
          if (vm.fbProviders.length > 0) {
            vm.fbProviderUrl = vm.fbProviders[0].url;
          }
        }
        angular.element($window).bind('resize', function () {
          vm.windowWidth = $window.innerWidth;
          $timeout(function () {
            changeFBPagePlugin(vm.fbProviderUrl)
          }, 500);
          $scope.$digest();
        });

        function changeFBPagePlugin(url) {
          //getting parent box width
          var container_width = Number($('.fb-widget-container').width()).toFixed(0);
          var container_height = Number($('.fb-widget-container').height()).toFixed(0);
          if (!isNaN(container_width) && !isNaN(container_height)) {
            $(".fb-page").attr("data-width", container_width).attr("data-height", container_height);
          }
          if (url) {
            $(".fb-page").attr("data-href", url);
          }
          if (typeof FB !== 'undefined') {
            FB.XFBML.parse();
          }
        }

        //initial card load requires call to FB.XFBML.parse to render per page
        $timeout(function () {
          changeFBPagePlugin(vm.fbProviderUrl)
        }, 1000);
      }
      ,
      controllerAs: 'fbWidgetCardC'
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('fbReviewsCard', fbReviewsCard);

  function fbReviewsCard () {

    return {
      replace: true,
      scope: {
        reviews: '=',
        page: '='
      },
      templateUrl: 'app/localLanding/cards/fbReviewsCard.directive.html',
      restrict: 'AE',
      controller: function ($scope,localLandingData) {
        var vm = this;
        var location = $scope.reviews[0];
        localLandingData.getFbReviewsForLocation(location.momentfeed_venue_id).then(function (response) {
          $scope.reviews = response.data;
          $scope.page = response.data[0].profile_url;
        });
      },
      controllerAs: 'fbReviewsCardC'
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('fbCard', fbCard);

  function fbCard () {

    return {
      replace: true,
      scope: {
        posts: '=',
        clientName: '=',
        limit: '@'
      },
      templateUrl: 'app/localLanding/cards/fbCard.directive.html',
      restrict: 'AE',
      controller: function ($filter, $timeout, $scope, $sce, $document, localLandingData) {
        var vm = this;

        if($scope.posts==='brandPosts'){
            getBrandPosts();
        }
        else{
          var fbResponseLocal = localLandingData.getFbPostsForLocation($scope.posts).then(function(response){
            if(response.data.length<=0){
                getBrandPosts();
            }
            else{
              $scope.posts=response.data;
              getVideoUrl()
            }
          });
        }

        function getBrandPosts(){
          var fbResponseBrand = localLandingData.getBrandFbPosts().then(function(response){
            $scope.posts=response.data;
            getVideoUrl()
          });
        }

        if(_.isUndefined($scope.limit)) $scope.limit = 1;

        function getVideoUrl(){
          _.each($scope.posts, function(p){

            if(p.graph_post_type == 'video') {
              //build the embed url
              if ($scope.posts[0].permalink.includes('video')) {
                vm.videoUrl = $sce.trustAsResourceUrl('https://www.facebook.com/plugins/video.php?href=' + $filter('urlCleaner')($scope.posts[0].permalink) + '&show_text=0');
                vm.isVideo = true;
              }
              else {
                vm.videoUrl = $sce.trustAsResourceUrl($scope.posts[0].permalink);
                vm.isVideo = false;
              }
            }
          });
        };

        function setHeight(element) {
          //set the height of the iframe
          element[0].height = element[0].offsetWidth;
        }

        vm.onLoad = function () {
          var element = angular.element($document[0].getElementById('video-post'));
          if (element[0]) setHeight(element)
        }

      },
      controllerAs: 'fbCardC'
    };
  }
})();

//DEADCODE
(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('eventCardOld', eventCardOld);

  function eventCardOld() {

    return {
      replace: true,
      scope: {
        location: '='
      },
      templateUrl: 'app/localLanding/cards/eventCardOld.directive.html',
      restrict: 'AE',
      controller: function($scope, _) {
        var vm = this;
        vm.eventObject = {};
        vm.location = $scope.location;
        _.each(vm.location.custom_fields, function(field) {
          if(isFieldTypeOf(field, 'Content')){
            addToEventObject(field, 'Content')
          }else if(isFieldTypeOf(field, 'Title')){
            addToEventObject(field, 'Title')
          }
        });

        function isFieldTypeOf(field, type) {
          return field.name.indexOf(type) > -1
        }

        function addToEventObject(field, type) {
          var name = field.name.replace(type, '')
          if (!_.isUndefined(vm.eventObject[name])) {
            vm.eventObject[name][type] = field.data
          } else {
            var object = {}
            object[type] = field.data
            vm.eventObject[name] = object
          }
        }

      },
      controllerAs: 'eventCardC'
    };
  }
})();

//DEADCODE
(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('eventCard', eventCard);

  function eventCard(customFieldFactory) {

    return {
      replace: true,
      scope: {
        location: '=',
        title: '@'
      },
      templateUrl: 'app/localLanding/cards/eventCard.directive.html',
      restrict: 'AE',
      controller: function ($scope, _) {
        var vm = this;

        if (typeof $scope.title === 'undefined') {
          vm.title = 'Events';
        } else {
          vm.title = $scope.title;
        }

        vm.eventObject = [];
        vm.indexes = [];

        vm.location = $scope.location;
        if ($scope.collapseAddress) {
          vm.addressExtended = vm.location.store_info.address + " " + vm.location.store_info.address_extended;
        }
        _.each(vm.location.custom_fields, function (field) {
          if (field.name.toLowerCase().indexOf('event_title') === 0) {
            var indexPosition = field.name.lastIndexOf('_');
            var index = field.name.substring(indexPosition + 1);
            if (index <= 1) {
              addToEventObject(field);
            }
          }
        });

        function getStartTimeStringFromHours(hours, day) {
          var dayTimes = hours.split(';');
          var correctDayTime = _.find(dayTimes, function (dayTime) {
            return (dayTime.charAt(0) === (day + 1).toString());
            //our app's day indexing starts at 1, date object starts at 0
          }).split(',');
          var startTime = correctDayTime[1].substring(0, 4);
          var startHours = startTime.substring(0, 2);
          var startMinutes = startTime.substring(2, 4);
          var startAMPM = 'AM';
          if (parseInt(startHours) - 12 >= 0) {
            startAMPM = 'PM';
          }
          if (startHours === '00') {
            startHours = '12';
          }
          return startHours + ':' + startMinutes + ' ' + startAMPM;
        }

        function convertTimeStringToMillis(time, date) {
          var split = time.split(/[ :]/);
          var hours = parseInt(split[0]);
          var minutes = parseInt(split[1]);
          var AMPM = _.find(split, function (tokens) {
            return tokens.charAt(0).toLowerCase() === 'a' || tokens.charAt(0).toLowerCase() === 'p';
          });
          if (AMPM !== undefined) {
            if (AMPM.charAt(0).toLowerCase() === 'a') {
              var hourMillis = hours % 12 * 60 * 60 * 1000;
            }
            else {
              var hourMillis = (hours === 12 ? 12 : hours + 12) * 60 * 60 * 1000;
            }
          } else {
            var hourMillis = hours * 60 * 60 * 1000;
          }
          var dateWithoutTime = new Date(date.toLocaleDateString());
          return dateWithoutTime.getTime() + hourMillis + minutes * 60 * 1000;
        }

        function addToEventObject(title) {
          var indexPosition = title.name.lastIndexOf('_');
          var index = title.name.substring(indexPosition + 1);
          var data;
          if (!vm.eventObject[index]) {
            vm.eventObject[index] = {};
            vm.indexes.push(index);
          }
          //title
          vm.eventObject[index].Title = title.data;

          //content
          if (data = customFieldFactory.getValueByName(vm.location.custom_fields, 'event_content_' + index)) {
            vm.eventObject[index].Content = data;
          }

          //location
          if (data = customFieldFactory.getValueByName(vm.location.custom_fields, 'event_location_' + index)) {
            vm.eventObject[index].Location = data;
          }
          else {
            vm.eventObject[index].Location = vm.location.store_info.name;
          }

          //address
          vm.eventObject[index].Address = {};
          vm.eventObject[index].Address.streetAddress = vm.addressExtended || vm.location.store_info.address;
          vm.eventObject[index].Address.locality = vm.location.store_info.locality;
          vm.eventObject[index].Address.region = vm.location.store_info.region;
          vm.eventObject[index].Address.postcode = vm.location.store_info.postcode;
          vm.eventObject[index].Address.country = vm.location.store_info.country;

          //start date
          vm.eventObject[index].StartDate = {};
          var locale = "en-us";
          if (data = customFieldFactory.getValueByName(vm.location.custom_fields, 'event_start_date_' + index)) {
            vm.eventObject[index].StartDate.date = new Date(data);
          }
          else {
            vm.eventObject[index].StartDate.date = new Date();
          }
          if (data = customFieldFactory.getValueByName(vm.location.custom_fields, 'event_start_time_' + index)) {
            vm.eventObject[index].StartDate.date.setTime(convertTimeStringToMillis(data, vm.eventObject[index].StartDate.date));
            vm.eventObject[index].StartDate.time = vm.eventObject[index].StartDate.date.toLocaleTimeString(locale, {
              hour: '2-digit',
              minute: '2-digit'
            });
          }
          else {
            console.log(vm.eventObject[index].StartDate.date);
            var openTime = getStartTimeStringFromHours(vm.location.store_info.hours, vm.eventObject[index].StartDate.date.getDay());
            vm.eventObject[index].StartDate.date.setTime(convertTimeStringToMillis(openTime, vm.eventObject[index].StartDate.date));
            vm.eventObject[index].StartDate.time = openTime;
          }
          vm.eventObject[index].StartDate.ISO = vm.eventObject[index].StartDate.date.toISOString();
          vm.eventObject[index].StartDate.weekday = vm.eventObject[index].StartDate.date.toLocaleString(locale, {weekday: "short"})
          vm.eventObject[index].StartDate.day = vm.eventObject[index].StartDate.date.getDate();
          vm.eventObject[index].StartDate.monthStr = vm.eventObject[index].StartDate.date.toLocaleString(locale, {month: "short"});
          vm.eventObject[index].StartDate.dayTime = vm.eventObject[index].StartDate.weekday + ', ' + vm.eventObject[index].StartDate.time;

        }
      },
      controllerAs: 'eventCardController'
    };
  }
})();

angular
  .module('storeLocator')
  .directive('errorCard', errorCard);

function errorCard() {

  return {
    templateUrl: 'app/localLanding/cards/errorCard.directive.html',
    restrict: 'E',
    bindToController:{
      locationError: '=',
      customLocator: '@'
    },
    controller:errorCardController,
    controllerAs:'errorCardC'
    }
}

    function errorCardController(localLandingData, CLIENT_ROUTE, $timeout, $window, $scope) {
      var vm=this;
      var errorStatusCode = $scope.localLanding.errorStatus;
      vm.errorHeading;
      vm.nearbyLocationsFlag = true;
      
      errorStatus(errorStatusCode);

      function errorStatus(errorCode){

        if(errorCode == 400){
          vm.errorHeading = "HTTP ERROR 400: (BAD REQUEST)"
          vm.nearbyLocationsFlag = false;
        }
        else if(errorCode == 404){
          vm.errorHeading = "HTTP ERROR 404: (RESOURCE NOT FOUND)"
          vm.nearbyLocationsFlag = false;
        }
        else if(errorCode == 500) {
          vm.errorHeading = "HTTP ERROR 500: (INTERNAL SERVER ERROR)"
          vm.nearbyLocationsFlag = false;
        }
        else {
          vm.errorHeading = "Location Not Found"
        }
      }

      vm.indexURI = CLIENT_ROUTE;

      vm.auto_redirect=false;

      vm.location_p = localLandingData.getLocationForLocality().then(locationListComplete);

      function locationListComplete(response) {
        vm.location=response.data;

        if(vm.location.length == undefined){
          vm.nearbyLocationsFlag = false;
        }
        else if(vm.location.length==1){
          vm.auto_redirect=true;
          $timeout(load, 3500);
        }
      }
      function load(){
        $window.location.href = vm.indexURI +vm.location[0].llp_url;
      }

}

(function () {
    'use strict';
    angular
      .module('storeLocator')
      .directive('deliveryModalCard', deliveryModalCard);

    function deliveryModalCard() {
      return {
        replace: true,
        scope: {
          location: '=',
          buttonClass: '@',
          extendedDelivery: '=',
        },
        controller: deliveryModalCardController,
        controllerAs: 'deliveryModalCardCtrl',
        templateUrl: 'app/localLanding/cards/deliveryModalCard.directive.html',
        restrict: 'AE',
        bindToController: {}
      };

      function deliveryModalCardController(_, $location, $scope, $modal, $sce, customFieldFactory, BASE_URL) {

        var $ctrl = this;
        $ctrl.buttonClass = $scope.buttonClass;
        $ctrl.validDelivery = false;
        $ctrl.extendedDelivery = $scope.extendedDelivery;
        $ctrl.location = $scope.location;
        $ctrl.orderOnline = getCustomFieldValueByName($scope.location.custom_fields, "order_online_link")
          || getCustomFieldValueByName($scope.location.custom_fields, "online_order_link");
        $ctrl.text = getCustomFieldValueByName($scope.location.custom_fields, "order_online_button_text") || 'Order Online';
        var customModalTitle = getCustomFieldValueByName($scope.location.custom_fields, "order_online_modal_title")
        $ctrl.modalTitle = customModalTitle || "Online Order Options"
        $ctrl.pageCategory = $location.path() === '/' ? 'Store Locator' : 'LLP';
        var orderOnlineLink2 = getCustomFieldValueByName($scope.location.custom_fields, "order_online_link2");
        var orderOnlineLink3 = getCustomFieldValueByName($scope.location.custom_fields, "order_online_link3");
        var orderOnlineLink4 = getCustomFieldValueByName($scope.location.custom_fields, "order_online_link4");
        var orderOnlineLink5 = getCustomFieldValueByName($scope.location.custom_fields, "order_online_link5");
        var orderOnlineLink6 = getCustomFieldValueByName($scope.location.custom_fields, "order_online_link6");
        var logoLinkBase = 'https://s3-us-west-1.amazonaws.com/mfeed-store-locator.momentfeed.com/momentfeed/cards/delivery_modal/';
        var focus;
        var modal;
        $ctrl.showModal = function () {
          deliveryModal.$promise
          .then(deliveryModal.show)
          
        };

        $ctrl.keypressShowModal = function(e) {
          focus = document.activeElement
          var key=e.keyCode || e.which;
          if (key==13){
            e.preventDefault()
            deliveryModal.$promise
            .then(deliveryModal.show)
            .then(setTimeout(function() { document.getElementsByClassName('modal-content')[0].focus() },200))
            .then( function() {
              var anchors = document.getElementsByTagName('a');
              var buttons = document.getElementsByTagName('button');
              var inputs = document.getElementsByTagName('input');
              var selects = document.getElementsByTagName('select');
              var tabs = document.querySelectorAll('[tabindex]')
              var close = document.getElementById('delivery-modal-close')
              
              Array.from(anchors).forEach(function(x) { x.setAttribute('tabindex', '-1') })
              Array.from(buttons).forEach(function(x) { x.setAttribute('tabindex', '-1') })
              Array.from(inputs).forEach(function(x) { x.setAttribute('tabindex', '-1') })
              Array.from(selects).forEach(function(x) { x.setAttribute('tabindex', '-1') })
              Array.from(tabs).forEach(function(x) { x.setAttribute('tabindex', '-1') })
              close.setAttribute('tabindex', "0")
              
              setTimeout(setTabIndiciesToNegOne, 0)
            })
            .then(modal = document.getElementsByClassName('modal'))
            .then(setTimeout(addEventListenersToModal, 0));
          };
        };

        $ctrl.closeModal = function(e) {
          var key=e.keyCode || e.which;
          if (key==13){
            e.preventDefault()
            deliveryModal.$promise
            .then(deliveryModal.hide)
            .then(resetTabIndices())
            .then(focus.focus());
          }
        };

        function setTabIndiciesToNegOne() {
          var popup = document.querySelectorAll('.leaflet-popup a')
          Array.from(popup).forEach(function(x) { x.setAttribute('tabindex', '-1') })
        }

        function addEventListenersToModal() {
          modal[0].addEventListener('click', function() {
            resetTabIndices();
            focus.focus();
          })
          document.addEventListener('keydown', function(e) {
            var key2=e.keyCode || e.which;
            if(key2==27) {
              resetTabIndices();
            }
          })
        }

        function resetTabIndices() {
          var anchors = document.getElementsByTagName('a');
          var buttons = document.getElementsByTagName('button');
          var inputs = document.getElementsByTagName('input');
          var selects = document.getElementsByTagName('select');
          var tabs = document.querySelectorAll('[tabindex]')

          Array.from(anchors).forEach(function(x) { x.setAttribute('tabindex', '0') })
          Array.from(buttons).forEach(function(x) { x.setAttribute('tabindex', '0') })
          Array.from(inputs).forEach(function(x) { x.setAttribute('tabindex', '0') })
          Array.from(selects).forEach(function(x) { x.setAttribute('tabindex', '0') })
          Array.from(tabs).forEach(function(x) { x.setAttribute('tabindex', '0') })
        }
        
        $ctrl.getCustomFieldValueByName = getCustomFieldValueByName;
        $ctrl.hasCustomFieldValue = hasCustomFieldValue;

        function getCustomFieldValueByName(customFields, name) {
          if (hasCustomFieldValue(customFields, name)) {
            var value = customFieldFactory.getValueByName(customFields, name);
          }
          return value;
        }

        function hasCustomFieldValue(customFields, name) {
          return customFieldFactory.getValueByName(customFields, name) ? true : false;
        }


        function extractHostname(url) {
          var hostname;
          //find & remove protocol (http, ftp, etc.) and get hostname
          if (url.indexOf("//") > -1) {
            hostname = url.split('/')[2];
          }
          else {
            hostname = url.split('/')[0];
          }

          //find & remove port number
          hostname = hostname.split(':')[0];
          //find & remove "?"
          hostname = hostname.split('?')[0];

          return hostname;
        }

        //Extract the Root Domain
        function extractRootDomain(url) {
          var domain = extractHostname(url),
            splitArr = domain.split('.'),
            arrLen = splitArr.length;

          //Checking for a subdomain
          if (arrLen > 2) {
            domain = splitArr[arrLen - 2] + '.' + splitArr[arrLen - 1];
            if (splitArr[arrLen - 2].length == 2 && splitArr[arrLen - 1].length == 2) {
              domain = splitArr[arrLen - 3] + '.' + domain;
            }
          }
          var result = domain.split('.');
          return result[0];
        }

        function extractClientDomain(BASE_URL){
          //NEW Clients case
          if (BASE_URL.indexOf('llp.prod.momentfeed.com') > -1){
            return  BASE_URL.substring(BASE_URL.indexOf('//') +2,BASE_URL.indexOf('.llp.prod.momentfeed.com'));
          }
          // OLD Clients case
          // gets last item before .com, which historically has always been the client's preferred domain name
          // ex stores.cricketwireless, locations.jamba, etc
          else{
            var chunks = BASE_URL.split('.');
            return chunks[chunks.length-1];

          }
        }
        function pushOrderOnlineData(link) {
          var orderOnlineLabel = extractRootDomain(link).toUpperCase();
          $ctrl.linkCount++;
          $scope.labels.push(orderOnlineLabel);
          $scope.links.push(link);
          if (orderOnlineLabel.toUpperCase().indexOf($ctrl.clientDomain) > -1) {
            $scope.logos.push($ctrl.clientLogoLink);
          } else {
            $scope.logos.push(logoLinkBase + orderOnlineLabel.toLowerCase() + '.png');
          }
        }

        $scope.labels = [];
        $scope.links = [];
        $scope.logos = [];
        $ctrl.linkCount = 0;

        $ctrl.clientDomain = extractClientDomain(BASE_URL).toUpperCase();

        $ctrl.clientLogoElem = document.getElementsByClassName("main-logo")[0] || document.getElementsByClassName("logo")[0] || document.getElementById("logo");
        if ($ctrl.clientLogoElem) {
          var  clientLogoImg = $ctrl.clientLogoElem.getElementsByTagName("img")[0];
          if(clientLogoImg){
            $ctrl.clientLogoLink = clientLogoImg.src;
          }
        }

        if ($ctrl.orderOnline != null) {
          pushOrderOnlineData($ctrl.orderOnline);
        }

        if (orderOnlineLink2 != null) {
          pushOrderOnlineData(orderOnlineLink2);
        }

        if (orderOnlineLink3 != null) {
          pushOrderOnlineData(orderOnlineLink3);

        }

        if (orderOnlineLink4 != null) {
          pushOrderOnlineData(orderOnlineLink4);
        }

        if (orderOnlineLink5 != null) {
          pushOrderOnlineData(orderOnlineLink5);
        }

        if (orderOnlineLink6 != null) {
          pushOrderOnlineData(orderOnlineLink6);
        }

        if ($ctrl.linkCount > 0){
          $ctrl.validDelivery = true;
        }
        if ($ctrl.linkCount > 1) {
          $ctrl.extendedDelivery = true;
        } else if($ctrl.linkCount > 0 && $ctrl.extendedDelivery == true) {
          $ctrl.extendedDelivery = true;
        }
        var deliveryModal = $modal(
          {
            title: 'Delivery Options',
            templateUrl: 'app/localLanding/cards/delivery.modal.html',
            placement: "center",
            windowClass: "center",
            show: false,
            animation: "am-fade-and-scale",
            scope: $scope
          });
      }
    }

  }

)();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('customServicesCard', customServicesCard);

  function customServicesCard() {

    return {
      replace: true,
      scope: {
          customFields: '=',
          title: '@'
      },
      templateUrl: 'app/localLanding/cards/customServicesCard.directive.html',
      restrict: 'AE',
      controller: customServicesCardController,
      controllerAs: 'customServicesCardC',
      bindToController: true
    };
  }

  function customServicesCardController(_) {
    var customServicesCardC = this;

    customServicesCardC.services = [];
    if (typeof customServicesCardC.title === 'undefined') {
        customServicesCardC.title = 'Available Services';
    }
    var findServices = _.find(customServicesCardC.customFields, {'name': 'services'});

    if(!_.isUndefined(findServices)) {
      var services = findServices.data;
      services.split(",").forEach(function (service) {
        customServicesCardC.services.push(service);
      });
    }


  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('customFieldsButton', customFieldsButton);

  function customFieldsButton() {

    return {
      replace: true,
      scope: {
        customFields: '=',
        customFieldName: "@",
        buttonText: "@",
        buttonTarget: '@'
      },
      templateUrl: 'app/localLanding/cards/customFieldsButton.directive.html',
      restrict: 'AE',
      controller: customFieldsButtonController,
      controllerAs: 'customFieldsButtonC',
      bindToController: true
    };
  }

  function customFieldsButtonController(_) {
    var customFieldsButtonC = this;

    if(_.isUndefined(customFieldsButtonC.buttonTarget)) {
      customFieldsButtonC.buttonTarget = "_blank";
    }

    customFieldsButtonC.findLink = _.find(customFieldsButtonC.customFields, {'name': customFieldsButtonC.customFieldName});

    // new custom button: customFieldName_link
    customFieldsButtonC.btnLink = _.find(customFieldsButtonC.customFields, {'name': customFieldsButtonC.customFieldName + "_link"});
    // new custom button: customFieldName_text
    customFieldsButtonC.btnText = _.find(customFieldsButtonC.customFields, {'name': customFieldsButtonC.customFieldName + "_text"});
    // 
    customFieldsButtonC.btnTitle = _.find(customFieldsButtonC.customFields, {'name': customFieldsButtonC.customFieldName + "_title" });
 


    if(!_.isUndefined(customFieldsButtonC.findLink)) {
      customFieldsButtonC.link = customFieldsButtonC.findLink.data;
    } else if (customFieldsButtonC.btnLink && customFieldsButtonC.btnText) {
      customFieldsButtonC.link = customFieldsButtonC.btnLink.data;
      customFieldsButtonC.buttonText = customFieldsButtonC.btnText.data;
    }

    if(!_.isUndefined(customFieldsButtonC.btnTitle)) {
      customFieldsButtonC.title = customFieldsButtonC.btnTitle.data;

    } else {
      customFieldsButtonC.title = customFieldsButtonC.buttonText;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('customDescriptionCard', customDescriptionCard);

  function customDescriptionCard() {

    return {
      replace: true,
      scope: {
        location: '=',
        descriptionText: '@',
        descriptionTitle: '@',
        multiLine: '@'
      },
      templateUrl: 'app/localLanding/cards/customDescriptionCard.directive.html',
      restrict: 'AE',
      controller: customDescriptionCardController,
      controllerAs: 'customDescriptionCardC',
      bindToController: true
    };
  }

  function customDescriptionCardController(_, $sce, $scope, RegionService) {
    var customDescriptionCardC = this;
    var descriptionTextField = $scope.customDescriptionCardC.descriptionText ? $scope.customDescriptionCardC.descriptionText : 'description';
    var descriptionTitleField = $scope.customDescriptionCardC.descriptionTitle ? $scope.customDescriptionCardC.descriptionTitle : 'description_title';
    customDescriptionCardC.findDescription = _.find(customDescriptionCardC.location.custom_fields, {'name': descriptionTextField});
    customDescriptionCardC.findCustomName = _.find(customDescriptionCardC.location.custom_fields, {'name': 'store_name_about'});
    customDescriptionCardC.findCustomTitle = _.find(customDescriptionCardC.location.custom_fields, {'name': descriptionTitleField});
    var storeinfo = customDescriptionCardC.location.store_info;
    storeinfo.name = customDescriptionCardC.findCustomName ? customDescriptionCardC.findCustomName.data : storeinfo.name
    customDescriptionCardC.customTitle = customDescriptionCardC.findCustomTitle ? customDescriptionCardC.findCustomTitle.data : undefined;
    customDescriptionCardC.location.store_info.friendlyRegion = RegionService.lookupRegionFromCountry(storeinfo.country,storeinfo.region);

    if (!_.isUndefined(customDescriptionCardC.findDescription)) {
      customDescriptionCardC.description = $sce.trustAsHtml(customDescriptionCardC.findDescription.data);
      customDescriptionCardC.description = customDescriptionCardC.description.toString().replace(/\[\[([0-9.A-Za-z]*?[^.])\]\]/g, function(s, key) {
        return customDescriptionCardC.location.store_info[key];
      });
    }
  }
})();


(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('carouselMenu', carouselMenu);

  function carouselMenu() {

    return {
      replace: true,
      scope: {
        location: '='
      },
      templateUrl: 'app/localLanding/cards/carouselMenu.directive.html',
      restrict: 'AE',
      controller: carouselMenuController,
      controllerAs: 'carouselMenuC',
      bindToController: true
    };
  }

  function carouselMenuController($scope, _) {
    var vm = this;
    vm.menuData = _.find(vm.location.custom_fields, {'name': 'carousel_menu_data'});
    if (vm.menuData) {
      vm.slides = JSON.parse(JSON.parse("\"" + vm.menuData.data + "\""));
    }
  }
})();

(function () {
    'use strict';

    angular.module('storeLocator').directive('awardsCard', awardsCard);

    function awardsCard() {
        return {
            replace: true,
            scope: {
                customFields: '=',
                client: '@'
            },
            templateUrl: 'app/localLanding/cards/awardsCard.directive.html',
            restrict: 'AE',
            controller: awardsCardController,
            controllerAs: 'awardsCardController',
            bindToController: true
        };
    }

    function awardsCardController() {
        var awardsCardController = this;
        awardsCardController.awards = [];

        _.each(awardsCardController.customFields, function (field) {
            if (field.name.toLowerCase().indexOf('award_') === 0) {
                if (field.data.toUpperCase() !== 'FALSE') {
                    awardsCardController.awards.push(field);
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('storeLocator').directive('amenitiesCard', amenitiesCard);

    function amenitiesCard() {
        return {
            replace: true,
            scope: {
                customFields: '=',
                defaultImage: '@',
                displayInOneLine: '@',
                title: '@',
                client: '@',
                customContent: '@'
            },
            templateUrl: 'app/localLanding/cards/amenitiesCard.directive.html',
            restrict: 'AE',
            controller: amenitiesCardController,
            controllerAs: 'amenitiesCardController',
            bindToController: true
        };
    }

    function amenitiesCardController(amenitiesService, $filter, $sce) {
        var amenitiesCardController = this;
        amenitiesCardController.amenities = [];
        amenitiesCardController.amenitiesWithIcons = [];
        amenitiesCardController.amenitiesWithNoIcons = [];

        if (typeof amenitiesCardController.title === 'undefined') {
            amenitiesCardController.title = 'Amenities';
        }

        if (amenitiesCardController.customFields) {
            if(amenitiesCardController.customContent){
              var amenities = amenitiesService.getContents(amenitiesCardController.customFields, amenitiesCardController.customContent);
              amenitiesCardController.hasAmenities = amenities !== null && amenities.length > 0;
              amenitiesCardController.amenities = amenities;

              amenities.forEach(function (amenity) {
                  amenity.nameAmenity = $sce.trustAsHtml(amenity.data);
                  amenitiesCardController.amenitiesWithNoIcons.push(amenity);
              });
            }
            else{
              var amenities = amenitiesService.getAmenities(amenitiesCardController.customFields);
              amenitiesCardController.hasAmenities = amenities !== null && amenities.length > 0;
              amenitiesCardController.amenities = amenities;

              amenities.forEach(function (amenity) {
                if (amenity.tooltip === '') {
                  amenity.nameAmenity = $sce.trustAsHtml(amenity.data);
                  amenitiesCardController.amenitiesWithNoIcons.push(amenity);
                } else {
                  amenity.nameAmenity = $sce.trustAsHtml(amenity.tooltip);
                  amenitiesCardController.amenitiesWithIcons.push(amenity);
                }
              });
            }
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('addressCard', addressCard);

  function addressCard () {

    return {
      replace: true,
      scope: {
        location: '=',
        collapseAddress: '@',
        nameExtended: '@',
        customStoreName: '@',
        customButtonField: '@',
        customButtonText: '@',
        customButton2Field: '@',
        customButton2Text: '@',
        addressLink: '@',
        addressLinkTitle: '@',
        hideGetDirections: '=?', // Optional param for whether to show the "Get Directions" button.
        gtmOnClick: '=',
        deliveryModalExtendedDelivery: '=',
        altPhone: '@'
      },
      templateUrl: 'app/localLanding/cards/addressCard.directive.html',
      restrict: 'AE',
      controller:addressCardController,
      controllerAs:'addressCardC',
      bindToController: {altPhoneTitle: '=', mainPhoneTitle: '='}
      }
  }
      function addressCardController($scope) {
        var vm = this;

        vm.showGetDirections = true;
        vm.storeSEOName = $scope.location.store_info.name;
        if ($scope.hideGetDirections) {
          vm.showGetDirections = false;
        }

        vm.statusFlag = '';

        if ($scope.location.status == "coming soon"){
          vm.statusFlag = "This Location is Coming Soon."
        }
        else if ($scope.location.status == "temp closed"){
          vm.statusFlag = "This Location is Temporarily Closed."
        }

        vm.directionsUrl = $scope.location.store_info.directionsUrl;

        if ($scope.customStoreName) {
            var findName = _.find($scope.location.custom_fields, { "name": $scope.customStoreName });
            vm.storeName = findName ? findName.data : $scope.location.store_info.name;
        } else {
            vm.storeName = $scope.location.store_info.name;
        }

        if ($scope.nameExtended && $scope.nameExtended.includes('[')) {
          var arr = $scope.nameExtended.substr(1, $scope.nameExtended.length - 2).split(',');
          var nameExtendedConfig = [];
          arr.forEach(function(item) {
            item = _.find($scope.location.custom_fields, { "name": item });
            if(item && item.data) nameExtendedConfig.push(item.data);
          })
          nameExtendedConfig.length > 0 ? vm.nameExtendedConfig = nameExtendedConfig : vm.nameExtended = (_.find($scope.location.custom_fields, { "name": "name_extended" })).data
        } else if ($scope.nameExtended && !$scope.nameExtended.includes('[')) {
          vm.nameExtendedConfig = (_.find($scope.location.custom_fields, { "name": $scope.nameExtended })).data
        } else if(!$scope.nameExtended) {
          var name = _.find($scope.location.custom_fields, { "name": "name_extended" })
          if(name) vm.nameExtended = name.data;
        }

        vm.menuLink = _.find($scope.location.custom_fields, {"name": "menulink"});
        if (_.find($scope.location.custom_fields, {"name": "online_order_link"})) {
          vm.onlineOrderLink = _.find($scope.location.custom_fields, {"name": "online_order_link"});
        } else if (_.find($scope.location.custom_fields, {"name": "order_online_link"})) {
          vm.onlineOrderLink = _.find($scope.location.custom_fields, {"name": "order_online_link"}); }
        vm.customButtonLink = _.find($scope.location.custom_fields, { "name": $scope.customButtonField });
        var customButtonText = _.find($scope.location.custom_fields, { "name": $scope.customButtonText })
        vm.customButtonText = customButtonText ? customButtonText.data : $scope.customButtonText;

        vm.customButton2Link = _.find($scope.location.custom_fields, { "name": $scope.customButton2Field });
        var customButton2Text = _.find($scope.location.custom_fields, { "name": $scope.customButton2Text })
        vm.customButton2Text = customButton2Text ? customButton2Text.data : $scope.customButton2Text;

        if($scope.collapseAddress){
        vm.addressExtended = $scope.location.store_info.address+" "+$scope.location.store_info.address_extended;
        }
        
        //Populating alternatie phone number
        if($scope.location.custom_fields) {
          var findAltPhone = _.find($scope.location.custom_fields, { "name": $scope.altPhone });
          if(findAltPhone) {
            vm.altPhone = findAltPhone ? findAltPhone.data : findAltPhone ;
          }
        }
        
        if($scope.gtmOnClick == true) {
          window.onload = function() {
            var getDirectionsBtn = document.getElementsByClassName('get-directions')
            var deliveryModal = document.getElementsByClassName('delivery-modal')
            if(getDirectionsBtn[0]) {
              getDirectionsBtn[0].addEventListener('click', function() {
                getDirectionsLLP($scope.location.store_info.corporate_id)
              })
            }
            if(deliveryModal[0]) {
              deliveryModal[0].addEventListener('click', function() {
                deliveryModalLLP($scope.location.store_info.corporate_id)
              })
            }
          }
        }

      }
})();

(function () {
    'use strict';

    angular
      .module('storeLocator')
      .directive('addressBreadcrumbCard', addressBreadcrumbCard);

    function addressBreadcrumbCard() {

        return {
            replace: true,
            scope: { location: '=' },
            templateUrl: 'app/localLanding/cards/addressBreadcrumbCard.directive.html',
            restrict: 'AE'
        };
    }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('activitiesCard', activitiesCard);

  function activitiesCard () {

    return {
      replace: true,
      scope: { activities: '='},
      templateUrl: 'app/localLanding/cards/activitiesCard.directive.html',
      restrict: 'AE',
      controller: function () {
       // var vm = this;
      },
      controllerAs: 'activitiesCardC'
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('aboutWithPictureCard', aboutWithPictureCard);

  function aboutWithPictureCard() {

    return {
      replace: true,
      scope: {
        location: '=',
        title: '@'
      },
      templateUrl: 'app/localLanding/cards/aboutWithPictureCard.directive.html',
      restrict: 'AE',
      controller: aboutWithPictureCardController,
      controllerAs: 'aboutWithPictureCardC',
      bindToController: true
    };
  }

  function aboutWithPictureCardController($sce) {
    var aboutWithPictureCardC = this;
    if (typeof aboutWithPictureCardC.title === 'undefined') {
      aboutWithPictureCardC.hasTitle = false;
    } else {
      aboutWithPictureCardC.hasTitle = true;
    }

    if (!_.isUndefined(aboutWithPictureCardC.location.description)) {
      aboutWithPictureCardC.location.description = $sce.trustAsHtml(aboutWithPictureCardC.location.description);
    }
}



})();

(function() {
	'use strict';

	angular
		.module('storeLocator')
		.directive('aboutCard', aboutCard);

	function aboutCard() {

		return {
			replace: true,
			scope: {
			    location: '=',
                   title: '@'
			},
			templateUrl: 'app/localLanding/cards/aboutCard.directive.html',
			restrict: 'AE',
			controller: aboutCardController,
			controllerAs: 'aboutCardCtrl',
			bindToController: true
		};
	}

	function aboutCardController($sce) {
	    var aboutCardCtrl = this;
	    if (typeof aboutCardCtrl.title === 'undefined') {
	        aboutCardCtrl.hasTitle = false;
	    } else {
	        aboutCardCtrl.hasTitle = true;
	    }

	    if (!_.isUndefined(aboutCardCtrl.location.description)) {
	        aboutCardCtrl.description = $sce.trustAsHtml(aboutCardCtrl.location.description);
	    }
	}

})();

/**
 * angular-bootstrap-scrolling-tabs
 * @version v1.2.0
 * @link https://github.com/mikejacobson/angular-bootstrap-scrolling-tabs
 * @author Mike Jacobson <michaeljjacobson1@gmail.com>
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
; (function ($, window) {
    'use strict';

    var scrollingTabsModule = angular.module('mj.scrollingTabs', []);

    var CONSTANTS = {
        CONTINUOUS_SCROLLING_TIMEOUT_INTERVAL: 50, // timeout interval for repeatedly moving the tabs container
        // by one increment while the mouse is held down--decrease to
        // make mousedown continous scrolling faster
        SCROLL_OFFSET_FRACTION: 6, // each click moves the container this fraction of the fixed container--decrease
        // to make the tabs scroll farther per click
        DATA_KEY_IS_MOUSEDOWN: 'ismousedown'
    };

    // smartresize from Paul Irish (debounced window resize)
    (function ($, sr) {
        var debounce = function (func, threshold, execAsap) {
            var timeout;

            return function debounced() {
                var obj = this, args = arguments;
                function delayed() {
                    if (!execAsap)
                        func.apply(obj, args);
                    timeout = null;
                }

                if (timeout)
                    clearTimeout(timeout);
                else if (execAsap)
                    func.apply(obj, args);

                timeout = setTimeout(delayed, threshold || 100);
            };
        };
        jQuery.fn[sr] = function (fn) { return fn ? this.bind('resize.scrtabs', debounce(fn)) : this.trigger(sr); };

    })(jQuery, 'smartresize');

    /* *************************************************************
     * scrolling-tabs element directive template
     * *************************************************************/
    // plunk: http://plnkr.co/edit/YhKiIhuAPkpAyacu6tuk
    var scrollingTabsTemplate = [
      '<div class="scrtabs-tab-container">',
      ' <div class="scrtabs-tab-scroll-arrow scrtabs-js-tab-scroll-arrow-left"><span class="glyphicon glyphicon-chevron-left"></span></div>',
      '   <div class="scrtabs-tabs-fixed-container">',
      '     <div class="scrtabs-tabs-movable-container">',
      '       <ul class="nav nav-tabs" role="tablist">',
      '         <li ng-class="{ \'active\': tab[propActive || \'active\'], ',
      '                         \'disabled\': tab[propDisabled || \'disabled\'] }" ',
      '             data-tab="{{tab}}" data-index="{{$index}}" ng-repeat="tab in tabsArr">',
      '           <a ng-href="{{\'#\' + tab[propPaneId || \'paneId\']}}" role="tab"',
      '                data-toggle="{{tab[propDisabled || \'disabled\'] ? \'\' : \'tab\'}}" ',
      '                ng-bind-html="sanitize(tab[propTitle || \'title\']);">',
      '           </a>',
      '         </li>',
      '       </ul>',
      '     </div>',
      ' </div>',
      ' <div class="scrtabs-tab-scroll-arrow scrtabs-js-tab-scroll-arrow-right"><span class="glyphicon glyphicon-chevron-right"></span></div>',
      '</div>'
    ].join('');


    /* *************************************************************
     * scrolling-tabs-wrapper element directive template
     * *************************************************************/
    // plunk: http://plnkr.co/edit/lWeQxxecKPudK7xlQxS3
    var scrollingTabsWrapperTemplate = [
      '<div class="scrtabs-tab-wrapper-container" ng-class="{ \'force-height\': !scrtc.hasTabContentOutsideMovableContainer }">',
      ' <div class="scrtabs-tab-scroll-arrow scrtabs-js-tab-scroll-arrow-left"><span class="glyphicon glyphicon-chevron-left"></span></div>',
      '   <div class="scrtabs-tabs-fixed-container">',
      '     <div class="scrtabs-tabs-movable-container" ng-transclude></div>',
      '   </div>',
      ' <div class="scrtabs-tab-scroll-arrow scrtabs-js-tab-scroll-arrow-right"><span class="glyphicon glyphicon-chevron-right"></span></div>',
      '</div>'
    ].join('');

    /* ***********************************************************************************
     * ElementsHandler - Class that each instance of ScrollingTabsControl will instantiate
     * **********************************************************************************/
    function ElementsHandler(scrollingTabsControl) {
        var ehd = this;

        ehd.stc = scrollingTabsControl;
    }

    // ElementsHandler prototype methods
    (function (p) {
        p.initElements = function (options) {
            var ehd = this,
                stc = ehd.stc,
                $tabsContainer = stc.$tabsContainer;

            ehd.setElementReferences();

            if (options.isWrappingAngularUITabset) {
                ehd.moveTabContentOutsideScrollContainer(options);
            }

            ehd.setEventListeners();
        };

        p.moveTabContentOutsideScrollContainer = function (options) {
            var ehd = this,
                stc = ehd.stc,
                $tabsContainer = stc.$tabsContainer,
                $movableContainer = $tabsContainer.find('.scrtabs-tabs-movable-container'),
                $tabContentInMovableContainer = $movableContainer.find('.tab-content'),
                uibTabsetController = $movableContainer.find('> div').eq(0).data('$uibTabsetController');

            $tabContentInMovableContainer.show().appendTo($tabsContainer);

            if (uibTabsetController) {
                $tabContentInMovableContainer.data('$uibTabsetController', uibTabsetController);
            }
        };

        p.refreshAllElementSizes = function () {
            var ehd = this,
                stc = ehd.stc,
                smv = stc.scrollMovement,
                scrollArrowsWereVisible = stc.scrollArrowsVisible,
                actionsTaken = {
                    didScrollToActiveTab: false
                },
                minPos;

            ehd.setElementWidths();
            ehd.setScrollArrowVisibility();

            if (stc.scrollArrowsVisible) {
                ehd.setFixedContainerWidthForJustVisibleScrollArrows();
            }

            // this could have been a window resize or the removal of a
            // dynamic tab, so make sure the movable container is positioned
            // correctly because, if it is far to the left and we increased the
            // window width, it's possible that the tabs will be too far left,
            // beyond the min pos.
            if (stc.scrollArrowsVisible || scrollArrowsWereVisible) {
                if (stc.scrollArrowsVisible) {
                    // make sure container not too far left
                    minPos = smv.getMinPos();
                    if (stc.movableContainerLeftPos < minPos) {
                        smv.incrementScrollRight(minPos);
                    } else {
                        smv.scrollToActiveTab({
                            isOnWindowResize: true
                        });

                        actionsTaken.didScrollToActiveTab = true;
                    }
                } else {
                    // scroll arrows went away after resize, so position movable container at 0
                    stc.movableContainerLeftPos = 0;
                    smv.slideMovableContainerToLeftPos();
                }
            }

            return actionsTaken;
        };

        p.setElementReferences = function () {
            var ehd = this,
                stc = ehd.stc,
                $tabsContainer = stc.$tabsContainer;

            stc.isNavPills = false;

            stc.$fixedContainer = $tabsContainer.find('.scrtabs-tabs-fixed-container');
            stc.$movableContainer = $tabsContainer.find('.scrtabs-tabs-movable-container');
            stc.$tabsUl = stc.$movableContainer.find('.nav-tabs');

            // check for pills
            if (!stc.$tabsUl.length) {
                stc.$tabsUl = stc.$movableContainer.find('.nav-pills');

                if (stc.$tabsUl.length) {
                    stc.isNavPills = true;
                }
            }

            stc.$tabsLiCollection = stc.$tabsUl.find('> li');
            stc.$leftScrollArrow = $tabsContainer.find('.scrtabs-js-tab-scroll-arrow-left');
            stc.$rightScrollArrow = $tabsContainer.find('.scrtabs-js-tab-scroll-arrow-right');
            stc.$scrollArrows = stc.$leftScrollArrow.add(stc.$rightScrollArrow);

            stc.$win = $(window);
        };

        p.setElementWidths = function () {
            var ehd = this,
                stc = ehd.stc;

            if (!stc.$win) {
                return;
            }

            stc.containerWidth = stc.$tabsContainer.outerWidth();
            stc.winWidth = stc.$win.width();

            stc.scrollArrowsCombinedWidth = stc.$leftScrollArrow.outerWidth() + stc.$rightScrollArrow.outerWidth();

            ehd.setFixedContainerWidth();
            ehd.setMovableContainerWidth();
        };

        p.setEventListeners = function () {
            var ehd = this,
                stc = ehd.stc,
                evh = stc.eventHandlers; // eventHandlers

            stc.$leftScrollArrow.off('.scrtabs').on({
                'mousedown.scrtabs touchstart.scrtabs': function (e) { evh.handleMousedownOnLeftScrollArrow.call(evh, e); },
                'mouseup.scrtabs touchend.scrtabs': function (e) { evh.handleMouseupOnLeftScrollArrow.call(evh, e); },
                'click.scrtabs': function (e) { evh.handleClickOnLeftScrollArrow.call(evh, e); }
            });

            stc.$rightScrollArrow.off('.scrtabs').on({
                'mousedown.scrtabs touchstart.scrtabs': function (e) { evh.handleMousedownOnRightScrollArrow.call(evh, e); },
                'mouseup.scrtabs touchend.scrtabs': function (e) { evh.handleMouseupOnRightScrollArrow.call(evh, e); },
                'click.scrtabs': function (e) { evh.handleClickOnRightScrollArrow.call(evh, e); }
            });

            stc.$win.smartresize(function (e) { evh.handleWindowResize.call(evh, e); });
        };

        p.setFixedContainerWidth = function () {
            var ehd = this,
                stc = ehd.stc,
                tabsContainerRect = stc.$tabsContainer.get(0).getBoundingClientRect();

            stc.fixedContainerWidth = tabsContainerRect.width || (tabsContainerRect.right - tabsContainerRect.left);
            stc.$fixedContainer.width(stc.fixedContainerWidth);
        };

        p.setFixedContainerWidthForJustHiddenScrollArrows = function () {
            var ehd = this,
                stc = ehd.stc;

            stc.$fixedContainer.width(stc.fixedContainerWidth);
        };

        p.setFixedContainerWidthForJustVisibleScrollArrows = function () {
            var ehd = this,
                stc = ehd.stc;

            stc.$fixedContainer.width(stc.fixedContainerWidth - stc.scrollArrowsCombinedWidth);
        };

        p.setMovableContainerWidth = function () {
            var ehd = this,
                stc = ehd.stc,
                $tabLi = stc.$tabsUl.find('li'),
                fixedContainerHeight = stc.$fixedContainer.height(),
                maxWidthExpansions = 10; // prevent infinite loop

            stc.movableContainerWidth = 0;

            if ($tabLi.length) {

                $tabLi.each(function __getLiWidth() {
                    var $li = $(this),
                        totalMargin = 0;

                    if (stc.isNavPills) { // pills have a margin-left, tabs have no margin
                        totalMargin = parseInt($li.css('margin-left'), 10) + parseInt($li.css('margin-right'), 10);
                    }

                    stc.movableContainerWidth += ($li.outerWidth() + totalMargin);
                });

                stc.movableContainerWidth += 1;

                // if the tabs don't span the width of the page, force the
                // movable container width to full page width so the bottom
                // border spans the page width instead of just spanning the
                // width of the tabs
                if (stc.movableContainerWidth < stc.fixedContainerWidth) {
                    stc.movableContainerWidth = stc.fixedContainerWidth;
                }
            }

            stc.$movableContainer.width(stc.movableContainerWidth);

            // when we have >35 pills, sometimes the movable container width ends
            // up being a pixel short, causing the last pill to wrap; so we do
            // this check for a wrapped pill--we check if the movable container
            // height has expanded beyond the fixed container height (indicating
            // a wrapped pill), and if it has, we increase the movable container
            // width 1 pixel at a time until there's no wrap. We also put a
            // limit on the number of checks/expansions to prevent an infinite
            // loop, in case we get into some weird situation where adding width
            // never fixes the wrap.
            while ((stc.$movableContainer.height() > fixedContainerHeight) && maxWidthExpansions--) {
                stc.$movableContainer.width(stc.movableContainerWidth += 1);
            }

        };

        p.setScrollArrowVisibility = function () {
            var ehd = this,
                stc = ehd.stc,
                shouldBeVisible = stc.movableContainerWidth > stc.fixedContainerWidth;

            if (shouldBeVisible && !stc.scrollArrowsVisible) {
                stc.$scrollArrows.show();
                stc.scrollArrowsVisible = true;
                ehd.setFixedContainerWidthForJustVisibleScrollArrows();
            } else if (!shouldBeVisible && stc.scrollArrowsVisible) {
                stc.$scrollArrows.hide();
                stc.scrollArrowsVisible = false;
                ehd.setFixedContainerWidthForJustHiddenScrollArrows();
            }
        };

    }(ElementsHandler.prototype));

    /* ***********************************************************************************
     * EventHandlers - Class that each instance of ScrollingTabsControl will instantiate
     * **********************************************************************************/
    function EventHandlers(scrollingTabsControl) {
        var evh = this;

        evh.stc = scrollingTabsControl;
    }

    // prototype methods
    (function (p) {
        p.handleClickOnLeftScrollArrow = function (e) {
            var evh = this,
                stc = evh.stc;

            stc.scrollMovement.incrementScrollLeft();
        };

        p.handleClickOnRightScrollArrow = function (e) {
            var evh = this,
                stc = evh.stc,
                scrollMovement = stc.scrollMovement;

            scrollMovement.incrementScrollRight(scrollMovement.getMinPos());
        };

        p.handleMousedownOnLeftScrollArrow = function (e) {
            var evh = this,
                stc = evh.stc;

            stc.scrollMovement.startScrollLeft();
        };

        p.handleMousedownOnRightScrollArrow = function (e) {
            var evh = this,
                stc = evh.stc;

            stc.scrollMovement.startScrollRight();
        };

        p.handleMouseupOnLeftScrollArrow = function (e) {
            var evh = this,
                stc = evh.stc;

            stc.scrollMovement.stopScrollLeft();
        };

        p.handleMouseupOnRightScrollArrow = function (e) {
            var evh = this,
                stc = evh.stc;

            stc.scrollMovement.stopScrollRight();
        };

        p.handleWindowResize = function (e) {
            var evh = this,
                stc = evh.stc,
                newWinWidth = stc.$win.width();

            if (newWinWidth === stc.winWidth) {
                return false; // false alarm
            }

            stc.winWidth = newWinWidth;
            stc.elementsHandler.refreshAllElementSizes();
        };

    }(EventHandlers.prototype));

    /* ***********************************************************************************
     * ScrollMovement - Class that each instance of ScrollingTabsControl will instantiate
     * **********************************************************************************/
    function ScrollMovement(scrollingTabsControl) {
        var smv = this;

        smv.stc = scrollingTabsControl;
    }

    // prototype methods
    (function (p) {

        p.continueScrollLeft = function () {
            var smv = this,
                stc = smv.stc;

            stc.$timeout(function () {
                if (stc.$leftScrollArrow.data(CONSTANTS.DATA_KEY_IS_MOUSEDOWN) && (stc.movableContainerLeftPos < 0)) {
                    if (!smv.incrementScrollLeft()) { // scroll limit not reached, so keep scrolling
                        smv.continueScrollLeft();
                    }
                }
            }, CONSTANTS.CONTINUOUS_SCROLLING_TIMEOUT_INTERVAL);
        };

        p.continueScrollRight = function (minPos) {
            var smv = this,
                stc = smv.stc;

            stc.$timeout(function () {
                if (stc.$rightScrollArrow.data(CONSTANTS.DATA_KEY_IS_MOUSEDOWN) && (stc.movableContainerLeftPos > minPos)) {
                    // slide tabs LEFT -> decrease movable container's left position
                    // min value is (movableContainerWidth - $tabHeader width)
                    if (!smv.incrementScrollRight(minPos)) {
                        smv.continueScrollRight(minPos);
                    }
                }
            }, CONSTANTS.CONTINUOUS_SCROLLING_TIMEOUT_INTERVAL);
        };

        p.decrementMovableContainerLeftPos = function (minPos) {
            var smv = this,
                stc = smv.stc;

            stc.movableContainerLeftPos -= (stc.fixedContainerWidth / CONSTANTS.SCROLL_OFFSET_FRACTION);
            if (stc.movableContainerLeftPos < minPos) {
                stc.movableContainerLeftPos = minPos;
            } else if (stc.scrollToTabEdge) {
                smv.setMovableContainerLeftPosToTabEdge('right');

                if (stc.movableContainerLeftPos < minPos) {
                    stc.movableContainerLeftPos = minPos;
                }
            }
        };

        p.getMinPos = function () {
            var smv = this,
                stc = smv.stc;

            return stc.scrollArrowsVisible ? (stc.fixedContainerWidth - stc.movableContainerWidth - stc.scrollArrowsCombinedWidth) : 0;
        };

        p.getMovableContainerCssLeftVal = function () {
            var smv = this,
                stc = smv.stc;

            return (stc.movableContainerLeftPos === 0) ? '0' : stc.movableContainerLeftPos + 'px';
        };

        p.incrementScrollLeft = function () {
            var smv = this,
                stc = smv.stc;

            stc.movableContainerLeftPos += (stc.fixedContainerWidth / CONSTANTS.SCROLL_OFFSET_FRACTION);

            if (stc.movableContainerLeftPos > 0) {
                stc.movableContainerLeftPos = 0;
            } else if (stc.scrollToTabEdge) {
                smv.setMovableContainerLeftPosToTabEdge('left');

                if (stc.movableContainerLeftPos > 0) {
                    stc.movableContainerLeftPos = 0;
                }
            }

            smv.slideMovableContainerToLeftPos();

            return (stc.movableContainerLeftPos === 0); // indicates scroll limit reached
        };

        p.incrementScrollRight = function (minPos) {
            var smv = this,
                stc = smv.stc;

            smv.decrementMovableContainerLeftPos(minPos);
            smv.slideMovableContainerToLeftPos();

            return (stc.movableContainerLeftPos === minPos);
        };

        p.scrollToActiveTab = function (options) {
            var smv = this,
                stc = smv.stc,
                offset = 0,
                $activeTab,
                activeTabWidth,
                activeTabLeftPos,
                activeTabRightPos,
                rightArrowLeftPos,
                leftArrowRightPos,
                visibleAreaLeftPos,
                visibleAreaRightPos,
                minPos;

            // if the active tab is not fully visible, scroll till it is
            if (!stc.scrollArrowsVisible) {
                return;
            }

            $activeTab = stc.$tabsUl.find('li.active');

            if (!$activeTab.length) {
                return;
            }

            activeTabLeftPos = $activeTab.offset().left;
            activeTabWidth = $activeTab.outerWidth();
            activeTabRightPos = activeTabLeftPos + activeTabWidth + parseInt(stc.scrollingTabsActiveOffset || 0, 10);

            rightArrowLeftPos = stc.$rightScrollArrow.offset().left;
            leftArrowRightPos = stc.$leftScrollArrow.outerWidth(); // its leftpos is 0
            visibleAreaLeftPos = leftArrowRightPos;
            visibleAreaRightPos = rightArrowLeftPos;

            if (activeTabLeftPos < visibleAreaLeftPos) {
                offset = activeTabLeftPos - visibleAreaLeftPos;
                stc.movableContainerLeftPos = stc.movableContainerLeftPos - offset;
            } else if (activeTabRightPos > visibleAreaRightPos) {
                offset = activeTabRightPos - visibleAreaRightPos;
                stc.movableContainerLeftPos = stc.movableContainerLeftPos - offset;
            }

            if (offset) {
                minPos = smv.getMinPos();

                if (stc.movableContainerLeftPos < minPos) {
                    stc.movableContainerLeftPos = minPos;
                } else if (stc.movableContainerLeftPos > 0) {
                    stc.movableContainerLeftPos = 0;
                }

                smv.slideMovableContainerToLeftPos();
            } else if (stc.scrollingTabsActiveOffset) {
                stc.handleArrowsClassNames('left');
            }
        };

        p.setMovableContainerLeftPosToTabEdge = function (scrollArrowClicked) {
            var smv = this,
                stc = smv.stc,
                offscreenWidth = -stc.movableContainerLeftPos,
                totalTabWidth = 0;

            // make sure LeftPos is set so that a tab edge will be against the
            // left scroll arrow so we won't have a partial, cut-off tab
            stc.$tabsLiCollection.each(function (index) {
                var tabWidth = $(this).width();

                totalTabWidth += tabWidth;

                if (totalTabWidth > offscreenWidth) {
                    stc.movableContainerLeftPos = (scrollArrowClicked === 'left') ? -(totalTabWidth - tabWidth) : -totalTabWidth;
                    return false; // exit .each() loop
                }

            });
        };

        p.slideMovableContainerToLeftPos = function () {
            var smv = this,
                stc = smv.stc,
                leftVal;

            stc.movableContainerLeftPos = stc.movableContainerLeftPos / 1;
            leftVal = smv.getMovableContainerCssLeftVal();

            stc.$movableContainer.stop().animate({ left: leftVal }, 'slow', function () {
                var newMinPos = smv.getMinPos();

                // if we slid past the min pos--which can happen if you resize the window
                // quickly--move back into position
                if (stc.movableContainerLeftPos < newMinPos) {
                    smv.decrementMovableContainerLeftPos(newMinPos);
                    stc.$movableContainer.stop().animate({ left: smv.getMovableContainerCssLeftVal() }, 'fast');
                }

                if (stc.scrollingTabsActiveOffset) {
                    var edge;
                    // taking 2px offset error
                    if (stc.movableContainerLeftPos <= 0 && stc.movableContainerLeftPos >= -2) {
                        // left edge
                        edge = 'left';
                    } else if ((stc.movableContainerLeftPos - newMinPos) >= 0 &&
                               (stc.movableContainerLeftPos - newMinPos) <= 2) {
                        edge = 'right';
                    }

                    stc.handleArrowsClassNames(edge);
                }
            });
        };

        p.startScrollLeft = function () {
            var smv = this,
                stc = smv.stc;

            stc.$leftScrollArrow.data(CONSTANTS.DATA_KEY_IS_MOUSEDOWN, true);
            smv.continueScrollLeft();
        };

        p.startScrollRight = function () {
            var smv = this,
                stc = smv.stc;

            stc.$rightScrollArrow.data(CONSTANTS.DATA_KEY_IS_MOUSEDOWN, true);
            smv.continueScrollRight(smv.getMinPos());
        };

        p.stopScrollLeft = function () {
            var smv = this,
                stc = smv.stc;

            stc.$leftScrollArrow.data(CONSTANTS.DATA_KEY_IS_MOUSEDOWN, false);
        };

        p.stopScrollRight = function () {
            var smv = this,
                stc = smv.stc;

            stc.$rightScrollArrow.data(CONSTANTS.DATA_KEY_IS_MOUSEDOWN, false);
        };

    }(ScrollMovement.prototype));

    /* **********************************************************************
     * ScrollingTabsControl - Class that each directive will instantiate
     * **********************************************************************/
    function ScrollingTabsControl($tabsContainer, $timeout, options) {
        var stc = this;

        options = options || {};

        stc.$tabsContainer = $tabsContainer;
        stc.$timeout = $timeout;

        stc.movableContainerLeftPos = 0;
        stc.scrollArrowsVisible = false;
        stc.scrollToTabEdge = false;

        stc.scrollMovement = new ScrollMovement(stc);
        stc.eventHandlers = new EventHandlers(stc);
        stc.elementsHandler = new ElementsHandler(stc);

        stc.scrollingTabsActiveOffset = options.scrollingTabsActiveOffset || 0;
    }

    // prototype methods
    (function (p) {
        p.handleTriggeredRefresh = function () {
            var stc = this,
                scrollMovement = stc.scrollMovement,
                actionsTaken = stc.elementsHandler.refreshAllElementSizes(true);

            if (!actionsTaken.didScrollToActiveTab) {
                stc.$timeout(function () {
                    scrollMovement.scrollToActiveTab({
                        isOnTabsRefresh: true
                    });
                }, stc.scrollingTabsActiveOffset ? 200 : 100);
            }
        };

        p.initTabs = function (options) {
            var stc = this,
                elementsHandler = stc.elementsHandler,
                scrollMovement = stc.scrollMovement;

            if (options.scrollToTabEdge) {
                stc.scrollToTabEdge = true;
            }

            stc.$timeout(function __initTabsAfterTimeout() {
                var actionsTaken;

                elementsHandler.initElements(options);
                actionsTaken = elementsHandler.refreshAllElementSizes();

                if (!actionsTaken.didScrollToActiveTab) {
                    scrollMovement.scrollToActiveTab({
                        isOnTabsRefresh: options.isWatchingTabs
                    });
                }
            }, 100);
        };

        /**
         * Handles control arrows classnames
         *
         * @param {string} edge ('left'|'right')
         * @return {undefined}
         */
        p.handleArrowsClassNames = function (edge) {
            var stc = this;
            var edgeClassName = 'scrtabs-tab-scroll-arrow--is-on-edge';
            var arrows = {
                left: stc.$leftScrollArrow,
                right: stc.$rightScrollArrow,
            };

            if (edge) {
                arrows[edge].addClass(edgeClassName);
                arrows[edge == 'left' ? 'right' : 'left'].removeClass(edgeClassName);
            } else {
                arrows.left.removeClass(edgeClassName);
                arrows.right.removeClass(edgeClassName);
            }
        };

    }(ScrollingTabsControl.prototype));

    scrollingTabsModule.directive('scrollingTabs', scrollingTabsDirective);

    scrollingTabsDirective.$inject = ['$timeout', '$sce'];
    function scrollingTabsDirective($timeout, $sce) {

        function sanitize(html) {
            return $sce.trustAsHtml(html);
        }


        // ------------ Directive Object ---------------------------
        return {
            restrict: 'E',
            template: scrollingTabsTemplate,
            transclude: false,
            replace: true,
            scope: {
                tabs: '@',
                watchTabs: '=',
                propPaneId: '@',
                propTitle: '@',
                propActive: '@',
                propDisabled: '@',
                localTabClick: '&tabClick',
                refreshOn: '='
            },
            link: function (scope, element, attrs) {
                var scrollingTabsControl = new ScrollingTabsControl(element, $timeout),
                    scrollToTabEdge = attrs.scrollToTabEdge && attrs.scrollToTabEdge.toLowerCase() === 'true';

                scope.tabsArr = scope.$eval(scope.tabs);
                scope.propPaneId = scope.propPaneId || 'paneId';
                scope.propTitle = scope.propTitle || 'title';
                scope.propActive = scope.propActive || 'active';
                scope.propDisabled = scope.propDisabled || 'disabled';
                scope.sanitize = sanitize;


                element.on('click.scrollingTabs', '.nav-tabs > li', function __handleClickOnTab(e) {
                    var clickedTabElData = $(this).data();

                    scope.localTabClick({
                        $event: e,
                        $index: clickedTabElData.index,
                        tab: clickedTabElData.tab
                    });

                });

                if (attrs.refreshOn) {
                    scope.$watch('refreshOn', function (newVal, oldVal) {
                        if (newVal && newVal !== oldVal) {
                            scrollingTabsControl.handleTriggeredRefresh();
                        }
                    });
                }

                if (!attrs.watchTabs) {

                    // we're not watching the tabs array for changes so just init
                    // the tabs without adding a watch
                    scrollingTabsControl.initTabs({
                        isWrapperDirective: false,
                        scrollToTabEdge: scrollToTabEdge,
                        scrollingTabsActiveOffset: attrs.scrollingTabsActiveOffset
                    });

                    return;
                }

                // we're watching the tabs array for changes...
                scope.$watch('watchTabs', function (latestTabsArray, prevTabsArray) {
                    var $activeTabLi,
                        activeIndex;

                    scope.tabsArr = scope.$eval(scope.tabs);

                    if (latestTabsArray && latestTabsArray.length && latestTabsArray[latestTabsArray.length - 1].active) { // new tab should be active

                        // the tab we just added should be active, so, after giving the
                        // elements time to render (thus the $timeout), force a click on it so
                        // bootstrap's built-in tab/pane activation can do its thing, otherwise
                        // the tab will show as active but its content pane won't be
                        $timeout(function () {

                            element.find('ul.nav-tabs > li:last').removeClass('active').find('a[role="tab"]').click();

                        }, 0);

                    } else { // --------- preserve the currently active tab

                        // we've replaced the nav-tabs so, to get the currently active tab
                        // we need to get it from the DOM because clicking a tab doesn't update
                        // the tabs array (Bootstrap's js just makes the clicked tab and its
                        // corresponding tab-content pane active); then we need to update
                        // the tabs array so it reflects the currently active tab before we
                        // call initTabs() because initTabs() generates the tab elements based
                        // on the array data.

                        // get the index of the currently active tab
                        $activeTabLi = element.find('.nav-tabs > li.active');

                        if ($activeTabLi.length) {

                            activeIndex = $activeTabLi.data('index');

                            scope.tabsArr.some(function __forEachTabsArrItem(t) {
                                if (t[scope.propActive]) {
                                    t[scope.propActive] = false;
                                    return true; // exit loop
                                }
                            });

                            scope.tabsArr[activeIndex][scope.propActive] = true;
                        }
                    }

                    scrollingTabsControl.initTabs({
                        isWrapperDirective: false,
                        isWatchingTabs: true,
                        scrollToTabEdge: scrollToTabEdge
                    });

                }, true);

            }

        };
    }

    scrollingTabsModule.directive('scrollingTabsWrapper', scrollingTabsWrapperDirective);

    scrollingTabsWrapperDirective.$inject = ['$timeout'];
    function scrollingTabsWrapperDirective($timeout) {
        // ------------ Directive Object ---------------------------
        return {
            restrict: 'A',
            template: scrollingTabsWrapperTemplate,
            transclude: true,
            replace: true,
            link: function (scope, element, attrs) {
                var scrollingTabsControl = new ScrollingTabsControl(element, $timeout, { scrollingTabsActiveOffset: attrs.scrollingTabsActiveOffset }),
                    isWrappingAngularUIBTabset = element.find('uib-tabset').length > 0,
                    isWrappingAngularUITabset = isWrappingAngularUIBTabset || element.find('tabset, .scrtabs-tabs-movable-container div > ul.nav').length > 0,
                    scrollToTabEdge = attrs.scrollToTabEdge && attrs.scrollToTabEdge.toLowerCase() === 'true',
                    scrtc = {
                        hasTabContentOutsideMovableContainer: true
                    };

                angular.extend(scope, { scrtc: scrtc });

                if (attrs.refreshOn) {
                    scope.$watch(attrs.refreshOn, function (newVal, oldVal) {
                        if (newVal && newVal !== oldVal) {
                            scrollingTabsControl.handleTriggeredRefresh();
                        }
                    });
                }

                if (!isWrappingAngularUITabset) {
                    scrtc.hasTabContentOutsideMovableContainer = false;
                }

                if (!isWrappingAngularUIBTabset && !attrs.watchTabs) {
                    // we don't need to watch the tabs for changes, so just
                    // init the tabs control and return
                    scrollingTabsControl.initTabs({
                        isWrapperDirective: true,
                        isWrappingAngularUITabset: isWrappingAngularUITabset,
                        scrollToTabEdge: scrollToTabEdge
                    });

                    return;
                }


                // ----- watch the tabs DOM for changes --------------
                // if we're watching angular uib-tabset after version 1.2.0, we
                // need to explicitly watch the tabs for DOM changes because
                // from 1.2.0, they added controllerAs and bindToController,
                // which messed up the direct connection between the tabs
                // model data and the transcluded DOM that allowed the tab-content
                // outside the movable container to update itself when the
                // active tab inside the movable container changed.
                // So if we're watching uib-tabset AND there is not a watch-tabs
                // attribute pointing to the tabs array, we set up this watch,
                // just watching for the active tab to change.
                // We also set up this watch if there's a watch-tabs="true"
                // attribute.
                if (isWrappingAngularUIBTabset ||
                    (attrs.watchTabs && attrs.watchTabs.toLowerCase() === 'true')) {

                    if (isWrappingAngularUITabset) {
                        scrtc.hasTabContentOutsideMovableContainer = false;
                    }

                    // we're watching the tabs html (rather than array) for changes,
                    // so init them then set up a watch that watches for changes
                    // to the number of tabs or to the active tab
                    initTabsAsWrapperWatchingTabs();

                    // give the DOM changes time to process, then set up our watch
                    $timeout(watchForTabDomChanges, 10);

                    // we can return out of here UNLESS we're wrapping uib-tabset AND
                    // also watching the tabs array for changes, in which case we need
                    // to continue on and set up the watch on the tabs array.
                    if (!isWrappingAngularUIBTabset || !attrs.watchTabs || attrs.watchTabs.toLowerCase() === 'true') {
                        return;
                    }
                }


                // ----- watch the tabs array for changes --------------
                // watch the tabs array for changes and refresh the tabs
                // control any time it changes (whether the change is a
                // new tab or just a change in which tab is selected)
                scope.$watch(attrs.watchTabs, function (latestTabsArray, prevTabsArray) {

                    if (!isWrappingAngularUITabset) { // wrapping regular bootstrap nav-tabs
                        // if we're wrapping regular bootstrap nav-tabs, we need to
                        // manually track the active tab because, if a tab is clicked,
                        // the tabs array doesn't update to reflect the new active tab;
                        // so if we make each dynamically added tab the new active tab,
                        // we need to deactivate whatever the currently active tab is,
                        // and we have no way of knowing that from the state of the tabs
                        // array--we need to check the tab elements on the page
                        // listen for tab clicks and update our tabs array accordingly because
                        // bootstrap doesn't do that
                        if (latestTabsArray && latestTabsArray.length && latestTabsArray[latestTabsArray.length - 1].active) {

                            // the tab we just added should be active, so, after giving the
                            // elements time to render (thus the $timeout), force a click on it so
                            // bootstrap's built-in tab/pane activation can do its thing, otherwise
                            // the tab will show as active but its content pane won't be
                            $timeout(function () {

                                element.find('ul.nav-tabs > li:last').removeClass('active').find('a[role="tab"]').click();

                            }, 0);

                        }

                    } else if (isWrappingAngularUIBTabset) {

                        if (latestTabsArray.length && latestTabsArray[latestTabsArray.length - 1].active) {
                            $timeout(function () {
                                element.find('.scrtabs-tabs-movable-container ul.nav-tabs > li:last').find('a[role="tab"],a.nav-link').click();
                            }, 0);
                        }

                    }

                    initTabsAsWrapperWatchingTabs();

                }, true);


                function initTabsAsWrapperWatchingTabs(options) {
                    scrollingTabsControl.initTabs({
                        isWrapperDirective: true,
                        isWrappingAngularUITabset: isWrappingAngularUITabset,
                        isWatchingTabs: true,
                        scrollToTabEdge: scrollToTabEdge,
                        isWatchingDom: options && options.isWatchingDom
                    });
                }

                function watchForTabDomChanges() {
                    var $navTabs = element.find('ul.nav-tabs'),
                        currActiveTabIdx,
                        showingActiveTabIdx;

                    if (!$navTabs.length) {
                        return;
                    }

                    // ---- watch for tabs being added or removed ----
                    scope.$watch(function () {
                        return $navTabs[0].childNodes.length;
                    }, function (newVal, oldVal) {
                        if (newVal !== oldVal) {
                            initTabsAsWrapperWatchingTabs({
                                isWatchingDom: true
                            });
                        }
                    });

                    // ---- watch for a change in the active tab ----
                    // we can't just use the built-in watch functionality
                    // to check for a change in the active tab because the
                    // function we pass to $watch sometimes executes before the
                    // active class changes to the newly-clicked tab, so our watch
                    // doesn't detect any change; to detect the change, we need
                    // to perform the check after a timeout, so we just hook
                    // into the $watch because we need to perform the check
                    // when a digest occurs, but we don't use the $watch's
                    // callback to make any changes, we just do it in our
                    // timeout function.
                    scope.$watch(function () {
                        // pass false as 3rd arg so digest is not initiated,
                        // otherwise we end up in infinite loop
                        $timeout(checkForActiveTabChange, 0, false);
                        return $navTabs.find('li.active').index();
                    }, angular.noop);


                    function checkForActiveTabChange() {
                        currActiveTabIdx = $navTabs.find('li.active').index();

                        if (currActiveTabIdx !== showingActiveTabIdx) {
                            showingActiveTabIdx = currActiveTabIdx;
                            initTabsAsWrapperWatchingTabs({
                                isWatchingDom: true
                            });
                        }

                        return false;
                    }
                }

            }
        };

    }


}(jQuery, window));

//DEADCODE
(function () {
  'use strict';
  angular
    .module("storeLocator")
    .filter('urldash', urldash);

  function urldash() {
    return function (input,reverse) {
      if (input) {
         if(reverse) {
           var out = input.split('+_').join('/');
           out = out.split('*').join(',');
           out = out.split('_').join('.');
           out =  out.split('+~').join('&');
           out = out.split('-').join(' ');
           return out.split('~').join('-');
         }else{
           return input.replace(/\s+/g, '-');
         }
      }
    }
  }
})();


(function() {
  'use strict';

  angular
    .module('storeLocator')
    .filter('urlCleaner', urlCleaner);

  /** @ngInject */
  function urlCleaner() {

    return function (value) {
      return (!value) ? '' : value.replace(/:/g, '%3A').replace(/\//g, '%2F');
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .filter('telephone', telephone);

  /** @ngInject */
  function telephone() {
      return function (tel) {
        if (!tel) { return ''; }
        var value = tel.toString().trim().replace(/\D/g,'');
        if (value.match(/[^0-9]/)) {
          return tel;
        }
        var country, city, number;
        switch (value.length) {
          case 10: // +1PPP####### -> C (PPP) ###-####
            country = 1;
            city = value.slice(0, 3);
            number = value.slice(3);
            break;
          // case 11: // +CPPP####### -> CCC (PP) ###-####
          //   country = value[0];
          //   city = value.slice(1, 4);
          //   number = value.slice(4);
          //   break;
          // case 12: // +CCCPP####### -> CCC (PP) ###-####
          //   country = value.slice(0, 3);
          //   city = value.slice(3, 5);
          //   number = value.slice(5);
          //   break;
          default:
            return tel;
        }
        if (country == 1) {
          country = '';
        }
        number = number.slice(0, 3) + '-' + number.slice(3);
        return (country + ' (' + city + ') ' + number).trim();
      };
  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .filter('removeHash', removeHash);

  /** @ngInject */
  function removeHash() {

    return function (value) {
      return (!value) ? '' : value.replace(/#/g, '');
    };

  }
})();

(function () {
  'use strict';
  angular
    .module("storeLocator")
    .filter('moment', moment);

  function moment(moment) {
    return function (input, momentFn, format) {
      var args = Array.prototype.slice.call(arguments, 2),
        momentObj = moment(input, format);
      return momentObj[momentFn].apply(momentObj, args);
    };
  }
})();


(function () {
  'use strict';

  angular
    .module('storeLocator')
    .filter('miToKm', miToKm);

  function miToKm(_) {
    return function (distance) {
      if (!_.isUndefined(distance)) return (distance / 0.62137).toFixed(1);
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .filter('labelizeLocation', labelizeLocation);

  /** @ngInject */
  function labelizeLocation() {
    return function (location) {
      return '{"url": "'+location.llp_url +'", "location_id": "'+location.momentfeed_venue_id +'"}';
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .filter('hasHttp', hasHttp);

  /** @ngInject */
  function hasHttp() {

    return function (value) {
      if(value && !value.match(/^http([s]?):\/\/.*/)){
        return '//' + value
      } else {
        return value
      }
    };

  }
})();

//DEADCODE
(function() {
  'use strict';

  angular
    .module('storeLocator')
    .filter('commaSpace', commaSpace);

  function commaSpace(_) {
    return function (list) {
      if (!_.isUndefined(list) && list.length) return list.replace(/,/g, ', ');
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .directive('windowResize', windowResize);

  function windowResize ($window, _, $rootScope) {
    return function (scope) {

      var w = angular.element($window);

      if(!$rootScope.isMobile.ios()) {
        scope.$watch(function () {
          return {
            'h': $window.innerHeight,
            'w': $window.innerWidth
          };
        }, function (newValue) {

          scope.windowHeight = newValue.h;
          scope.windowWidth = newValue.w;

          scope.getMaxHeightWithOffsets = function () {
            var offset_pixels = 0;
            _.each(arguments, function(id){
              var tmp_el = angular.element(angular.element('#' + id));
              offset_pixels = offset_pixels + parseInt(tmp_el.outerHeight());
            });
            return {
              'max-height': (newValue.h - offset_pixels) + 'px'
            };
          };

          scope.getHeightwithOffsets = function () {
            var offset_pixels = 0;
            _.each(arguments, function(id){
              var tmp_el = angular.element(angular.element(id));
              offset_pixels = offset_pixels + parseInt(tmp_el.outerHeight());
            });
            return {
              'height': (newValue.h - offset_pixels) + 'px'
            };
          };

          scope.fillScreen = function () {
            var offset_pixels = 0;
            _.each(arguments, function(id){
              var tmp_el = angular.element(angular.element('#' + id));
              offset_pixels = offset_pixels + parseInt(tmp_el.outerHeight());
            });
            return {
              'min-height': (newValue.h - offset_pixels) + 'px'
            };
          };

          scope.getColumnHeight = function (id) {
            var set_height = 0;
            var offset_height = 0;

            //get height of left column
            var tmp_el = angular.element(angular.element('#' + id));
            var column_height = parseInt(tmp_el.outerHeight());

            //get height window minus nav
            var get_nav_height = angular.element(angular.element('#js-mf-navbar'));
            var nav_height = parseInt(get_nav_height.outerHeight());
            offset_height = newValue.h - nav_height;

            //set height
            if (offset_height >= column_height) {
              set_height = offset_height;
            } else {
              set_height = column_height;
            }

            return {
              'min-height': set_height + 'px'
            };
          };

        }, true);

      }

      w.bind('resize', function () {
        scope.$apply();
      });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('mapbox', mapbox);

  mapbox.$inject = ['MAPBOX_KEY', '$window', 'MFeedMap'];
  function mapbox(MAPBOX_KEY, $window, MFeedMap) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        callback: "="
      },
      template: '<div class="mf-map"></div>',
      link: function (scope, element) {
        mapboxgl.accessToken = MAPBOX_KEY;
        var mapbox = new mapboxgl.Map({ 
          container: element[0],
          style: 'mapbox://styles/momentfeed/ckekfnwp3079w19qmiwkaneut'
        });

        // buttons: zoom-in, zoom-out and 'reset bearing to north'
        mapbox.addControl(new mapboxgl.NavigationControl());
        
        var map = new MFeedMap.MapboxMap(mapbox);

        setTimeout(function() {
          var mapboxExternalLinks = mapbox._controlPositions['bottom-right'].children[0].children[0].children;
          for(var i = 0; i < mapboxExternalLinks.length; i++) {
            mapboxExternalLinks[i].setAttribute('rel', 'noopener')
          }
        },500)

        scope.callback(map);
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('imageFallback', imageFallback);

  // Code taken from:
  // https://stackoverflow.com/questions/27549134/angularjs-ng-src-condition-if-not-found-via-url
  function imageFallback() {
    return {
      link: function (scope, element, attrs) {
        element.bind('error', function () {
          if (attrs.src !== attrs.imageFallback) {
            attrs.$set('src', attrs.imageFallback);
          }
        });
      }
    }
  }
})();

//set a fallback_url if the trust_url links to a missing image, 404s

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('googleMap', GoogleMap);

  GoogleMap.$inject = ['MFeedMap'];
  function GoogleMap(MFeedMap) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        callback: "="
      },
      template: '<div class="mf-map"></div>',
      link: function (scope, element) {

        var mapCenter;
        var gmap = new google.maps.Map(element[0],
          {
            mapTypeControlOptions: {
              position: google.maps.ControlPosition.BOTTOM_CENTER
            },
            zoomControlOptions: {
              position: google.maps.ControlPosition.LEFT_TOP
            },
            streetViewControlOptions: {
              position: google.maps.ControlPosition.LEFT_TOP
            },
            styles: [{
              featureType: 'poi.business',
              stylers: [{ visibility: 'off' }]
            }]
          });

        // update the center of the map when it becomes idle after panning or zooming.
        google.maps.event.addListener(gmap, 'idle', function () {
          mapCenter = gmap.getCenter();
        });

        // re-center the map after the window has been resized.
        google.maps.event.addDomListener(window, 'resize', function () {
          gmap.setCenter(mapCenter);
        });

        var mapObj = new MFeedMap.GoogleMap(gmap);
        scope.callback(mapObj);
      }
    };
  }
})();

//I think this may be broken... 💀
(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('googleAutocomplete', GoogleAutocomplete);

  GoogleAutocomplete.$inject = [
    'STORE_LOCATOR_SEARCH_COUNTRY',
    'STORE_LOCATOR_GOOGLE_SEARCH_TYPE',
    'CUSTOM_DICTIONARY'
  ];
  function GoogleAutocomplete(STORE_LOCATOR_SEARCH_COUNTRY,
    STORE_LOCATOR_GOOGLE_SEARCH_TYPE, CUSTOM_DICTIONARY) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        placeChangedCallback: "="
      },
      template: '<input id="searchField" type="text" aria-label="Search Location" placeholder={{placeholder}} ></div>',
      link: function (scope, element) {

        // Note: For more than 1 country, Google requires country codes as an array of ISO 3166-1 Alpha-2 country
        //       codes (case insensitive e.g. us, ca, br, au). It will restrict results to up to 5 country codes.
        var countries = STORE_LOCATOR_SEARCH_COUNTRY.split(',');
        var options = {
          types: [STORE_LOCATOR_GOOGLE_SEARCH_TYPE],
          componentRestrictions: { "country": countries }
        };
        scope.placeholder = CUSTOM_DICTIONARY && CUSTOM_DICTIONARY.placeholder;

        var autocomplete = new google.maps.places.Autocomplete(element[0], options);

        google.maps.event.addListener(autocomplete, 'place_changed', function () {
          var place = autocomplete.getPlace();
          scope.$apply(function () {
            scope.placeChangedCallback(place);
          });
        });

      }
    };
  }
})();

angular.module('storeLocator').factory('focus', function($timeout, $window) {
    return function(id) {
        // timeout makes sure that it is invoked after any other event has been triggered.
        // e.g. click events that need to run before the focus or
        // inputs elements that are in a disabled state but are enabled when those events
        // are triggered.
        $timeout(function() {
            var element = $window.document.getElementById(id);
            if(element)
                element.focus();
        });
    };
});
angular.module('storeLocator').directive('eventFocus', function(focus) {
        return function(scope, elem, attr) {
            elem.on(attr.eventFocus, function() {
                focus(attr.eventFocusId);
            });

            // Removes bound events in the element itself
            // when the scope is destroyed
            scope.$on('$destroy', function() {
                elem.off(attr.eventFocus);
            });
        };
    });

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .factory('storeLocatorDictionary', storeLocatorDictionary);

  function storeLocatorDictionary(STORE_LOCATOR_ZOOM_LEVELS, STORE_LOCATOR_MESSAGES, STORE_LOCATOR_MAP_CONFIGS, STORE_LOCATOR_PIN, SHOW_ICONS) {

      var d = {};
      var defaultValues = {
          zoomLevels: {
              initial: 3,
              region: 5,
              administrative_area_level_1: 5,
              locality: 9,
              place: 10,
              street_address: 7,
              postcode: 7,
              poi: 12,
              nearMe: 10,
              store: 7,
              fallback: 7,
              country: 3,
          },
          messages: {
              loading: 'Gathering locations...',
              noResultsWithFilters: 'No {filters} in {location}',
              noResults: 'No Results for {location}',
              resultsWithFilters: '{filters} in {location}',
              results: 'Results for {location}',
              listView: 'LIST',
              mapView: 'MAP'
          },
          mapConfigs: {
            showSearchButtonOnZoomChange: false,
            centerPointOnTheRight: false,
            pinUseLetters: false,
            pinShowText: true,
            pinColor: STORE_LOCATOR_PIN || 'black',
            pinBorderColor: '#ffffff1c',
            pinBorderWidth: 3,
            pinFontFamily: 'inherit',
            pinFontSize: 22,
            pinFontColor: 'white',
            pinFontWeight: '700'
          },
          showIcons: false
      };

      function init() {
          initZoomLevels();
          initMessages();
          initMapConfigs();
          d.showIcons = SHOW_ICONS ? SHOW_ICONS : defaultValues.showIcons;
      }

      function initZoomLevels()
      {
          var clientZoomLevels;
          if (STORE_LOCATOR_ZOOM_LEVELS && STORE_LOCATOR_ZOOM_LEVELS !== '') {
              clientZoomLevels = JSON.parse(STORE_LOCATOR_ZOOM_LEVELS);
          }

          if (clientZoomLevels) {
              d.zoomLevels = {
                  initial: clientZoomLevels.initial
                      ? clientZoomLevels.initial
                      : defaultValues.zoomLevels.initial,
                  region: clientZoomLevels.region ? clientZoomLevels.region : defaultValues.zoomLevels.region,
                  administrative_area_level_1: clientZoomLevels.administrative_area_level_1 ? clientZoomLevels.administrative_area_level_1 : defaultValues.zoomLevels.administrative_area_level_1,
                  locality: clientZoomLevels.locality ? clientZoomLevels.locality : defaultValues.zoomLevels.locality,
                  place: clientZoomLevels.place ? clientZoomLevels.place : defaultValues.zoomLevels.place,
                  street_address: clientZoomLevels.street_address ? clientZoomLevels.street_address : defaultValues.zoomLevels.street_address,
                  postcode: clientZoomLevels.postcode
                      ? clientZoomLevels.postcode
                      : defaultValues.zoomLevels.postcode,
                  poi: clientZoomLevels.poi ? clientZoomLevels.poi : defaultValues.zoomLevels.poi,
                  nearMe: clientZoomLevels.nearMe ? clientZoomLevels.nearMe : defaultValues.zoomLevels.nearMe,
                  store: clientZoomLevels.store ? clientZoomLevels.store : defaultValues.zoomLevels.store,
                  fallback: clientZoomLevels.fallback
                      ? clientZoomLevels.fallback
                      : defaultValues.zoomLevels.fallback,
                  country: clientZoomLevels.country ? clientZoomLevels.country : defaultValues.zoomLevels.country
              };
          } else {
              d.zoomLevels = defaultValues.zoomLevels;
          }
      }

      function initMessages() {
          var clientMessages;
          if (STORE_LOCATOR_MESSAGES && STORE_LOCATOR_MESSAGES !== '') {
              clientMessages = JSON.parse(STORE_LOCATOR_MESSAGES);
          }

          if (clientMessages) {
              d.messages = {
                  loading: angular.isDefined(clientMessages.loading)
                      ? clientMessages.loading
                      : defaultValues.messages.loading,
                  noResults: angular.isDefined(clientMessages.noResults)
                      ? clientMessages.noResults
                      : defaultValues.messages.noResults,
                  results: angular.isDefined(clientMessages.results)
                      ? clientMessages.results
                      : defaultValues.messages.results,
                  noResultsWithFilters: angular.isDefined(clientMessages.noResultsWithFilters)
                     ? clientMessages.noResultsWithFilters
                     : defaultValues.messages.noResultsWithFilters,
                  resultsWithFilters: angular.isDefined(clientMessages.resultsWithFilters)
                      ? clientMessages.resultsWithFilters
                      : defaultValues.messages.resultsWithFilters,
                  listView: angular.isDefined(clientMessages.listView)
                     ? clientMessages.listView
                     : defaultValues.messages.listView,
                  mapView: angular.isDefined(clientMessages.mapView)
                      ? clientMessages.mapView
                      : defaultValues.messages.mapView
              };
          } else {
              d.messages = defaultValues.messages;
          }
      }

      function initMapConfigs() {
        var mapConfigs;

        if (STORE_LOCATOR_MAP_CONFIGS && STORE_LOCATOR_MAP_CONFIGS !== '') {
            mapConfigs = JSON.parse(STORE_LOCATOR_MAP_CONFIGS);
        }
        
        if (mapConfigs) {
            d.mapConfigs = {
                showSearchButtonOnZoomChange: angular.isDefined(mapConfigs.showSearchButtonOnZoomChange)
                    ? mapConfigs.showSearchButtonOnZoomChange
                    : defaultValues.mapConfigs.showSearchButtonOnZoomChange,
                centerPointOnTheRight: angular.isDefined(mapConfigs.centerPointOnTheRight)
                    ? mapConfigs.centerPointOnTheRight
                    : defaultValues.mapConfigs.centerPointOnTheRight,
                pinUseLetters: angular.isDefined(mapConfigs.pinUseLetters)
                    ? mapConfigs.pinUseLetters
                    : defaultValues.mapConfigs.pinUseLetters,
                pinShowText: angular.isDefined(mapConfigs.pinShowText)
                    ? mapConfigs.pinShowText
                    : defaultValues.mapConfigs.pinShowText,
                pinColor: angular.isDefined(mapConfigs.pinColor)
                   ? mapConfigs.pinColor
                   : defaultValues.mapConfigs.pinColor,
                pinBorderColor: angular.isDefined(mapConfigs.pinBorderColor)
                    ? mapConfigs.pinBorderColor
                    : defaultValues.mapConfigs.pinBorderColor,
                pinBorderWidth: angular.isDefined(mapConfigs.pinBorderWidth)
                   ? mapConfigs.pinBorderWidth
                   : defaultValues.mapConfigs.pinBorderWidth,
                pinFontFamily: angular.isDefined(mapConfigs.pinFontFamily)
                    ? mapConfigs.pinFontFamily
                    : defaultValues.mapConfigs.pinFontFamily,
                pinFontSize: angular.isDefined(mapConfigs.pinFontSize)
                    ? mapConfigs.pinFontSize
                    : defaultValues.mapConfigs.pinFontSize,         
                pinFontColor: angular.isDefined(mapConfigs.pinFontColor)
                    ? mapConfigs.pinFontColor
                    : defaultValues.mapConfigs.pinFontColor,     
                pinFontWeight: angular.isDefined(mapConfigs.pinFontWeight)
                    ? mapConfigs.pinFontWeight
                    : defaultValues.mapConfigs.pinFontWeight        
            };
        } else {
            d.mapConfigs = defaultValues.mapConfigs;
        }
      }

      init();

      return d;
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .controller('storeLocatorController', storeLocatorController);

  /** @ngInject */
  function storeLocatorController($scope,
                                  $rootScope,
                                  $analytics,
                                  $timeout,
                                  mapHelper,
                                  MetaDataService,
                                  META,
                                  pubSub,
                                  APIService,
                                  APILocationFinderService,
                                  STORE_LOCATOR_LATITUDE,
                                  STORE_LOCATOR_LONGITUDE,
                                  STORE_LOCATOR_TEXT,
                                  STORE_LOCATOR_LOC_ID,
                                  CUSTOM_DICTIONARY,
                                  customFieldFactory,
                                  storeLocatorDictionary,
                                  SHOW_LIST_DEFAULT,
                                  tabsService,
                                  $location,
                                  storeLocatorCache,
                                  $window) {

    var $ctrl = this;

    $ctrl.storeLocatorText = STORE_LOCATOR_TEXT;
    $ctrl.searchLabel = CUSTOM_DICTIONARY && CUSTOM_DICTIONARY.placeholder;

    var locatorState = storeLocatorCache.get('state');
    if (!angular.isUndefined(locatorState)) {
      $ctrl.locatorStates = locatorState;
    } else {
      $ctrl.locatorStates = {
        current: '',
        geoEnabled: false,
        isRadius: false,
        isLoading: true,
        locations: [],
        locationsArray: [],
        locationMarkers: [],
        locationMarkersArray: [],
        mapCenter: {latitude: STORE_LOCATOR_LATITUDE, longitude: STORE_LOCATOR_LONGITUDE},
        message: 'Share your location or type a location in the search box',
        reloadMap: false,
        selectedFilters: [],
        showSearchAreaBtn: false,
        areaSearched: false,
        position: {},
        zoom: storeLocatorDictionary.zoomLevels.initial,
        tabs: tabsService.showTabs() ? tabsService.getTabs() : null,
        activeTab: tabsService.getActiveTab()
      };
    }

    $ctrl.mapObj = {};
    $ctrl.metaData = {};
    $ctrl.window = $window;

    MetaDataService.loadMetaData().then(function (response) {
      $ctrl.metaData = response;
      determineLocation();
    }.bind(this));

    pubSub.subscribe(storeLocatorMetaCallback);

    function determineLocation() {
      setStoreLocatorMeta();
    };

    function storeLocatorMetaCallback() {

      $ctrl.metaData['title'] = $ctrl.metaData.location_finder_title;
      $ctrl.metaData['description'] = $ctrl.metaData.location_finder_description;

    }

    function setStoreLocatorMeta() {

      if ($rootScope)
        $rootScope.title = function () {
          var metaTitle = $ctrl.metaData['title'],
            fallbackTitle = META.title ? META.title : '',
            title = s(metaTitle || fallbackTitle)
              .replace('undefined', '')
              .replace('null', '')
              .trim().clean().value();
          return title;
        };

      $rootScope.image = function () {
        var src = $ctrl.metaData['image'];
        return src;
      }

      $rootScope.description = function () {
        var metaDescription = $ctrl.metaData['description'],
          fallbackDescription = META.description ? META.description : '',
          description = s(metaDescription || fallbackDescription)
            .replace('undefined', '')
            .replace('null', '')
            .trim().clean().value();
        return description;
      };

      $rootScope.keywords = function () {
        var metaKeywords = $ctrl.metaData['keywords'],
          fallbackKeywords = META.keywords ? META.keywords : '',
          keywords = s(metaKeywords || fallbackKeywords)
            .replace('undefined', '')
            .replace('null', '')
            .trim().clean().value();
        return keywords;
      };
      storeLocatorMetaCallback()
    }


    $ctrl.showTabs = tabsService.showTabs();

    // handles whether to show the list view by default, or the map view.
    // default is usually set to "false" - show the map view first.
    $ctrl.showList = SHOW_LIST_DEFAULT;
    $ctrl.showIcons = storeLocatorDictionary.showIcons;
    $ctrl.listViewText = storeLocatorDictionary.messages.listView;
    $ctrl.mapViewText = storeLocatorDictionary.messages.mapView;


    $ctrl.getSpecificLocationById = function getSpecificLocationById(STORE_LOCATOR_LOC_ID) {
      if (STORE_LOCATOR_LOC_ID && STORE_LOCATOR_LOC_ID !== '') {
        var req = APILocationFinderService.one('location/store-info/' + STORE_LOCATOR_LOC_ID);
        return req.get().then(function (response) {
          return response.data;
        });
      } else {
        return null;
      }
    };
    if (STORE_LOCATOR_LOC_ID) {
      $ctrl.getSpecificLocationById(STORE_LOCATOR_LOC_ID).then(function (storeLoc) {
        $ctrl.customLocation = storeLoc;
      });
    }
    $ctrl.getCustomFieldValueByName = function getCustomFieldValueByName(customFields, name) {
      return customFieldFactory.getValueByName(customFields, name);
    };
    $ctrl.hasCustomFieldValue = function hasCustomFieldValue(customFields, name) {
      return customFieldFactory.getValueByName(customFields, name) ? true : false;
    };

    // if the user doesn't allow or deny location data,
    // automatically fire location search without their
    // location data after 5 seconds. this also covers in
    // the case that the user is using firefox and
    // selects "not now" for access to their location data.
    $timeout(function () {
      var searchParam = $location.search();
      if (Object.keys(searchParam).length > 0 && !searchParam.loc_q) {
          return;
      }
      if (!$ctrl.locatorStates.geoPermission && Object.keys(searchParam).length === 0) {
        mapHelper.geoLocationError($ctrl.locatorStates);
        $ctrl.locatorStates.geoEnabled = null;
      }
    }, 3000);

    // GA track Page View event
    $analytics.eventTrack('Page View', {
      category: 'Store Locator', label: 'Store Locator', noninteraction: 'true'
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .factory('siteMapNewData', siteMapNewData);

  function siteMapNewData(APISiteMapNewService) {

    return {
        getAllLocations: getAllLocations,
        getLocationsByContinent: getLocationsByContinent,
        getLocationsByCountry: getLocationsByCountry,
        getLocationsByRegion: getLocationsByRegion,
        getLocationsByLocality: getLocationsByLocality
        //getRegionalLocations: getRegionalLocations
    };

    function getLocationsByLocality(country, region, locality) {
        var params = {
            country: country,
            region: region,
            locality: locality
        };

        return getRegionalLocations(params);
    }

    function getLocationsByRegion(country, region) {
      var params = {
          country: country,
          region: region
      };
      return getLocations(params);
    }

    function getLocationsByCountry(country) {
      var params = {
          country: country
      };
      return getLocations(params);
    }

    function getLocationsByContinent(continent) {
      var params = {
        continent: continent
      };

      return getLocations(params);
    }

    function getAllLocations() {
      var params = {};

      return getLocations(params);
    }

    function getLocations(params) {
      var req = APISiteMapNewService.one("counts");
      return req.get(params);
    }

    /**
     * get the instagram account info for the user
     * @param {object} params
     * @param {object} responseData response object
     * @returns {json} api respnse
     */
    function getRegionalLocations(params) {
      var req = APISiteMapNewService.one("locations");
      return req.get(params);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .factory('siteMapData', siteMapData);

  function siteMapData(APIService, MULTI_ACCOUNT) {

    return {
        getAllLocations: getAllLocations,
        getLocationsByContinent: getLocationsByContinent,
        getLocationsByCountry: getLocationsByCountry,
        getLocationsByRegion: getLocationsByRegion,
        getLocationsByLocality: getLocationsByLocality
    };

    function getLocationsByLocality(country, region, locality) {
        var params = {
            country: country,
            region: region,
            locality: locality,
            multi_account: MULTI_ACCOUNT
        };

        return getLocations(params);
    }

    function getLocationsByRegion(country, region) {
      var params = {
          country: country,
          region: region,
          multi_account: MULTI_ACCOUNT
      };

      return getLocations(params);
    }

    function getLocationsByCountry(country) {
        var params = {
            country: country,
            multi_account: MULTI_ACCOUNT
        };

        return getLocations(params);
    }

    function getLocationsByContinent(continent) {
      var params = {
        continent: continent,
        multi_account: MULTI_ACCOUNT
      };

      return getLocations(params);
    }

    function getAllLocations() {
      var params = {
        multi_account: MULTI_ACCOUNT
      };

      return getLocations(params);
    }

    function getLocations(params) {
      var req = APIService.one("v2/llp/sitemap");

      return req.get(params);
    }
  }
})();

(function() {
  'use strict';

  /**
   * Common Feed Language
   */

  siteMapDictionary.$inject = [];

  function siteMapDictionary() {
    const dictionary = {};

    dictionary.locationsNotFound = 'No matching locations found';
    dictionary.clientNameCricketWireless = 'Cricket Wireless';
    dictionary.clientListForRedirects = { Thrifty: 'http://www.thrifty.com',
                                          Dollar: 'http://www.dollar.com'};

    return dictionary;
  }

  angular.module('storeLocator')
    .factory('siteMapDictionary', siteMapDictionary);
}());

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .controller('SiteMapController', SiteMapController);

  /** @ngInject */
  function SiteMapController(_,
                             siteMapData,
                             siteMapNewData,
                             $log,
                             CLIENT_NAME,
                             RegionService,
                             BASE_URL,
                             $stateParams,
                             $analytics,
                             CLIENT_ROUTE,
                             MetaDataService,
                             pubSub,
                             $rootScope,
                             $location,
                             META,
                             USE_NEW_SITE_MAP,
                             siteMapDictionary,
                             $window){
    var vm = this;
    vm.position= "global";
    vm.windowWidth = window.innerWidth;
    vm.locations = [];
    vm.showPage = false;
    vm.use_new_site_map = USE_NEW_SITE_MAP;
    vm.client_name = CLIENT_NAME;
    vm.client_route = CLIENT_ROUTE;
    vm.showBreadcrumb = true;
    vm.region = $stateParams.region;
    vm.country = $stateParams.country;
    vm.continent = (angular.isDefined($stateParams.continent)) ? $stateParams.continent : RegionService.lookupContinent(vm.country);
    vm.all = (angular.isDefined($stateParams.all)) ? $stateParams.all : false;
    vm.locality = $stateParams.locality;
    vm.metaData = {};
    vm.othersList=[];
    vm.featuredList = [];
    vm.fullList = [];
    vm.selectedContinent = {name: ''};

    //new sitemap for cricket which will be a standard in the future
    if (angular.isDefined(USE_NEW_SITE_MAP) && USE_NEW_SITE_MAP) {
      initNewSiteMap();
    } else {
      init();
    }

    MetaDataService.loadMetaData().then(function(response) {
      vm.metaData = response;
      determineLocation();
    }.bind(this));

    pubSub.subscribe(siteMapMetaCallback);

    function determineLocation() {
      setSiteMapMeta();
    }

    function siteMapMetaCallback() {
      var title;
      var description;
      var currentRegion = $stateParams.locality ? $stateParams.locality : RegionService.lookupRegionFromCountry($stateParams.country, $stateParams.region);
      var currentCountry = $stateParams.country;
      var currentArea = ', ' + RegionService.lookupRegionFromCountry($stateParams.country, $stateParams.region);
      var placeholder = "Your Local Area"
      //Use the word 'marker' as a designator for the spot for the region/locality to be inserted.
      //This section can be expanded as we allow for more complex meta tags. e.g. regionMarker, localityMarker, cityMarker, etc.
      //ex: Visiting marker? Make your money count more with Dollar. Book at any of our three convenient marker
      //locations to begin your vacation. Start your adventure with Dollar and reserve your marker car rental today.

      if (vm.metaData["site_map_title"] != null && vm.metaData["site_map_description"] != null){
        title = vm.metaData["site_map_title"].replace(/\[\[region\]\]/, currentRegion).replace(/\[\[area\]\]/, '');
      //Replacement scheme for when we are on a country level page.
      if (currentRegion == undefined && currentCountry) {
        if (currentCountry == 'US') {
          currentCountry = 'the United States';
        }

        title = vm.metaData["site_map_title"].replace(/\[\[region\]\]/, currentCountry).replace(/\[\[area\]\]/, '');
        description = vm.metaData["site_map_description"].replace(/\[\[region\]\]/g, currentCountry).replace(/\[\[area\]\]/g, '');
      }
      //Replacement scheme for when we are on the "All" level page.
      else if (currentRegion == undefined && currentCountry == undefined) {
        title = vm.metaData["site_map_title"].replace(/\[\[region\]\]/, placeholder).replace(/\[\[area\]\]/, '');
        description = vm.metaData["site_map_description"].replace(/\[\[region\]\]/g, placeholder).replace(/\[\[area\]\]/g, '');
      }
      //Replacement scheme for when we are on a region level page.
      else if ($stateParams.locality == undefined && currentArea) {
        title = vm.metaData["site_map_title"].replace(/\[\[region\]\]/, currentRegion).replace(/\[\[area\]\]/, '');
        description = vm.metaData["site_map_description"].replace(/\[\[region\]\]/g, currentRegion).replace(/\[\[area\]\]/g, '')
      }
      //Replacement scheme for when we are on a locality level page.
      else {
        description = vm.metaData["site_map_description"].replace(/\[\[region\]\]/g, currentRegion).replace(/\[\[area\]\]/g, currentArea);
      }

      vm.metaData['title'] = title;
      vm.metaData['description'] = description;
    }
    else{
      console.log("SiteMap meta tags have not been set!")
      }
    }

    function setSiteMapMeta() {

      if ($rootScope)
        $rootScope.title = function(){
          var metaTitle = vm.metaData['title'],
            fallbackTitle = META.title ? META.title : '',
            title = s(metaTitle || fallbackTitle)
              .replace('undefined', '')
              .replace('null', '')
              .trim().clean().value();
          return title;
        };

      $rootScope.image = function() {
        var src = vm.metaData['image'];
        return src;
      }

      $rootScope.description = function(){
        var metaDescription = vm.metaData['description'],
          fallbackDescription = META.description ? META.description : '',
          description = s(metaDescription || fallbackDescription)
            .replace('undefined', '')
            .replace('null', '')
            .trim().clean().value();
        return description;
      };

      $rootScope.keywords = function(){
        var metaKeywords = vm.metaData['keywords'],
          fallbackKeywords = META.keywords ? META.keywords : '',
          keywords = s(metaKeywords || fallbackKeywords)
            .replace('undefined', '')
            .replace('null', '')
            .trim().clean().value();
        return keywords;
      };
      $rootScope.canonical_url = function(){
        if(BASE_URL.indexOf('thrifty') > -1 || BASE_URL.indexOf('dollar') > -1){
          return (BASE_URL + $location.$$path).toLowerCase();
        }
        return BASE_URL + $location.$$path;
      };
      siteMapMetaCallback()
    };

    $analytics.eventTrack('Page View', {
        category: 'Site Map', label: 'Site Map'
    });

    function init() {
        if ($stateParams.region && $stateParams.locality && $stateParams.country) {
          vm.position = 'locality';
          siteMapData.getLocationsByLocality($stateParams.country, $stateParams.region, $stateParams.locality).then(locationsComplete).catch(llerror);
        } else if ($stateParams.locality && $stateParams.country && $stateParams.region == '') { // added for locations with no region
          vm.position = 'locality';
          siteMapData.getLocationsByLocality($stateParams.country, '', $stateParams.locality).then(locationsComplete).catch(llerror);
        } else if ($stateParams.region && $stateParams.country) {
          vm.position = 'region';
          siteMapData.getLocationsByRegion($stateParams.country, $stateParams.region).then(locationsComplete).then(groupFeaturedOthers).catch(llerror);
        } else if ($stateParams.country) {
          vm.position = 'country';
          siteMapData.getLocationsByCountry($stateParams.country).then(locationsComplete).catch(llerror);
        }
        else if (vm.continent) {
          vm.position = 'continent';
          siteMapData.getLocationsByContinent(vm.continent).then(locationsComplete).catch(llerror);
        }
        else {
          (vm.all) ? vm.position = 'all' : vm.position = 'global';
          vm.showBreadcrumb = false;
          siteMapData.getAllLocations().then(locationsComplete).catch(llerror);
        }
    }

    /**
     * initial setup for the new site map feature for cricket
     * if else for the different pages i.e. country, region, state
     */
    function initNewSiteMap() {
      if ($stateParams.region && $stateParams.locality && $stateParams.country) {
        vm.position = 'locality';
        siteMapNewData.getLocationsByLocality($stateParams.country, $stateParams.region, $stateParams.locality).then(parselocationsData).catch(llerror);
      } else if ($stateParams.region && $stateParams.country) {
        vm.position = 'region';
        siteMapNewData.getLocationsByRegion($stateParams.country, $stateParams.region).then(parselocationsData).catch(llerror);
      } else if ($stateParams.country) {
        vm.position = 'country';
        siteMapNewData.getLocationsByCountry($stateParams.country).then(parselocationsData).catch(llerror);
      }
      else if (vm.continent) {
        vm.position = 'continent';
        siteMapNewData.getLocationsByContinent(vm.continent).then(parselocationsData).catch(llerror);
      }
      else {
        (vm.all) ? vm.position = 'all' : vm.position = 'global';
        vm.showBreadcrumb = false;
        siteMapNewData.getAllLocations().then(parselocationsData).catch(llerror);
      }
    }

    function groupFeaturedOthers(){
      vm.fullList.forEach(function(l){
        if (l.store_info.featured) vm.featuredList.push(l);
        else vm.othersList.push(l);
      });
      vm.featuredList = _(vm.featuredList)
        .groupBy(function(l){
          return l.store_info.locality;
        })
        .value();
      vm.othersList = _(vm.othersList)
        .groupBy(function(l){
          return l.store_info.locality;
        })
        .value();
    }


    // New Site Map: the function filters the different locations depending upon
    // the different object properties
    function newSiteMapGroupFeaturedOthers(){
      vm.fullList.forEach(function(l){
        if (l.storeInfo.featured) vm.featuredList.push(l);
        else vm.othersList.push(l);
      });
      vm.featuredList = _(vm.featuredList)
        .groupBy(function(l){
          return l.storeInfo.locality;
        })
        .value();
      vm.othersList = _(vm.othersList)
        .groupBy(function(l){
          return l.storeInfo.locality;
        })
        .value();
    }

    function locationsComplete(response) {
      vm.locations = response.data.locations;
      //temporary redirect for thrifty when locations are not found.
      if (response.data.message === siteMapDictionary.locationsNotFound ) {
        if (_.has(siteMapDictionary.clientListForRedirects, vm.client_name)) {
          $window.location.href = siteMapDictionary.clientListForRedirects[vm.client_name];
        } else {
          $location.path('/404');
        }
      }
      vm.showPage = true;

      if(vm.position==="country") vm.locList = vm.getByRegionForCountry(vm.locations);

      else if(vm.position==="region" || vm.position==="locality") {
        vm.locList = vm.getByLocalityForRegion(vm.locations);
      }

      else if(vm.position==="continent") vm.locList = vm.getByCountryForContinent(vm.locations);

      else if(vm.position === 'global'){
        vm.locList = _(vm.locations)
          .filter(function (l) {
            return vm.includeLocationsWithoutRegion(l);
          })
          .each(function (l) {
            l.regionTransformed = RegionService.lookupRegionFromCountry(l.store_info.country, l.store_info.region);
          })
          .sortBy(function (l) {
            return l.store_info.continent + " " + l.store_info.country + " " + l.regionTransformed;
          })
          .groupBy(function (l) {
            return l.store_info.continent;
          })
          .value();
      }
      else {
        vm.locList = _(vm.locations)
          .filter(function (l) {
            return (l.open_or_closed === "open" || l.open_or_closed === "coming soon" || l.open_or_closed === "temp closed") && l.store_info.region && l.local_landing_page;
          })
          .each(function(l){
            l.regionTransformed = RegionService.lookupRegionFromCountry(l.store_info.country, l.store_info.region);
          })
          .sortBy(function (l) {
            return l.regionTransformed + " " + l.store_info.locality;
          })
          .groupBy(function (l) {
            if (vm.locality)
            {
              return vm.locality;
            }
            return l.regionTransformed;
          })
          .value();
      }
    }

    // New Site Map: the function filters the different locations depending upon
    // the different object properties
    function parselocationsData(response) {
      if (angular.isDefined(response)) {
        vm.locations = response.data.counts;
      }
      vm.showPage = true;

      if (vm.position === 'country') {
        vm.locList = _.sortBy(response.data.counts, function (obj) {
          return obj.name;
        });
      }
      else if (vm.position === 'region' || vm.position === 'locality') {
        if (vm.position === 'locality') {
          vm.locations = response.data.locations;
          vm.locList = vm.newSiteMapGetByLocalityForRegion(vm.locations);
          newSiteMapGroupFeaturedOthers();
        } else {
          vm.locList = _.sortBy(response.data.counts, function (obj) {
            return obj.name;
          });
        }
      }

      else if (vm.position === "continent") vm.locList = response.data.counts;

      //continents page
      else if (vm.position === 'global'){
        vm.locList = response.data.counts;
      }
      else {
        vm.locList = _(vm.locations)
          .filter(function (l) {
            return l.storeInfo.region && l.localLandingPage;
          })
          .each(function(l){
            l.regionTransformed = RegionService.lookupRegionFromCountry(l.storeInfo.country, l.storeInfo.region);
          })
          .sortBy(function (l) {
            return l.regionTransformed + " " + l.storeInfo.locality;
          })
          .groupBy(function (l) {
            if (vm.locality)
            {
              return vm.locality;
            }
            return l.regionTransformed;
          })
          .value();
      }
    }
    vm.noIndexHead = function() {
      $window.document.getElementsByName('robots')[0].content = 'noindex';
    };

    vm.includeLocationsWithoutRegion = function (l) {
      return l.store_info.region ? ( l.open_or_closed === "open"  ||  l.open_or_closed === "coming soon" || l.open_or_closed === "temp closed") && l.store_info.region && l.local_landing_page :
        ( l.open_or_closed === "open" ||  l.open_or_closed === "coming soon") && l.local_landing_page;
    }

    vm.getByCountryForContinent = function (locList) {
      return _(locList)
        .filter(function (l) {
          return vm.includeLocationsWithoutRegion(l);
        })
        .each(function (l) {
          l.regionTransformed = RegionService.lookupRegionFromCountry(l.store_info.country, l.store_info.region);
        })
        .sortBy(function (l) {
          return l.store_info.country + " " + l.regionTransformed + " " + l.store_info.locality;
        })
        .groupBy(function (l) {
          return l.store_info.country;
        })
        .value();
    };

    vm.getByRegionForCountry = function (locList) {
      return _(locList)
        .filter(function (l) {
          return vm.includeLocationsWithoutRegion(l);
        })
        .each(function (l) {
          var regionTransformed = RegionService.lookupRegionFromCountry(l.store_info.country, l.store_info.region);
          if(regionTransformed.length != 2) {
            var arr = regionTransformed.toLowerCase().split(' ')
            var i = 0
            var arrRev = []
            while(i < arr.length) {
              if(arr[i]) {
                arrRev.push(arr[i].charAt(0).toUpperCase() + arr[i].slice(1, arr[i].length))
              }
              i++
            }
            l.regionTransformed = arrRev.join(' ')
          } else {
            l.regionTransformed = regionTransformed
          }
        })
        .sortBy(function (l) {
          return l.regionTransformed + " " + l.store_info.locality;
        })
        .groupBy(function (l) {
          return l.regionTransformed;
        })
        .value();
    };

    vm.getByLocalityForRegion = function (locList) {
      return _(locList)
        .filter(function (l) {
          return vm.includeLocationsWithoutRegion(l);       
        })
        .sortBy(function (l) {
          return l.store_info.locality + " " + l.store_info.address;
        })
        .each(function (l) {
          vm.fullList.push(l);
        })
        .groupBy(function (l) {
          return l.store_info.locality;
        })
        .value();
    };

    /**
     * filters the location list
     * @param {object} locList list of location objects
     * @returns {object} location list
     */
    vm.newSiteMapGetByLocalityForRegion = function (locList) {
      return _(locList)
        .filter(function (l) {
          return l.storeInfo.region && l.localLandingPage;
        })
        .sortBy(function (l) {
          return l.storeInfo.locality + " " + l.storeInfo.address;
        })
        .each(function (l) {
          vm.fullList.push(l);
        })
        .groupBy(function (l) {
          return l.storeInfo.locality;
        })
        .value();
    };

    function llerror(error) {
      $log.debug(error);
      if(error.status === 404){
        $location.path('/404')
      }
      else if(error.status === 400){
        $location.path('/400')
      }
      else if(error.status === 500){
        $location.path('/500')
      }
    }
  }
})();

(function () {
  'use strict';

  angular
      .module('storeLocator')
      .directive('locationListNewSitemap', locationListNewSitemap);

  function locationListNewSitemap() {

    return {
      replace: true,
      scope: {
          locations: '=',
          clientRoute: '=',
          position: '=',
          featured: '=',
          others: '=',
          getByCountry: '&',
          customHeading: '@',
          selectedContinent: '=',
          showBreadcrumb: '='
      },
      templateUrl: 'app/siteMap/locationListNewSitemap.directive.html',
      restrict: 'AE',
      controller: LocationListNewSiteMapController,
      controllerAs: 'locationListNewSitemapC',
      bindToController: true
    };
  }

  LocationListNewSiteMapController.$inject = ['urldashFilter', 'RegionService', '$stateParams', '$rootScope', 'siteMapNewData', '$log', '$location'];
  function LocationListNewSiteMapController(urldashFilter, RegionService, $stateParams, $rootScope, siteMapNewData, $log, $location){
    var vm = this;

    vm.urldashIt = function (text) {
      return urldashFilter(text);
    };
    vm.getCountry = function(code){
      return RegionService.lookupCountryNameFromCode(code)
    };
    vm.getRegion = function(countryCode, regionCode){
      // Temporary fix to accomodate data issues with Dollar/Thrifty's source of truth. To be removed when their data is clean.
      if (angular.isDefined(regionCode)) {
        if (countryCode === "US") {
          return RegionService.lookup(regionCode);
        } else {
          return regionCode;
        }
      }
    };

    /**
     * returns true if the object is empty
     * @param {object} javascript object
     * @returns {boolean}
     */
    vm.isObjectEmpty = function(obj) {
      return Object.keys(obj.featured).length === 0;
    };

    /**
     * sets the name of the continent and makes the call to
     * retrieve the list of countries for the selected value.
     * @param {string} continent name of the continent
     */
    vm.setContinent = function(continent) {
      vm.selectedContinent.name = continent;
      vm.position = 'continent';
      vm.showBreadcrumb = true;
      siteMapNewData.getLocationsByContinent(vm.selectedContinent.name).then(parselocationsData).catch(llerror);
    };

    /**
     * parse the API response and sets the locations valriable
     * @param {object} response
     */
    function parselocationsData(response) {
      vm.locations = response.data.counts;
    }

    function llerror(error) {
      $log.debug(error);
      if(error.status === 404){
        $location.path('/404')
      }
      else if(error.status === 400){
        $location.path('/400')
      }
      else if(error.status === 500){
        $location.path('/500')
      }
    }

    vm.worldwideh1 = ['global', 'all'].indexOf(vm.position) >= 0
    vm.heading = vm.customHeading || "Locations";
    vm.stateParams = $stateParams;
  }
})();

(function () {
  'use strict';

  angular
      .module('storeLocator')
      .directive('locationList', locationList);

  function locationList() {

    return {
      replace: true,
      scope: {
          client:'=',
          locations: '=',
          clientRoute: '=',
          position: '=',
          featured: '=',
          others: '=',
          getByCountry: '&',
          customHeading: '@',
          comingSoonText: '@'
      },
      templateUrl: 'app/siteMap/locationList.directive.html',
      restrict: 'AE',
      controller: LocationListController,
      controllerAs: 'locationListC',
      bindToController: true
    };
  }

  LocationListController.$inject = ['urldashFilter', 'RegionService'];
  function LocationListController(urldashFilter, RegionService){
    var vm = this;

    vm.urldashIt = function (text) {
      return urldashFilter(text);
    };
    vm.getCountry = function(code){
      return RegionService.lookupCountryNameFromCode(code)
    };
    vm.getRegion = function(countryCode, regionCode){
      // Temporary fix to accomodate data issues with Dollar/Thrifty's source of truth. To be removed when their data is clean.
      if(countryCode === "US") {
        return RegionService.lookup(regionCode);
      } else if (regionCode && regionCode.length != 2) {
        var arr = regionCode.toLowerCase().split(' ')
        var i = 0
        var arrRev = []
        while(i < arr.length) {
          if(arr[i]) {
            arrRev.push(arr[i].charAt(0).toUpperCase() + arr[i].slice(1, arr[i].length))
          }
          i++
        }
        regionCode = arrRev.join(' ')
        return regionCode
      }  else {
        return RegionService.lookupRegionFromCountry(countryCode, regionCode)
      }
    };

    vm.getListOfCountries = function (locations) {
      return {
        keys: Object.keys(vm.getByCountry({locList: locations})),
        values: Object.keys(vm.getByCountry({locList: locations})).map(function(key) {
          return vm.getByCountry({locList: locations})[key];
        })
      }
    };
    vm.checkCountryInContinent = function(countryCode){
      return RegionService.lookupContinent(countryCode);
    };
    vm.worldwideh1 = ['global', 'all'].indexOf(vm.position) >= 0
    vm.heading = vm.customHeading || "Locations";
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .service('socialMediaService', socialMediaService);

    function socialMediaService() {
        var yelpType = 'Yelp',
            foursquareType = 'Foursquare';

        this.storeHasYelp = function (data) {
            if (data && data.store_info && data.store_info.providers) {
                var yelp = _.findWhere(data.store_info.providers, { _type: yelpType });
                return !!yelp && yelp.venue_id !== "";
            }
            return false;
        }

        this.storeHasFoursquare = function (data) {
            if (data && data.store_info && data.store_info.providers) {
                var foursquare = _.findWhere(data.store_info.providers, { _type: foursquareType });
                return !!foursquare;
            }
            return false;
        }
    }
    
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .service('menuService', menuService);

  function menuService($q, Restangular, menuMapper, MENU_API_HOST, API_TOKEN) {
    var GET_MENU_ID_URL = MENU_API_HOST + '/v1/location/%s/menus';

    this.getMenu = function (languageCode, locationId) {
      var deferred = $q.defer();
      getMenu(locationId).then(function (response) {
        if (response) {
          var menu = menuMapper.map(response, languageCode);
          deferred.resolve(menu);

        } else {
          deferred.reject();
        }
      });
      return deferred.promise;
    };

    // function getMenuId(locationId) {
    //   var url = s(GET_MENU_ID_URL).sprintf(encodeURIComponent(locationId)).value();
    //   var params = {
    //     'auth_token': API_TOKEN,
    //     'ghosted': true
    //   };
    //
    //   return Restangular.oneUrl('getMenuId', url).get(params);
    // };

    function getMenu(locationId) {
      var url = s(GET_MENU_ID_URL).sprintf(encodeURIComponent(locationId)).value();
      var params = {
        'auth_token': API_TOKEN,
        'ghosted': true
      };

      return Restangular.oneUrl('getMenu', url).get(params);
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .service('amenitiesService', amenitiesService);

  function amenitiesService() {
        this.storeHasAmenities = function (storeInfo) {
            var amenities = getAmenities(storeInfo);
            return amenities.length > 0;
        };

        this.storeHasCustomAmenities = function (storeInfo,contentTag) {
            var amenities = getContents(storeInfo,contentTag);
            return amenities.length > 0;
        };

        this.getAmenities = function (storeInfo) {
            var amenities = getAmenities(storeInfo);

            if (amenities) {
                amenities.forEach(function(amenity) {
                    var tooltips = storeInfo.filter(function(tooltip) {
                        return tooltip.name.indexOf(amenity.name + '_tooltip') === 0;
                    });
                    amenity.tooltip = '';
                    if (tooltips.length > 0) {
                        amenity.tooltip = tooltips[0].data;
                    }
                    amenity.showTooltip = false;
                });
            }

            return amenities;
        };

        this.getContents = function (storeInfo, contentTag) {
          var contents = getContents(storeInfo, contentTag);
          if (contents) {
            contents.forEach(function (item, i) {
                item.tooltip = contents[i].data;
            });
          }

          return contents;
        };

        function getAmenities(storeInfo) {
            var amenities = storeInfo.filter(function(amenity) {
                return isAmenity(amenity);
            });
            return amenities;
        }

        function isAmenity(data)
        {
            return data.name.indexOf('service_') === 0 && data.name.indexOf('_tooltip') === -1 && data.name.indexOf('service_custom') === -1 && data.data.toUpperCase() !== 'FALSE';
        }

        function getContents(storeInfo, contentTag) {
          var contents = storeInfo.filter(function(data) {
            return data.name.indexOf('service_custom_' + contentTag) === 0 && data.name.indexOf('_tooltip') === -1 && data.data.toUpperCase() !== 'FALSE';
          });
          return contents;
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .factory('menuMapper', menuMapper);

  function menuMapper() {
      var DESCRIPTION_LIMIT = 150;

      return {
          map: map
      };


      function map(data, languageCode) {
          var menu = null;

          if (data && data.data) {
              menu = getMenu(data.data, languageCode);
          }

          return menu;
      }

      function getMenu(data, languageCode) {
          var menu = [];
          _.each(data,
              function(element) {
                if (angular.isDefined(element.isEnabled)? element.isEnabled : true) {

                  for (var i = 0; i < element.sections.length; i++) {
                    var category = mapCategory(element.sections[i], languageCode)
                    menu.push(category)
                  }
                }
              });

          _.each(data,
              function(element) {
                if (angular.isDefined(element.isEnabled)? element.isEnabled : true) {

                  for(var i = 0; i < element.sections.length; i++) {
                    var items = element.sections[i].items
                    var category = menu[i]
                    category.options = [];
                    for (var j = 0; j < items.length; j++) {
                      category.options.push(mapOption(items[j], languageCode));

                    }
                  }
                }
              });

          return menu;
      }

      function mapCategory(element, languageCode) {
          var category = {
              categoryId: element.id,
              categoryName: element.displayName,
              active: false
          };

          return category;
      }

      function mapOption(element, languageCode) {
          var option = {
              optionId: element.id,
              name: element.displayName,
              description: formatDescription(element.description),
              price: element.price
          };

          return option;
      }

      function formatDescription(content) {
          var description = {
              truncated: false,
              text: content,
              truncatedText: ''
          };

          if (content && content.length > DESCRIPTION_LIMIT) {
              description = {
                  truncated: true,
                  text: content.substr(0, DESCRIPTION_LIMIT),
                  truncatedText: content.substr(DESCRIPTION_LIMIT)
              }
          }

          return description;
      }
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .factory('localLandingData', localLandingData);

  function localLandingData($log, APIService, APIServiceAuthHeader, $stateParams, urldashFilter, INSTAGRAM_BUSINESS_ACCOUNT_ID, LOCATIONS_API, USE_NAME_INSTEAD_TAGS, storeLocatorCache, MULTI_ACCOUNT, localLandingDictionary, $window) {

    return {
      getLocationForAddress: getLocationForAddress,
      getLocationForLocality: getLocationForLocality,
      getPhotosForLocation: getPhotosForLocation,
      getLocationsForSearch: getLocationsForSearch,
      getFbPostsForLocation: getFbPostsForLocation,
      getBrandFbPosts: getBrandFbPosts,
      getFbReviewsForLocation: getFbReviewsForLocation,
      getGoogleActivities: getGoogleActivities,
      getAccountForLocation: getAccountForLocation,
      getLocationsForGeoSearch: getLocationsForGeoSearch,
      getYelpReviewsForLocation: getYelpReviewsForLocation,
      redirectToClientHomePage: redirectToClientHomePage
    };

    function getLocationForAddress() {
      var params = {
        name: urldashFilter($stateParams.name, true),
        address: urldashFilter($stateParams.address,true),
        locality: urldashFilter($stateParams.locality,true),
        region: urldashFilter($stateParams.region),
        pageSize: 30,
        multi_account: MULTI_ACCOUNT
      };

      var req = APIServiceAuthHeader.one(LOCATIONS_API);
      // Undo the auth_token here

      return req.get(params);
    }

    function getLocationForLocality() {
      var params = {
        locality: urldashFilter($stateParams.locality,true),
        region: urldashFilter($stateParams.region),
        pageSize: 30,
        multi_account: MULTI_ACCOUNT
      };

      var req = APIService.one(LOCATIONS_API);
      return req.get(params);
    }

    function getAccountForLocation(id) {
      var req = APIService.one("account/" + id);
      return req.get();
    }

    function getLocationsForSearch(center, coordinates_string, tags, limit, type) {
      var params = {
        center: center,
        coordinates: coordinates_string,
        page: 1,
        pageSize: limit,
        multi_account: MULTI_ACCOUNT
      };

      if (tags) {
        if (USE_NAME_INSTEAD_TAGS) {
          params.name = tags;
        } else {
          params.tags = tags;
        }
      }

      if (type) {
        params.type = type;
      }

      var req = APIService.one(LOCATIONS_API);
      var locationsList = req.get(params);
      if(storeLocatorCache.get('geoFlag')){
        storeLocatorCache.save('currentLocationsList', locationsList);
      }
      else {
        storeLocatorCache.save('locationsList', locationsList);
      }
      return locationsList;
    }

    function getLocationsForGeoSearch(lat,long,radius,limit) {
      var params = {
        geo: lat+","+long,
        radius: radius,
        page:1,
        pageSize:limit,
        multi_account: MULTI_ACCOUNT
      };

      var req = APIService.one("llp/nearby.json");
      return req.get(params);
    }

    function getPhotosForLocation() {
      var params = {
          sort: "photo_date",
          per_page: 20,
          page: 1,
          business_account_id: INSTAGRAM_BUSINESS_ACCOUNT_ID,
          tab: "my_photos"
      };

      var req = APIService.one("instagram/media");
      return req.get(params);
    }

    function getFbPosts(params){
      var req = APIService.one("content/posts");
      return req.get(params);
    }

    function getFbPostsForLocation(loc_id) {
      var now = moment()._d
      var params = {
        touched: true,
        q: {
          filter: "owned",
          llp: "true",
          sort: "post_date_formatted" <= now,
          sort_direction: "desc",
          per_page: 2,
          page: 1,
          location_id: loc_id
        }
      };
      return getFbPosts(params);
    }

    function getBrandFbPosts() {
      var now = moment()._d
      var params = {
        touched: true,
        q: {
          filter: "owned",
          llp: "true",
          sort: "post_date_formatted" <= now,
          sort_direction: "desc",
          per_page: 2,
          page: 1,
          brand_level: "true"
        }
      };
      return getFbPosts(params);
    }

    function getFbReviewsForLocation(loc_id) {
      var params = {
        q: {
          filter: "ratings_5",
          sort: "created_time",
          sort_direction: "desc",
          per_page: 1,
          page: 1,
          location_id: loc_id
        }
      };
      var req = APIService.one("content/posts");
      return req.get(params);
    }

    function getYelpReviewsForLocation(loc_id) {
      var params = {
        q: {
          filter: "ratings_0",
          sort: "created_time",
          sort_direction: "desc",
          per_page: 5,
          page: 1,
          location_id: loc_id
        }
      };
      var req = APIService.one("content/yelp");
      return req.get(params);
    }

    function getGoogleActivities(loc_id) {
      var params = {
        q: {
          filter: "ratings_0",
          sort: "created_time",
          sort_direction: "desc",
          per_page: 1,
          page: 1,
          location_id: loc_id
        }
      };
      var req = APIService.one("content/activities");
      return req.get(params);
    }

    /**
     * redirects the user to the custom URL if the location is not found
     * @param {object} response
     * @param {string} clientName
     * @returns
     */
    function redirectToClientHomePage(response, clientName) {
      if (_.has(localLandingDictionary.CLIENT_LIST, clientName)) {
        $window.location.href = localLandingDictionary.CLIENT_LIST[clientName];
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .factory('localLandingDictionary', localLandingDictionary);

  /** @ngInject */
  function localLandingDictionary() {
    var dictionary = {};

    //state values
    dictionary.LOCATION_NEW = {label: 'New Location', value: 'new', css_bg:'i-info', css:''};
    //list of cleints for which we will be redirecting them to the home page
    // or custom URL if the no results are found during location search.
    dictionary.CLIENT_LIST = { Thrifty: 'http://www.thrifty.com',
                               Dollar: 'http://www.dollar.com'};
    dictionary.locationsNotFound = 'No matching locations found';
    return dictionary;
  }
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .controller('LocalLandingController', LocalLandingController);

  /** @ngInject */
  function LocalLandingController($q, $stateParams, localLandingData, $log, _, $analytics, $state, $rootScope, $scope, $window, $timeout, MetaDataService, pubSub, BASE_URL, storeLocatorCache, urldashFilter, urlBuilderFactory, localLandingDictionary, CLIENT_NAME) {
    var vm = this;
    vm.location = 'loading';
    vm.photos = ['photos'];
    vm.fbReviews = [];
    vm.activities = [];
    vm.nearbyLocations = [];
    vm.error = false;
    vm.errorStatus;

    $state.current.title = '';

    vm.address = $stateParams.address;

    // if we have the cache in side and this address is the address in the llp.json, then use cache
    if (storeLocatorCache.get('location') && (urldashFilter($stateParams.address, true) === storeLocatorCache.get('location').address)) {
      locationListComplete({
        data: [storeLocatorCache.get('location').entire_location]
      });
    } else {
      localLandingData.getLocationForAddress().then(locationListComplete).catch(llerror);
    }
    vm.windowWidth = window.innerWidth;


    $rootScope.canonical_url = function(){
      if(BASE_URL.indexOf('thrifty') > -1 || BASE_URL.indexOf('dollar') > -1){
        return (BASE_URL + '/loc' + vm.location.llp_url).toLowerCase();
      }
      if(BASE_URL.includes('advisors.arvest')){
        return BASE_URL + '/ll/' + vm.location.store_info.name + vm.location.llp_url.slice(3, vm.location.llp_url.length);
      }
      return BASE_URL+ vm.location.llp_url;
    };

    $rootScope.twitter_handle = function () {
      return vm.location.twitter_handle ? '@' + vm.location.twitter_handle : '';
    }

    $window.onresize = function (event) {
      $timeout(function () {
        vm.windowWidth = window.innerWidth;
      });
    };

      function checkCricketLocation(locationList) {
          if (locationList[0].store_info.account_id == '55415f4241f8766f5d06ae77' || locationList[0].store_info.account_id == '5367f3a1ef070044f1418f27' || locationList[0].store_info.account_id == '54ac30c141f876123c0edf5c') {
              return _.find(locationList, function(location) {
                  return location.store_info.account_id == '5367f3a1ef070044f1418f27';
              });
          }
          else {
              return locationList[0];
          }
      }

    function locationListComplete(response) {
      // if the location are not found check if we have custome redirect URL's for the clients
      if (response.data.message === localLandingDictionary.locationsNotFound) {
        localLandingData.redirectToClientHomePage(response, CLIENT_NAME);
      }
      // throw an error in case of null response
      if (response.data[0] == null) {
        vm.error = true;
        return;
      }

      vm.location = checkCricketLocation(response.data);

      vm.location.store_info.directionsUrl = urlBuilderFactory.getDirectionsUrl(vm.location.store_info);

      vm.fbReviews = [vm.location];
      // GA track Page View event
      $analytics.eventTrack('Page View', {
        category: 'LLP',
        label: '{ "url": "' + vm.location.llp_url + '", "location_id": "' + vm.location.momentfeed_venue_id + '"}',
        noninteraction: 'true'
      });
      // Meta.json call is made when localLandingData is requested. Its is a part of the location object for the specific address.
      MetaDataService.loadMetaData(vm.location.momentfeed_venue_id);
      var address = vm.location.store_info.address + vm.location.store_info.address_extended;
      var locality = vm.location.store_info.locality;
      var region = vm.location.store_info.region;
      var postcode = vm.location.store_info.postcode;

      vm.alphanumeric = _.find(vm.location.custom_fields, function (o) {
        return o.name == "alphanumeric";
      });

      if (vm.alphanumeric) {
        vm.alphanumeric = vm.alphanumeric.data;
      }

      $state.current.title = ' at ' + address + ', ' + locality + ', ' + region + ' ' + postcode;
      vm.posts = vm.location.momentfeed_venue_id;
      vm.brandPosts = "brandPosts";

      //Reduce Twitter API callback by referencing location data that we already have rather than calling the twitter endpoint
      //Compare against the old assignment: var account = localLandingData.getAccountForLocation(vm.location.store_info.account_id);
      //Twitter card differs from the other API reduction efforts in that there is no functionality to migrate INTO the card controller
      //just a smarter way to use data.
      var account = {
        "twitter_subscriptions": {
          "user": [vm.location.twitter_handle]
        }
      };
      vm.account = account;
      vm.nearbyLocations = [vm.location];
      // var google_activities = localLandingData.getGoogleActivities(vm.location.momentfeed_venue_id);
      //var yelps = localLandingData.getYelpReviewsForLocation(vm.location.momentfeed_venue_id);

      $q.all([vm.location.meta]).then(function (data) {
        locationMetaComplete(data[0]);
        // activitiesComplete(data[1]);
        // yelpsComplete(data[2]);
      }).catch(llerror);
    }

    function locationMetaComplete(response) {

      var image;
      var metaImageElement;

      metaImageElement = document.querySelector('.map-container img');
      if (metaImageElement) {
        image = metaImageElement.src;
      }

      else {

        metaImageElement = document.querySelector("#hero");
        if (metaImageElement) {
          image = metaImageElement.getAttribute("data");
        }

        if (metaImageElement == null) {
          image = "src/assets/images/map_default.png";
        }

      }

      pubSub.publish({
        meta: response,
        'msg': 'metaImage',
        'img': image
      });
    }

    //function activitiesComplete(response) {
    //  vm.activities = response.data;
    //}

    // function yelpsComplete(response) {
    //   vm.yelps = response.data;
    // }

    function llerror(error) {
      $log.debug(error);
      vm.error = true;
      vm.errorStatus = error.status;
    }
  }
})();

angular
  .module('storeLocator')
  .controller('500errorCard', errorPage);

function errorPage($scope) {

  $scope.back = function() {
    history.back();
  };

  return {
    templateUrl: 'app/errorPages/500.html',
    restrict: 'E',
    bindToController: {
      locationError: '='
    },
    controller: function(CLIENT_ROUTE, $scope, $timeout, $window) {
      var vm = this;

      if (CLIENT_ROUTE != undefined) vm.indexURI = CLIENT_ROUTE;
      else vm.indexURI = '';

      vm.auto_redirect = false;

    },
    controllerAs: '500Ctrl'
  };

}

angular
  .module('storeLocator')
  .controller('404errorCard', errorPage);

function errorPage($scope) {

  $scope.back = function() {
    history.back();
  };

  return {
    templateUrl: 'app/errorPages/404.html',
    restrict: 'E',
    bindToController: {
      locationError: '='
    },
    controller: function(CLIENT_ROUTE, $timeout, $window) {
      var vm = this;

      if (CLIENT_ROUTE != undefined) vm.indexURI = CLIENT_ROUTE;
      else vm.indexURI = '';

      vm.auto_redirect = false;

    },
    controllerAs: '404Ctrl'
  };

}

angular
  .module('storeLocator')
  .controller('400errorCard', errorPage);

function errorPage($scope) {

  $scope.back = function() {
    history.back();
  };

  return {
    templateUrl: 'app/errorPages/400.html',
    restrict: 'E',
    bindToController: {
      locationError: '='
    },
    controller: function(CLIENT_ROUTE, $scope, $timeout, $window) {
      var vm = this;

      vm.back = function() {
        history.back();
      };

      if (CLIENT_ROUTE != undefined) vm.indexURI = CLIENT_ROUTE;
      else vm.indexURI = '';

      vm.auto_redirect = false;

    },
    controllerAs: '400Ctrl'
  };

}

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .factory('urlBuilderFactory', urlBuilderFactory);

  function urlBuilderFactory(urldashFilter) {

    var DIRECTIONS_URL = 'https://www.google.com/maps/dir/?api=1&destination=';
    var INSTAGRAM_URL = 'https://www.instagram.com/';

    var factory = {
      getDirectionsUrl: getDirectionsUrl,
      getInstagramUrl: getInstagramUrl
    };

    //data passed in should be location.store_info object
    function getDirectionsUrlByAddress(data) {
      var fullAddress = data.address + " " + data.locality + " " + data.region + " " + data.postcode;
      var directionsUrl = DIRECTIONS_URL + urldashFilter(fullAddress);

      return directionsUrl;
    }

    function getDirectionsUrlByCoordinates(data) {
      if (data.latitude === null || data.longitude === null) {
        return null;
      }

      var coordinates = data.latitude + ", " + data.longitude;
      var directionsUrl = DIRECTIONS_URL + coordinates;
      return directionsUrl;
    }

    function getDirectionsUrlByPlaceId(data) {
      var googleProviderObj = _.find(data.providers, function(prov){return prov._type === "Google"}) || {};
      if (_.isEmpty(googleProviderObj)) {
        return null;
      }

      var gmbPlaceId = googleProviderObj.place_id;
      var gmbDestinationName = googleProviderObj.name;
      var directionsUrl = encodeURI("https://www.google.com/maps/dir/?api=1&destination_place_id=" + gmbPlaceId + "&destination=" + gmbDestinationName);
      return directionsUrl;
    }

    //returns a directions url when passing in location.store_info with priority given to
    // 1. gmb place_id 2. coordinates 3. address
    function getDirectionsUrl(data) {
      if (data !== null && angular.isDefined(data)) {
        var getByPlaceId = getDirectionsUrlByPlaceId(data);
        if (getByPlaceId !== null) {
          return getByPlaceId;
        }
        var getByCoordinates = getDirectionsUrlByCoordinates(data);
        if (getByCoordinates !== null) {
          return getByCoordinates;
        }
        return getDirectionsUrlByAddress(data);
      }
      return DIRECTIONS_URL;
    }

    function getInstagramUrl(handle) {
      var url = INSTAGRAM_URL + handle;
      return url;
    }

    return factory;
  }
})();

(function () {
  'use strict';
  angular
    .module("storeLocator")
    .factory('s', UnderscoreStringService);

  function UnderscoreStringService($window) {
    return $window.s; // assumes underscore has already been loaded on the page
  }
}());

(function () {
  'use strict';
  angular
    .module("storeLocator")
    .factory('RegionService', RegionService);

  function RegionService() {

    var regions = {
      //US
      AL: "Alabama",
      AK: "Alaska",
      AS: "American Samoa",
      AZ: "Arizona",
      AR: "Arkansas",
      CA: "California",
      CO: "Colorado",
      CT: "Connecticut",
      DE: "Delaware",
      DC: "District Of Columbia",
      FM: "Federated States Of Micronesia",
      FL: "Florida",
      GA: "Georgia",
      GU: "Guam",
      HI: "Hawaii",
      ID: "Idaho",
      IL: "Illinois",
      IN: "Indiana",
      IA: "Iowa",
      KS: "Kansas",
      KY: "Kentucky",
      LA: "Louisiana",
      ME: "Maine",
      MH: "Marshall Islands",
      MD: "Maryland",
      MA: "Massachusetts",
      MI: "Michigan",
      MN: "Minnesota",
      MS: "Mississippi",
      MO: "Missouri",
      MT: "Montana",
      NE: "Nebraska",
      NV: "Nevada",
      NH: "New Hampshire",
      NJ: "New Jersey",
      NM: "New Mexico",
      NY: "New York",
      NC: "North Carolina",
      ND: "North Dakota",
      MP: "Northern Mariana Islands",
      OH: "Ohio",
      OK: "Oklahoma",
      OR: "Oregon",
      PW: "Palau",
      PA: "Pennsylvania",
      PR: "Puerto Rico",
      RI: "Rhode Island",
      SC: "South Carolina",
      SD: "South Dakota",
      TN: "Tennessee",
      TX: "Texas",
      UT: "Utah",
      VT: "Vermont",
      VI: "Virgin Islands",
      VA: "Virginia",
      WA: "Washington",
      WV: "West Virginia",
      WI: "Wisconsin",
      WY: "Wyoming",
    };

    var countries = {
      "AE": [
        {
          "province" :"00",
          "province-name": "Abu Dhabi"
        },
        {
          "province" :"01",
          "province-name": "Dubai"
        },
        {
          "province" :"02",
          "province-name": "Sharjah"
        },
        {
          "province" :"03",
          "province-name": "Umm al Khaimah"
        },
        {
          "province" :"04",
          "province-name": "Ajman"
        },
        {
          "province" :"05",
          "province-name": "Ras Al Khaimah "
        },
        {
          "province" :"06",
          "province-name": "Fujairahß"
        }
      ],
      "AL": [],
      "AR": [
        {
          "province": "00",
          "province-name": "Capital Federal"
        },
        {
          "province": "01",
          "province-name": "Buenos Aires"
        },
        {
          "province": "02",
          "province-name": "Catamarca"
        },
        {
          "province": "03",
          "province-name": "Córdoba"
        },
        {
          "province": "04",
          "province-name": "Corrientes"
        },
        {
          "province": "05",
          "province-name": "Entre Rios"
        },
        {
          "province": "06",
          "province-name": "Jujuy"
        },
        {
          "province": "07",
          "province-name": "Mendoza"
        },
        {
          "province": "08",
          "province-name": "La Rioja"
        },
        {
          "province": "09",
          "province-name": "Salta"
        },
        {
          "province": "10",
          "province-name": "San Juan"
        },
        {
          "province": "11",
          "province-name": "San Luis"
        },
        {
          "province": "12",
          "province-name": "Santa Fé"
        },
        {
          "province": "13",
          "province-name": "Santiago del Estero"
        },
        {
          "province": "14",
          "province-name": "Tucumán"
        },
        {
          "province": "16",
          "province-name": "Chaco"
        },
        {
          "province": "17",
          "province-name": "Chubut"
        },
        {
          "province": "18",
          "province-name": "Formosa"
        },
        {
          "province": "19",
          "province-name": "Misiones"
        },
        {
          "province": "20",
          "province-name": "Neuquen"
        },
        {
          "province": "21",
          "province-name": "La Pampa"
        },
        {
          "province": "22",
          "province-name": "Rio Negro"
        },
        {
          "province": "23",
          "province-name": "Santa Cruz"
        },
        {
          "province": "24",
          "province-name": "Tierra de Fuego"
        }
      ],
      "AT": [
        {
          "province": "B",
          "province-name": "Burgenland"
        },
        {
          "province": "K",
          "province-name": "Carinthia"
        },
        {
          "province": "NÖ",
          "province-name": "Lower Austria"
        },
        {
          "province": "OÖ",
          "province-name": "Upper Austria"
        },
        {
          "province": "S",
          "province-name": "Salzburg"
        },
        {
          "province": "ST",
          "province-name": "Styria"
        },
        {
          "province": "T",
          "province-name": "Tyrol"
        },
        {
          "province": "V",
          "province-name": "Vorarlberg"
        },
        {
          "province": "W",
          "province-name": "Vienna"
        }
      ],
      "AU": [
        {
          "province": "ACT",
          "province-name": "Aust Capital Terr"
        },
        {
          "province": "AC", // to accomodate Dollar/Thrifty bad data
          "province-name": "Aust Capital Terr"
        },
        {
          "province": "NSW",
          "province-name": "New South Wales"
        },{
          "province": "NS", // to accomodate Dollar/Thrifty bad data
          "province-name": "New South Wales"
        },
        {
          "province": "NT",
          "province-name": "Northern Territory"
        },
        {
          "province": "QLD",
          "province-name": "Queensland"
        },
        {
          "province": "QL", // to accomodate Dollar/Thrifty bad data
          "province-name": "Queensland"
        },
        {
          "province": "SA",
          "province-name": "South Australia"
        },
        {
          "province": "TAS",
          "province-name": "Tasmania"
        },
        {
          "province": "TS", // to accomodate Dollar/Thrifty bad data
          "province-name": "Tasmania"
        },
        {
          "province": "VIC",
          "province-name": "Victoria"
        },
        {
          "province": "VI", // to accomodate Dollar/Thrifty bad data
          "province-name": "Victoria"
        },
        {
          "province": "WA",
          "province-name": "Western Australia"
        }
      ],
      "BE": [
        {
          "province": "01",
          "province-name": "Antwerp"
        },
        {
          "province": "02",
          "province-name": "Brabant (Flemish)"
        },
        {
          "province": "03",
          "province-name": "Hainaut"
        },
        {
          "province": "04",
          "province-name": "Liege"
        },
        {
          "province": "05",
          "province-name": "Limburg"
        },
        {
          "province": "06",
          "province-name": "Luxembourg"
        },
        {
          "province": "07",
          "province-name": "Namur"
        },
        {
          "province": "08",
          "province-name": "Oost-Vlaanderen"
        },
        {
          "province": "09",
          "province-name": "West-Vlaanderen"
        },
        {
          "province": "10",
          "province-name": "Brabant (Walloon)"
        },
        {
          "province": "11",
          "province-name": "Brussels (Capital)"
        }
      ],
      "BG": [
        {
          "province": "01",
          "province-name": "Burgas"
        },
        {
          "province": "02",
          "province-name": "Grad Sofiya"
        },
        {
          "province": "03",
          "province-name": "Khaskovo"
        },
        {
          "province": "04",
          "province-name": "Lovech"
        },
        {
          "province": "05",
          "province-name": "Montana"
        },
        {
          "province": "06",
          "province-name": "Plovdiv"
        },
        {
          "province": "07",
          "province-name": "Ruse"
        },
        {
          "province": "08",
          "province-name": "Sofiya"
        },
        {
          "province": "09",
          "province-name": "Varna"
        }
      ],
      "BN": [
        {
          "province": "BE",
          "province-name": "Belait"
        },
        {
          "province": "BM",
          "province-name": "Brunei-Muara"
        },
        {
          "province": "TE",
          "province-name": "Temburong"
        },
        {
          "province": "TU",
          "province-name": "Tutong"
        }
      ],
      "BR": [
        {
          "province": "AC",
          "province-name": "Acre"
        },
        {
          "province": "AL",
          "province-name": "Alagoas"
        },
        {
          "province": "AM",
          "province-name": "Amazon"
        },
        {
          "province": "AP",
          "province-name": "Amapá"
        },
        {
          "province": "BA",
          "province-name": "Bahia"
        },
        {
          "province": "CE",
          "province-name": "Ceará"
        },
        {
          "province": "DF",
          "province-name": "Brasília"
        },
        {
          "province": "ES",
          "province-name": "Espírito Santo"
        },
        {
          "province": "GO",
          "province-name": "Goiás"
        },
        {
          "province": "MA",
          "province-name": "Maranhão"
        },
        {
          "province": "MG",
          "province-name": "Minas Gerais"
        },
        {
          "province": "MS",
          "province-name": "Mato Grosso do Sul"
        },
        {
          "province": "MT",
          "province-name": "Mato Grosso"
        },
        {
          "province": "PA",
          "province-name": "Pará"
        },
        {
          "province": "PB",
          "province-name": "Paraíba"
        },
        {
          "province": "PE",
          "province-name": "Pernambuco"
        },
        {
          "province": "PI",
          "province-name": "Piauí"
        },
        {
          "province": "PR",
          "province-name": "Paraná"
        },
        {
          "province": "RJ",
          "province-name": "Rio de Janeiro"
        },
        {
          "province": "RN",
          "province-name": "Rio Grande do Norte"
        },
        {
          "province": "RO",
          "province-name": "Rondônia"
        },
        {
          "province": "RR",
          "province-name": "Roraima"
        },
        {
          "province": "RS",
          "province-name": "Rio Grande do Sul"
        },
        {
          "province": "SC",
          "province-name": "Santa Catarina"
        },
        {
          "province": "SE",
          "province-name": "Sergipe"
        },
        {
          "province": "SP",
          "province-name": "São Paulo"
        },
        {
          "province": "TO",
          "province-name": "Tocantins"
        }
      ],
      "BZ": [
        {
          "province": "BZ",
          "province-name": "Belize"
        },
        {
          "province": "CY",
          "province-name": "Cayo"
        },
        {
          "province": "CZ",
          "province-name": "Corozal"
        },
        {
          "province": "OW",
          "province-name": "Orange Walk"
        },
        {
          "province": "SC",
          "province-name": "Stann Creek"
        },
        {
          "province": "TO",
          "province-name": "Toledo"
        }
      ],
      "CA": [
        {
          "province": "AB",
          "province-name": "Alberta"
        },{
          "province": "AL", // to accomodate Dollar/Thrifty bad data
          "province-name": "Alberta"
        },
        {
          "province": "BC",
          "province-name": "British Columbia"
        },
        {
          "province": "MB",
          "province-name": "Manitoba"
        },{
          "province": "MN", // to accomodate Dollar/Thrifty bad data
          "province-name": "Manitoba"
        },
        {
          "province": "NB",
          "province-name": "New Brunswick"
        },
        {
          "province": "NE",
          "province-name": "ACS Legacy"
        },
        {
          "province": "NF",
          "province-name": "Newfoundland (old)"
        },
        {
          "province": "NL",
          "province-name": "Newfoundland & Labr."
        },
        {
          "province": "NS",
          "province-name": "Nova Scotia"
        },
        {
          "province": "NT",
          "province-name": "Northwest Terr."
        },
        {
          "province": "NU",
          "province-name": "Nunavut"
        },
        {
          "province": "ON",
          "province-name": "Ontario"
        },{
          "province": "OT", // to accomodate Dollar/Thrifty bad data
          "province-name": "Ontario"
        },
        {
          "province": "PE",
          "province-name": "Prince Edward Island"
        },
        {
          "province": "PQ",
          "province-name": "ACS Legacy"
        },
        {
          "province": "QC",
          "province-name": "Quebec"
        },{
          "province": "QU", // to accomodate Dollar/Thrifty bad data
          "province-name": "Quebec"
        },
        {
          "province": "SK",
          "province-name": "Saskatchewan"
        },{
          "province": "SA", // to accomodate Dollar/Thrifty bad data
          "province-name": "Saskatchewan"
        },
        {
          "province": "YT",
          "province-name": "Yukon Territory"
        }
      ],
      "CH": [
        {
          "province": "AG",
          "province-name": "Aargau"
        },
        {
          "province": "AI",
          "province-name": "Inner-Rhoden"
        },
        {
          "province": "AR",
          "province-name": "Ausser-Rhoden"
        },
        {
          "province": "BE",
          "province-name": "Bern"
        },
        {
          "province": "BL",
          "province-name": "Basel Land"
        },
        {
          "province": "BS",
          "province-name": "Basel Stadt"
        },
        {
          "province": "FR",
          "province-name": "Fribourg"
        },
        {
          "province": "GE",
          "province-name": "Geneva"
        },
        {
          "province": "GL",
          "province-name": "Glarus"
        },
        {
          "province": "GR",
          "province-name": "Graubuenden"
        },
        {
          "province": "JU",
          "province-name": "Jura"
        },
        {
          "province": "LU",
          "province-name": "Lucerne"
        },
        {
          "province": "NE",
          "province-name": "Neuchatel"
        },
        {
          "province": "NW",
          "province-name": "Nidwalden"
        },
        {
          "province": "OW",
          "province-name": "Obwalden"
        },
        {
          "province": "SG",
          "province-name": "St. Gallen"
        },
        {
          "province": "SH",
          "province-name": "Schaffhausen"
        },
        {
          "province": "SO",
          "province-name": "Solothurn"
        },
        {
          "province": "SZ",
          "province-name": "Schwyz"
        },
        {
          "province": "TG",
          "province-name": "Thurgau"
        },
        {
          "province": "TI",
          "province-name": "Ticino"
        },
        {
          "province": "UR",
          "province-name": "Uri"
        },
        {
          "province": "VD",
          "province-name": "Vaud"
        },
        {
          "province": "VS",
          "province-name": "Valais"
        },
        {
          "province": "ZG",
          "province-name": "Zug"
        },
        {
          "province": "ZH",
          "province-name": "Zurich"
        }
      ],
      "CL": [
        {
          "province": "01",
          "province-name": "I - Iquique"
        },
        {
          "province": "02",
          "province-name": "II - Antofagasta"
        },
        {
          "province": "03",
          "province-name": "III - Copiapo"
        },
        {
          "province": "04",
          "province-name": "IV - La Serena"
        },
        {
          "province": "05",
          "province-name": "V - Valparaiso"
        },
        {
          "province": "06",
          "province-name": "VI - Rancagua"
        },
        {
          "province": "07",
          "province-name": "VII - Talca"
        },
        {
          "province": "08",
          "province-name": "VIII - Concepción"
        },
        {
          "province": "09",
          "province-name": "IX - Temuco"
        },
        {
          "province": "10",
          "province-name": "X - Puerto Montt"
        },
        {
          "province": "11",
          "province-name": "XI - Coyhaique"
        },
        {
          "province": "12",
          "province-name": "XII - Punta Arenas"
        },
        {
          "province": "13",
          "province-name": "RM - Santiago"
        }
      ],
      "CN": [
        {
          "province": "010",
          "province-name": "Beijing"
        },
        {
          "province": "020",
          "province-name": "Shanghai"
        },
        {
          "province": "030",
          "province-name": "Tianjin"
        },
        {
          "province": "040",
          "province-name": "Nei Mongol"
        },
        {
          "province": "050",
          "province-name": "Shanxi"
        },
        {
          "province": "060",
          "province-name": "Hebei"
        },
        {
          "province": "070",
          "province-name": "Liaoning"
        },
        {
          "province": "080",
          "province-name": "Jilin"
        },
        {
          "province": "090",
          "province-name": "Heilongjiang"
        },
        {
          "province": "100",
          "province-name": "Jiangsu"
        },
        {
          "province": "110",
          "province-name": "Anhui"
        },
        {
          "province": "120",
          "province-name": "Shandong"
        },
        {
          "province": "130",
          "province-name": "Zhejiang"
        },
        {
          "province": "140",
          "province-name": "Jiangxi"
        },
        {
          "province": "150",
          "province-name": "Fujian"
        },
        {
          "province": "160",
          "province-name": "Hunan"
        },
        {
          "province": "170",
          "province-name": "Hubei"
        },
        {
          "province": "180",
          "province-name": "Henan"
        },
        {
          "province": "190",
          "province-name": "Guangdong"
        },
        {
          "province": "200",
          "province-name": "Hainan"
        },
        {
          "province": "210",
          "province-name": "Guangxi"
        },
        {
          "province": "220",
          "province-name": "Guizhou"
        },
        {
          "province": "230",
          "province-name": "Sichuan"
        },
        {
          "province": "240",
          "province-name": "Yunnan"
        },
        {
          "province": "250",
          "province-name": "Shaanxi"
        },
        {
          "province": "260",
          "province-name": "Gansu"
        },
        {
          "province": "270",
          "province-name": "Ningxia"
        },
        {
          "province": "280",
          "province-name": "Qinghai"
        },
        {
          "province": "290",
          "province-name": "Xinjiang"
        },
        {
          "province": "300",
          "province-name": "Xizang"
        },
        {
          "province": "310",
          "province-name": "Taiwan"
        }
      ],
      "CO": [
        {
          "province": "05",
          "province-name": "ANTIOQUIA"
        },
        {
          "province": "08",
          "province-name": "ATLANTICO"
        },
        {
          "province": "11",
          "province-name": "BOGOTA"
        },
        {
          "province": "13",
          "province-name": "BOLIVAR"
        },
        {
          "province": "15",
          "province-name": "BOYACA"
        },
        {
          "province": "17",
          "province-name": "CALDAS"
        },
        {
          "province": "18",
          "province-name": "CAQUETA"
        },
        {
          "province": "19",
          "province-name": "CAUCA"
        },
        {
          "province": "20",
          "province-name": "CESAR"
        },
        {
          "province": "23",
          "province-name": "CORDOBA"
        },
        {
          "province": "25",
          "province-name": "CUNDINAMARCA"
        },
        {
          "province": "27",
          "province-name": "CHOCO"
        },
        {
          "province": "41",
          "province-name": "HUILA"
        },
        {
          "province": "44",
          "province-name": "LA GUAJIRA"
        },
        {
          "province": "47",
          "province-name": "MAGDALENA"
        },
        {
          "province": "50",
          "province-name": "META"
        },
        {
          "province": "52",
          "province-name": "NARIÑO"
        },
        {
          "province": "54",
          "province-name": "NORTE SANTANDER"
        },
        {
          "province": "63",
          "province-name": "QUINDIO"
        },
        {
          "province": "66",
          "province-name": "RISARALDA"
        },
        {
          "province": "68",
          "province-name": "SANTANDER"
        },
        {
          "province": "70",
          "province-name": "SUCRE"
        },
        {
          "province": "73",
          "province-name": "TOLIMA"
        },
        {
          "province": "76",
          "province-name": "VALLE"
        },
        {
          "province": "81",
          "province-name": "ARAUCA"
        },
        {
          "province": "85",
          "province-name": "CASANARE"
        },
        {
          "province": "86",
          "province-name": "PUTUMAYO"
        },
        {
          "province": "88",
          "province-name": "SAN ANDRES"
        },
        {
          "province": "91",
          "province-name": "AMAZONAS"
        },
        {
          "province": "94",
          "province-name": "GUAINIA"
        },
        {
          "province": "95",
          "province-name": "GUAVIARE"
        },
        {
          "province": "97",
          "province-name": "VAUPES"
        },
        {
          "province": "99",
          "province-name": "VICHADA"
        }
      ],
      "CR":[
        {
          "province": "01",
          "province-name": "San Jose"
        },
        {
          "province": "02",
          "province-name": "Heredia"
        },
        {
          "province": "03",
          "province-name": "Alajuela"
        },
        {
          "province": "04",
          "province-name": "Cartago"
        },
        {
          "province": "05",
          "province-name": "Puntarenas"
        },
        {
          "province": "06",
          "province-name": "Guanacaste"
        },
        {
          "province": "07",
          "province-name": "Guanacaste"
        },
      ],
      "CZ": [
        {
          "province": "01",
          "province-name": "Jihocesky"
        },
        {
          "province": "31",
          "province-name": "Jihočeský"
        },
        {
          "province": "02",
          "province-name": "Jihomoravsky"
        },
        {
          "province": "64",
          "province-name": "Jihomoravský"
        },
        {
          "province": "03",
          "province-name": "Praha"
        },
        {
          "province": "04",
          "province-name": "Severocesky"
        },
        {
          "province": "05",
          "province-name": "Severomoravsky"
        },
        {
          "province": "06",
          "province-name": "Stredocesky"
        },
        {
          "province": "07",
          "province-name": "Vychodocesky"
        },
        {
          "province": "08",
          "province-name": "Zapadocesky"
        },
        {
          "province": "20",
          "province-name": "Středočeský"
        },
        {
          "province": "41",
          "province-name": "Karlovarský"
        },
        {
          "province": "52",
          "province-name": "Královéhradecký"
        },
        {
          "province": "51",
          "province-name": "Liberecký"
        },
        {
          "province": "80",
          "province-name": "Moravskoslezský"
        },
        {
          "province": "71",
          "province-name": "Olomoucký"
        },
        {
          "province": "53",
          "province-name": "Pardubický"
        },
        {
          "province": "32",
          "province-name": "Plzeňský"
        },
        {
          "province": "10",
          "province-name": "Praha"
        },
        {
          "province": "42",
          "province-name": "Ústecký"
        },
        {
          "province": "63",
          "province-name": "Kraj Vysočina"
        },
        {
          "province": "72",
          "province-name": "Zlínský"
        }
      ],
      "DE": [
        {
          "province": "01",
          "province-name": "Schleswig-Holstein"
        },
        {
          "province": "02",
          "province-name": "Hamburg"
        },
        {
          "province": "03",
          "province-name": "Lower Saxony"
        },
        {
          "province": "04",
          "province-name": "Bremen"
        },
        {
          "province": "05",
          "province-name": "Nrth Rhine Westfalia"
        },
        {
          "province": "06",
          "province-name": "Hesse"
        },
        {
          "province": "07",
          "province-name": "Rhineland Palatinate"
        },
        {
          "province": "08",
          "province-name": "Baden-Wurttemberg"
        },
        {
          "province": "09",
          "province-name": "Bavaria"
        },
        {
          "province": "10",
          "province-name": "Saarland"
        },
        {
          "province": "11",
          "province-name": "Berlin"
        },
        {
          "province": "12",
          "province-name": "Brandenburg"
        },
        {
          "province": "13",
          "province-name": "Mecklenburg-Vorpomm."
        },
        {
          "province": "14",
          "province-name": "Saxony"
        },
        {
          "province": "15",
          "province-name": "Saxony-Anhalt"
        },
        {
          "province": "16",
          "province-name": "Thuringia"
        }
      ],
      "DK": [
        {
          "province": "001",
          "province-name": "Copenhagen"
        },
        {
          "province": "002",
          "province-name": "Århus amt"
        },
        {
          "province": "003",
          "province-name": "Bornholm amt"
        },
        {
          "province": "004",
          "province-name": "Frederiksborg amt"
        },
        {
          "province": "005",
          "province-name": "Fyn amt"
        },
        {
          "province": "006",
          "province-name": "København amt"
        },
        {
          "province": "007",
          "province-name": "Nordjylland amt"
        },
        {
          "province": "008",
          "province-name": "Ribe amt"
        },
        {
          "province": "009",
          "province-name": "Ringkøbing amt"
        },
        {
          "province": "010",
          "province-name": "Roskilde amt"
        },
        {
          "province": "011",
          "province-name": "Sønderjylland amt"
        },
        {
          "province": "012",
          "province-name": "Storstrøm amt"
        },
        {
          "province": "013",
          "province-name": "Vejle amt"
        },
        {
          "province": "014",
          "province-name": "Vestsjælland amt"
        },
        {
          "province": "015",
          "province-name": "Viborg amt"
        },
        {
          "province": "016",
          "province-name": "Grønlands amt"
        }
      ],
      "DO": [],
      "ES": [
        {
          "province": "01",
          "province-name": "Alava"
        },
        {
          "province": "02",
          "province-name": "Albacete"
        },
        {
          "province": "03",
          "province-name": "Alicante"
        },
        {
          "province": "04",
          "province-name": "Almeria"
        },
        {
          "province": "05",
          "province-name": "Avila"
        },
        {
          "province": "06",
          "province-name": "Badajoz"
        },
        {
          "province": "07",
          "province-name": "Baleares"
        },
        {
          "province": "08",
          "province-name": "Barcelona"
        },
        {
          "province": "09",
          "province-name": "Burgos"
        },
        {
          "province": "10",
          "province-name": "Caceres"
        },
        {
          "province": "11",
          "province-name": "Cadiz"
        },
        {
          "province": "12",
          "province-name": "Castellon"
        },
        {
          "province": "13",
          "province-name": "Ciudad Real"
        },
        {
          "province": "14",
          "province-name": "Córdoba"
        },
        {
          "province": "15",
          "province-name": "La Coruña"
        },
        {
          "province": "16",
          "province-name": "Cuenca"
        },
        {
          "province": "17",
          "province-name": "Gerona"
        },
        {
          "province": "18",
          "province-name": "Granada"
        },
        {
          "province": "19",
          "province-name": "Guadalajara"
        },
        {
          "province": "20",
          "province-name": "Guipuzcoa"
        },
        {
          "province": "21",
          "province-name": "Huelva"
        },
        {
          "province": "22",
          "province-name": "Huesca"
        },
        {
          "province": "23",
          "province-name": "Jaen"
        },
        {
          "province": "24",
          "province-name": "Leon"
        },
        {
          "province": "25",
          "province-name": "Lerida"
        },
        {
          "province": "26",
          "province-name": "La Rioja"
        },
        {
          "province": "27",
          "province-name": "Lugo"
        },
        {
          "province": "28",
          "province-name": "Madrid"
        },
        {
          "province": "M", // to accomodate Dollar/Thrifty bad data
          "province-name": "Madrid"
        },
        {
          "province": "29",
          "province-name": "Malaga"
        },
        {
          "province": "30",
          "province-name": "Murcia"
        },
        {
          "province": "31",
          "province-name": "Navarra"
        },
        {
          "province": "32",
          "province-name": "Orense"
        },
        {
          "province": "33",
          "province-name": "Asturias"
        },
        {
          "province": "34",
          "province-name": "Palencia"
        },
        {
          "province": "35",
          "province-name": "Las Palmas"
        },
        {
          "province": "36",
          "province-name": "Pontevedra"
        },
        {
          "province": "37",
          "province-name": "Salamanca"
        },
        {
          "province": "38",
          "province-name": "Sta. Cruz Tenerife"
        },
        {
          "province": "39",
          "province-name": "Cantabria"
        },
        {
          "province": "40",
          "province-name": "Segovia"
        },
        {
          "province": "41",
          "province-name": "Sevilla"
        },
        {
          "province": "42",
          "province-name": "Soria"
        },
        {
          "province": "43",
          "province-name": "Tarragona"
        },
        {
          "province": "44",
          "province-name": "Teruel"
        },
        {
          "province": "45",
          "province-name": "Toledo"
        },
        {
          "province": "46",
          "province-name": "Valencia"
        },
        {
          "province": "47",
          "province-name": "Valladolid"
        },
        {
          "province": "48",
          "province-name": "Vizcaya"
        },
        {
          "province": "49",
          "province-name": "Zamora"
        },
        {
          "province": "50",
          "province-name": "Zaragoza"
        }
      ],
      "FI": [
        {
          "province": "001",
          "province-name": "Ahvenanmaa"
        },
        {
          "province": "002",
          "province-name": "Etelä-Suomi"
        },
        {
          "province": "003",
          "province-name": "Itä-Suomi"
        },
        {
          "province": "004",
          "province-name": "Lappi"
        },
        {
          "province": "FI", // to accomodate Dollar/Thrifty bad data
          "province-name": "Lappi"
        },
        {
          "province": "005",
          "province-name": "Länsi-Suomi"
        },
        {
          "province": "006",
          "province-name": "Oulu"
        }
      ],
      "FR": [
        {
          "province": "01",
          "province-name": "Ain"
        },
        {
          "province": "02",
          "province-name": "Aisne"
        },
        {
          "province": "03",
          "province-name": "Allier"
        },
        {
          "province": "04",
          "province-name": "Alpes (Hte-Provence)"
        },
        {
          "province": "05",
          "province-name": "Alpes (Hautes)"
        },
        {
          "province": "06",
          "province-name": "Alpes-Maritimes"
        },
        {
          "province": "07",
          "province-name": "Ardèche"
        },
        {
          "province": "08",
          "province-name": "Ardennes"
        },
        {
          "province": "09",
          "province-name": "Ariège"
        },
        {
          "province": "10",
          "province-name": "Aube"
        },
        {
          "province": "11",
          "province-name": "Aude"
        },
        {
          "province": "12",
          "province-name": "Aveyron"
        },
        {
          "province": "13",
          "province-name": "Bouches-du-Rhône"
        },
        {
          "province": "14",
          "province-name": "Calvados"
        },
        {
          "province": "15",
          "province-name": "Cantal"
        },
        {
          "province": "16",
          "province-name": "Charente"
        },
        {
          "province": "17",
          "province-name": "Charente-Maritime"
        },
        {
          "province": "18",
          "province-name": "Cher"
        },
        {
          "province": "19",
          "province-name": "Corrèze"
        },
        {
          "province": "21",
          "province-name": "Côte-d'Or"
        },
        {
          "province": "22",
          "province-name": "Côtes-d'Armor"
        },
        {
          "province": "23",
          "province-name": "Creuse"
        },
        {
          "province": "24",
          "province-name": "Dordogne"
        },
        {
          "province": "25",
          "province-name": "Doubs"
        },
        {
          "province": "26",
          "province-name": "Drôme"
        },
        {
          "province": "27",
          "province-name": "Eure"
        },
        {
          "province": "28",
          "province-name": "Eure-et-Loir"
        },
        {
          "province": "29",
          "province-name": "Finistère"
        },
        {
          "province": "2A",
          "province-name": "Corse-du-Sud"
        },
        {
          "province": "2B",
          "province-name": "Corse-du-Nord"
        },
        {
          "province": "30",
          "province-name": "Gard"
        },
        {
          "province": "31",
          "province-name": "Garonne (Haute)"
        },
        {
          "province": "32",
          "province-name": "Gers"
        },
        {
          "province": "33",
          "province-name": "Gironde"
        },
        {
          "province": "34",
          "province-name": "Hérault"
        },
        {
          "province": "35",
          "province-name": "Ille-et-Vilaine"
        },
        {
          "province": "36",
          "province-name": "Indre"
        },
        {
          "province": "37",
          "province-name": "Indre-et-Loire"
        },
        {
          "province": "38",
          "province-name": "Isère"
        },
        {
          "province": "39",
          "province-name": "Jura"
        },
        {
          "province": "40",
          "province-name": "Landes"
        },
        {
          "province": "41",
          "province-name": "Loir-et-Cher"
        },
        {
          "province": "42",
          "province-name": "Loire"
        },
        {
          "province": "43",
          "province-name": "Loire (Haute)"
        },
        {
          "province": "44",
          "province-name": "Loire-Atlantique"
        },
        {
          "province": "45",
          "province-name": "Loiret"
        },
        {
          "province": "46",
          "province-name": "Lot"
        },
        {
          "province": "47",
          "province-name": "Lot-et-Garonne"
        },
        {
          "province": "48",
          "province-name": "Lozère"
        },
        {
          "province": "49",
          "province-name": "Maine-et-Loire"
        },
        {
          "province": "50",
          "province-name": "Manche"
        },
        {
          "province": "51",
          "province-name": "Marne"
        },
        {
          "province": "52",
          "province-name": "Marne (Haute)"
        },
        {
          "province": "53",
          "province-name": "Mayenne"
        },
        {
          "province": "54",
          "province-name": "Meurthe-et-Moselle"
        },
        {
          "province": "55",
          "province-name": "Meuse"
        },
        {
          "province": "56",
          "province-name": "Morbihan"
        },
        {
          "province": "57",
          "province-name": "Moselle"
        },
        {
          "province": "58",
          "province-name": "Nièvre"
        },
        {
          "province": "59",
          "province-name": "Nord"
        },
        {
          "province": "60",
          "province-name": "Oise"
        },
        {
          "province": "61",
          "province-name": "Orne"
        },
        {
          "province": "62",
          "province-name": "Pas-de-Calais"
        },
        {
          "province": "63",
          "province-name": "Puy-de-Dôme"
        },
        {
          "province": "64",
          "province-name": "Pyrénées-Atlantiques"
        },
        {
          "province": "65",
          "province-name": "Pyrénées (Hautes)"
        },
        {
          "province": "66",
          "province-name": "Pyrénées-Orientales"
        },
        {
          "province": "67",
          "province-name": "Bas-Rhin"
        },
        {
          "province": "68",
          "province-name": "Haut-Rhin"
        },
        {
          "province": "69",
          "province-name": "Rhône"
        },
        {
          "province": "70",
          "province-name": "Saône (Haute)"
        },
        {
          "province": "71",
          "province-name": "Saône-et-Loire"
        },
        {
          "province": "72",
          "province-name": "Sarthe"
        },
        {
          "province": "73",
          "province-name": "Savoie"
        },
        {
          "province": "74",
          "province-name": "Savoie (Haute)"
        },
        {
          "province": "75",
          "province-name": "Paris"
        },
        {
          "province": "76",
          "province-name": "Seine-Maritime"
        },
        {
          "province": "77",
          "province-name": "Seine-et-Marne"
        },
        {
          "province": "78",
          "province-name": "Yvelines"
        },
        {
          "province": "79",
          "province-name": "Sèvres (Deux)"
        },
        {
          "province": "80",
          "province-name": "Somme"
        },
        {
          "province": "81",
          "province-name": "Tarn"
        },
        {
          "province": "82",
          "province-name": "Tarn-et-Garonne"
        },
        {
          "province": "83",
          "province-name": "Var"
        },
        {
          "province": "84",
          "province-name": "Vaucluse"
        },
        {
          "province": "85",
          "province-name": "Vendée"
        },
        {
          "province": "86",
          "province-name": "Vienne"
        },
        {
          "province": "87",
          "province-name": "Vienne (Haute)"
        },
        {
          "province": "88",
          "province-name": "Vosges"
        },
        {
          "province": "89",
          "province-name": "Yonne"
        },
        {
          "province": "90",
          "province-name": "Territ.-de-Belfort"
        },
        {
          "province": "91",
          "province-name": "Essonne"
        },
        {
          "province": "92",
          "province-name": "Hauts-de-Seine"
        },
        {
          "province": "93",
          "province-name": "Seine-Saint-Denis"
        },
        {
          "province": "94",
          "province-name": "Val-de-Marne"
        },
        {
          "province": "95",
          "province-name": "Val-d'Oise"
        },
        {
          "province": "97",
          "province-name": "D.O.M.-T.O.M."
        },
        {
          "province": "971",
          "province-name": "Guadeloupe"
        },
        {
          "province": "972",
          "province-name": "Martinique"
        },
        {
          "province": "973",
          "province-name": "Guyane"
        },
        {
          "province": "974",
          "province-name": "Réunion"
        },
        {
          "province": "975",
          "province-name": "Saint-Pierre-et-Miq."
        },
        {
          "province": "976",
          "province-name": "Wallis-et-Futuna"
        },
        {
          "province": "99",
          "province-name": "Hors-France"
        }
      ],
      "GB": [
        {
          "province": "AM",
          "province-name": "Armagh"
        },
        {
          "province": "AR",
          "province-name": "Ards"
        },
        {
          "province": "AT",
          "province-name": "Antrim"
        },
        {
          "province": "BA",
          "province-name": "Ballymena"
        },
        {
          "province": "BB",
          "province-name": "Blackburn"
        },
        {
          "province": "BE",
          "province-name": "Bedfordshire"
        },
        {
          "province": "BF",
          "province-name": "Bracknell Forest"
        },
        {
          "province": "BH",
          "province-name": "Brighton & Hove"
        },
        {
          "province": "BK",
          "province-name": "Berkshire"
        },
        {
          "province": "BL",
          "province-name": "Belfast"
        },
        {
          "province": "BM",
          "province-name": "Bournemouth"
        },
        {
          "province": "BN",
          "province-name": "Banbridge"
        },
        {
          "province": "BO",
          "province-name": "Borders"
        },
        {
          "province": "BP",
          "province-name": "Blackpool"
        },
        {
          "province": "BR",
          "province-name": "Bristol"
        },
        {
          "province": "BS",
          "province-name": "Bath&NthEstSomerset"
        },
        {
          "province": "BU",
          "province-name": "Buckinghamshire"
        },
        {
          "province": "BY",
          "province-name": "Ballymoney"
        },
        {
          "province": "CA",
          "province-name": "Cambridgeshire"
        },
        {
          "province": "CE",
          "province-name": "Central"
        },
        {
          "province": "CG",
          "province-name": "Craigavon"
        },
        {
          "province": "CH",
          "province-name": "Cheshire"
        },
        {
          "province": "CI",
          "province-name": "Coleraine"
        },
        {
          "province": "CK",
          "province-name": "Cookstown"
        },
        {
          "province": "CL",
          "province-name": "Clwyd"
        },
        {
          "province": "CO",
          "province-name": "Cornwall"
        },
        {
          "province": "CR",
          "province-name": "Carrickfergus"
        },
        {
          "province": "CS",
          "province-name": "Castlereagh"
        },
        {
          "province": "CU",
          "province-name": "Cumbria"
        },
        {
          "province": "CV",
          "province-name": "Cleveland"
        },
        {
          "province": "DB",
          "province-name": "Derbyshire"
        },
        {
          "province": "DF",
          "province-name": "Dumfries a. Galloway"
        },
        {
          "province": "DG",
          "province-name": "Dungannon"
        },
        {
          "province": "DL",
          "province-name": "Darlington"
        },
        {
          "province": "DN",
          "province-name": "Down"
        },
        {
          "province": "DO",
          "province-name": "Dorset"
        },
        {
          "province": "DU",
          "province-name": "Durham"
        },
        {
          "province": "DV",
          "province-name": "Devon"
        },
        {
          "province": "DY",
          "province-name": "Dyfed"
        },
        {
          "province": "ER",
          "province-name": "East Riding"
        },
        {
          "province": "ES",
          "province-name": "Essex"
        },
        {
          "province": "FI",
          "province-name": "Fife"
        },
        {
          "province": "FM",
          "province-name": "Fermanagh"
        },
        {
          "province": "GL",
          "province-name": "Gloucestershire"
        },
        {
          "province": "GM",
          "province-name": "Greater Manchester"
        },
        {
          "province": "GR",
          "province-name": "Grampian"
        },
        {
          "province": "GS",
          "province-name": "Sth. Gloucestershire"
        },
        {
          "province": "GW",
          "province-name": "Gwent"
        },
        {
          "province": "GY",
          "province-name": "Gwynedd"
        },
        {
          "province": "HA",
          "province-name": "Hampshire"
        },
        {
          "province": "HI",
          "province-name": "Highland"
        },
        {
          "province": "HL",
          "province-name": "Halton"
        },
        {
          "province": "HR",
          "province-name": "Hartlepool"
        },
        {
          "province": "HT",
          "province-name": "Hertfordshire"
        },
        {
          "province": "HW",
          "province-name": "Hereford and Worcs."
        },
        {
          "province": "IW",
          "province-name": "Isle of Wight"
        },
        {
          "province": "KE",
          "province-name": "Kent"
        },
        {
          "province": "KH",
          "province-name": "Kingston-upon-Hull"
        },
        {
          "province": "LA",
          "province-name": "Lancashire"
        },
        {
          "province": "LC",
          "province-name": "Leicester City"
        },
        {
          "province": "LD",
          "province-name": "Londonderry"
        },
        {
          "province": "LE",
          "province-name": "Leicestershire"
        },
        {
          "province": "LI",
          "province-name": "Lincolnshire"
        },
        {
          "province": "LM",
          "province-name": "Limavady"
        },
        {
          "province": "LO",
          "province-name": "Greater London"
        },
        {
          "province": "LR",
          "province-name": "Larne"
        },
        {
          "province": "LS",
          "province-name": "Lisburn"
        },
        {
          "province": "LT",
          "province-name": "Lothian"
        },
        {
          "province": "LU",
          "province-name": "Luton"
        },
        {
          "province": "MA",
          "province-name": "Magherafelt"
        },
        {
          "province": "MG",
          "province-name": "Mid Glamorgan"
        },
        {
          "province": "MI",
          "province-name": "Middlesbrough"
        },
        {
          "province": "MK",
          "province-name": "Milton Keynes"
        },
        {
          "province": "MO",
          "province-name": "Moyle"
        },
        {
          "province": "MY",
          "province-name": "Merseyside"
        },
        {
          "province": "NA",
          "province-name": "Newtownabbey"
        },
        {
          "province": "NB",
          "province-name": "Newbury"
        },
        {
          "province": "NC",
          "province-name": "Nottingham City"
        },
        {
          "province": "ND",
          "province-name": "North Down"
        },
        {
          "province": "NE",
          "province-name": "NthEast Lincolnshire"
        },
        {
          "province": "NH",
          "province-name": "Northamptonshire"
        },
        {
          "province": "NK",
          "province-name": "Norfolk"
        },
        {
          "province": "NL",
          "province-name": "North Lincolnshire"
        },
        {
          "province": "NM",
          "province-name": "Newry and Mourne"
        },
        {
          "province": "NS",
          "province-name": "North Somerset"
        },
        {
          "province": "NT",
          "province-name": "Nottinghamshire"
        },
        {
          "province": "NU",
          "province-name": "Northumberland"
        },
        {
          "province": "OM",
          "province-name": "Omagh"
        },
        {
          "province": "OR",
          "province-name": "Orkney"
        },
        {
          "province": "OX",
          "province-name": "Oxfordshire"
        },
        {
          "province": "PB",
          "province-name": "Peterborough"
        },
        {
          "province": "PL",
          "province-name": "Poole"
        },
        {
          "province": "PM",
          "province-name": "Portsmouth"
        },
        {
          "province": "PO",
          "province-name": "Powys"
        },
        {
          "province": "PY",
          "province-name": "Plymouth"
        },
        {
          "province": "RD",
          "province-name": "Redcar and Cleveland"
        },
        {
          "province": "RE",
          "province-name": "Reading"
        },
        {
          "province": "RM",
          "province-name": "Rochester up. Medway"
        },
        {
          "province": "RU",
          "province-name": "Rutland"
        },
        {
          "province": "SC",
          "province-name": "Strathclyde"
        },
        {
          "province": "SD",
          "province-name": "Southend"
        },
        {
          "province": "SE",
          "province-name": "East Sussex"
        },
        {
          "province": "SG",
          "province-name": "South Glamorgan"
        },
        {
          "province": "SH",
          "province-name": "Shropshire"
        },
        {
          "province": "SK",
          "province-name": "Suffolk"
        },
        {
          "province": "SL",
          "province-name": "Shetland"
        },
        {
          "province": "SN",
          "province-name": "Stockton-on-Tees"
        },
        {
          "province": "SO",
          "province-name": "Somerset"
        },
        {
          "province": "SP",
          "province-name": "Southampton"
        },
        {
          "province": "SR",
          "province-name": "Strabane"
        },
        {
          "province": "ST",
          "province-name": "Staffordshire"
        },
        {
          "province": "SU",
          "province-name": "Slough"
        },
        {
          "province": "SW",
          "province-name": "West Sussex"
        },
        {
          "province": "SY",
          "province-name": "Surrey"
        },
        {
          "province": "TA",
          "province-name": "Tayside"
        },
        {
          "province": "TD",
          "province-name": "Thamesdown"
        },
        {
          "province": "TH",
          "province-name": "Thurrock"
        },
        {
          "province": "TO",
          "province-name": "Torbay"
        },
        {
          "province": "TW",
          "province-name": "Tyne and Wear"
        },
        {
          "province": "WA",
          "province-name": "Warwickshire"
        },
        {
          "province": "WD",
          "province-name": "Windsor & Maidenhead"
        },
        {
          "province": "WG",
          "province-name": "West Glamorgan"
        },
        {
          "province": "WI",
          "province-name": "Wiltshire"
        },
        {
          "province": "WL",
          "province-name": "Western Isles"
        },
        {
          "province": "WM",
          "province-name": "West Midlands"
        },
        {
          "province": "WO",
          "province-name": "Wokingham"
        },
        {
          "province": "WR",
          "province-name": "Wrekin"
        },
        {
          "province": "WT",
          "province-name": "Warrington"
        },
        {
          "province": "YK",
          "province-name": "York"
        },
        {
          "province": "YN",
          "province-name": "North Yorkshire"
        },
        {
          "province": "YS",
          "province-name": "South Yorkshire"
        },
        {
          "province": "YW",
          "province-name": "West Yorkshire"
        }
      ],
      "GR": [
        {
          "province": "01",
          "province-name": "Aitolia kai Akarnan."
        },
        {
          "province": "02",
          "province-name": "Akhaia"
        },
        {
          "province": "03",
          "province-name": "Argolis"
        },
        {
          "province": "04",
          "province-name": "Arkadhia"
        },
        {
          "province": "05",
          "province-name": "Arta"
        },
        {
          "province": "06",
          "province-name": "Attiki"
        },
        {
          "province": "07",
          "province-name": "Dhodhekanisos"
        },
        {
          "province": "08",
          "province-name": "Dhrama"
        },
        {
          "province": "09",
          "province-name": "Evritania"
        },
        {
          "province": "10",
          "province-name": "Evros"
        },
        {
          "province": "11",
          "province-name": "Evvoia"
        },
        {
          "province": "12",
          "province-name": "Florina"
        },
        {
          "province": "13",
          "province-name": "Fokis"
        },
        {
          "province": "14",
          "province-name": "Fthiotis"
        },
        {
          "province": "15",
          "province-name": "Grevena"
        },
        {
          "province": "16",
          "province-name": "Ilia"
        },
        {
          "province": "17",
          "province-name": "Imathia"
        },
        {
          "province": "18",
          "province-name": "Ioannina"
        },
        {
          "province": "19",
          "province-name": "Iraklion"
        },
        {
          "province": "20",
          "province-name": "Kardhitsa"
        },
        {
          "province": "21",
          "province-name": "Kastoria"
        },
        {
          "province": "22",
          "province-name": "Kavala"
        },
        {
          "province": "23",
          "province-name": "Kefallinia"
        },
        {
          "province": "24",
          "province-name": "Kerkira"
        },
        {
          "province": "25",
          "province-name": "Khalkidhiki"
        },
        {
          "province": "26",
          "province-name": "Khania"
        },
        {
          "province": "27",
          "province-name": "Khios"
        },
        {
          "province": "28",
          "province-name": "Kikladhes"
        },
        {
          "province": "29",
          "province-name": "Kilkis"
        },
        {
          "province": "30",
          "province-name": "Korinthia"
        },
        {
          "province": "31",
          "province-name": "Kozani"
        },
        {
          "province": "32",
          "province-name": "Lakonia"
        },
        {
          "province": "33",
          "province-name": "Larisa"
        },
        {
          "province": "34",
          "province-name": "Lasithi"
        },
        {
          "province": "35",
          "province-name": "Lesvos"
        },
        {
          "province": "36",
          "province-name": "Levkas"
        },
        {
          "province": "37",
          "province-name": "Magnisia"
        },
        {
          "province": "38",
          "province-name": "Messinia"
        },
        {
          "province": "39",
          "province-name": "Pella"
        },
        {
          "province": "40",
          "province-name": "Pieria"
        },
        {
          "province": "41",
          "province-name": "Piraievs"
        },
        {
          "province": "42",
          "province-name": "Preveza"
        },
        {
          "province": "43",
          "province-name": "Rethimni"
        },
        {
          "province": "44",
          "province-name": "Rodhopi"
        },
        {
          "province": "45",
          "province-name": "Samos"
        },
        {
          "province": "46",
          "province-name": "Serrai"
        },
        {
          "province": "47",
          "province-name": "Thesprotia"
        },
        {
          "province": "48",
          "province-name": "Thessaloniki"
        },
        {
          "province": "49",
          "province-name": "Trikala"
        },
        {
          "province": "50",
          "province-name": "Voiotia"
        },
        {
          "province": "51",
          "province-name": "Xanthi"
        },
        {
          "province": "52",
          "province-name": "Zakinthos"
        }
      ],
      "HK": [
        {
          "province": "HK",
          "province-name": "Hong Kong Island"
        },
        {
          "province": "KLN",
          "province-name": "Kowloon"
        },
        {
          "province": "NT",
          "province-name": "New Territories"
        }
      ],
      "HN": [
        {
          "province": "AT",
          "province-name": "Atlántida"
        },
        {
          "province": "CH",
          "province-name": "Choluteca"
        },
        {
          "province": "CL",
          "province-name": "Colón"
        },
        {
          "province": "CM",
          "province-name": "Comayagua"
        },
        {
          "province": "CP",
          "province-name": "Copán"
        },
        {
          "province": "CR",
          "province-name": "Cortés"
        },
        {
          "province": "EP",
          "province-name": "El Paraíso"
        },
        {
          "province": "FM",
          "province-name": "Francisco Morazán"
        },
        {
          "province": "GD",
          "province-name": "Gracias a Dios"
        },
        {
          "province": "IB",
          "province-name": "Islas de la Bahía"
        },
        {
          "province": "IN",
          "province-name": "Intibucá"
        },
        {
          "province": "LE",
          "province-name": "Lempira"
        },
        {
          "province": "LP",
          "province-name": "La Paz"
        },
        {
          "province": "OC",
          "province-name": "Ocotepeque"
        },
        {
          "province": "OL",
          "province-name": "Olancho"
        },
        {
          "province": "SB",
          "province-name": "Santa Bárbara"
        },
        {
          "province": "VA",
          "province-name": "Valle"
        },
        {
          "province": "YO",
          "province-name": "Yoro"
        }
      ],
      "HR": [
        {
          "province": "01",
          "province-name": "Bjelovar-Bilogora"
        },
        {
          "province": "02",
          "province-name": "Stadt Zagreb"
        },
        {
          "province": "03",
          "province-name": "Dubrovnik-Neretva"
        },
        {
          "province": "04",
          "province-name": "Istra"
        },
        {
          "province": "05",
          "province-name": "Karlovac"
        },
        {
          "province": "06",
          "province-name": "Koprivnica-Krizevci"
        },
        {
          "province": "07",
          "province-name": "Lika-Senj"
        },
        {
          "province": "08",
          "province-name": "Medimurje"
        },
        {
          "province": "09",
          "province-name": "Osijek-Baranja"
        },
        {
          "province": "10",
          "province-name": "Pozega-Slavonija"
        },
        {
          "province": "11",
          "province-name": "Primorje-Gorski Kot."
        },
        {
          "province": "12",
          "province-name": "Sibenik"
        },
        {
          "province": "13",
          "province-name": "Sisak-Moslavina"
        },
        {
          "province": "14",
          "province-name": "Slavonski"
        },
        {
          "province": "15",
          "province-name": "Brod-Posavina"
        },
        {
          "province": "16",
          "province-name": "Split-Dalmatia"
        },
        {
          "province": "17",
          "province-name": "Varazdin"
        },
        {
          "province": "18",
          "province-name": "Virovitica-Podravina"
        },
        {
          "province": "19",
          "province-name": "Vukovar-Srijem"
        },
        {
          "province": "20",
          "province-name": "Zadar-Knin"
        },
        {
          "province": "21",
          "province-name": "Zagreb"
        }
      ],
      "HU": [
        {
          "province": "01",
          "province-name": "Bacs-Kiskun"
        },
        {
          "province": "02",
          "province-name": "Baranya"
        },
        {
          "province": "03",
          "province-name": "Bekes"
        },
        {
          "province": "04",
          "province-name": "Bekescsaba"
        },
        {
          "province": "05",
          "province-name": "Borsod-Abauj-Zemplen"
        },
        {
          "province": "06",
          "province-name": "Budapest"
        },
        {
          "province": "07",
          "province-name": "Csongrad"
        },
        {
          "province": "08",
          "province-name": "Debrecen"
        },
        {
          "province": "09",
          "province-name": "Dunaujvaros"
        },
        {
          "province": "10",
          "province-name": "Eger"
        },
        {
          "province": "11",
          "province-name": "Fejer"
        },
        {
          "province": "12",
          "province-name": "Gyor"
        },
        {
          "province": "13",
          "province-name": "Gyor-Moson-Sopron"
        },
        {
          "province": "14",
          "province-name": "Hajdu-Bihar"
        },
        {
          "province": "15",
          "province-name": "Heves"
        },
        {
          "province": "16",
          "province-name": "Hodmezovasarhely"
        },
        {
          "province": "17",
          "province-name": "Jasz-Nagykun-Szolnok"
        },
        {
          "province": "18",
          "province-name": "Kaposvar"
        },
        {
          "province": "19",
          "province-name": "Kecskemet"
        },
        {
          "province": "20",
          "province-name": "Komarom-Esztergom"
        },
        {
          "province": "21",
          "province-name": "Miskolc"
        },
        {
          "province": "22",
          "province-name": "Nagykanizsa"
        },
        {
          "province": "23",
          "province-name": "Nograd"
        },
        {
          "province": "24",
          "province-name": "Nyiregyhaza"
        },
        {
          "province": "25",
          "province-name": "Pecs"
        },
        {
          "province": "26",
          "province-name": "Pest"
        },
        {
          "province": "27",
          "province-name": "Somogy"
        },
        {
          "province": "28",
          "province-name": "Sopron"
        },
        {
          "province": "29",
          "province-name": "Szabolcs-Szat.-Bereg"
        },
        {
          "province": "30",
          "province-name": "Szeged"
        },
        {
          "province": "31",
          "province-name": "Szekesfehervar"
        },
        {
          "province": "32",
          "province-name": "Szolnok"
        },
        {
          "province": "33",
          "province-name": "Szombathely"
        },
        {
          "province": "34",
          "province-name": "Tatabanya"
        },
        {
          "province": "35",
          "province-name": "Tolna"
        },
        {
          "province": "36",
          "province-name": "Vas"
        },
        {
          "province": "37",
          "province-name": "Veszprem"
        },
        {
          "province": "38",
          "province-name": "Zala"
        },
        {
          "province": "39",
          "province-name": "Zalaegerszeg"
        }
      ],
      "ID": [
        {
          "province": "01",
          "province-name": "DKI Jakarta Jakarta"
        },
        {
          "province": "02",
          "province-name": "Jawa Barat West Java"
        },
        {
          "province": "03",
          "province-name": "Jawa Tengah Central"
        },
        {
          "province": "04",
          "province-name": "Jawa Timur East Java"
        },
        {
          "province": "05",
          "province-name": "DI Yogyakarta Yogyak"
        },
        {
          "province": "06",
          "province-name": "DI Aceh Aceh"
        },
        {
          "province": "07",
          "province-name": "Sumatera Utara North"
        },
        {
          "province": "08",
          "province-name": "Sumatera Barat West"
        },
        {
          "province": "09",
          "province-name": "Riau Riau"
        },
        {
          "province": "10",
          "province-name": "Jambi Jambi"
        },
        {
          "province": "11",
          "province-name": "Sumatera Selatan Sou"
        },
        {
          "province": "12",
          "province-name": "Bengkulu Bengkulu"
        },
        {
          "province": "13",
          "province-name": "Lampung Lampung"
        },
        {
          "province": "14",
          "province-name": "Kalimantan Selatan S"
        },
        {
          "province": "15",
          "province-name": "Kalimantan Barat Wes"
        },
        {
          "province": "16",
          "province-name": "Kalimantan Tengah Ce"
        },
        {
          "province": "17",
          "province-name": "Kalimantan Timur Eas"
        },
        {
          "province": "18",
          "province-name": "Sulawesi Selatan Sou"
        },
        {
          "province": "19",
          "province-name": "Sulawesi Tenggara So"
        },
        {
          "province": "20",
          "province-name": "Sulawesi Tengah Cent"
        },
        {
          "province": "21",
          "province-name": "Sulawesi Utara North"
        },
        {
          "province": "22",
          "province-name": "Bali Bali"
        },
        {
          "province": "23",
          "province-name": "Nusa Tenggara Barat"
        },
        {
          "province": "24",
          "province-name": "Nusa Tenggara Timur"
        },
        {
          "province": "25",
          "province-name": "Maluku Maluku"
        },
        {
          "province": "26",
          "province-name": "Irian Jaya Irian Jay"
        },
        {
          "province": "27",
          "province-name": "Timor Timur East Tim"
        }
      ],
      "IE": [
        {
          "province": "CK",
          "province-name": "Cork"
        },
        {
          "province": "CL",
          "province-name": "Clare"
        },
        {
          "province": "CV",
          "province-name": "Cavan"
        },
        {
          "province": "CW",
          "province-name": "Carlow"
        },
        {
          "province": "DB",
          "province-name": "Dublin"
        },
        {
          "province": "DG",
          "province-name": "Donegal"
        },
        {
          "province": "GW",
          "province-name": "Galway"
        },
        {
          "province": "KD",
          "province-name": "Kildare"
        },
        {
          "province": "KK",
          "province-name": "Kilkenny"
        },
        {
          "province": "KY",
          "province-name": "Kerry"
        },
        {
          "province": "LF",
          "province-name": "Longford"
        },
        {
          "province": "LI",
          "province-name": "Limerick"
        },
        {
          "province": "LM",
          "province-name": "Leitrim"
        },
        {
          "province": "LS",
          "province-name": "Laois"
        },
        {
          "province": "LT",
          "province-name": "Louth"
        },
        {
          "province": "MH",
          "province-name": "Monaghan"
        },
        {
          "province": "MT",
          "province-name": "Meath"
        },
        {
          "province": "MY",
          "province-name": "Mayo"
        },
        {
          "province": "OF",
          "province-name": "Offaly"
        },
        {
          "province": "RC",
          "province-name": "Rosscommon"
        },
        {
          "province": "SG",
          "province-name": "Sligo"
        },
        {
          "province": "TP",
          "province-name": "Tipperary"
        },
        {
          "province": "WF",
          "province-name": "Waterford"
        },
        {
          "province": "WK",
          "province-name": "Wicklow"
        },
        {
          "province": "WM",
          "province-name": "Westmeath"
        },
        {
          "province": "WX",
          "province-name": "Wexford"
        }
      ],
      "IL": [
        {
          "province": "01",
          "province-name": "Central"
        },
        {
          "province": "M",
          "province-name": "Central"
        },
        {
          "province": "02",
          "province-name": "Haifa"
        },
        {
          "province": "HA",
          "province-name": "Haifa"
        },
        {
          "province": "03",
          "province-name": "Jerusalem"
        },
        {
          "province": "JM",
          "province-name": "Jerusalem"
        },
        {
          "province": "04",
          "province-name": "Northern"
        },
        {
          "province": "Z",
          "province-name": "Northern"
        },
        {
          "province": "05",
          "province-name": "Southern"
        },
        {
          "province": "D",
          "province-name": "Southern"
        },
        {
          "province": "06",
          "province-name": "Tel Aviv"
        },
        {
          "province": "TA",
          "province-name": "Tel Aviv"
        }
      ],
      "IN": [
        {
          "province": "01",
          "province-name": "Andra Pradesh"
        },
        {
          "province": "02",
          "province-name": "Arunachal Pradesh"
        },
        {
          "province": "03",
          "province-name": "Assam"
        },
        {
          "province": "04",
          "province-name": "Bihar"
        },
        {
          "province": "05",
          "province-name": "Goa"
        },
        {
          "province": "06",
          "province-name": "Gujarat"
        },
        {
          "province": "07",
          "province-name": "Haryana"
        },
        {
          "province": "08",
          "province-name": "Himachal Pradesh"
        },
        {
          "province": "09",
          "province-name": "Jammu und Kashmir"
        },
        {
          "province": "10",
          "province-name": "Karnataka"
        },
        {
          "province": "11",
          "province-name": "Kerala"
        },
        {
          "province": "12",
          "province-name": "Madhya Pradesh"
        },
        {
          "province": "13",
          "province-name": "Maharashtra"
        },
        {
          "province": "14",
          "province-name": "Manipur"
        },
        {
          "province": "15",
          "province-name": "Megalaya"
        },
        {
          "province": "16",
          "province-name": "Mizoram"
        },
        {
          "province": "17",
          "province-name": "Nagaland"
        },
        {
          "province": "18",
          "province-name": "Orissa"
        },
        {
          "province": "19",
          "province-name": "Punjab"
        },
        {
          "province": "20",
          "province-name": "Rajasthan"
        },
        {
          "province": "21",
          "province-name": "Sikkim"
        },
        {
          "province": "22",
          "province-name": "Tamil Nadu"
        },
        {
          "province": "23",
          "province-name": "Tripura"
        },
        {
          "province": "24",
          "province-name": "Uttar Pradesh"
        },
        {
          "province": "25",
          "province-name": "West Bengal"
        },
        {
          "province": "26",
          "province-name": "Andaman und Nico.In."
        },
        {
          "province": "27",
          "province-name": "Chandigarh"
        },
        {
          "province": "28",
          "province-name": "Dadra und Nagar Hav."
        },
        {
          "province": "29",
          "province-name": "Daman und Diu"
        },
        {
          "province": "30",
          "province-name": "Delhi"
        },
        {
          "province": "31",
          "province-name": "Lakshadweep"
        },
        {
          "province": "32",
          "province-name": "Pondicherry"
        },
        {
          "province": "33",
          "province-name": "Pondicherry"
        },
        {
          "province": "34",
          "province-name": ""
        },
        {
          "province": "35",
          "province-name": ""
        }
      ],
      "IT": [
        {
          "province": "AG",
          "province-name": "Agriento"
        },
        {
          "province": "AL",
          "province-name": "Alessandria"
        },
        {
          "province": "AN",
          "province-name": "Ancona"
        },
        {
          "province": "AO",
          "province-name": "Aosta"
        },
        {
          "province": "AP",
          "province-name": "Ascoli Piceno"
        },
        {
          "province": "AQ",
          "province-name": "L'Aquila"
        },
        {
          "province": "AR",
          "province-name": "Arezzo"
        },
        {
          "province": "AT",
          "province-name": "Asti"
        },
        {
          "province": "AV",
          "province-name": "Avellino"
        },
        {
          "province": "BA",
          "province-name": "Bari"
        },
        {
          "province": "BG",
          "province-name": "Bergamo"
        },
        {
          "province": "BI",
          "province-name": "Biella"
        },
        {
          "province": "BL",
          "province-name": "Belluno"
        },
        {
          "province": "BN",
          "province-name": "Benevento"
        },
        {
          "province": "BO",
          "province-name": "Bologna"
        },
        {
          "province": "BR",
          "province-name": "Brindisi"
        },
        {
          "province": "BS",
          "province-name": "Brescia"
        },
        {
          "province": "BZ",
          "province-name": "Bolzano"
        },
        {
          "province": "CA",
          "province-name": "Cagliari"
        },
        {
          "province": "CB",
          "province-name": "Campobasso"
        },
        {
          "province": "CE",
          "province-name": "Caserta"
        },
        {
          "province": "CH",
          "province-name": "Chieti"
        },
        {
          "province": "CL",
          "province-name": "Caltanisetta"
        },
        {
          "province": "CN",
          "province-name": "Cuneo"
        },
        {
          "province": "CO",
          "province-name": "Como"
        },
        {
          "province": "CR",
          "province-name": "Cremona"
        },
        {
          "province": "CS",
          "province-name": "Cosenza"
        },
        {
          "province": "CT",
          "province-name": "Catania"
        },
        {
          "province": "CZ",
          "province-name": "Catanzaro"
        },
        {
          "province": "EN",
          "province-name": "Enna"
        },
        {
          "province": "FE",
          "province-name": "Ferrara"
        },
        {
          "province": "FG",
          "province-name": "Foggia"
        },
        {
          "province": "FI",
          "province-name": "Florence"
        },
        {
          "province": "FO",
          "province-name": "Forlì"
        },
        {
          "province": "FR",
          "province-name": "Frosinone"
        },
        {
          "province": "GE",
          "province-name": "Genova"
        },
        {
          "province": "GO",
          "province-name": "Gorizia"
        },
        {
          "province": "GR",
          "province-name": "Grosseto"
        },
        {
          "province": "IM",
          "province-name": "Imperia"
        },
        {
          "province": "IS",
          "province-name": "Isernia"
        },
        {
          "province": "KR",
          "province-name": "Crotone"
        },
        {
          "province": "LC",
          "province-name": "Lecco"
        },
        {
          "province": "LE",
          "province-name": "Lecce"
        },
        {
          "province": "LI",
          "province-name": "Livorno"
        },
        {
          "province": "LO",
          "province-name": "Lodi"
        },
        {
          "province": "LT",
          "province-name": "Latina"
        },
        {
          "province": "LU",
          "province-name": "Lucca"
        },
        {
          "province": "MC",
          "province-name": "Macerata"
        },
        {
          "province": "ME",
          "province-name": "Messina"
        },
        {
          "province": "MI",
          "province-name": "Milan"
        },
        {
          "province": "MN",
          "province-name": "Mantova"
        },
        {
          "province": "MO",
          "province-name": "Modena"
        },
        {
          "province": "MS",
          "province-name": "Massa Carrara"
        },
        {
          "province": "MT",
          "province-name": "Matera"
        },
        {
          "province": "NA",
          "province-name": "Naples"
        },
        {
          "province": "NO",
          "province-name": "Novara"
        },
        {
          "province": "NU",
          "province-name": "Nuoro"
        },
        {
          "province": "OR",
          "province-name": "Oristano"
        },
        {
          "province": "PA",
          "province-name": "Palermo"
        },
        {
          "province": "PC",
          "province-name": "Piacenza"
        },
        {
          "province": "PD",
          "province-name": "Padova"
        },
        {
          "province": "PE",
          "province-name": "Pescara"
        },
        {
          "province": "PG",
          "province-name": "Perugia"
        },
        {
          "province": "PI",
          "province-name": "Pisa"
        },
        {
          "province": "PN",
          "province-name": "Pordenone"
        },
        {
          "province": "PO",
          "province-name": "Prato"
        },
        {
          "province": "PR",
          "province-name": "Parma"
        },
        {
          "province": "PS",
          "province-name": "Pesaro"
        },
        {
          "province": "PT",
          "province-name": "Pistoia"
        },
        {
          "province": "PU",
          "province-name": "Pesaro-Urbino"
        },
        {
          "province": "PV",
          "province-name": "Pavia"
        },
        {
          "province": "PZ",
          "province-name": "Potenza"
        },
        {
          "province": "RA",
          "province-name": "Ravenna"
        },
        {
          "province": "RC",
          "province-name": "Reggio Calabria"
        },
        {
          "province": "RE",
          "province-name": "Reggio Emilia"
        },
        {
          "province": "RG",
          "province-name": "Ragusa"
        },
        {
          "province": "RI",
          "province-name": "Rieti"
        },
        {
          "province": "RM",
          "province-name": "Rome"
        },
        {
          "province": "RN",
          "province-name": "Rimini"
        },
        {
          "province": "RO",
          "province-name": "Rovigo"
        },
        {
          "province": "RV",
          "province-name": "Rovigo"
        },
        {
          "province": "SA",
          "province-name": "Salerno"
        },
        {
          "province": "SI",
          "province-name": "Siena"
        },
        {
          "province": "SO",
          "province-name": "Sondrio"
        },
        {
          "province": "SP",
          "province-name": "La Spezia"
        },
        {
          "province": "SR",
          "province-name": "Siracusa"
        },
        {
          "province": "SS",
          "province-name": "Sassari"
        },
        {
          "province": "SV",
          "province-name": "Savona"
        },
        {
          "province": "TA",
          "province-name": "Taranto"
        },
        {
          "province": "TE",
          "province-name": "Teramo"
        },
        {
          "province": "TN",
          "province-name": "Trento"
        },
        {
          "province": "TO",
          "province-name": "Turin"
        },
        {
          "province": "TP",
          "province-name": "Trapani"
        },
        {
          "province": "TR",
          "province-name": "Terni"
        },
        {
          "province": "TS",
          "province-name": "Trieste"
        },
        {
          "province": "TV",
          "province-name": "Treviso"
        },
        {
          "province": "UD",
          "province-name": "Udine"
        },
        {
          "province": "VA",
          "province-name": "Varese"
        },
        {
          "province": "VC",
          "province-name": "Vercelli"
        },
        {
          "province": "VE",
          "province-name": "Venice"
        },
        {
          "province": "VI",
          "province-name": "Vicenza"
        },
        {
          "province": "VR",
          "province-name": "Verona"
        },
        {
          "province": "VT",
          "province-name": "Viterbo"
        },
        {
          "province": "VV",
          "province-name": "Vibo Valentia"
        }
      ],
      "JP": [
        {
          "province": "01",
          "province-name": "Hokkaido"
        },
        {
          "province": "02",
          "province-name": "Aomori"
        },
        {
          "province": "03",
          "province-name": "Iwate"
        },
        {
          "province": "04",
          "province-name": "Miyagi"
        },
        {
          "province": "05",
          "province-name": "Akita"
        },
        {
          "province": "06",
          "province-name": "Yamagata"
        },
        {
          "province": "07",
          "province-name": "Fukushima"
        },
        {
          "province": "08",
          "province-name": "Ibaraki"
        },
        {
          "province": "09",
          "province-name": "Tochigi"
        },
        {
          "province": "10",
          "province-name": "Gunma"
        },
        {
          "province": "11",
          "province-name": "Saitama"
        },
        {
          "province": "12",
          "province-name": "Chiba"
        },
        {
          "province": "13",
          "province-name": "Tokyo"
        },
        {
          "province": "14",
          "province-name": "Kanagawa"
        },
        {
          "province": "15",
          "province-name": "Niigata"
        },
        {
          "province": "16",
          "province-name": "Toyama"
        },
        {
          "province": "17",
          "province-name": "Ishikawa"
        },
        {
          "province": "18",
          "province-name": "Fukui"
        },
        {
          "province": "19",
          "province-name": "Yamanashi"
        },
        {
          "province": "20",
          "province-name": "Nagano"
        },
        {
          "province": "21",
          "province-name": "Gifu"
        },
        {
          "province": "22",
          "province-name": "Shizuoka"
        },
        {
          "province": "23",
          "province-name": "Aichi"
        },
        {
          "province": "24",
          "province-name": "Mie"
        },
        {
          "province": "25",
          "province-name": "Shiga"
        },
        {
          "province": "26",
          "province-name": "Kyoto"
        },
        {
          "province": "27",
          "province-name": "Osaka"
        },
        {
          "province": "28",
          "province-name": "Hyogo"
        },
        {
          "province": "29",
          "province-name": "Nara"
        },
        {
          "province": "30",
          "province-name": "Wakayama"
        },
        {
          "province": "31",
          "province-name": "Tottori"
        },
        {
          "province": "32",
          "province-name": "Shimane"
        },
        {
          "province": "33",
          "province-name": "Okayama"
        },
        {
          "province": "34",
          "province-name": "Hiroshima"
        },
        {
          "province": "35",
          "province-name": "Yamaguchi"
        },
        {
          "province": "36",
          "province-name": "Tokushima"
        },
        {
          "province": "37",
          "province-name": "Kagawa"
        },
        {
          "province": "38",
          "province-name": "Ehime"
        },
        {
          "province": "39",
          "province-name": "Kochi"
        },
        {
          "province": "40",
          "province-name": "Fukuoka"
        },
        {
          "province": "41",
          "province-name": "Saga"
        },
        {
          "province": "42",
          "province-name": "Nagasaki"
        },
        {
          "province": "43",
          "province-name": "Kumamoto"
        },
        {
          "province": "44",
          "province-name": "Oita"
        },
        {
          "province": "45",
          "province-name": "Miyazaki"
        },
        {
          "province": "46",
          "province-name": "Kagoshima"
        },
        {
          "province": "47",
          "province-name": "Okinawa"
        }
      ],
      "KN": [],
      "KR": [
        {
          "province": "01",
          "province-name": "Cheju-do"
        },
        {
          "province": "02",
          "province-name": "Cholla-bukto"
        },
        {
          "province": "03",
          "province-name": "Cholla-namdo"
        },
        {
          "province": "04",
          "province-name": "Ch´ungch´ong-bukto"
        },
        {
          "province": "05",
          "province-name": "Ch´ungch´ong-namdo"
        },
        {
          "province": "06",
          "province-name": "Inch´on-jikhalsi"
        },
        {
          "province": "07",
          "province-name": "Kangwon-do"
        },
        {
          "province": "08",
          "province-name": "Kwangju-jikhalsi"
        },
        {
          "province": "09",
          "province-name": "Kyonggi-do"
        },
        {
          "province": "10",
          "province-name": "Kyongsang-bukto"
        },
        {
          "province": "11",
          "province-name": "Kyongsang-namdo"
        },
        {
          "province": "12",
          "province-name": "Pusan-jikhalsi"
        },
        {
          "province": "13",
          "province-name": "Soul-t´ukpyolsi"
        },
        {
          "province": "14",
          "province-name": "Taegu-jikhalsi"
        },
        {
          "province": "15",
          "province-name": "Taejon-jikhalsi"
        }
      ],
      "KZ": [
        {
          "province": "00",
          "province-name": "Almatynskaia"
        },
        {
          "province": "01",
          "province-name": "Kostanaiskaia"
        },
        {
          "province": "02",
          "province-name": "Severo-Kazakhstansk"
        },
        {
          "province": "03",
          "province-name": "Pavlodarskaia"
        },
        {
          "province": "04",
          "province-name": "Akmolinskaia"
        },
        {
          "province": "05",
          "province-name": "Aktubinskaia"
        },
        {
          "province": "06",
          "province-name": "Atyrauskaia"
        },
        {
          "province": "07",
          "province-name": "Zapadno-Kazakhst"
        },
        {
          "province": "08",
          "province-name": "Mangystayskaia"
        },
        {
          "province": "09",
          "province-name": "Karagandinskaia"
        },
        {
          "province": "10",
          "province-name": "Vostochno-Kazakhstan"
        },
        {
          "province": "11",
          "province-name": "Gambilskaia"
        },
        {
          "province": "12",
          "province-name": "Kyzilordinskaia"
        }
      ],
      "KW": [
        {
          "province": "AH",
          "province-name": "Al Aḩmadī"
        },
        {
          "province": "FA",
          "province-name": "Al Farwānīyah"
        },
        {
          "province": "JA",
          "province-name": "Al Jahrā’"
        },
        {
          "province": "KU",
          "province-name": "Al ‘Āşimah"
        },
        {
          "province": "HA",
          "province-name": "Ḩawallī"
        },
        {
          "province": "MU",
          "province-name": "Mubārak al Kabīr"
        }
      ],
      "LT": [],
      "LU": [
        {
          "province": "CA",
          "province-name": "Capellen"
        },
        {
          "province": "CL",
          "province-name": "Clervaux"
        },
        {
          "province": "DI",
          "province-name": "Diekirch"
        },
        {
          "province": "EC",
          "province-name": "Echternach"
        },
        {
          "province": "ES",
          "province-name": "Esch-sur-Alzette"
        },
        {
          "province": "GR",
          "province-name": "Grevenmacher"
        },
        {
          "province": "LU",
          "province-name": "Luxembourg"
        },
        {
          "province": "ME",
          "province-name": "Mersch"
        },
        {
          "province": "RD",
          "province-name": "Redange"
        },
        {
          "province": "RM",
          "province-name": "Remich"
        },
        {
          "province": "VD",
          "province-name": "Vianden"
        },
        {
          "province": "WI",
          "province-name": "Wiltz"
        }
      ],
      "MA": [
        {
          "province": "AGD",
          "province-name": "Agadir"
        },
        {
          "province":  "AOU", 
          "province-name": "Aousserd "
        },
        {
          "province":  "ASZ", 
          "province-name": "Assa-Zag "
        },
        {
          "province":  "AZI", 
          "province-name": "Azilal"
        },
        {
          "province":  "BEM", 
          "province-name": "Béni Mellal"
        },
        {
          "province":  "BES", 
          "province-name": "Benslimane"
        },
        {
          "province":  "BER", 
          "province-name": "Berkane"
        },
        {
          "province":  "BRR", 
          "province-name": "Berrechid"
        },
        {
          "province":  "BOD", 
          "province-name": "Boujdour "
        },
        {
          "province":  "BOM", 
          "province-name": "Boulemane"
        },
        {
          "province":  "CAS", 
          "province-name": "Casablanca "
        },
        {
          "province":  "CHE", 
          "province-name": "Chefchaouen"
        },
        {
          "province":  "CHI", 
          "province-name": "Chichaoua"
        },
        {
          "province":  "CHT", 
          "province-name": "Chtouka-Ait Baha"
        },
        {
          "province":  "DRI", 
          "province-name": "Driouch"
        },
        {
          "province":  "ERR", 
          "province-name": "Errachidia"
        },
        {
          "province":  "ESM", 
          "province-name": "Es-Semara "
        },
        {
          "province":  "ESI", 
          "province-name": "Essaouira"
        },
        {
          "province":  "FAH", 
          "province-name": "Fahs-Anjra"
        },
        {
          "province":  "FES", 
          "province-name": "Fès"
        },
        {
          "province":  "FIG", 
          "province-name": "Figuig"
        },
        {
          "province":  "FQH", 
          "province-name": "Fquih Ben Salah"
        },
        {
          "province":  "GUE", 
          "province-name": "Guelmim"
        },
        {
          "province":  "GUF", 
          "province-name": "Guercif"
        },
        {
          "province":  "HAJ", 
          "province-name": "El Hajeb"
        },
        {
          "province":  "HAO", 
          "province-name": "Al Haouz"
        },
        {
          "province":  "HOC", 
          "province-name": "Al Hoceïma"
        },
        {
          "province":  "IFR", 
          "province-name": "Ifrane"
        },
        {
          "province":  "INE", 
          "province-name": "Inezgane-Ait Melloul"
        },
        {
          "province":  "JDI", 
          "province-name": "El Jadida"
        },
        {
          "province":  "JRA", 
          "province-name": "Jerada"
        },
        {
          "province":  "KES", 
          "province-name": "El Kelâa des Sraghna"
        },
        {
          "province":  "KEN", 
          "province-name": "Kénitra"
        },
        {
          "province":  "KHE", 
          "province-name": "Khemisset"
        },
        {
          "province":  "KHN", 
          "province-name": "Khenifra"
        },
        {
          "province":  "KHO", 
          "province-name": "Khouribga"
        },
        {
          "province":  "LAA", 
          "province-name": "Laâyoune "
        },
        {
          "province":  "LAR", 
          "province-name": "Larache"
        },
        {
          "province":  "MAR", 
          "province-name": "Marrakech"
        },
        {
          "province":  "MDF", 
          "province-name": "M’diq-Fnideq"
        },
        {
          "province":  "MED", 
          "province-name": "Médiouna"
        },
        {
          "province":  "MEK", 
          "province-name": "Meknès"
        },
        {
          "province":  "MID", 
          "province-name": "Midelt"
        },
        {
          "province":  "MOH", 
          "province-name": "Mohammadia"
        },
        {
          "province":  "MOU", 
          "province-name": "Moulay Yacoub"
        },
        {
          "province":  "NAD", 
          "province-name": "Nador"
        },
        {
          "province":  "NOU", 
          "province-name": "Nouaceur"
        },
        {
          "province":  "OUA", 
          "province-name": "Ouarzazate"
        },
        {
          "province":  "OUD", 
          "province-name": "Oued Ed-Dahab "
        },
        {
          "province":  "OUZ", 
          "province-name": "Ouezzane"
        },
        {
          "province":  "OUJ", 
          "province-name": "Oujda-Angad"
        },
        {
          "province":  "RAB", 
          "province-name": "Rabat"
        },
        {
          "province":  "REH", 
          "province-name": "Rehamna"
        },
        {
          "province":  "SAF", 
          "province-name": "Safi"
        },
        {
          "province":  "SAL", 
          "province-name": "Salé"
        },
        {
          "province":  "SEF", 
          "province-name": "Sefrou"
        },
        {
          "province":  "SET", 
          "province-name": "Settat"
        },
        {
          "province":  "SIB", 
          "province-name": "Sidi Bennour"
        },
        {
          "province":  "SIF", 
          "province-name": "Sidi Ifni"
        },
        {
          "province":  "SIK", 
          "province-name": "Sidi Kacem"
        },
        {
          "province":  "SIL", 
          "province-name": "Sidi Slimane"
        },
        {
          "province":  "SKH", 
          "province-name": "Skhirate-Témara"
        },
        {
          "province":  "TNT", 
          "province-name": "Tan-Tan "
        },
        {
          "province":  "TNG", 
          "province-name": "Tanger-Assilah"
        },
        {
          "province":  "TAO", 
          "province-name": "Taounate"
        },
        {
          "province":  "TAI", 
          "province-name": "Taourirt"
        },
        {
          "province":  "TAF", 
          "province-name": "Tarfaya "
        },
        {
          "province":  "TAR", 
          "province-name": "Taroudant"
        },
        {
          "province":  "TAT", 
          "province-name": "Tata"
        },
        {
          "province":  "TAZ", 
          "province-name": "Taza"
        },
        {
          "province":  "TET", 
          "province-name": "Tétouan"
        },
        {
          "province":  "TIN", 
          "province-name": "Tinghir"
        },
        {
          "province":  "TIZ", 
          "province-name": "Tiznit"
        },
        {
          "province":  "YUS", 
          "province-name": "Youssoufia"
        },
        {
          "province":  "ZAG", 
          "province-name": "Zagora"
        },          
      ],
      "MT": [],
      "MX": [
        {
          "province": "AGS",
          "province-name": "Aguascalientes"
        },
        {
          "province": "AGU",
          "province-name": "Aguascalientes"
        },
        {
          "province": "BCN",
          "province-name": "Baja California (N)"
        },
        {
          "province": "BCS",
          "province-name": "Baja California Sur"
        },
        {
          "province": "CAM",
          "province-name": "Campeche"
        },
        {
          "province": "CHH",
          "province-name": "Chihuahua"
        },
        {
          "province": "CHI",
          "province-name": "Chihuahua"
        },
        {
          "province": "CHP",
          "province-name": "Chiapas"
        },
        {
          "province": "CHS",
          "province-name": "Chiapas"
        },
        {
          "province": "CMP",
          "province-name": "Campeche"
        },
        {
          "province": "COA",
          "province-name": "Coahuila"
        },
        {
          "province": "COL",
          "province-name": "Colima"
        },
        {
          "province": "DF",
          "province-name": "Distrito Federal"
        },
        {
          "province": "DGO",
          "province-name": "Durango"
        },
        {
          "province": "DIF",
          "province-name": "Distrito Federal"
        },
        {
          "province": "DUR",
          "province-name": "Durango"
        },
        {
          "province": "GRO",
          "province-name": "Guerrero"
        },
        {
          "province": "GTO",
          "province-name": "Guanajuato"
        },
        {
          "province": "GUA",
          "province-name": "Guanajuato"
        },
        {
          "province": "HGO",
          "province-name": "Hidalgo"
        },
        {
          "province": "HID",
          "province-name": "Hidalgo"
        },
        {
          "province": "JAL",
          "province-name": "Jalisco"
        },
        {
          "province": "MCH",
          "province-name": "Michoacán"
        },
        {
          "province": "MEX",
          "province-name": "Estado de México"
        },
        {
          "province": "MIC",
          "province-name": "Michoacán"
        },
        {
          "province": "MOR",
          "province-name": "Morelos"
        },
        {
          "province": "NAY",
          "province-name": "Nayarit"
        },
        {
          "province": "NL",
          "province-name": "Nuevo Léon"
        },
        {
          "province": "NLE",
          "province-name": "Nuevo Léon"
        },
        {
          "province": "OAX",
          "province-name": "Oaxaca"
        },
        {
          "province": "PUE",
          "province-name": "Puebla"
        },
        {
          "province": "QR",
          "province-name": "Quintana Roo"
        },
        {
          "province": "QRO",
          "province-name": "Querétaro"
        },
        {
          "province": "QUE",
          "province-name": "Querétaro"
        },
        {
          "province": "ROO",
          "province-name": "Quintana Roo"
        },
        {
          "province": "SIN",
          "province-name": "Sinaloa"
        },
        {
          "province": "SLP",
          "province-name": "San Luis Potosí"
        },
        {
          "province": "SON",
          "province-name": "Sonora"
        },
        {
          "province": "TAB",
          "province-name": "Tabasco"
        },
        {
          "province": "TAM",
          "province-name": "Tamaulipas"
        },
        {
          "province": "TLA",
          "province-name": "Tlaxcala"
        },
        {
          "province": "TLX",
          "province-name": "Tlaxcala"
        },
        {
          "province": "TMS",
          "province-name": "Tamaulipas"
        },
        {
          "province": "VER",
          "province-name": "Veracruz"
        },
        {
          "province": "YUC",
          "province-name": "Yucatán"
        },
        {
          "province": "ZAC",
          "province-name": "Zacatecas"
        }
      ],
      "MY": [
        {
          "province": "JOH",
          "province-name": "Johor"
        },
        {
          "province": "KED",
          "province-name": "Kedah"
        },
        {
          "province": "KEL",
          "province-name": "Kelantan"
        },
        {
          "province": "KUL",
          "province-name": "Kuala Lumpur"
        },
        {
          "province": "LAB",
          "province-name": "Labuan"
        },
        {
          "province": "MEL",
          "province-name": "Melaka"
        },
        {
          "province": "PAH",
          "province-name": "Pahang"
        },
        {
          "province": "PEL",
          "province-name": "Perlis"
        },
        {
          "province": "PER",
          "province-name": "Perak"
        },
        {
          "province": "PIN",
          "province-name": "Pulau Pinang"
        },
        {
          "province": "SAB",
          "province-name": "Sabah"
        },
        {
          "province": "SAR",
          "province-name": "Sarawak"
        },
        {
          "province": "SEL",
          "province-name": "Selangor"
        },
        {
          "province": "SER",
          "province-name": "Negeri Sembilan"
        },
        {
          "province": "TRE",
          "province-name": "Trengganu"
        }
      ],
      "NA": [
        {
          "province": "ER",
          "province-name": "Erongo"
        },
        {
          "province": "HA",
          "province-name": "Hardap"
        },
        {
          "province": "KA",
          "province-name": "Karas"
        },
        {
          "province": "KE",
          "province-name": "Kavango East"
        },
        {
          "province": "KW",
          "province-name": "Kavango West"
        },
        {
          "province": "KH",
          "province-name": "Khomas"
        },
        {
          "province": "KU",
          "province-name": "Kunene"
        },
        {
          "province": "OW",
          "province-name": "Ohangwena"
        },
        {
          "province": "OH",
          "province-name": "Omaheke"
        },
        {
          "province": "OS",
          "province-name": "Omusati"
        },
        {
          "province": "ON",
          "province-name": "Oshana"
        },
        {
          "province": "OT",
          "province-name": "Oshikoto"
        },
        {
          "province": "OD",
          "province-name": "Otjozondjupa"
        },
        {
          "province": "CA",
          "province-name": "Zambezi"
        }
      ],
      "NI": [],
      "NL": [
        {
          "province": "01",
          "province-name": "Drenthe"
        },
        {
          "province": "02",
          "province-name": "Flevoland"
        },
        {
          "province": "03",
          "province-name": "Friesland"
        },
        {
          "province": "04",
          "province-name": "Gelderland"
        },
        {
          "province": "05",
          "province-name": "Groningen"
        },
        {
          "province": "06",
          "province-name": "Limburg"
        },
        {
          "province": "07",
          "province-name": "Noord-Brabant"
        },
        {
          "province": "08",
          "province-name": "Noord-Holland"
        },
        {
          "province": "09",
          "province-name": "Overijssel"
        },
        {
          "province": "10",
          "province-name": "Utrecht"
        },
        {
          "province": "11",
          "province-name": "Zeeland"
        },
        {
          "province": "12",
          "province-name": "Zuid-Holland"
        }
      ],
      "NO": [
        {
          "province": "01",
          "province-name": "Østfold Fylke"
        },
        {
          "province": "02",
          "province-name": "Akershus Fylke"
        },
        {
          "province": "03",
          "province-name": "Oslo"
        },
        {
          "province": "04",
          "province-name": "Hedmark Fylke"
        },
        {
          "province": "05",
          "province-name": "Oppland Fylke"
        },
        {
          "province": "06",
          "province-name": "Buskerud Fylke"
        },
        {
          "province": "07",
          "province-name": "Vestfold Fylke"
        },
        {
          "province": "08",
          "province-name": "Telemark Fylke"
        },
        {
          "province": "09",
          "province-name": "Aust-Agder Fylke"
        },
        {
          "province": "10",
          "province-name": "Vest-Agder Fylke"
        },
        {
          "province": "11",
          "province-name": "Rogaland Fylke"
        },
        {
          "province": "12",
          "province-name": "Hordaland Fylke"
        },
        {
          "province": "14",
          "province-name": "Sogn og Fjordane F."
        },
        {
          "province": "15",
          "province-name": "Møre og Romsdal F."
        },
        {
          "province": "16",
          "province-name": "Sør-Trøndelag Fylke"
        },
        {
          "province": "17",
          "province-name": "Nord-Trøndelag Fylke"
        },
        {
          "province": "18",
          "province-name": "Nordland Fylke"
        },
        {
          "province": "19",
          "province-name": "Troms Fylke"
        },
        {
          "province": "20",
          "province-name": "Finnmark Fylke"
        }
      ],
      "NZ": [
        {
          "province": "AKL",
          "province-name": "Auckland"
        },
        {
          "province": "BOP",
          "province-name": "Bay of Plenty"
        },
        {
          "province": "CAN",
          "province-name": "Canterbury"
        },
        {
          "province": "HAB",
          "province-name": "Hawke´s Bay"
        },
        {
          "province": "MAN",
          "province-name": "Manawatu-Wanganui"
        },
        {
          "province": "NTL",
          "province-name": "Northland"
        },
        {
          "province": "OTA",
          "province-name": "Otago"
        },
        {
          "province": "STL",
          "province-name": "Southland"
        },
        {
          "province": "TAR",
          "province-name": "Taranaki"
        },
        {
          "province": "WAI",
          "province-name": "Waikato"
        },
        {
          "province": "WEC",
          "province-name": "West Coast"
        },
        {
          "province": "WLG",
          "province-name": "Wellington"
        }
      ],
      "OM": [
        {
          "province": "DA",
          "province-name": "Ad Dākhilīyah"
        },
        {
          "province": "BS",
          "province-name": "Shamāl al Bāţinah"
        },
        {
          "province": "BJ",
          "province-name": "Janūb al Bāţinah"
        },
        {
          "province": "WU",
          "province-name": "Al Wusţá"
        },
        {
          "province": "SS",
          "province-name": "Shamāl ash Sharqīyah"
        },
        {
          "province": "SJ",
          "province-name": "Janūb ash Sharqīyah"
        },
        {
          "province": "ZA",
          "province-name": "Az̧ Z̧āhirah"
        },
        {
          "province": "BU",
          "province-name": "Al Buraymī"
        },
        {
          "province": "MA",
          "province-name": "Masqaţ"
        },
        {
          "province": "MU",
          "province-name": "Musandam"
        },
        {
          "province": "ZU",
          "province-name": "Z̧ufār"
        }
      ],
      "PA": [],
      "PE": [
        {
          "province": "01",
          "province-name": "Tumbes"
        },
        {
          "province": "02",
          "province-name": "Piura"
        },
        {
          "province": "03",
          "province-name": "Lambayeque"
        },
        {
          "province": "04",
          "province-name": "La Libertad"
        },
        {
          "province": "05",
          "province-name": "Ancash"
        },
        {
          "province": "06",
          "province-name": "Lima y Callao"
        },
        {
          "province": "07",
          "province-name": "Ica"
        },
        {
          "province": "08",
          "province-name": "Arequipa"
        },
        {
          "province": "09",
          "province-name": "Moquegua"
        },
        {
          "province": "10",
          "province-name": "Tacna"
        },
        {
          "province": "11",
          "province-name": "Amazon"
        },
        {
          "province": "12",
          "province-name": "Cajamarca"
        },
        {
          "province": "13",
          "province-name": "San Martín"
        },
        {
          "province": "14",
          "province-name": "Huánuco"
        },
        {
          "province": "15",
          "province-name": "Pasco"
        },
        {
          "province": "16",
          "province-name": "Junín"
        },
        {
          "province": "17",
          "province-name": "Huancavelica"
        },
        {
          "province": "18",
          "province-name": "Ayacucho"
        },
        {
          "province": "19",
          "province-name": "Apurimac"
        },
        {
          "province": "20",
          "province-name": "Cuzco"
        },
        {
          "province": "21",
          "province-name": "Puno"
        },
        {
          "province": "22",
          "province-name": "Loreto"
        },
        {
          "province": "23",
          "province-name": "Ucayali"
        },
        {
          "province": "24",
          "province-name": "Madre de Díos"
        }
      ],
      "PH": [
        {
          "province": "01",
          "province-name": "Ilocos"
        },
        {
          "province": "02",
          "province-name": "Cagayan Valley"
        },
        {
          "province": "03",
          "province-name": "Central Luzon"
        },
        {
          "province": "04",
          "province-name": "South Luzon"
        },
        {
          "province": "05",
          "province-name": "Bicol"
        },
        {
          "province": "06",
          "province-name": "West Visayas"
        },
        {
          "province": "07",
          "province-name": "Central Visayas"
        },
        {
          "province": "08",
          "province-name": "Eastern Visayas"
        },
        {
          "province": "09",
          "province-name": "Western Mindanao"
        },
        {
          "province": "10",
          "province-name": "Northern Mindanao"
        },
        {
          "province": "11",
          "province-name": "Central Mindanao"
        },
        {
          "province": "12",
          "province-name": "South Mindanao"
        }
      ],
      "PL": [
        {
          "province": "01",
          "province-name": "Biala Podlaska"
        },
        {
          "province": "02",
          "province-name": "Bialystok"
        },
        {
          "province": "03",
          "province-name": "Bielsko Biala"
        },
        {
          "province": "04",
          "province-name": "Bydgoszcz"
        },
        {
          "province": "05",
          "province-name": "Chelm"
        },
        {
          "province": "06",
          "province-name": "Ciechanow"
        },
        {
          "province": "07",
          "province-name": "Czestochowa"
        },
        {
          "province": "08",
          "province-name": "Elblag"
        },
        {
          "province": "09",
          "province-name": "Gdansk"
        },
        {
          "province": "10",
          "province-name": "Gorzow"
        },
        {
          "province": "11",
          "province-name": "Jelenia Gora"
        },
        {
          "province": "12",
          "province-name": "Kalisz"
        },
        {
          "province": "13",
          "province-name": "Katowice"
        },
        {
          "province": "14",
          "province-name": "Kielce"
        },
        {
          "province": "15",
          "province-name": "Konin"
        },
        {
          "province": "16",
          "province-name": "Koszalin"
        },
        {
          "province": "17",
          "province-name": "Krakow"
        },
        {
          "province": "18",
          "province-name": "Krosno"
        },
        {
          "province": "19",
          "province-name": "Legnica"
        },
        {
          "province": "20",
          "province-name": "Leszno"
        },
        {
          "province": "21",
          "province-name": "Lodz"
        },
        {
          "province": "22",
          "province-name": "Lomza"
        },
        {
          "province": "23",
          "province-name": "Lublin"
        },
        {
          "province": "24",
          "province-name": "Nowy Sacz"
        },
        {
          "province": "25",
          "province-name": "Olsztyn"
        },
        {
          "province": "26",
          "province-name": "Opole"
        },
        {
          "province": "27",
          "province-name": "Ostroleka"
        },
        {
          "province": "28",
          "province-name": "Pila"
        },
        {
          "province": "29",
          "province-name": "Piotrkow"
        },
        {
          "province": "30",
          "province-name": "Plock"
        },
        {
          "province": "31",
          "province-name": "Poznan"
        },
        {
          "province": "32",
          "province-name": "Przemysl"
        },
        {
          "province": "33",
          "province-name": "Radom"
        },
        {
          "province": "34",
          "province-name": "Rzeszow"
        },
        {
          "province": "35",
          "province-name": "Siedlce"
        },
        {
          "province": "36",
          "province-name": "Sieradz"
        },
        {
          "province": "37",
          "province-name": "Skierniewice"
        },
        {
          "province": "38",
          "province-name": "Slupsk"
        },
        {
          "province": "39",
          "province-name": "Suwalki"
        },
        {
          "province": "40",
          "province-name": "Szczecin"
        },
        {
          "province": "41",
          "province-name": "Tarnobrzeg"
        },
        {
          "province": "42",
          "province-name": "Tarnow"
        },
        {
          "province": "43",
          "province-name": "Torun"
        },
        {
          "province": "44",
          "province-name": "Walbrzych"
        },
        {
          "province": "45",
          "province-name": "Warszawa"
        },
        {
          "province": "46",
          "province-name": "Wloclawek"
        },
        {
          "province": "47",
          "province-name": "Wroclaw"
        },
        {
          "province": "48",
          "province-name": "Zamosc"
        },
        {
          "province": "49",
          "province-name": "Zielona Gora"
        }
      ],
      "PR": [
        {
          "province": "0",
          "province-name": "Isla Verde",
        },
        {
          "province": "1",
          "province-name": "Rafael Hernandez",
        },
        {
          "province": "2",
          "province-name": "San Juan",
        },
      ],
      "PT": [
        {
          "province": "10",
          "province-name": "Minho-Lima"
        },
        {
          "province": "11",
          "province-name": "Cávado"
        },
        {
          "province": "12",
          "province-name": "Ave"
        },
        {
          "province": "13",
          "province-name": "Grande Porto"
        },
        {
          "province": "14",
          "province-name": "Tâmega"
        },
        {
          "province": "15",
          "province-name": "Entre Douro e Vouga"
        },
        {
          "province": "16",
          "province-name": "Douro"
        },
        {
          "province": "17",
          "province-name": "Alto Trás-os-Montes"
        },
        {
          "province": "20",
          "province-name": "Baixo Vouga"
        },
        {
          "province": "21",
          "province-name": "Baixo Mondego"
        },
        {
          "province": "22",
          "province-name": "Pinhal Litoral"
        },
        {
          "province": "23",
          "province-name": "Pinhal Interior N."
        },
        {
          "province": "24",
          "province-name": "Pinhal Interior Sul"
        },
        {
          "province": "25",
          "province-name": "Dão-Lafoes"
        },
        {
          "province": "26",
          "province-name": "Serra da Estrela"
        },
        {
          "province": "27",
          "province-name": "Beira Interior Norte"
        },
        {
          "province": "28",
          "province-name": "Beira Interior Sul"
        },
        {
          "province": "29",
          "province-name": "Cova da Beira"
        },
        {
          "province": "30",
          "province-name": "Oeste"
        },
        {
          "province": "31",
          "province-name": "Grande Lisboa"
        },
        {
          "province": "32",
          "province-name": "Península de Setúbal"
        },
        {
          "province": "33",
          "province-name": "Médio Tejo"
        },
        {
          "province": "34",
          "province-name": "Lezíria do Tejo"
        },
        {
          "province": "40",
          "province-name": "Alentejo Litoral"
        },
        {
          "province": "41",
          "province-name": "Alto Alentejo"
        },
        {
          "province": "42",
          "province-name": "Alentejo Central"
        },
        {
          "province": "43",
          "province-name": "Baixo Alentejo"
        },
        {
          "province": "50",
          "province-name": "Algarve"
        },
        {
          "province": "60",
          "province-name": "Reg. Aut. dos Açores"
        },
        {
          "province": "70",
          "province-name": "Reg. Aut. da Madeira"
        }
      ],
      "RE": [],
      "RO": [
        {
          "province": "01",
          "province-name": "Alba"
        },
        {
          "province": "02",
          "province-name": "Arad"
        },
        {
          "province": "03",
          "province-name": "Arges"
        },
        {
          "province": "04",
          "province-name": "Bacau"
        },
        {
          "province": "05",
          "province-name": "Bihor"
        },
        {
          "province": "06",
          "province-name": "Bistrita-Nasaud"
        },
        {
          "province": "07",
          "province-name": "Botosani"
        },
        {
          "province": "08",
          "province-name": "Braila"
        },
        {
          "province": "09",
          "province-name": "Brasov"
        },
        {
          "province": "10",
          "province-name": "Bucuresti"
        },
        {
          "province": "11",
          "province-name": "Buzau"
        },
        {
          "province": "12",
          "province-name": "Calarasi"
        },
        {
          "province": "13",
          "province-name": "Caras-Severin"
        },
        {
          "province": "14",
          "province-name": "Cluj"
        },
        {
          "province": "15",
          "province-name": "Constanta"
        },
        {
          "province": "16",
          "province-name": "Covasna"
        },
        {
          "province": "17",
          "province-name": "Dimbovita"
        },
        {
          "province": "18",
          "province-name": "Dolj"
        },
        {
          "province": "19",
          "province-name": "Galati"
        },
        {
          "province": "20",
          "province-name": "Gorj"
        },
        {
          "province": "21",
          "province-name": "Giurgiu"
        },
        {
          "province": "22",
          "province-name": "Harghita"
        },
        {
          "province": "23",
          "province-name": "Hunedoara"
        },
        {
          "province": "24",
          "province-name": "Ialomita"
        },
        {
          "province": "25",
          "province-name": "Iasi"
        },
        {
          "province": "26",
          "province-name": "Maramures"
        },
        {
          "province": "27",
          "province-name": "Mehedinti"
        },
        {
          "province": "28",
          "province-name": "Mures"
        },
        {
          "province": "29",
          "province-name": "Neamt"
        },
        {
          "province": "30",
          "province-name": "Olt"
        },
        {
          "province": "31",
          "province-name": "Prahova"
        },
        {
          "province": "32",
          "province-name": "Salaj"
        },
        {
          "province": "33",
          "province-name": "Satu Mare"
        },
        {
          "province": "34",
          "province-name": "Sibiu"
        },
        {
          "province": "35",
          "province-name": "Suceava"
        },
        {
          "province": "36",
          "province-name": "Teleorman"
        },
        {
          "province": "37",
          "province-name": "Timis"
        },
        {
          "province": "38",
          "province-name": "Tulcea"
        },
        {
          "province": "39",
          "province-name": "Vaslui"
        },
        {
          "province": "40",
          "province-name": "Vilcea"
        },
        {
          "province": "41",
          "province-name": "Vrancea"
        }
      ],
      "RS": [
        {
          "province": "KM",
          "province-name": "Kosovo-Metohija"
        },
        {
          "province": "VO",
          "province-name": "Vojvodina"
        }
      ],
      "RU": [
        {
          "province": "01",
          "province-name": "Adigeja Republic"
        },
        {
          "province": "02",
          "province-name": "Highlands-Altay Rep."
        },
        {
          "province": "03",
          "province-name": "Republ.of Bashkortos"
        },
        {
          "province": "04",
          "province-name": "Buryat Republic"
        },
        {
          "province": "05",
          "province-name": "Dagestan Republic"
        },
        {
          "province": "06",
          "province-name": "Ingushetija Republic"
        },
        {
          "province": "07",
          "province-name": "Kabardino-Balkar.Rep"
        },
        {
          "province": "08",
          "province-name": "Kalmyk Republic"
        },
        {
          "province": "09",
          "province-name": "Karach.-Cherkessk Re"
        },
        {
          "province": "10",
          "province-name": "Karelian Republic"
        },
        {
          "province": "11",
          "province-name": "Komi Republic"
        },
        {
          "province": "12",
          "province-name": "Marijskaya Republic"
        },
        {
          "province": "13",
          "province-name": "Mordovian Republic"
        },
        {
          "province": "14",
          "province-name": "Yakutiya-Saha Rrepub"
        },
        {
          "province": "15",
          "province-name": "North-Osetiya Republ"
        },
        {
          "province": "16",
          "province-name": "Tatarstan Republic"
        },
        {
          "province": "17",
          "province-name": "Tuva Republic"
        },
        {
          "province": "18",
          "province-name": "The Udmurt Republic"
        },
        {
          "province": "19",
          "province-name": "Chakassky Republic"
        },
        {
          "province": "20",
          "province-name": "Chechenskaya Republ."
        },
        {
          "province": "21",
          "province-name": "Chuvash Republic"
        },
        {
          "province": "22",
          "province-name": "Altay Territory"
        },
        {
          "province": "23",
          "province-name": "Krasnodar Territory"
        },
        {
          "province": "24",
          "province-name": "Krasnoyarsk Territor"
        },
        {
          "province": "25",
          "province-name": "Primorye Territory"
        },
        {
          "province": "26",
          "province-name": "Stavropol Territory"
        },
        {
          "province": "27",
          "province-name": "Khabarovsk Territory"
        },
        {
          "province": "28",
          "province-name": "The Amur Area"
        },
        {
          "province": "29",
          "province-name": "The Arkhangelsk Area"
        },
        {
          "province": "30",
          "province-name": "The Astrakhan Area"
        },
        {
          "province": "31",
          "province-name": "The Belgorod Area"
        },
        {
          "province": "32",
          "province-name": "The Bryansk Area"
        },
        {
          "province": "33",
          "province-name": "The Vladimir Area"
        },
        {
          "province": "34",
          "province-name": "The Volgograd Area"
        },
        {
          "province": "35",
          "province-name": "The Vologda Area"
        },
        {
          "province": "36",
          "province-name": "The Voronezh Area"
        },
        {
          "province": "37",
          "province-name": "The Ivanovo Area"
        },
        {
          "province": "38",
          "province-name": "The Irkutsk Area"
        },
        {
          "province": "39",
          "province-name": "The Kaliningrad Area"
        },
        {
          "province": "40",
          "province-name": "The Kaluga Area"
        },
        {
          "province": "41",
          "province-name": "The Kamchatka Area"
        },
        {
          "province": "42",
          "province-name": "The Kemerovo Area"
        },
        {
          "province": "43",
          "province-name": "The Kirov Area"
        },
        {
          "province": "44",
          "province-name": "The Kostroma Area"
        },
        {
          "province": "45",
          "province-name": "The Kurgan Area"
        },
        {
          "province": "46",
          "province-name": "The Kursk Area"
        },
        {
          "province": "47",
          "province-name": "The Leningrad Area"
        },
        {
          "province": "48",
          "province-name": "The Lipetsk Area"
        },
        {
          "province": "49",
          "province-name": "The Magadan Area"
        },
        {
          "province": "50",
          "province-name": "The Moscow Area"
        },
        {
          "province": "51",
          "province-name": "The Murmansk Area"
        },
        {
          "province": "52",
          "province-name": "The Nizhniy Novgorod"
        },
        {
          "province": "53",
          "province-name": "The Novgorod Area"
        },
        {
          "province": "54",
          "province-name": "The Novosibirsk Area"
        },
        {
          "province": "55",
          "province-name": "The Omsk Area"
        },
        {
          "province": "56",
          "province-name": "The Orenburg Area"
        },
        {
          "province": "57",
          "province-name": "The Oryol Area"
        },
        {
          "province": "58",
          "province-name": "The Penza Area"
        },
        {
          "province": "59",
          "province-name": "The Perm Area"
        },
        {
          "province": "60",
          "province-name": "The Pskov Area"
        },
        {
          "province": "61",
          "province-name": "The Rostov Area"
        },
        {
          "province": "62",
          "province-name": "The Ryazan Area"
        },
        {
          "province": "63",
          "province-name": "The Samara Area"
        },
        {
          "province": "64",
          "province-name": "The Saratov Area"
        },
        {
          "province": "65",
          "province-name": "The Sakhalin Area"
        },
        {
          "province": "66",
          "province-name": "The Sverdlovsk Area"
        },
        {
          "province": "67",
          "province-name": "The Smolensk Area"
        },
        {
          "province": "68",
          "province-name": "The Tambov Area"
        },
        {
          "province": "69",
          "province-name": "The Tver Area"
        },
        {
          "province": "70",
          "province-name": "The Tomsk Area"
        },
        {
          "province": "71",
          "province-name": "The Tula Area"
        },
        {
          "province": "72",
          "province-name": "The Tyumen Area"
        },
        {
          "province": "73",
          "province-name": "The Ulyanovsk Area"
        },
        {
          "province": "74",
          "province-name": "The Chelyabinsk Area"
        },
        {
          "province": "75",
          "province-name": "The Chita Area"
        },
        {
          "province": "76",
          "province-name": "The Yaroslavl Area"
        },
        {
          "province": "77",
          "province-name": "c.Moscow"
        },
        {
          "province": "78",
          "province-name": "c.St-Peterburg"
        },
        {
          "province": "79",
          "province-name": "The Jewish Auton.are"
        },
        {
          "province": "80",
          "province-name": "Aginsk Buryat Aut.di"
        },
        {
          "province": "81",
          "province-name": "Komy Permjats.Aut.di"
        },
        {
          "province": "82",
          "province-name": "Korjacs Auton.distri"
        },
        {
          "province": "83",
          "province-name": "Nenekchky Auton.dist"
        },
        {
          "province": "84",
          "province-name": "The Taymir Auton.dis"
        },
        {
          "province": "85",
          "province-name": "Ust-Ordinsky Buryat"
        },
        {
          "province": "86",
          "province-name": "Chanti-Mansyjsky Aut"
        },
        {
          "province": "87",
          "province-name": "Chukotka Auton. dist"
        },
        {
          "province": "88",
          "province-name": "Evensky Auton.distri"
        },
        {
          "province": "89",
          "province-name": "Jamalo-Nenekchky Aut"
        }
      ],
      "SE": [
        {
          "province": "001",
          "province-name": "Blekinge Län"
        },
        {
          "province": "002",
          "province-name": "Dalarnas Län"
        },
        {
          "province": "003",
          "province-name": "Gotlands Län"
        },
        {
          "province": "004",
          "province-name": "Gävleborgs Län"
        },
        {
          "province": "005",
          "province-name": "Hallands Län"
        },
        {
          "province": "006",
          "province-name": "Jämtlands Län"
        },
        {
          "province": "007",
          "province-name": "Jönköpings Län"
        },
        {
          "province": "008",
          "province-name": "Kalmar Län"
        },
        {
          "province": "009",
          "province-name": "Kronobergs Län"
        },
        {
          "province": "010",
          "province-name": "Norrbottens Län"
        },
        {
          "province": "011",
          "province-name": "Skåne Län"
        },
        {
          "province": "012",
          "province-name": "Stockholms Län"
        },
        {
          "province": "013",
          "province-name": "Södermanlands Län"
        },
        {
          "province": "014",
          "province-name": "Uppsala Län"
        },
        {
          "province": "015",
          "province-name": "Värmlands Län"
        },
        {
          "province": "016",
          "province-name": "Västerbottens Län"
        },
        {
          "province": "017",
          "province-name": "Västernorrlands Län"
        },
        {
          "province": "018",
          "province-name": "Västmanlands Län"
        },
        {
          "province": "019",
          "province-name": "Västra Götalands Län"
        },
        {
          "province": "020",
          "province-name": "Örebro Län"
        },
        {
          "province": "021",
          "province-name": "Östergötlands Län"
        }
      ],
      "SG": [
        {
          "province": "SG",
          "province-name": "Singapore"
        }
      ],
      "SI": [
        {
          "province": "01",
          "province-name": "Ajdovscina"
        },
        {
          "province": "02",
          "province-name": "Brezice"
        },
        {
          "province": "03",
          "province-name": "Celje"
        },
        {
          "province": "04",
          "province-name": "Cerknica"
        },
        {
          "province": "05",
          "province-name": "Crnomelj"
        },
        {
          "province": "06",
          "province-name": "Dravograd"
        },
        {
          "province": "07",
          "province-name": "Gornja Radgona"
        },
        {
          "province": "08",
          "province-name": "Grosuplje"
        },
        {
          "province": "09",
          "province-name": "Hrastnik Lasko"
        },
        {
          "province": "10",
          "province-name": "Idrija"
        },
        {
          "province": "11",
          "province-name": "Ilirska Bistrica"
        },
        {
          "province": "12",
          "province-name": "Izola"
        },
        {
          "province": "13",
          "province-name": "Jesenice"
        },
        {
          "province": "14",
          "province-name": "Kamnik"
        },
        {
          "province": "15",
          "province-name": "Kocevje"
        },
        {
          "province": "16",
          "province-name": "Koper"
        },
        {
          "province": "17",
          "province-name": "Kranj"
        },
        {
          "province": "18",
          "province-name": "Krsko"
        },
        {
          "province": "19",
          "province-name": "Lenart"
        },
        {
          "province": "20",
          "province-name": "Lendava"
        },
        {
          "province": "21",
          "province-name": "Litija"
        },
        {
          "province": "22",
          "province-name": "Ljubljana-Bezigrad"
        },
        {
          "province": "23",
          "province-name": "Ljubljana-Center"
        },
        {
          "province": "24",
          "province-name": "Ljubljana-Moste-Polj"
        },
        {
          "province": "25",
          "province-name": "Ljubljana-Siska"
        },
        {
          "province": "26",
          "province-name": "Ljubljana-Vic-Rudnik"
        },
        {
          "province": "27",
          "province-name": "Ljutomer"
        },
        {
          "province": "28",
          "province-name": "Logatec"
        },
        {
          "province": "29",
          "province-name": "Maribor"
        },
        {
          "province": "30",
          "province-name": "Metlika"
        },
        {
          "province": "31",
          "province-name": "Mozirje"
        },
        {
          "province": "32",
          "province-name": "Murska Sobota"
        },
        {
          "province": "33",
          "province-name": "Nova Gorica"
        },
        {
          "province": "34",
          "province-name": "Novo Mesto"
        },
        {
          "province": "35",
          "province-name": "Ormoz"
        },
        {
          "province": "36",
          "province-name": "Pesnica"
        },
        {
          "province": "37",
          "province-name": "Piran"
        },
        {
          "province": "38",
          "province-name": "Postojna"
        },
        {
          "province": "39",
          "province-name": "Ptuj"
        },
        {
          "province": "40",
          "province-name": "Radlje Ob Dravi"
        },
        {
          "province": "41",
          "province-name": "Radovljica"
        },
        {
          "province": "42",
          "province-name": "Ravne Na Koroskem"
        },
        {
          "province": "43",
          "province-name": "Ribnica"
        },
        {
          "province": "44",
          "province-name": "Ruse"
        },
        {
          "province": "45",
          "province-name": "Sentjur Pri Celju"
        },
        {
          "province": "46",
          "province-name": "Sevnica"
        },
        {
          "province": "47",
          "province-name": "Sezana"
        },
        {
          "province": "48",
          "province-name": "Skofja Loka"
        },
        {
          "province": "49",
          "province-name": "Slovenj Gradec"
        },
        {
          "province": "50",
          "province-name": "Slovenska Bistrica"
        },
        {
          "province": "51",
          "province-name": "Slovenske Konjice"
        },
        {
          "province": "52",
          "province-name": "Smarje Pri Jelsah"
        },
        {
          "province": "53",
          "province-name": "Tolmin"
        },
        {
          "province": "54",
          "province-name": "Trbovlje"
        },
        {
          "province": "55",
          "province-name": "Trebnje"
        },
        {
          "province": "56",
          "province-name": "Trzic"
        },
        {
          "province": "57",
          "province-name": "Velenje"
        },
        {
          "province": "58",
          "province-name": "Vrhnika"
        },
        {
          "province": "59",
          "province-name": "Zagorje Ob Savi"
        },
        {
          "province": "60",
          "province-name": "Zalec"
        }
      ],
      "SK": [
        {
          "province": "01",
          "province-name": "Bratislava"
        },
        {
          "province": "02",
          "province-name": "Zapadoslovensky"
        },
        {
          "province": "03",
          "province-name": "Stredoslovensky"
        },
        {
          "province": "04",
          "province-name": "Vychodoslovensky"
        }
      ],
      "TH": [
        {
          "province": "01",
          "province-name": "Amnat Charoen"
        },
        {
          "province": "02",
          "province-name": "Ang Thong"
        },
        {
          "province": "03",
          "province-name": "Buriram"
        },
        {
          "province": "04",
          "province-name": "Chachoengsao"
        },
        {
          "province": "05",
          "province-name": "Chai Nat"
        },
        {
          "province": "06",
          "province-name": "Chaiyaphum"
        },
        {
          "province": "07",
          "province-name": "Chanthaburi"
        },
        {
          "province": "08",
          "province-name": "Chiang Mai"
        },
        {
          "province": "09",
          "province-name": "Chiang Rai"
        },
        {
          "province": "10",
          "province-name": "Chon Buri"
        },
        {
          "province": "11",
          "province-name": "Chumphon"
        },
        {
          "province": "12",
          "province-name": "Kalasin"
        },
        {
          "province": "13",
          "province-name": "Kamphaeng Phet"
        },
        {
          "province": "14",
          "province-name": "Kanchanaburi"
        },
        {
          "province": "15",
          "province-name": "Khon Kaen"
        },
        {
          "province": "16",
          "province-name": "Krabi"
        },
        {
          "province": "17",
          "province-name": "Krung Thep"
        },
        {
          "province": "18",
          "province-name": "Mahanakhon"
        },
        {
          "province": "19",
          "province-name": "Lampang"
        },
        {
          "province": "20",
          "province-name": "Lamphun"
        },
        {
          "province": "21",
          "province-name": "Loei"
        },
        {
          "province": "22",
          "province-name": "Lop Buri"
        },
        {
          "province": "23",
          "province-name": "Mae Hong Son"
        },
        {
          "province": "24",
          "province-name": "Maha Sarakham"
        },
        {
          "province": "25",
          "province-name": "Mukdahan"
        },
        {
          "province": "26",
          "province-name": "Nakhon Nayok"
        },
        {
          "province": "27",
          "province-name": "Nakhon Pathom"
        },
        {
          "province": "28",
          "province-name": "Nakhon Phanom"
        },
        {
          "province": "29",
          "province-name": "Nakhon Ratchasima"
        },
        {
          "province": "30",
          "province-name": "Nakhon Sawan"
        },
        {
          "province": "31",
          "province-name": "Nakhon Si Thammarat"
        },
        {
          "province": "32",
          "province-name": "Nan"
        },
        {
          "province": "33",
          "province-name": "Narathiwat"
        },
        {
          "province": "34",
          "province-name": "Nong Bua Lamphu"
        },
        {
          "province": "35",
          "province-name": "Nong Khai"
        },
        {
          "province": "36",
          "province-name": "Nonthaburi"
        },
        {
          "province": "37",
          "province-name": "Pathum Thani"
        },
        {
          "province": "38",
          "province-name": "Pattani"
        },
        {
          "province": "39",
          "province-name": "Phangnga"
        },
        {
          "province": "40",
          "province-name": "Phatthalung"
        },
        {
          "province": "41",
          "province-name": "Phayao"
        },
        {
          "province": "42",
          "province-name": "Phetchabun"
        },
        {
          "province": "43",
          "province-name": "Phetchaburi"
        },
        {
          "province": "44",
          "province-name": "Phichit"
        },
        {
          "province": "45",
          "province-name": "Phitsanulok"
        },
        {
          "province": "46",
          "province-name": "Phra Nakhon Si Ayut."
        },
        {
          "province": "47",
          "province-name": "Phrae"
        },
        {
          "province": "48",
          "province-name": "Phuket"
        },
        {
          "province": "49",
          "province-name": "Prachin Buri"
        }
      ],
      "TR": [
        {
          "province": "01",
          "province-name": "Adana"
        },
        {
          "province": "02",
          "province-name": "Adiyaman"
        },
        {
          "province": "03",
          "province-name": "Afyon"
        },
        {
          "province": "04",
          "province-name": "Agri"
        },
        {
          "province": "05",
          "province-name": "Amasya"
        },
        {
          "province": "06",
          "province-name": "Ankara"
        },
        {
          "province": "07",
          "province-name": "Antalya"
        },
        {
          "province": "08",
          "province-name": "Artvin"
        },
        {
          "province": "09",
          "province-name": "Aydin"
        },
        {
          "province": "10",
          "province-name": "Balikesir"
        },
        {
          "province": "11",
          "province-name": "Bilecik"
        },
        {
          "province": "12",
          "province-name": "Bingöl"
        },
        {
          "province": "13",
          "province-name": "Bitlis"
        },
        {
          "province": "14",
          "province-name": "Bolu"
        },
        {
          "province": "15",
          "province-name": "Burdur"
        },
        {
          "province": "16",
          "province-name": "Bursa"
        },
        {
          "province": "17",
          "province-name": "Canakkale"
        },
        {
          "province": "18",
          "province-name": "Cankiri"
        },
        {
          "province": "19",
          "province-name": "Corum"
        },
        {
          "province": "20",
          "province-name": "Denizli"
        },
        {
          "province": "21",
          "province-name": "Diyarbakir"
        },
        {
          "province": "22",
          "province-name": "Edirne"
        },
        {
          "province": "23",
          "province-name": "Elazig"
        },
        {
          "province": "24",
          "province-name": "Erzincan"
        },
        {
          "province": "25",
          "province-name": "Erzurum"
        },
        {
          "province": "26",
          "province-name": "Eskisehir"
        },
        {
          "province": "27",
          "province-name": "Gaziantep"
        },
        {
          "province": "28",
          "province-name": "Giresun"
        },
        {
          "province": "29",
          "province-name": "Gümüshane"
        },
        {
          "province": "30",
          "province-name": "Hakkari"
        },
        {
          "province": "31",
          "province-name": "Hatay"
        },
        {
          "province": "32",
          "province-name": "Isparta"
        },
        {
          "province": "33",
          "province-name": "Icel"
        },
        {
          "province": "34",
          "province-name": "Istanbul"
        },
        {
          "province": "35",
          "province-name": "Izmir"
        },
        {
          "province": "36",
          "province-name": "Kars"
        },
        {
          "province": "37",
          "province-name": "Kastamonu"
        },
        {
          "province": "38",
          "province-name": "Kayseri"
        },
        {
          "province": "39",
          "province-name": "Kirklareli"
        },
        {
          "province": "40",
          "province-name": "Kirshehir"
        },
        {
          "province": "41",
          "province-name": "Kocaeli"
        },
        {
          "province": "42",
          "province-name": "Konya"
        },
        {
          "province": "43",
          "province-name": "Kütahya"
        },
        {
          "province": "44",
          "province-name": "Malatya"
        },
        {
          "province": "45",
          "province-name": "Manisa"
        },
        {
          "province": "46",
          "province-name": "K.Marash"
        },
        {
          "province": "47",
          "province-name": "Mardin"
        },
        {
          "province": "48",
          "province-name": "Mugla"
        },
        {
          "province": "49",
          "province-name": "Mush"
        },
        {
          "province": "50",
          "province-name": "Nevshehir"
        },
        {
          "province": "51",
          "province-name": "Nigde"
        },
        {
          "province": "52",
          "province-name": "Ordu"
        },
        {
          "province": "53",
          "province-name": "Rize"
        },
        {
          "province": "54",
          "province-name": "Sakarya"
        },
        {
          "province": "55",
          "province-name": "Samsun"
        },
        {
          "province": "56",
          "province-name": "Siirt"
        },
        {
          "province": "57",
          "province-name": "Sinop"
        },
        {
          "province": "58",
          "province-name": "Sivas"
        },
        {
          "province": "59",
          "province-name": "Tekirdag"
        },
        {
          "province": "60",
          "province-name": "Tokat"
        },
        {
          "province": "61",
          "province-name": "Trabzon"
        },
        {
          "province": "62",
          "province-name": "Tunceli"
        },
        {
          "province": "63",
          "province-name": "Shanliurfa"
        },
        {
          "province": "64",
          "province-name": "Ushak"
        },
        {
          "province": "65",
          "province-name": "Van"
        },
        {
          "province": "66",
          "province-name": "Yozgat"
        },
        {
          "province": "67",
          "province-name": "Zonguldak"
        },
        {
          "province": "68",
          "province-name": "Aksaray"
        },
        {
          "province": "69",
          "province-name": "Bayburt"
        },
        {
          "province": "70",
          "province-name": "Karaman"
        },
        {
          "province": "71",
          "province-name": "Kirikkale"
        },
        {
          "province": "72",
          "province-name": "Batman"
        },
        {
          "province": "73",
          "province-name": "Shirnak"
        },
        {
          "province": "74",
          "province-name": "Bartin"
        },
        {
          "province": "75",
          "province-name": "Ardahan"
        },
        {
          "province": "76",
          "province-name": "Igdir"
        },
        {
          "province": "77",
          "province-name": "Yalova"
        }
      ],
      "TW": [
        {
          "province": "FJN",
          "province-name": "Fu-chien"
        },
        {
          "province": "KSH",
          "province-name": "Kao-hsiung"
        },
        {
          "province": "TPE",
          "province-name": "T´ai-pei"
        },
        {
          "province": "TWN",
          "province-name": "Taiwan"
        }
      ],
      "UA": [
        {
          "province": "CHG",
          "province-name": "Chernigivs'ka"
        },
        {
          "province": "CHR",
          "province-name": "Cherkas'ka"
        },
        {
          "province": "CHV",
          "province-name": "Chernovits'ka"
        },
        {
          "province": "DNP",
          "province-name": "Dnipropetrovs'ka"
        },
        {
          "province": "DON",
          "province-name": "Donets'ka"
        },
        {
          "province": "HAR",
          "province-name": "Harkivs'ka"
        },
        {
          "province": "HML",
          "province-name": "Hmel'nits'ka"
        },
        {
          "province": "HRS",
          "province-name": "Hersons'ka"
        },
        {
          "province": "IVF",
          "province-name": "Ivano-Frankivs'ka"
        },
        {
          "province": "KIE",
          "province-name": "Kievs'ka"
        },
        {
          "province": "KIR",
          "province-name": "Kirovograds'ka"
        },
        {
          "province": "KRM",
          "province-name": "Respublika Krim"
        },
        {
          "province": "LUG",
          "province-name": "Lugans'ka"
        },
        {
          "province": "L'V",
          "province-name": "L'vivsbka"
        },
        {
          "province": "M_K",
          "province-name": "m.Kiev"
        },
        {
          "province": "M_S",
          "province-name": "m.Sevastopil'"
        },
        {
          "province": "MIK",
          "province-name": "Mikolaivs'ka"
        },
        {
          "province": "ODS",
          "province-name": "Odes'ka"
        },
        {
          "province": "POL",
          "province-name": "Poltavs'ka"
        },
        {
          "province": "RIV",
          "province-name": "Rivnens'ka"
        },
        {
          "province": "SUM",
          "province-name": "Sums'ka"
        },
        {
          "province": "TER",
          "province-name": "Ternopil's'ka"
        },
        {
          "province": "VIN",
          "province-name": "Vinnits'ka"
        },
        {
          "province": "VOL",
          "province-name": "Volins'ka"
        },
        {
          "province": "ZAK",
          "province-name": "Zakarpats'ka"
        },
        {
          "province": "ZAP",
          "province-name": "Zaporiz'ka"
        },
        {
          "province": "ZHI",
          "province-name": "Zhitomirs'ka"
        }
      ],
      "US": [
        {
          "province": "AA",
          "province-name": "Armed Forces America"
        },
        {
          "province": "AE",
          "province-name": "Armed Forces Europe"
        },
        {
          "province": "AK",
          "province-name": "Alaska"
        },
        {
          "province": "AL",
          "province-name": "Alabama"
        },
        {
          "province": "AP",
          "province-name": "Armed Forces Pacific"
        },
        {
          "province": "AR",
          "province-name": "Arkansas"
        },
        {
          "province": "AS",
          "province-name": "American Samoa"
        },
        {
          "province": "AZ",
          "province-name": "Arizona"
        },
        {
          "province": "CA",
          "province-name": "California"
        },
        {
          "province": "CO",
          "province-name": "Colorado"
        },
        {
          "province": "CT",
          "province-name": "Connecticut"
        },
        {
          "province": "DC",
          "province-name": "District of Columbia"
        },
        {
          "province": "DE",
          "province-name": "Delaware"
        },
        {
          "province": "FL",
          "province-name": "Florida"
        },
        {
          "province": "GA",
          "province-name": "Georgia"
        },
        {
          "province": "GU",
          "province-name": "Guam"
        },
        {
          "province": "HI",
          "province-name": "Hawaii"
        },
        {
          "province": "IA",
          "province-name": "Iowa"
        },
        {
          "province": "ID",
          "province-name": "Idaho"
        },
        {
          "province": "IL",
          "province-name": "Illinois"
        },
        {
          "province": "IN",
          "province-name": "Indiana"
        },
        {
          "province": "KS",
          "province-name": "Kansas"
        },
        {
          "province": "KY",
          "province-name": "Kentucky"
        },
        {
          "province": "LA",
          "province-name": "Louisiana"
        },
        {
          "province": "MA",
          "province-name": "Massachusetts"
        },
        {
          "province": "MD",
          "province-name": "Maryland"
        },
        {
          "province": "ME",
          "province-name": "Maine"
        },
        {
          "province": "MI",
          "province-name": "Michigan"
        },
        {
          "province": "MN",
          "province-name": "Minnesota"
        },
        {
          "province": "MO",
          "province-name": "Missouri"
        },
        {
          "province": "MP",
          "province-name": "Northern Mariana Isl"
        },
        {
          "province": "MS",
          "province-name": "Mississippi"
        },
        {
          "province": "MT",
          "province-name": "Montana"
        },
        {
          "province": "NC",
          "province-name": "North Carolina"
        },
        {
          "province": "ND",
          "province-name": "North Dakota"
        },
        {
          "province": "NE",
          "province-name": "Nebraska"
        },
        {
          "province": "NH",
          "province-name": "New Hampshire"
        },
        {
          "province": "NJ",
          "province-name": "New Jersey"
        },
        {
          "province": "NM",
          "province-name": "New Mexico"
        },
        {
          "province": "NP",
          "province-name": "No Plate"
        },
        {
          "province": "NV",
          "province-name": "Nevada"
        },
        {
          "province": "NY",
          "province-name": "New York"
        },
        {
          "province": "OH",
          "province-name": "Ohio"
        },
        {
          "province": "OK",
          "province-name": "Oklahoma"
        },
        {
          "province": "OR",
          "province-name": "Oregon"
        },
        {
          "province": "PA",
          "province-name": "Pennsylvania"
        },
        {
          "province": "PP",
          "province-name": "Paper Plate"
        },
        {
          "province": "PR",
          "province-name": "Puerto Rico"
        },
        {
          "province": "RI",
          "province-name": "Rhode Island"
        },
        {
          "province": "SC",
          "province-name": "South Carolina"
        },
        {
          "province": "SD",
          "province-name": "South Dakota"
        },
        {
          "province": "TN",
          "province-name": "Tennessee"
        },
        {
          "province": "TX",
          "province-name": "Texas"
        },
        {
          "province": "UT",
          "province-name": "Utah"
        },
        {
          "province": "VA",
          "province-name": "Virginia"
        },
        {
          "province": "VI",
          "province-name": "Virgin Islands"
        },
        {
          "province": "VT",
          "province-name": "Vermont"
        },
        {
          "province": "WA",
          "province-name": "Washington"
        },
        {
          "province": "WI",
          "province-name": "Wisconsin"
        },
        {
          "province": "WV",
          "province-name": "West Virginia"
        },
        {
          "province": "WY",
          "province-name": "Wyoming"
        }
      ],
      "UY": [],
      "VE": [
        {
          "province": "AMA",
          "province-name": "Amazon"
        },
        {
          "province": "ANZ",
          "province-name": "Anzoategui"
        },
        {
          "province": "APU",
          "province-name": "Apure"
        },
        {
          "province": "ARA",
          "province-name": "Aragua"
        },
        {
          "province": "BAR",
          "province-name": "Barinas"
        },
        {
          "province": "BOL",
          "province-name": "Bolivar"
        },
        {
          "province": "CAR",
          "province-name": "Carabobo"
        },
        {
          "province": "COJ",
          "province-name": "Cojedes"
        },
        {
          "province": "DA",
          "province-name": "Delta Amacuro"
        },
        {
          "province": "DF",
          "province-name": "Distrito Federal"
        },
        {
          "province": "FAL",
          "province-name": "Falcon"
        },
        {
          "province": "GUA",
          "province-name": "Guarico"
        },
        {
          "province": "LAR",
          "province-name": "Lara"
        },
        {
          "province": "MER",
          "province-name": "Merida"
        },
        {
          "province": "MIR",
          "province-name": "Miranda"
        },
        {
          "province": "MON",
          "province-name": "Monagas"
        },
        {
          "province": "NE",
          "province-name": "Nueva Esparta"
        },
        {
          "province": "POR",
          "province-name": "Portuguesa"
        },
        {
          "province": "SUC",
          "province-name": "Sucre"
        },
        {
          "province": "TAC",
          "province-name": "Tachira"
        },
        {
          "province": "TRU",
          "province-name": "Trujillo"
        },
        {
          "province": "VAR",
          "province-name": "Vargas"
        },
        {
          "province": "YAR",
          "province-name": "Yaracuy"
        },
        {
          "province": "ZUL",
          "province-name": "Zulia"
        }
      ],
      "VI": [],
      "VG": [],
      "ZA": [
        {
          "province": "EC",
          "province-name": "Eastern Cape"
        },
        {
          "province": "FS",
          "province-name": "Freestate"
        },
        {
          "province": "GP",
          "province-name": "Gauteng"
        },
        {
          "province": "KZN",
          "province-name": "Kwazulu/Natal"
        },
        {
          "province": "MP",
          "province-name": "Mpumalanga"
        },
        {
          "province": "NC",
          "province-name": "Northern Cape"
        },
        {
          "province": "NP",
          "province-name": "Northern Province"
        },
        {
          "province": "NW",
          "province-name": "North-West"
        },
        {
          "province": "WC",
          "province-name": "Western Cape"
        }
      ]
    };

    var codeToCountry = {
      'AF': 'Afghanistan',
      'AX': 'Åland Islands',
      'AL': 'Albania',
      'DZ': 'Algeria',
      'AS': 'American Samoa',
      'AD': 'Andorra',
      'AO': 'Angola',
      'AI': 'Anguilla',
      'AQ': 'Antarctica',
      'AG': 'Antigua and Barbuda',
      'AR': 'Argentina',
      'AM': 'Armenia',
      'AW': 'Aruba',
      'AU': 'Australia',
      'AT': 'Austria',
      'AZ': 'Azerbaijan',
      'BS': 'Bahamas',
      'BH': 'Bahrain',
      'BD': 'Bangladesh',
      'BB': 'Barbados',
      'BY': 'Belarus',
      'BE': 'Belgium',
      'BZ': 'Belize',
      'BJ': 'Benin',
      'BM': 'Bermuda',
      'BT': 'Bhutan',
      'BO': 'Bolivia, Plurinational State of',
      'BQ': 'Bonaire, Sint Eustatius and Saba',
      'BA': 'Bosnia and Herzegovina',
      'BW': 'Botswana',
      'BV': 'Bouvet Island',
      'BR': 'Brazil',
      'IO': 'British Indian Ocean Territory',
      'BN': 'Brunei Darussalam',
      'BG': 'Bulgaria',
      'BF': 'Burkina Faso',
      'BI': 'Burundi',
      'KH': 'Cambodia',
      'CM': 'Cameroon',
      'CA': 'Canada',
      'CV': 'Cape Verde',
      'KY': 'Cayman Islands',
      'CF': 'Central African Republic',
      'TD': 'Chad',
      'CL': 'Chile',
      'CN': 'China',
      'CX': 'Christmas Island',
      'CC': 'Cocos (keeling) Islands',
      'CO': 'Colombia',
      'KM': 'Comoros',
      'CG': 'Congo',
      'CD': 'Congo, The Democratic Republic of The',
      'CK': 'Cook Islands',
      'CR': 'Costa Rica',
      'CI': 'Côte D\'Ivoire',
      'HR': 'Croatia',
      'CU': 'Cuba',
      'CW': 'Curaçao',
      'CY': 'Cyprus',
      'CZ': 'Czech Republic',
      'DK': 'Denmark',
      'DJ': 'Djibouti',
      'DM': 'Dominica',
      'DO': 'Dominican Republic',
      'EC': 'Ecuador',
      'EG': 'Egypt',
      'SV': 'El Salvador',
      'GQ': 'Equatorial Guinea',
      'ER': 'Eritrea',
      'EE': 'Estonia',
      'ET': 'Ethiopia',
      'FK': 'Falkland Islands (malvinas)',
      'FO': 'Faroe Islands',
      'FJ': 'Fiji',
      'FI': 'Finland',
      'FR': 'France',
      'GF': 'French Guiana',
      'PF': 'French Polynesia',
      'TF': 'French Southern Territories',
      'GA': 'Gabon',
      'GM': 'Gambia',
      'GE': 'Georgia',
      'DE': 'Germany',
      'GH': 'Ghana',
      'GI': 'Gibraltar',
      'GR': 'Greece',
      'GL': 'Greenland',
      'GD': 'Grenada',
      'GP': 'Guadeloupe',
      'GU': 'Guam',
      'GT': 'Guatemala',
      'GG': 'Guernsey',
      'GN': 'Guinea',
      'GW': 'Guinea-bissau',
      'GY': 'Guyana',
      'HT': 'Haiti',
      'HM': 'Heard Island and Mcdonald Islands',
      'VA': 'Holy See (vatican City State)',
      'HN': 'Honduras',
      'HK': 'Hong Kong',
      'HU': 'Hungary',
      'IS': 'Iceland',
      'IN': 'India',
      'ID': 'Indonesia',
      'IR': 'Iran, Islamic Republic of',
      'IQ': 'Iraq',
      'IE': 'Ireland',
      'IM': 'Isle of Man',
      'IL': 'Israel',
      'IT': 'Italy',
      'JM': 'Jamaica',
      'JP': 'Japan',
      'JE': 'Jersey',
      'JO': 'Jordan',
      'KZ': 'Kazakhstan',
      'KE': 'Kenya',
      'KI': 'Kiribati',
      'KP': 'Korea, Democratic People\'s Republic of',
      'KR': 'Korea, Republic of',
      'KW': 'Kuwait',
      'KG': 'Kyrgyzstan',
      'LA': 'Lao People\'s Democratic Republic',
      'LV': 'Latvia',
      'LB': 'Lebanon',
      'LS': 'Lesotho',
      'LR': 'Liberia',
      'LY': 'Libya',
      'LI': 'Liechtenstein',
      'LT': 'Lithuania',
      'LU': 'Luxembourg',
      'MO': 'Macao',
      'MK': 'Macedonia, The Former Yugoslav Republic of',
      'MG': 'Madagascar',
      'MW': 'Malawi',
      'MY': 'Malaysia',
      'MV': 'Maldives',
      'ML': 'Mali',
      'MT': 'Malta',
      'MH': 'Marshall Islands',
      'MQ': 'Martinique',
      'MR': 'Mauritania',
      'MU': 'Mauritius',
      'YT': 'Mayotte',
      'MX': 'Mexico',
      'FM': 'Micronesia, Federated States of',
      'MD': 'Moldova, Republic of',
      'MC': 'Monaco',
      'MN': 'Mongolia',
      'ME': 'Montenegro',
      'MS': 'Montserrat',
      'MA': 'Morocco',
      'MZ': 'Mozambique',
      'MM': 'Myanmar',
      'NA': 'Namibia',
      'NR': 'Nauru',
      'NP': 'Nepal',
      'NL': 'Netherlands',
      'NC': 'New Caledonia',
      'NZ': 'New Zealand',
      'NI': 'Nicaragua',
      'NE': 'Niger',
      'NG': 'Nigeria',
      'NU': 'Niue',
      'NF': 'Norfolk Island',
      'MP': 'Northern Mariana Islands',
      'NO': 'Norway',
      'OM': 'Oman',
      'PK': 'Pakistan',
      'PW': 'Palau',
      'PS': 'Palestine, State of',
      'PA': 'Panama',
      'PG': 'Papua New Guinea',
      'PY': 'Paraguay',
      'PE': 'Peru',
      'PH': 'Philippines',
      'PN': 'Pitcairn',
      'PL': 'Poland',
      'PT': 'Portugal',
      'PR': 'Puerto Rico',
      'QA': 'Qatar',
      'RE': 'Réunion',
      'RO': 'Romania',
      'RU': 'Russian Federation',
      'RW': 'Rwanda',
      'BL': 'Saint Barthélemy',
      'SH': 'Saint Helena, Ascension and Tristan Da Cunha',
      'KN': 'Saint Kitts and Nevis',
      'LC': 'Saint Lucia',
      'MF': 'Saint Martin (French Part)',
      'PM': 'Saint Pierre and Miquelon',
      'VC': 'Saint Vincent and The Grenadines',
      'WS': 'Samoa',
      'SM': 'San Marino',
      'ST': 'Sao Tome and Principe',
      'SA': 'Saudi Arabia',
      'SN': 'Senegal',
      'RS': 'Serbia',
      'SC': 'Seychelles',
      'SL': 'Sierra Leone',
      'SG': 'Singapore',
      'SX': 'Sint Maarten (Dutch Part)',
      'SK': 'Slovakia',
      'SI': 'Slovenia',
      'SB': 'Solomon Islands',
      'SO': 'Somalia',
      'ZA': 'South Africa',
      'GS': 'South Georgia and The South Sandwich Islands',
      'SS': 'South Sudan',
      'ES': 'Spain',
      'LK': 'Sri Lanka',
      'SD': 'Sudan',
      'SR': 'Suriname',
      'SJ': 'Svalbard and Jan Mayen',
      'SZ': 'Swaziland',
      'SE': 'Sweden',
      'CH': 'Switzerland',
      'SY': 'Syrian Arab Republic',
      'TW': 'Taiwan, Province of China',
      'TJ': 'Tajikistan',
      'TZ': 'Tanzania, United Republic of',
      'TH': 'Thailand',
      'TL': 'Timor-leste',
      'TG': 'Togo',
      'TK': 'Tokelau',
      'TO': 'Tonga',
      'TT': 'Trinidad and Tobago',
      'TN': 'Tunisia',
      'TR': 'Turkey',
      'TM': 'Turkmenistan',
      'TC': 'Turks and Caicos Islands',
      'TV': 'Tuvalu',
      'UG': 'Uganda',
      'UA': 'Ukraine',
      'AE': 'United Arab Emirates',
      'GB': 'United Kingdom',
      'US': 'United States',
      'UM': 'United States Minor Outlying Islands',
      'UY': 'Uruguay',
      'UZ': 'Uzbekistan',
      'VU': 'Vanuatu',
      'VE': 'Venezuela, Bolivarian Republic of',
      'VN': 'Viet Nam',
      'VG': 'Virgin Islands, British',
      'VI': 'Virgin Islands, U.s.',
      'WF': 'Wallis and Futuna',
      'EH': 'Western Sahara',
      'YE': 'Yemen',
      'ZM': 'Zambia',
      'ZW': 'Zimbabwe'
    };

    var countryCodeToContinent = {
      'AD':'Europe',
      'AE':'Asia',
      'AF':'Asia',
      'AG':'North America',
      'AI':'North America',
      'AL':'Europe',
      'AM':'Asia',
      'AN':'North America',
      'AO':'Africa',
      'AP':'Asia',
      'AQ':'Antartica',
      'AR':'South America',
      'AS':'Oceania',
      'AT':'Europe',
      'AU':'Oceania',
      'AW':'North America',
      'AX':'Europe',
      'AZ':'Asia',
      'BA':'Europe',
      'BB':'North America',
      'BD':'Asia',
      'BE':'Europe',
      'BF':'Africa',
      'BG':'Europe',
      'BH':'Asia',
      'BI':'Africa',
      'BJ':'Africa',
      'BL':'North America',
      'BM':'North America',
      'BN':'Asia',
      'BO':'South America',
      'BQ' :'South America',
      'BR':'South America',
      'BS':'North America',
      'BT':'Asia',
      'BV':'Antartica',
      'BW':'Africa',
      'BY':'Europe',
      'BZ':'North America',
      'CA':'North America',
      'CC':'Asia',
      'CD':'Africa',
      'CF':'Africa',
      'CG':'Africa',
      'CH':'Europe',
      'CI':'Africa',
      'CK':'Oceania',
      'CL':'South America',
      'CM':'Africa',
      'CN':'Asia',
      'CO':'South America',
      'CR':'North America',
      'CU':'North America',
      'CV':'Africa',
      'CX':'Asia',
      'CY':'Asia',
      'CZ':'Europe',
      'DE':'Europe',
      'DJ':'Africa',
      'DK':'Europe',
      'DM':'North America',
      'DO':'North America',
      'DZ':'Africa',
      'EC':'South America',
      'EE':'Europe',
      'EG':'Africa',
      'EH':'Africa',
      'ER':'Africa',
      'ES':'Europe',
      'ET':'Africa',
      'EU':'Europe',
      'FI':'Europe',
      'FJ':'Oceania',
      'FK':'South America',
      'FM':'Oceania',
      'FO':'Europe',
      'FR':'Europe',
      'FX':'Europe',
      'GA':'Africa',
      'GB':'Europe',
      'GD':'North America',
      'GE':'Asia',
      'GF':'South America',
      'GG':'Europe',
      'GH':'Africa',
      'GI':'Europe',
      'GL':'North America',
      'GM':'Africa',
      'GN':'Africa',
      'GP':'North America',
      'GQ':'Africa',
      'GR':'Europe',
      'GS':'Antartica',
      'GT':'North America',
      'GU':'Oceania',
      'GW':'Africa',
      'GY':'South America',
      'HK':'Asia',
      'HM':'Antartica',
      'HN':'North America',
      'HR':'Europe',
      'HT':'North America',
      'HU':'Europe',
      'ID':'Asia',
      'IE':'Europe',
      'IL':'Asia',
      'IM':'Europe',
      'IN':'Asia',
      'IO':'Asia',
      'IQ':'Asia',
      'IR':'Asia',
      'IS':'Europe',
      'IT':'Europe',
      'JE':'Europe',
      'JM':'North America',
      'JO':'Asia',
      'JP':'Asia',
      'KE':'Africa',
      'KG':'Asia',
      'KH':'Asia',
      'KI':'Oceania',
      'KM':'Africa',
      'KN':'North America',
      'KP':'Asia',
      'KR':'Asia',
      'KW':'Asia',
      'KY':'North America',
      'KZ':'Asia',
      'LA':'Asia',
      'LB':'Asia',
      'LC':'North America',
      'LI':'Europe',
      'LK':'Asia',
      'LR':'Africa',
      'LS':'Africa',
      'LT':'Europe',
      'LU':'Europe',
      'LV':'Europe',
      'LY':'Africa',
      'MA':'Africa',
      'MC':'Europe',
      'MD':'Europe',
      'ME':'Europe',
      'MF':'North America',
      'MG':'Africa',
      'MH':'Oceania',
      'MK':'Europe',
      'ML':'Africa',
      'MM':'Asia',
      'MN':'Asia',
      'MO':'Asia',
      'MP':'Oceania',
      'MQ':'North America',
      'MR':'Africa',
      'MS':'North America',
      'MT':'Europe',
      'MU':'Africa',
      'MV':'Asia',
      'MW':'Africa',
      'MX':'North America',
      'MY':'Asia',
      'MZ':'Africa',
      'NA':'Africa',
      'NC':'Oceania',
      'NE':'Africa',
      'NF':'Oceania',
      'NG':'Africa',
      'NI':'North America',
      'NL':'Europe',
      'NO':'Europe',
      'NP':'Asia',
      'NR':'Oceania',
      'NU':'Oceania',
      'NZ':'Oceania',
      'OM':'Asia',
      'PA':'North America',
      'PE':'South America',
      'PF':'Oceania',
      'PG':'Oceania',
      'PH':'Asia',
      'PK':'Asia',
      'PL':'Europe',
      'PM':'North America',
      'PN':'Oceania',
      'PR':'North America',
      'PS':'Asia',
      'PT':'Europe',
      'PW':'Oceania',
      'PY':'South America',
      'QA':'Asia',
      'RE':'Africa',
      'RO':'Europe',
      'RS':'Europe',
      'RU':'Europe',
      'RW':'Africa',
      'SA':'Asia',
      'SB':'Oceania',
      'SC':'Africa',
      'SD':'Africa',
      'SE':'Europe',
      'SG':'Asia',
      'SH':'Africa',
      'SI':'Europe',
      'SJ':'Europe',
      'SK':'Europe',
      'SL':'Africa',
      'SM':'Europe',
      'SN':'Africa',
      'SO':'Africa',
      'SR':'South America',
      'ST':'Africa',
      'SV':'North America',
      'SY':'Asia',
      'SZ':'Africa',
      'TC':'North America',
      'TD':'Africa',
      'TF':'Antartica',
      'TG':'Africa',
      'TH':'Asia',
      'TJ':'Asia',
      'TK':'Oceania',
      'TL':'Asia',
      'TM':'Asia',
      'TN':'Africa',
      'TO':'Oceania',
      'TR':'Europe',
      'TT':'North America',
      'TV':'Oceania',
      'TW':'Asia',
      'TZ':'Africa',
      'UA':'Europe',
      'UG':'Africa',
      'UM':'Oceania',
      'US':'North America',
      'UY':'South America',
      'UZ':'Asia',
      'VA':'Europe',
      'VC':'North America',
      'VE':'South America',
      'VG':'North America',
      'VI':'North America',
      'VN':'Asia',
      'VU':'Oceania',
      'WF':'Oceania',
      'WS':'Oceania',
      'YE':'Asia',
      'YT':'Africa',
      'ZA':'Africa',
      'ZM':'Africa',
      'ZW':'Africa'
    };

    return {
      lookup: function(abbr){
        return regions[abbr.toUpperCase()] || abbr;
      },
      lookupRegionFromCountry: function (country, province) {
        if(countries[country]){
          var result = countries[country].filter(function(data){
            return data.province === province
          });
          return result.length === 0 ? province : result[0]['province-name'];
        }
         else {
            return country;
         }
      },
      lookupCountryNameFromCode: function(countryCode){
        return codeToCountry[countryCode];
      },
      lookupContinent: function (countryCode) {
        return countryCodeToContinent[countryCode];
      }
    }
  }
}());

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .factory('pubSub', pubSub);

  function pubSub() {

    var listeners = [];

    function subscribe(callback) {
      listeners.push(callback);
    }

    function unsubscribe(callback) {
      var index = listeners.indexOf(callback);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    }

    function publish(message) {
      for (var i = 0; i < listeners.length; i++) {
        listeners[i](message);
      }
    }

    return {
      subscribe: subscribe,
      unsubscribe: unsubscribe,
      publish: publish
    }
  };
})();

(function () {
  'use strict';
  angular
    .module("storeLocator")
    .factory('moment', MomentService);

  function MomentService($window) {
    return $window.moment; // assumes underscore has already been loaded on the page
  }
}());

(function () {
    'use strict';

    angular
        .module('storeLocator')
        .factory('MFeedMarkerService', MFeedMarkerService);

    MFeedMarkerService.$inject = ['STORE_LOCATOR_MAP_TYPE',
        'STORE_LOCATOR_PIN',
        'STORE_LOCATOR_PIN_ICON_NO_NR',
        '$window',
        '$compile',
        'mapService',
        'storeLocatorDictionary',
        'mapHelper',
        'customFieldFactory',
        'MFeedMap',
        'pubSub',
        'storeLocatorCache'];
    function MFeedMarkerService(STORE_LOCATOR_MAP_TYPE,
        STORE_LOCATOR_PIN,
        STORE_LOCATOR_PIN_ICON_NO_NR,
        $window,
        $compile,
        mapService,
        storeLocatorDictionary,
        mapHelper,
        customFieldFactory,
        MFeedMap,
        pubSub,
        storeLocatorCache) {
        var service = {
            createMFMarker: createMFMarker
        };

        return service;

        function createMFMarker(mfMap, location, locatorStates, scope) {
            if (mapHelper.isGoogleMapsEnabled()) {
                return createGoogleMarker(mfMap.map, location, locatorStates, scope);
            }
            else {
                return createMapboxMarker(mfMap.map, location, locatorStates, scope);
            }
        }

        function createGoogleMarker(map, location, locatorStates, scope) {
            var findBorder = customFieldFactory.getValueByName(location.entire_location.custom_fields, 'custom_pin_border');
            var borderColor = findBorder ? findBorder : STORE_LOCATOR_PIN;

            var svg = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 144.9 200" xml:space="preserve"> \
                         <path stroke="' + borderColor + '" stroke-width="6" fill="' + STORE_LOCATOR_PIN + '" d="M72.5,12.3c-33.3,0-60.3,27-60.3,60.3c0,52.8,60.3,115.8,60.3,115.8s60.3-63,60.3-115.8 \
                           C132.9,39.3,105.8,12.3,72.5,12.3z M72.5,109.3c-20.3,0-36.7-16.4-36.7-36.7C35.8,52.4,52.3,36,72.5,36s36.7,16.4,36.7,36.7 \
                           C109.2,92.9,92.8,109.3,72.5,109.3z"/> \
                         <path fill="white" d="M 68.186839,108.94311 C 53.694467,106.92303 42.094081,97.362316 37.69889,83.815789 \
                           c -2.309623,-7.118544 -2.278746,-15.590568 0.08246,-22.624471 3.404628,-10.14221 11.48484,-18.671795 \
                           21.285937,-22.469732 13.409339,-5.196135 27.9895,-2.412608 38.39836,7.330706 5.234626,4.899923 \
                           8.821926,11.0678 10.626646,18.2711 0.89523,3.573195 1.1417,10.344745 0.51539,14.159987 -2.45518,14.955889 \
                           -13.99847,26.912781 -28.916878,29.952951 -3.044223,0.62038 -8.85315,0.87627 -11.503963,0.50678 z" /> \
                       </svg>'

            var marker = new google.maps.Marker({
                label: {
                    text: location.number.toString(),
                    color: "black",
                    fontSize: "12px",
                    fontWeight:"bold"
                },
                id: location.id,
                icon: {
                    labelOrigin: new google.maps.Point(24,18),
                    scaledSize: new google.maps.Size(48, 48),
                    url: 'data:image/svg+xml;base64,' + btoa(svg)
                }
            });

            var position = new google.maps.LatLng(location.latitude, location.longitude);
            marker.setPosition(position);


            var html = '<map-popup></map-popup>';
            var linkFunction = $compile(angular.element(html));
            var mapPopupScope = scope.$new();


            mapPopupScope.location = location;

            var infoWindow = new google.maps.InfoWindow({
                content: linkFunction(mapPopupScope)[0]
            });

            // Re-style popup on load
            // google.maps.event.addListener(infoWindow, 'domready', function(){
            //     var iwOuter = angular.element(document.querySelector(".gm-style-iw"));
            //     if(iwOuter){

            //       // Grab reference to class-less sibling element so we can traverse its children
            //       var iwBackground = iwOuter.prev();

            //       // Remove background shadow DIV
            //       var iwDropShadow = iwBackground.children(':nth-child(-n+2)');
            //       iwDropShadow.css({'display' : 'none'});

            //       // Remove white background DIV
            //       iwBackground.children(':nth-child(4)').css({'display' : 'none'});

            //       // Reposition close button
            //       var iwCloseBtn = iwOuter.next();
            //       iwCloseBtn.css({
            //         right: '30px', top: '20px'
            //       });
            //     }
            // });

            marker.addListener('click', function () {
                // close other markers
                var locationId;
                locatorStates.locationMarkersArray.forEach(function (m) {
                    if (m.locationId == location.id) {
                        locationId = m.locationId;
                    }
                    m.closePopup();
                });

                mapService.scrollToItem(locationId);
                infoWindow.open(map, marker);
                pubSub.publish({
                  msg: 'mapMarkerOnClick',
                  data: location
                });
                storeLocatorCache.save('location', location);
            });

            return new MFeedMap.GoogleMarker(marker, map, location.number, infoWindow, storeLocatorDictionary.zoomLevels, location.id);
        }

        function createMapboxMarker(map, location, locatorStates, scope) {
            // Pin Configs
            var configs = storeLocatorDictionary.mapConfigs;

            // Pin Element
            var pinElement = document.createElement('div');
            var pinSvg = '<svg viewBox="0 0 53 65" height="45px" width="40px" xmlns="http://www.w3.org/2000/svg"> \
                <defs> \
                    <filter id="blur" x="0" y="0"> \
                        <feGaussianBlur in="SourceGraphic" stdDeviation="2"/> \
                    </filter> \
                    <linearGradient y2="1" x2="1" y1="1" x1="1" id="shadow"> \
                        <stop offset="0" stop-color="#eeeeee"/> \
                        <stop offset="1" stop-color="#363636"/> \
                    </linearGradient> \
                </defs> \
                <ellipse fill="url(#shadow)" filter="url(#blur)" fill-opacity="0.38" ry="9.90476" \
                    rx="21.5" cy="53.34227" cx="26.9" stroke-width="1.5"/> \
                <path stroke="' + configs.pinBorderColor + '" fill="' + configs.pinColor + '" \
                    stroke-width="' + configs.pinBorderWidth +'" stroke-miterlimit="4" \
                    d="m46.16229,22.724c0,2.71981 -1.23537,6.16637 -3.08318,9.79967c-2.00316,3.79336 -4.26834,7.44242 -6.77882,10.92085c-2.47073,3.47761 -4.931,6.61277 -6.77882,8.87582c-0.56059,0.69547 -1.0692,1.29758 -1.49491,1.81665c-0.39454,0.46863 -0.97583,0.7391 -1.58828,0.7391c-0.61257,0 -1.19385,-0.27048 -1.58828,-0.7391c-0.42559,-0.51908 -0.93432,-1.12118 -1.49491,-1.81665c-1.84782,-2.26305 -4.31855,-5.3981 -6.77882,-8.87582c-2.51424,-3.47596 -4.77942,-7.12538 -6.77882,-10.92085c-1.84782,-3.63342 -3.08318,-7.07987 -3.08318,-9.79967c0,-10.89322 8.83078,-19.724 19.724,-19.724c10.89322,0 19.724,8.83078 19.724,19.724l0.00002,0z" /> \
                <text fill="' + configs.pinFontColor + '" font-family="' + configs.pinFontFamily + '" \
                    font-size="' + configs.pinFontSize + '" font-weight="' + configs.pinFontWeight + '" \
                    x="49%" y="37%" dominant-baseline="middle" text-anchor="middle"ml:space="preserve">' 
                 + (Boolean(configs.pinShowText) ? location.number : '') + '</text>';

            pinElement.innerHTML = pinSvg;
            pinElement.addEventListener('click', onMarkerClick);

            // Marker
            var mapboxMarker = new mapboxgl.Marker({
              element: pinElement,
              id: location.id,
              title: location.name,
              number: location.number.toString(),
              getMessageScope: function () {
                return scope;
              },
              location: location
            }).setLngLat([location.longitude, location.latitude]);

            // Popup
            var html = '<map-popup></map-popup>';
            var linkFunction = $compile(angular.element(html));
            var mapPopupScope = scope.$new();
            mapPopupScope.location = location;

            var popUp = new mapboxgl.Popup({ 
                offset: {
                    'top': [0, 15],
                    'bottom': [0, -27],
                }
            })
            .setDOMContent(linkFunction(mapPopupScope)[0])
            .setMaxWidth("300px")

            mapboxMarker.setPopup(popUp).addTo(map);

            // scroll in the results lists when the user clicks on specific map pin
            // mimics behavior from resultsLiDirective
            function onMarkerClick() {
                var selectedMarker = _.find(locatorStates.locationMarkersArray,
                    function (mfMarker) {
                        return mfMarker.number == location.number;
                    });
                if (selectedMarker) {
                    var viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
                    var offset = [0, 0]; // default offset
                    var currentZoom = map.getZoom();

                    if (Boolean(storeLocatorDictionary.mapConfigs.centerPointOnTheRight)) {
                        if (viewportWidth > 1260) {
                            offset = [400, 0];
                        } else if (viewportWidth > 767 && viewportWidth < 1260) {
                            offset = [200, 0];
                        } 
                    }

                    map.flyTo({
                        center: selectedMarker.marker.getLngLat(),
                        offset: offset,
                        zoom: currentZoom < storeLocatorDictionary.zoomLevels.store
                        ? storeLocatorDictionary.zoomLevels.store
                        : currentZoom
                    })
                    var locationId;
                    locatorStates.locationMarkersArray.forEach(function (m) {
                        if (m.locationId == location.id) {
                            locationId = m.locationId;
                        }
                        // close all markers
                        m.closePopup();
                    });

                    mapService.scrollToItem(locationId);

                    pubSub.publish({
                        msg: 'mapMarkerOnClick',
                        data: location
                    });
                    storeLocatorCache.save('location', location);
                }
            }

            return new MFeedMap.MapboxMarker(mapboxMarker, map, location.number, storeLocatorDictionary.zoomLevels, location.id);
        }
    }

})();

/**
 * @file This service is intended to serve as an abstraction layer for the Mapbox and Google Map APIs.
 *       Google Maps and Mapbox API specific code should go here.
 */
(function () {
    'use strict';

    angular
        .module('storeLocator')
        .factory('MFeedMap', MFeedMap);

    MFeedMap.$inject = ['storeLocatorDictionary'];
    function MFeedMap(storeLocatorDictionary) {

        var mfeed = {};

        /**
         * Represents a lat/lng pair.
         * @constructor
         * @param {google.maps.LatLng|mapboxgl.LngLat} latLng The API-specific LatLng object.
         */
        mfeed.LatLng = function (latLng) {
            this.lat;
            this.lng;
            if (latLng.latitude && latLng.longitude) {
                this.lat = latLng.latitude;
                this.lng = latLng.longitude;
            }
            else if (latLng instanceof mapboxgl.LngLat) {
                this.lat = latLng.lat;
                this.lng = latLng.lng;
            }
            else if (latLng instanceof google.maps.LatLng) {
                this.lat = latLng.lat();
                this.lng = latLng.lng();
            } 
        }

        /**
         * Represents a lat/lng bounds.
         * @constructor
         * @param {google.maps.LatLngBounds|mapboxgl.LngLatBounds} bounds The API-specific LatLngBounds object.
         */
        mfeed.LatLngBounds = function (bounds) {
            this.southWest = {};
            this.northEast = {};
            this.center = {};
            if (bounds instanceof mapboxgl.LngLatBounds) {
                this.southWest = new mfeed.LatLng(bounds.getSouthWest());
                this.northEast = new mfeed.LatLng(bounds.getNorthEast());
                this.center = new mfeed.LatLng(bounds.getCenter());
            }
            else if (bounds instanceof google.maps.LatLngBounds) {
                this.southWest = new mfeed.LatLng(bounds.getSouthWest());
                this.northEast = new mfeed.LatLng(bounds.getNorthEast());
                this.center = new mfeed.LatLng(bounds.getCenter());
            }
        }



        /****************************************************
        MFeed Map "Interface"
        *****************************************************/

        mfeed.Map = {
            buildMap: function () { },
            getBounds: function () { },
            removeMarker: function () { },
            setScrollWheelZoom: function () { },
            addTo: function () { },
            setView: function () { },
            setCurrentLocationMarker: function () { }
        };

        /****************************************************
        Mapbox Map Implementation
        *****************************************************/

        /**
         * Represents the core Map object.
         * @constructor
         * @param {L.Map} map The Mapbox API Map object.
         */
        mfeed.MapboxMap = function (map) {
            this.map = map;
        };

        mfeed.MapboxMap.prototype = Object.create(mfeed.Map);

        /**
         * Enables or disables scrollwheel zooming.
         * @param {Boolean} value Value indicating whether to enable or disable scrollwheel zooming.
         */
        mfeed.MapboxMap.prototype.setScrollWheelZoom = function (value) {
            if (!value) {
                this.map.scrollZoom.disable();
            }
            else {
                this.map.scrollZoom.enable({ around: 'center' });
            }
        }

       /**
         * Runs the initial setup processes for the map object.
         * @param {$rootScope.Scope} scope Value indicating whether to enable or disable scrollwheel zooming.
         * @param {Object} locatorStates LocatorStates object that handles store locator-related state data.
         * @callback initMapCallback Callback that runs once the map has loaded.
         */
        mfeed.MapboxMap.prototype.buildMap = function (scope, locatorStates, initMapCallback) {
            this.map.on('load', function () {

                // set lat/lng
                this.setCenter([locatorStates.mapCenter.longitude, locatorStates.mapCenter.latitude]);
                
                if (locatorStates.zoom) {
                    this.setZoom(locatorStates.zoom);
                }

                initMapCallback();         
                
                // show 'Search this Area' button after drag
                this.on('dragend', function () {
                    scope.safeApply(function () {
                        locatorStates.showSearchAreaBtn = true;
                    })
                });

                // show 'Search this Area' button after zoom changes
                if (Boolean(storeLocatorDictionary.mapConfigs.showSearchButtonOnZoomChange)) {
                    this.on('zoomend', function (e) {
                        scope.safeApply(function () {
                            locatorStates.showSearchAreaBtn = true;
                        })
                    });
                }
            });

            scope.safeApply = function(fn) {
                var phase = this.$root.$$phase;
                if(phase == '$apply' || phase == '$digest') {
                  if(fn && (typeof(fn) === 'function')) {
                    fn();
                  }
                } else {
                  this.$apply(fn);
                }
            };
        }

        /**
         * Returns the current bounds for the map.
         * @returns {mfeed.LatLngBounds}
         */
        mfeed.MapboxMap.prototype.getBounds = function () {
            return new mfeed.LatLngBounds(this.map.getBounds());
        }

        /**
        * Returns the current zoom level for the map.
        * @returns number
        */
        mfeed.MapboxMap.prototype.getZoom = function () {
            return this.map.getZoom();
        }

        /**
         * Removes the marker from its associated map.
         * @param {mfeed.MapboxMarker} mfMarker MFeed marker object to be removed from the map.
         */
        mfeed.MapboxMap.prototype.removeMarker = function (mfMarker) {
            mfMarker.marker.remove();
        }

        /**
         * Sets the map's view to the latitude/longitude and zoom level.
         * @param {mfeed.LatLng} mfLatLng Latitude/longitude to center the map around.
         * @param {Number} zoom Zoom level 
         */
        mfeed.MapboxMap.prototype.setView = function (mfLatLng, zoom) {
            var viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            var offset = [0, 0]; // default

            if (Boolean(storeLocatorDictionary.mapConfigs.centerPointOnTheRight)) {
                if (viewportWidth > 1260) {
                    offset = [-210, 0];
                } else if (viewportWidth > 767 && viewportWidth < 1260) {
                    offset = [-140, 0];
                } 
            }

            this.map.jumpTo({ center: [mfLatLng.lng, mfLatLng.lat], zoom: zoom || null })
            this.map.panBy(offset);
        }

        /**
         * Sets the current location marker.
         * @param {GeoJSON} currentLocation GeoJSON-formatted object representing the user's current location.
         */
        mfeed.MapboxMap.prototype.setCurrentLocationMarker = function (currentLocation) {
            var viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            var geo = currentLocation.geometry;
            var offset = [0, 0]; // default

            if (Boolean(storeLocatorDictionary.mapConfigs.centerPointOnTheRight)) {
                if (viewportWidth > 1260) {
                    offset = [-200, 0];
                } else if (viewportWidth > 767 && viewportWidth < 1260) {
                    offset = [-140, 0];
                } 
            }

            this.map.jumpTo({ center: [geo.coordinates[0], geo.coordinates[1]], zoom: storeLocatorDictionary.zoomLevels.nearMe });
            this.map.panBy(offset);
        }

        /****************************************************
        Google Maps Implementation
        *****************************************************/

        /**
         * Represents the core Map object.
         * @constructor
         * @param {google.maps.Map} map The Google Maps API Map object.
         */
        mfeed.GoogleMap = function (map) {
            this.map = map;
        };

        mfeed.GoogleMap.prototype = Object.create(mfeed.Map);

        /**
         * Enables or disables scrollwheel zooming.
         * @param {Boolean} value Value indicating whether to enable or disable scrollwheel zooming.
         */
        mfeed.GoogleMap.prototype.setScrollWheelZoom = function (value) {
            this.map.set('scrollWheel', value);
        }

        /**
         * Runs the initial setup processes for the map object.
         * @param {$rootScope.Scope} scope Value indicating whether to enable or disable scrollwheel zooming.
         * @param {Object} locatorStates LocatorStates object that handles store locator-related state data.
         * @callback initMapCallback Callback that runs once the map has loaded.
         */
        mfeed.GoogleMap.prototype.buildMap = function (scope, locatorStates, initMap) {
            initMap();

            // set basic lat/lng
            this.map.setCenter(new google.maps.LatLng(
                locatorStates.mapCenter.latitude,
                locatorStates.mapCenter.longitude));

            if (locatorStates.zoom) {
                this.map.setZoom(+locatorStates.zoom);
            }

            // show 'Search this Area' button after drag
            google.maps.event.addListener(this.map, 'dragend', function () {
                scope.$apply(function() {
                    locatorStates.showSearchAreaBtn = true;
                });
            });

        }

        /**
         * Returns the current bounds for the map.
         * @returns {mfeed.LatLngBounds}
         */
        mfeed.GoogleMap.prototype.getBounds = function () {
            return new mfeed.LatLngBounds(this.map.getBounds());
        }

        /**
        * Returns the current zoom level for the map.
        * @returns number
        */
        mfeed.GoogleMap.prototype.getZoom = function () {
            return this.map.getZoom();
        }

        /**
         * Removes the marker from its associated map.
         * @param {mfeed.GoogleMarker} mfMarker MFeed marker object to be removed from the map.
         */
        mfeed.GoogleMap.prototype.removeMarker = function (mfMarker) {
            if (mfMarker) {
                mfMarker.marker.setMap(null);
            }
        }

        /**
         * Sets the map's view to the latitude/longitude and zoom level.
         * @param {mfeed.LatLng} mfLatLng Latitude/longitude to center the map around.
         * @param {Number} zoom Zoom level 
         */
        mfeed.GoogleMap.prototype.setView = function (mfLatLng, zoom) {
            this.map.setCenter(new google.maps.LatLng(mfLatLng.lat, mfLatLng.lng));
            if (zoom) {
                this.map.setZoom(+zoom);
            }
        }

        /**
         * Sets the current location marker.
         * @param {GeoJSON} currentLocation GeoJSON-formatted object representing the user's current location.
         */
        mfeed.GoogleMap.prototype.setCurrentLocationMarker = function (currentLocation) {
            this.map.data.addGeoJson(currentLocation);

            // set's the custom icon for the user's current location once setCurrentLocationMarker has been invoked
            this.map.data.setStyle(function (feature) {
                return {
                    icon: feature.getProperty('icon').iconPath,
                    clickable: false
                };
            });
        }




        /****************************************************
        MFeed Marker "Interface"
        *****************************************************/

        mfeed.Marker = {
            closePopup: function () { },
            openPopup: function () { },
            addToMap: function () { },
            zoomTo: function () { },
            getLatLng: function () { }
        };

        /****************************************************
        Mapbox Marker Implementation
        *****************************************************/

        /**
         * Represents the core Marker object.
         * @constructor
         * @param {L.Marker} map The Mapbox API Marker object.
         */
        mfeed.MapboxMarker = function (marker, map, number, zoomLevels, locationId) {
            this.marker = marker;
            this.map = map;
            this.number = number;
            this.zoomLevels = zoomLevels;
            this.locationId = locationId;
        };

        mfeed.MapboxMarker.prototype = Object.create(mfeed.Marker);

        /**
         * Closes the popup bound to the marker.
         */
        mfeed.MapboxMarker.prototype.closePopup = function () {
            if (this.marker.getPopup().isOpen()) {
                this.marker.togglePopup();
            }
        }

        /**
         * Opens the popup associated with the marker and pans the map to it.
         */
        mfeed.MapboxMarker.prototype.openPopup = function () {
            if (!this.marker.getPopup().isOpen()) {
                this.marker.togglePopup();
            }
        }

        /**
         * Adds the marker to its associated map.
         */
        mfeed.MapboxMarker.prototype.addToMap = function () {
            this.marker.addTo(this.map);
        }

        /**
         * Zooms (and pans) the map to the marker.
         */
        mfeed.MapboxMarker.prototype.zoomTo = function () {
            var viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            var offset = [0, 0]; // default offset

            if (Boolean(storeLocatorDictionary.mapConfigs.centerPointOnTheRight)) {
                if (viewportWidth > 1260) {
                    offset = [400, 0];
                } else if (viewportWidth > 767 && viewportWidth < 1260) {
                    offset = [200, 0];
                } 
            }

            var currentZoom = this.map.getZoom();
            this.map.flyTo({
              center: this.marker.getLngLat(),
              offset: offset,
              zoom: currentZoom < this.zoomLevels.store
                ? this.zoomLevels.store
                : currentZoom
            })
        }

        /**
         * Returns the Lat/Lng of the marker.
         * @returns {mfeed.LatLng} Lat/Lng pair
         */
        mfeed.MapboxMarker.prototype.getLatLng = function () {
            return new mfeed.LatLng(this.marker.getLatLng());
        }

        /****************************************************
        Google Marker Implementation
        *****************************************************/

        /**
         * Represents the core Marker object.
         * @constructor
         * @param {google.maps.Marker} map The Google Maps API Marker object.
         */
        mfeed.GoogleMarker = function (marker, map, number, infoWindow, zoomLevels, locationId) {
            this.marker = marker;
            this.map = map;
            this.number = number;
            this.zoomLevels = zoomLevels;
            this.infoWindow = infoWindow;
            this.locationId = locationId;
        };

        mfeed.GoogleMarker.prototype = Object.create(mfeed.Marker);

        /**
         * Closes the popup bound to the marker.
         */
        mfeed.GoogleMarker.prototype.closePopup = function () {
            this.infoWindow.close();
        }

        /**
         * Opens the popup associated with the marker and pans the map to it.
         */
        mfeed.GoogleMarker.prototype.openPopup = function () {
            this.infoWindow.open(this.map, this.marker);
        }

        /**
         * Adds the marker to its associated map.
         */
        mfeed.GoogleMarker.prototype.addToMap = function () {
            this.marker.setMap(this.map);
        }

        /**
         * Zooms (and pans) the map to the marker.
         */
        mfeed.GoogleMarker.prototype.zoomTo = function () {
            //TODO: Investigate ways to make panning smoother like Mapbox's setZoomAround method
            this.map.panTo(this.marker.getPosition());

            var currentZoom = this.map.getZoom();
            var zoom = currentZoom < this.zoomLevels.store
                ? this.zoomLevels.store
                : currentZoom
            this.map.setZoom(zoom);
        }

        /**
         * Returns the Lat/Lng of the marker.
         * @returns {mfeed.LatLng} Lat/Lng pair
         */
        mfeed.GoogleMarker.prototype.getLatLng = function () {
            return new mfeed.LatLng(this.marker.getPosition());
        }

        return mfeed;
    }

})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .factory('mfReviewFactory', mfReviewFactory);

  function mfReviewFactory(APIMenuService) {
    var mfReviewBaseUrl = "analytics/api/momentfeed";
    return {
      getMfReviewFromLocation: getMfReviewFromLocation,
      postMfReviewOnLocation: postMfReviewOnLocation
    };
    function getMfReviewFromLocation(id, page, pageSize, published) {
      var params = {
        page: page,
        pageSize: pageSize,
        published: published
      };
      var req = APIMenuService.one(mfReviewBaseUrl + "/location/" + id);
      return req.get(params);
    }
    function postMfReviewOnLocation(params) {
      var req = APIMenuService.one(mfReviewBaseUrl);
      return req.post("",params);
    }
  }

})();

(function () {
  'use strict';
  angular
    .module("storeLocator")
    .factory('_', LodashService);

  function LodashService($window) {
    //Add some mixins
    $window._.mixin({
      //Removes the null fields from an object
      compactObject: function (o) {
        var clone = _.clone(o);
        _.each(clone, function (v, k) {
          if (!v) {
            delete clone[k];
          }
        });
        return clone;
      }
    });
    return $window._; // assumes underscore has already been loaded on the page
  }
}());

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .provider("googleMapsLoader", googleMapsLoaderProvider)
    .run(function ($rootScope, googleMapsLoader) {
      googleMapsLoader.then(function () {
        $rootScope.isGoogleMapsApiLoaded = true;
      });
    });

  googleMapsLoaderProvider.$inject = [];
  function googleMapsLoaderProvider() {
    this.$get = googleMapsLoader;

    googleMapsLoader.$inject = ['$q', 'GOOGLE_API_KEY', '$window', 'mapHelper'];
    function googleMapsLoader($q, GOOGLE_API_KEY, $window, mapHelper) {
      var deferred = $q.defer();

      if (!mapHelper.isGoogleMapsEnabled()) {
        deferred.reject();
      }

      var onError = function () {
        deferred.reject();
      }

      if ($window.google && $window.google.maps) {
        deferred.resolve();
      } else {
        $window.onGoogleScriptLoad = function () {
          if ($window.google && $window.google.maps) {
            deferred.resolve();
          }
          else {
            deferred.reject();
          }
        };

        var script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = "https://maps.google.com/maps/api/js?v=3.31&libraries=places&callback=onGoogleScriptLoad&key=" + GOOGLE_API_KEY;

        script.onerror = onError;
        document.body.appendChild(script);
      }

      return deferred.promise;
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('storeLocator')
        .service('geocodeService', geocodeService);

    geocodeService.$inject = [
        'MAPBOX_KEY',
        'MAPBOX_GEOCODE_URL',
        'Restangular',
        's',
        'STORE_LOCATOR_SEARCH_COUNTRY',
        'STORE_LOCATOR_SEARCH_TYPE',
        '$q'];

    function geocodeService(MAPBOX_KEY,
        MAPBOX_GEOCODE_URL,
        Restangular,
        s,
        STORE_LOCATOR_SEARCH_COUNTRY,
        STORE_LOCATOR_SEARCH_TYPE,
        $q) {

        var googleGeocoder;

        var service = {
            geocodeGoogle: geocodeGoogle,
            reverseGeocodeGoogle: reverseGeocodeGoogle,
            geocodeMapbox: geocodeMapbox
        };
        return service;

        /**
         * Converts an address to a place.
         * This is a Google-specific function that should be moved to mfeed_map.service.js.
         * @param {string} address The address to be geocoded.
         * @param {MFeed.LatLngBounds} bounds Lat/Lng bounds for biasing the results towards the current viewport.
         * @returns {Promise<google.maps.GeocoderResult>} A promise containing the GeocoderResult object.
         */
        function geocodeGoogle(address, bounds) {
            if (!googleGeocoder) {
                googleGeocoder = new google.maps.Geocoder();
            }

            var deferred = $q.defer();

            var requestParams = { 'address': address };

            if (bounds) {
                requestParams.bounds = new google.maps.LatLngBounds(
                    {
                        lat: bounds.southWest.lat,
                        lng: bounds.southWest.lng
                    },
                    {
                        lat: bounds.northEast.lat,
                        lng: bounds.northEast.lng
                    });
            }

            googleGeocoder.geocode(requestParams, function (results, status) {
                if (status == 'OK') {
                    deferred.resolve(results[0]);
                }
                else {
                    deferred.reject();
                }
            });

            return deferred.promise;
        }

        /**
         * Converts a latitude/longitude pair into a list of possible locations at varying levels of specificity (street, zip, locality, county, state, country, etc).
         * This is a Google-specific function that should be moved to mfeed_map.service.js.
         * @param {number} latitude
         * @param {number} longitude
         * @returns {Promise<google.maps.GeocoderResult[]>} A promise containing an array of GeocoderResult objects.
         */
        function reverseGeocodeGoogle(latitude, longitude) {
            if (!googleGeocoder) {
                googleGeocoder = new google.maps.Geocoder();
            }

            var deferred = $q.defer();

            var requestParams = {
                "location":
                {
                    "lat": latitude,
                    "lng": longitude
                }
            };

            googleGeocoder.geocode(requestParams, function (results, status) {
                if (status === 'OK') {
                    deferred.resolve(results);
                } else {
                    deferred.reject();
                }
            });

            return deferred.promise;
        }

        /**
         * Converts an address to a location specified in the Carmen GeoJSON format used by Mapbox.
         * This is a Mapbox-specific function that should be moved to mfeed_map.service.js.
         * @param {string} address The address to be geocoded.
         * @param {number} latitude Latitude for biasing the results.
         * @param {number} longitude Longitude for biasing the results.
         * @returns {Promise<GeoJSON>} A promise containing a Carmen GeoJSON object.
         */
        function geocodeMapbox(address, latitude, longitude) {
            var url = s(MAPBOX_GEOCODE_URL).sprintf(encodeURIComponent(address)).value();
            var params = {
                "access_token": MAPBOX_KEY,
                "country": STORE_LOCATOR_SEARCH_COUNTRY,
                "types": STORE_LOCATOR_SEARCH_TYPE
            };
            if (latitude && longitude) params.proximity = longitude + "," + latitude;

            return Restangular.oneUrl('geocode', url).get(params).then(function (response) {
                return response.features[0];
            });
        }

    }
})();
(function () {
  'use strict';

  angular
    .module('storeLocator')
    .directive('elemReady', function ($parse) {
      return {
        restrict: 'A',
        link: function ($scope, elem, attrs) {
          setTimeout(function () {
            var started;

            elem.load(function () {
              if (!started) $scope.$apply(function () {
                var func = $parse(attrs.elemReady);
                func($scope);
                started = true;
              })
            });

            elem.ready(function () {
              if (!started) $scope.$apply(function () {
                var func = $parse(attrs.elemReady);
                func($scope);
                started = true;
              })
            })
          })

        }
      }
    })
})();

(function () {
  'use strict';

  angular
    .module('storeLocator')
    .factory('customFieldFactory', customFieldFactory);

  function customFieldFactory() {
    var factory = {
      getValueByName: getValueByName,
      getFieldCountByName: getFieldCountByName,
      getFieldCountByRegex: getFieldCountByRegex,
      getButtonCount: getButtonCount,
      getImageCount: getImageCount
    };

    function getValueByName(customFields, customFieldName) {
      if (customFields) {
        var field = _.find(customFields, {'name': customFieldName});
        if (field) {
          return field.data;
        }
      }

      return null;
    }

    function getFieldCountByName(customFields, customFieldName){
      if (customFields){
        var fields = _.filter(customFields, function(field){
          return field.name.toLowerCase().indexOf(customFieldName.toLowerCase()) === 0;
        });
        return fields.length;
      }
      return 0;
    }


    function getFieldCountByRegex(customFields, regex) {
      if (customFields) {
        var fields = _.filter(customFields, function (field) {
          return field.name.match(regex);
        });
        return fields.length;
      }
      return 0;
    }

    function getButtonCount(customFields) {
      return getFieldCountByRegex(customFields,new RegExp(/^button\d+_text$/));
    }

    function getImageCount(customFields) {
      return getFieldCountByRegex(customFields, new RegExp(/^single_image\d+$/));
    }


    return factory;
  }
})();

(function () {
  'use strict';

  angular
      .module('storeLocator')
      .factory('MetaDataService', MetaDataService);

  /*
   Need to decide on security(EC2/Apegee?)
   */
  function MetaDataService(APIService, META, _) {
    var metaData = {};
    var currentLocation = null;
    var pixel = null;

    var initPixel = _.once(function(pixel_id){
      fbq && fbq('init', pixel_id);
    });

    var mds = {
      //Don't really need this now
      loadMetaData: function(location_id){
        var req = APIService.one("llp/meta.json");
        return req.get({location_id: location_id}).then(function (o) {
          mds.setMetaData(o.data);
          return o.data;
        });
      },
      getMetaData: function(){
        return metaData;
      },
      resetMeta: function(){
        metaData = {};
        currentLocation = null;
        pixel = null;
      },
      setMetaData: function (meta, location) {
        mds.resetMeta();
        currentLocation = location;
        meta = meta || {};
        //Set metadata from location object OR use the default metadata in the client config
        _.each(META, function (v, k) {
          metaData[k] = meta[k] || v;
        });

        //Set the pixel id for tracking if it exists
        metaData.fbPixelId = meta.$$fb_pixel_id;
	       metaData.cluster_pins_llp = meta.cluster_pins_llp
        var fbTracking = {};
        //Build custom FB tracking object
        if(_.isObject(currentLocation)){
          var si = currentLocation.store_info || {};
          fbTracking.corporate_id = si.corporate_id;
          fbTracking.address = si.address;
          fbTracking.locality = si.locality;
          fbTracking.region = si.region;
          fbTracking.postcode = si.postcode;
          fbTracking.country = si.country;
        }
        fbTracking.isLandingPage = !!currentLocation;
        metaData.fbTracking = _.compactObject(fbTracking);
        if(meta.fb_pixel_enabled && metaData.fbPixelId){
          initPixel(metaData.fbPixelId);
          if(fbq){
            //Regular page view event
            fbq('track', 'PageView', fbTracking);
            //Standar event for campaign conversions
            fbq('track', 'ViewContent', fbTracking);
          }
        }
      }
    };
    return mds;
  }


})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .factory('APIService', APIService);

  /*
  Need to decide on security(EC2/Apegee?)
   */
  function APIService(API_HOST,API_TOKEN, Restangular) {
    return Restangular.withConfig(function (RestangularConfigurer) {
      RestangularConfigurer.setBaseUrl(API_HOST);
      RestangularConfigurer.setDefaultRequestParams({auth_token:API_TOKEN});
      RestangularConfigurer.setFullResponse(true);
      //Setting the timeout to 10 seconds to prevent 404 codes being returned prematurely in the case of clients with a
      //large number of locations and causing an unwanted side-effect with the logic of the error pages.
      RestangularConfigurer.setDefaultHttpFields({timeout: 10000});
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .factory('APILocationFinderService', APILocationFinderService);

  /*
  Need to decide on security(EC2/Apegee?)
   */
  function APILocationFinderService(API_HOST_LF, API_TOKEN, MULTI_ACCOUNT,Restangular) {
    return Restangular.withConfig(function (RestangularConfigurer) {
      RestangularConfigurer.setBaseUrl(API_HOST_LF);
      // RestangularConfigurer.setDefaultRequestParams({auth_token:API_TOKEN, multi_account:MULTI_ACCOUNT}); // Removed to allow for auto cache refresh
      RestangularConfigurer.setFullResponse(true);
      //Setting the timeout to 10 seconds to prevent 404 codes being returned prematurely in the case of clients with a
      //large number of locations and causing an unwanted side-effect with the logic of the error pages.
      RestangularConfigurer.setDefaultHttpFields({timeout: 10000});
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .factory('APISiteMapNewService', APISiteMapNewService);

  /*
  Need to decide on security(EC2/Apegee?)
   */
  function APISiteMapNewService(API_HOST_NEW_SITE_MAP, API_TOKEN, USE_NEW_SITE_MAP, ACCOUNT_ID, Restangular) {
    return Restangular.withConfig(function (RestangularConfigurer) {
      RestangularConfigurer.setBaseUrl(API_HOST_NEW_SITE_MAP);
      // hard coding the value of cricket wireless since this new sitemap is only being used for them. will
      // have to change the value to a param when we start rolling the new sitemap top other clients.
      RestangularConfigurer.setDefaultRequestParams({accountId:ACCOUNT_ID});
      RestangularConfigurer.setFullResponse(true);
      //Setting the timeout to 10 seconds to prevent 404 codes being returned prematurely in the case of clients with a
      //large number of locations and causing an unwanted side-effect with the logic of the error pages.
      RestangularConfigurer.setDefaultHttpFields({timeout: 10000});

    });
  }

})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .factory('APIMenuService', APIMenuService);

  function APIMenuService(REVIEWS_API_HOST,API_TOKEN, Restangular) {
    return Restangular.withConfig(function (RestangularConfigurer) {
      RestangularConfigurer.setBaseUrl(REVIEWS_API_HOST);
      RestangularConfigurer.setDefaultRequestParams({auth_token:API_TOKEN});
      RestangularConfigurer.setFullResponse(true);

    });
  }

})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .factory('APIServiceAuthHeader', APIServiceAuthHeader);

  /*
  Need to decide on security(EC2/Apegee?)
   */
  function APIServiceAuthHeader(API_HOST,API_TOKEN, Restangular) {
    return Restangular.withConfig(function (RestangularConfigurer) {
      RestangularConfigurer.setBaseUrl(API_HOST);
      RestangularConfigurer.setDefaultHeaders({Authorization: API_TOKEN});
      RestangularConfigurer.setFullResponse(true);
      //Setting the timeout to 10 seconds to prevent 404 codes being returned prematurely in the case of clients with a
      //large number of locations and causing an unwanted side-effect with the logic of the error pages.
      RestangularConfigurer.setDefaultHttpFields({timeout: 10000});
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .controller('RootController', RootController);

  /** @ngInject */

  function RootController(META, $window, _, $state, $rootScope, MetaDataService, $location, pubSub, BASE_URL) {

    var $ctrl = this;
    $ctrl.state = $state;
    $ctrl.metaData = {};
    MetaDataService.loadMetaData().then(function(response) {
      $ctrl.metaData = response;
      // initial determine location
      determineLocation();
    }.bind(this));

    pubSub.subscribe(llpMetaCallback);


    function determineLocation() {
      // if $location.path() === '/' --> show storeLocator meta data
      if(onStoreLocatorPage_()) {
        setStoreLocatorMeta();
      } else {
        // else show the llp meta
        setLLPMeta();
      }
    };

    function onStoreLocatorPage_() {
      return $location.path() === '/';
    };

    // this is coming from the LLP controller - after passing in the location_id, we are
    // getting a new response with dynamic field data present.
    function llpMetaCallback(response) {
      if(response.meta && !onStoreLocatorPage_()) {
        $ctrl.metaData['title'] = response.meta.title;
        $ctrl.metaData['description'] = response.meta.description;
        $ctrl.metaData['keywords'] = response.meta.keywords;
        $ctrl.metaData['location_finder_title'] = response.meta.location_finder_title;
        $ctrl.metaData['location_finder_description'] = response.meta.location_finder_description;
        $ctrl.metaData['location_finder_keywords'] = response.meta.location_finder_keywords;
      }

      if(response.msg === 'metaImage' && !onStoreLocatorPage_()) {
        $ctrl.metaData['image'] = response.img;
      }

      determineLocation();
    }

    //We don't want to index pages on search or produs, so we use this to flag and change the robots tag accordingly.
    // $rootScope.mfNoIndexPage = $location.host().indexOf('momentfeed.com') > -1 || $location.host().indexOf('produs.llp.momentfeed.com') > -1;

    function setStoreLocatorMeta() {
        $rootScope.title = function(){
          var metaTitle = $ctrl.metaData['location_finder_title'],
              fallbackTitle = META.location_finder_title ? META.location_finder_title : '',
              title = s(metaTitle || fallbackTitle)
                  .replace('undefined', '')
                  .replace('null', '')
                  .trim().clean().value();
          return title;
        };

        $rootScope.description = function(){
          var metaDescription = $ctrl.metaData['location_finder_description'],
              fallbackDescription = META.location_finder_description ? META.location_finder_description : '',
              description = s(metaDescription || fallbackDescription)
                  .replace('undefined', '')
                  .replace('null', '')
                  .trim().clean().value();
          return description;
        };

        $rootScope.keywords = function(){
          var metaKeywords = $ctrl.metaData['location_finder_keywords'],
              fallbackKeywords = META.location_finder_keywords ? META.location_finder_keywords : '',
              keywords = s(metaKeywords || fallbackKeywords)
                  .replace('undefined', '')
                  .replace('null', '')
                  .trim().clean().value();
          return keywords;
        };
      };

      function setLLPMeta() {
        $rootScope.title = function(){
          var metaTitle = $ctrl.metaData['title'],
              fallbackTitle = META.title ? META.title : '',
              title = s(metaTitle || fallbackTitle)
                  .replace('undefined', '')
                  .replace('null', '')
                  .trim().clean().value();
          return title;
        };

        $rootScope.image = function() {
            var src = $ctrl.metaData['image'];
            return src;
        };

        $rootScope.description = function(){
          var metaDescription = $ctrl.metaData['description'],
              fallbackDescription = META.description ? META.description : '',
              description = s(metaDescription || fallbackDescription)
                  .replace('undefined', '')
                  .replace('null', '')
                  .trim().clean().value();
          return description;
        };

        $rootScope.keywords = function(){
          var metaKeywords = $ctrl.metaData['keywords'],
              fallbackKeywords = META.keywords ? META.keywords : '',
              keywords = s(metaKeywords || fallbackKeywords)
                  .replace('undefined', '')
                  .replace('null', '')
                  .trim().clean().value();
          return keywords;
        };
      };

      $rootScope.canonical_url = function(){
        if(BASE_URL.indexOf('thrifty') > -1 || BASE_URL.indexOf('dollar') > -1){
          return (BASE_URL + $location.$$path).toLowerCase();
        }
        return BASE_URL + $location.$$path;
      };
      $rootScope.metaFind = function(f){
        return MetaDataService.getMetaData()[f];
      };
      $rootScope.showMetaFind = function(f){
        return !_.isUndefined($rootScope.metaFind(f));
      };

      $rootScope.isMobile = {
        android: function() { return navigator.userAgent.match(/Android/i); },
        ios: function() { return navigator.userAgent.match(/iPhone|iPad|iPod/i); }
      };
  }
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .run(['$rootScope', '$anchorScroll', '$location', function ($rootScope, $anchorScroll, $location) {
        $rootScope.$on("$locationChangeSuccess", function () {
           $anchorScroll();
        });
    }]);
})();

(function() {
  'use strict';

  angular
    .module('storeLocator')
    .config(routerConfig)
    .run(resetFocus);

    function resetFocus($rootScope) {
      $rootScope.$on('$viewContentLoaded' , function() {
          var firstInteractiveItem = angular.element("a.visually-hidden")[0];

          if (firstInteractiveItem) {
            firstInteractiveItem.focus();
          }
      });
    }

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, STORE_LOCATOR, LOCAL_LANDING_PAGE, ROOT_PAGE, SITE_MAP_PAGE, CLIENT_NAME, CLIENT_ROUTE) {
    //Use custom store locator for Cricket
    var storeLocatorCtrl = 'storeLocatorController';

    function getUrl(route) {
      return CLIENT_ROUTE == '' ? route : CLIENT_ROUTE + route;
    }

    $urlRouterProvider.otherwise(getUrl('/'));

    $stateProvider
      .state('root', {
        templateUrl: ROOT_PAGE,
        controller: 'RootController',
        controllerAs: 'rootC'
      })
      .state('root.home', {
        url: getUrl('/'),
        templateUrl: STORE_LOCATOR,
        controller: storeLocatorCtrl,
        controllerAs: 'storeLocatorCtrl',
        title: 'Store Locator'
      })
      .state('root.localLanding', {
        url: getUrl('/ll/:country/:region/:locality/:address'),
        templateUrl: LOCAL_LANDING_PAGE,
        controller: 'LocalLandingController',
        controllerAs: 'localLanding',
        resolve: {
          'MetaData': function (META, MetaDataService) {
            MetaDataService.setMetaData();
            return META.promise;
          }
        }
      })
      // Added for visionworks new requirement to include the name as parameter before country, start
      .state('root.localLandingWithName', {
        url: getUrl('/ll/:name/:country/:region/:locality/:address'),
        templateUrl: LOCAL_LANDING_PAGE,
        controller: 'LocalLandingController',
        controllerAs: 'localLanding',
        resolve: {
          'MetaData': function (META, MetaDataService) {
            MetaDataService.setMetaData();
            return META.promise;
          }
        }
      })
      // Added for visionworks new requirement to include the name as parameter before country, end
      .state('root.siteMap', {
        url: getUrl('/site-map'),
        templateUrl: SITE_MAP_PAGE,
        controller: 'SiteMapController',
        controllerAs: 'siteMapC',
        title: 'Site Map',
        params: {continent: null},
        resolve: {
            'MetaData': function (META, MetaDataService) {
                MetaDataService.setMetaData();
                return META.promise;
            }
        }
      })
      .state('root.siteMapAll', {
        url: getUrl('/site-map/all'),
        templateUrl: SITE_MAP_PAGE,
        controller: 'SiteMapController',
        controllerAs: 'siteMapC',
        title: 'Site Map',
        params: {all: true},
        resolve: {
          'MetaData': function (META, MetaDataService) {
            MetaDataService.setMetaData();
            return META.promise;
          }
        }
      })
      .state('root.siteMapCountry', {
        url: getUrl('/site-map/:country'),
        templateUrl: SITE_MAP_PAGE,
        controller: 'SiteMapController',
        controllerAs: 'siteMapC',
        title: 'Site Map',
        resolve: {
            'MetaData': function (META, MetaDataService) {
                MetaDataService.setMetaData();
                return META.promise;
            }
        }
      })
      .state('root.siteMapRegion', {
        url: getUrl('/site-map/:country/:region'),
        templateUrl: SITE_MAP_PAGE,
        controller: 'SiteMapController',
        controllerAs: 'siteMapC',
        title: 'Site Map',
        resolve: {
            'MetaData': function (META, MetaDataService) {
                MetaDataService.setMetaData();
                return META.promise;
            }
        }
      })
      .state('root.siteMapLocality', {
        url: getUrl('/site-map/:country/:region/:locality'),
        templateUrl: SITE_MAP_PAGE,
        controller: 'SiteMapController',
        controllerAs: 'siteMapC',
        title: 'Site Map',
        resolve: {
            'MetaData': function (META, MetaDataService) {
                MetaDataService.setMetaData();
                return META.promise;
            }
        }
      })

      .state('404', {
        url: '/404',
        templateUrl: 'app/errorPages/404.html',
        controller: '404errorCard',
        controllerAs: '404Ctrl'
      })

      .state('400', {
        url: '/400',
        templateUrl: 'app/errorPages/400.html',
        controller: '400errorCard',
        controllerAs: '400Ctrl'
      })
      .state('500', {
        url: '/500',
        templateUrl: 'app/errorPages/500.html',
        controller: '500errorCard',
        controllerAs: '500Ctrl'
      })
  }

})();

(function() { 
	'use strict'; 
	angular.module("storeLocator")
.constant("GOOGLE_API_KEY", "AIzaSyAgr874vecmMeUMxLw2hRbHUrCKgoX1mPw")
.constant("API_HOST", "https://api.momentfeed.com/v1/analytics/api")
.constant("API_HOST_NEW_SITE_MAP", "https://api.momentfeed.com/v1/lf/directory/")
.constant("API_HOST_LF", "https://api.momentfeed.com/v1/lf")
.constant("MENU_API_HOST", "https://api.momentfeed.com/v1/menus")
.constant("REVIEWS_API_HOST", "https://app.momentfeed.com")
.constant("GOOGLE_GEOCODE_URL", "https://maps.googleapis.com/maps/api/geocode/json")
.constant("MAPBOX_KEY", "pk.eyJ1IjoibW9tZW50ZmVlZCIsImEiOiJPS21SYV80In0.rZ-uswLQiEx1hkfcj5fVhw")
.constant("MAPBOX_GEOCODE_URL", "https://api.mapbox.com/geocoding/v5/mapbox.places/%s.json")
.constant("CLOUDINARY_NAME", "dvx9kdae1")
.constant("STORE_LOCATOR_MAP_TYPE", "Mapbox")
.constant("STORE_LOCATOR_GOOGLE_SEARCH_TYPE", "geocode")
.constant("LOCATIONS_API", "llp.json")
.constant("USE_NAME_INSTEAD_TAGS", false)
.constant("FORCE_GEOLOCATION", false)
.constant("CLIENT_ROUTE", "")
.constant("STORE_LOCATOR_TEXT", "Store Locator")
.constant("HAM_NAV_DATA", [])
.constant("HAM_NAV_TOGGLE", false)
.constant("ACCOUNT_ID", "")
.constant("STORE_LOCATOR_LOC_ID", "")
.constant("BOOKING_LOC_ID", "")
.constant("USE_NEW_SITE_MAP", false)
.constant("USES_METRIC", false)
.constant("STORE_LOCATOR_MAP_CONFIGS", "")
.constant("DISABLE_SCRIPTS_ON_QA", true);
 })();
(function() {
  'use strict';

  angular
    .module('storeLocator')
    .config(config);

  /** @ngInject */
  function config($logProvider, $locationProvider,
    RestangularProvider, API_HOST, cloudinaryProvider, CLOUDINARY_NAME, $analyticsProvider, GOOGLE_ANALYTICS, GOOGLE_ANALYTICS_CLIENT, SIGNAL_TAG, TEALIUM_HEAD_INJECTIONS, TEALIUM_BODY_INJECTIONS, GOOGLE_TAG_MANAGER, GOOGLE_AD_WORDS, FACEBOOK_PIXEL, DISABLE_SCRIPTS_ON_QA) {
    // Enable log
    $logProvider.debugEnabled(true);

    RestangularProvider
    .setBaseUrl(API_HOST);

    $locationProvider.html5Mode(true);

    var url = window.location.href;
    var prodEnvironment = url.indexOf('localhost') === -1 && url.indexOf('llp.qa') === -1;

    // Scripts will be appended only if it's a Prod environment or the DISABLE_SCRIPTS_ON_QA config is false.
    // DISABLE_SCRIPTS_ON_QA defaults to true, and to enable scripts on QA is necessary to add in the client configs as 'false'
    if (prodEnvironment || !DISABLE_SCRIPTS_ON_QA) {
      // MF analytics start
      if (GOOGLE_ANALYTICS) {
        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script','//www.google-analytics.com/analytics.js','ga');
            ga('create', GOOGLE_ANALYTICS, 'auto', {'allowLinker': true});  // where is this ga function coming from? can we use AnalyticsProvider instead?
      }
      // MF analytics end

      // Client analytics start
      // Assumes this is supplementary to GOOGLE_ANALYTICS and wouldn't exist otherwise.
      if (GOOGLE_ANALYTICS && GOOGLE_ANALYTICS_CLIENT) {
        ga('create', GOOGLE_ANALYTICS_CLIENT, 'auto', { 'name': 'clientTracker', 'allowLinker': true });
        // need this to integrate with angulartics
        $analyticsProvider.settings.ga.additionalAccountNames = ['clientTracker'];
      } else if(!GOOGLE_ANALYTICS && GOOGLE_ANALYTICS_CLIENT) {
        // If !GOOGLE_ANALYTICS, add the script from line 21 on line 30.
        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script','//www.google-analytics.com/analytics.js','ga');
        ga('create', GOOGLE_ANALYTICS_CLIENT, 'auto', {'allowLinker': true});
      }
      // Client analytics end

      // Optional client GTM
      if (GOOGLE_TAG_MANAGER) {
        $('head').append("<script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','" + GOOGLE_TAG_MANAGER + "');</script>");
        $('body').prepend('<noscript><iframe src="//www.googletagmanager.com/ns.html?id=' + GOOGLE_TAG_MANAGER + '" ' + 'height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>');
      }

      // END - Optional client GTM

      //Set up GOOGLE AD WORDS
      if (GOOGLE_AD_WORDS) {
        $('head').append("<script async src='https://www.googletagmanager.com/gtag/js?id=AW-"+GOOGLE_AD_WORDS+"'></script><script>window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '"+GOOGLE_AD_WORDS+"');</script>");
      }
      //End googleAdWords

      //Set up FACEBOOK_PIXEL
      if (FACEBOOK_PIXEL) {
        $('head').append("<script>!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod? n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', '"+FACEBOOK_PIXEL+"');</script><noscript><img height='1' width='1' style='display:none'src='https://www.facebook.com/tr?id="+FACEBOOK_PIXEL+"&ev=PageView&noscript=1'/></noscript>");
      }
      //End facebookPixel

      if (SIGNAL_TAG) {
        $('body').append('<script type="text/javascript">(function () { var tagjs = document.createElement("script"); var s = document.getElementsByTagName("script")[0]; tagjs.async = true;tagjs.src = "//s.btstatic.com/tag.js#site=1PR3l09"; s.parentNode.insertBefore(tagjs, s); }());</script><noscript><iframe src="//s.thebrighttag.com/iframe?c=1PR3l09" width="1" height="1" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe></noscript>');
      }

      if (TEALIUM_HEAD_INJECTIONS) {
        $('head').append(TEALIUM_HEAD_INJECTIONS);
      }

      if (TEALIUM_BODY_INJECTIONS) {
        $('body').prepend(TEALIUM_BODY_INJECTIONS);
      }
    }

    cloudinaryProvider
        .set("cloud_name", CLOUDINARY_NAME)
        .set("upload_preset", "UUUUUUUU");

  }


})();

(function() { 
    'use strict'; 
    /*
     This file hold all common fields for all clients.
     If any client has its own fields, put them to {client}/index.constants.js
     Client custom fields will overwritten common fields here with the same name.
    */
	angular.module("storeLocator")
    .constant("CUSTOM_DICTIONARY", {
        placeholder: "Zip Code or City, State"
      });
 })();
angular.module("storeLocator").run(["$templateCache", function($templateCache) {$templateCache.put("app/root.html","<div class=\"container\"><nav class=\"navbar navbar-default\" id=\"main_navigation\"><div class=\"container-fluid\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#bs-example-navbar-collapse-1\" aria-expanded=\"false\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"navbar-brand\" href=\"#\"><div></div><h2 id=\"location-finder-title\">Location Finder</h2></a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-1\"><ul class=\"nav navbar-nav navbar-right\"><li><a href=\"#\">Menu</a></li><li><a href=\"#\">Gift Certificate</a></li><li><a href=\"#\">Locations</a></li><li><a href=\"/site-map\">Site Map</a></li></ul></div></div></nav><div ui-view=\"\"></div></div>");
$templateCache.put("app/errorPages/400.html","<div class=\"container\"><div class=\"col-lg-12 col-md-12 col-sm-12\"><h2 id=\"errorPageh2\">HTTP ERROR 400: (BAD REQUEST)</h2><hr><h4>The requested resource could not be reached. Sorry.</h4>Click <a href=\"\" ng-click=\"back()\">here</a> to return to the previous page.<hr></div></div><div class=\"row\"></div>");
$templateCache.put("app/errorPages/404.html","<div class=\"container\"><div class=\"col-lg-12 col-md-12 col-sm-12\"><h2 id=\"errorPageh2\">HTTP ERROR 404: (RESOURCE NOT FOUND)</h2><hr><h4>The requested resource could not be reached. Sorry.</h4>It might have been deleted or service temporarily suspended, please try again later for a resumption of service. Click <a href=\"\" ng-click=\"back()\">here</a> to return to the previous page.<hr></div></div><div class=\"row\"></div>");
$templateCache.put("app/errorPages/500.html","<div class=\"container\"><div class=\"col-lg-12 col-md-12 col-sm-12\"><h2 id=\"errorPageh2\">HTTP ERROR 500: INTERNAL SERVER ERROR</h2><hr><h4>An error was encountered while serving your content.</h4>Click <a href=\"\" ng-click=\"back()\">here</a> to return to the previous page.<hr></div></div><div class=\"row\"></div>");
$templateCache.put("app/siteMap/locationList.directive.html","<div class=\"site-map-list push-top-lg\"><br><div><h1 ng-if=\"locationListC.worldwideh1\">{{locationListC.heading}}</h1></div><hr><div ng-if=\"locationListC.locations\"><div class=\"container\" ng-if=\"locationListC.position === \'global\'\" ng-repeat=\"(continent, locations) in locationListC.locations\"><div class=\"row push-top-md\"><h2><a class=\"bold\" title=\"{{(continent === \'Central American\') ? \'Central America\' : continent}}\">{{(continent === \'Central American\') ? \'Central America\' : continent}}</a></h2></div><div class=\"row\"><div ng-repeat=\"country in locationListC.getListOfCountries(locations).keys\"><div class=\"col-lg-4 country-locations\" ng-if=\"((locationListC.checkCountryInContinent(country)) === continent)\"><h3><a title=\"{{locationListC.getCountry(country)}}\" ui-sref=\"root.siteMapCountry({ country: country })\">{{locationListC.getCountry(country)}}</a></h3></div></div></div><br></div><div ng-if=\"locationListC.position === \'continent\'\" ng-repeat=\"(country, locations) in locationListC.locations\"><div ng-if=\"((locationListC.checkCountryInContinent(country)) === continent)\"><h2><a class=\"bold\" title=\"{{locationListC.getCountry(country)}}\" ui-sref=\"root.siteMapCountry({ country: locations[0].store_info.country })\">{{locationListC.getCountry(country)}}</a></h2></div></div><div ng-if=\"locationListC.position === \'country\'\" ng-repeat=\"(place, locations) in locationListC.locations\"><h2><a class=\"bold\" title=\"{{locationListC.getRegion(locations[0].store_info.region)}}\" ui-sref=\"root.siteMapRegion({ country: locations[0].store_info.country, region: locations[0].store_info.region})\">{{locationListC.getRegion(locations[0].store_info.country, locations[0].store_info.region)}}</a></h2><div class=\"region-locations\"><div ng-repeat=\"location in locations track by $index\" class=\"small\"><a class=\"sitemap-region\" ui-sref=\"root.siteMapLocality({ country: locations[0].store_info.country, region: locations[0].store_info.region, locality: location.store_info.locality })\">{{location.store_info.locality}}</a>- <a class=\"sitemap-location\" ng-href=\"{{locationListC.clientRoute}}{{location.llp_url}}\">{{location.store_info.address}}<span ng-if=\"location.store_info.address_extended\">, {{location.store_info.address_extended}}</span><span class=\"coming-soon-text\" ng-if=\"location.open_or_closed === \'coming soon\' && locationListC.comingSoonText\">- {{locationListC.comingSoonText}}</span><span class=\"coming-soon-text\" ng-if=\"location.open_or_closed === \'temp closed\'\">- Temporarily Closed</span></a></div></div></div><div ng-if=\"locationListC.position === \'region\'\"><div ng-repeat=\"(place, locations) in locationListC.others\"><h3><a class=\"bold\" title=\"{{place}}\" ui-sref=\"root.siteMapLocality({ country: locations[0].store_info.country, region: locations[0].store_info.region, locality: locations[0].store_info.locality})\">{{place}}</a></h3><div class=\"region-locations\"><div ng-repeat=\"loc in locations\" class=\"small\"><a class=\"sitemap-region\" ui-sref=\"root.siteMapLocality({ country: loc.store_info.country, region: loc.store_info.region, locality: loc.store_info.locality })\">{{loc.store_info.locality}}</a>- <a class=\"sitemap-location\" ng-href=\"{{locationListC.clientRoute}}{{loc.llp_url}}\">{{loc.store_info.address}}<span ng-if=\"loc.store_info.address_extended\">, {{loc.store_info.address_extended}}</span><span class=\"coming-soon-text\" ng-if=\"loc.open_or_closed === \'coming soon\' && locationListC.comingSoonText\">- {{locationListC.comingSoonText}}</span><span class=\"coming-soon-text\" ng-if=\"loc.open_or_closed === \'temp closed\'\">- Temporarily Closed</span></a></div></div></div><div ng-if=\"locationListC.featured.length > 0\"><h1 class=\"bold\">Featured</h1><div ng-repeat=\"(place, locations) in locationListC.featured\"><h3><a class=\"bold\" title=\"{{place}}\" ui-sref=\"root.siteMapLocality({ country: locations[0].store_info.country, region: locations[0].store_info.region, locality: locations[0].store_info.locality})\">{{place}}</a></h3><div class=\"region-locations\"><div ng-repeat=\"loc in locations\" class=\"small\"><a class=\"sitemap-region\" ui-sref=\"root.siteMapLocality({ country: loc.store_info.country, region: loc.store_info.region, locality: loc.store_info.locality })\">{{loc.store_info.locality}}</a>- <a class=\"sitemap-location\" ng-href=\"{{locationListC.clientRoute}}{{loc.llp_url}}\">{{loc.store_info.address}}<span ng-if=\"loc.store_info.address_extended\">, {{loc.store_info.address_extended}}</span><span class=\"coming-soon-text\" ng-if=\"loc.open_or_closed === \'coming soon\' && locationListC.comingSoonText\">- {{locationListC.comingSoonText}}</span><span class=\"coming-soon-text\" ng-if=\"loc.open_or_closed === \'temp closed\'\">- Temporarily Closed</span></a></div></div></div></div></div><div ng-if=\"locationListC.position === \'locality\'\" ng-repeat=\"(place, locations) in locationListC.locations\"><h3><a class=\"bold\" title=\"{{place}}\" ui-sref=\"root.siteMapLocality({ country: locations[0].store_info.country, region: locations[0].store_info.region, locality: locations[0].store_info.locality})\">{{place}}</a></h3><div class=\"region-locations\"><div ng-repeat=\"loc in locations\" class=\"small\"><a class=\"sitemap-region\" ui-sref=\"root.siteMapLocality({ country: loc.store_info.country, region: loc.store_info.region, locality: loc.store_info.locality })\">{{loc.store_info.locality}}</a>- <a class=\"sitemap-location\" ng-href=\"{{locationListC.clientRoute}}{{loc.llp_url}}\">{{loc.store_info.address}}<span ng-if=\"loc.store_info.address_extended\">, {{loc.store_info.address_extended}}</span><span class=\"coming-soon-text\" ng-if=\"loc.open_or_closed === \'coming soon\' && locationListC.comingSoonText\">- {{locationListC.comingSoonText}}</span><span class=\"coming-soon-text\" ng-if=\"loc.open_or_closed === \'temp closed\'\">- Temporarily Closed</span></a></div></div></div><div class=\"container\" ng-if=\"locationListC.position === \'all\'\"><div ng-repeat=\"(region, locations) in locationListC.locations\" ng-if=\"locationListC.locations\"><h2><a class=\"bold\" title=\"{{region}}\" ui-sref=\"root.siteMapRegion({ country: locations[0].store_info.country, region: locations[0].store_info.region })\">{{region}}</a></h2><div class=\"region-locations\"><div ng-repeat=\"location in locations track by $index\" class=\"small\"><a class=\"sitemap-region\" ui-sref=\"root.siteMapLocality({country: locations[0].store_info.country, region: locations[0].store_info.region, locality: location.store_info.locality})\">{{location.store_info.locality}}</a>- <a class=\"sitemap-location\" ng-href=\"{{locationListC.clientRoute}}{{location.llp_url}}\">{{location.store_info.address}}<span ng-if=\"location.store_info.address_extended\">, {{location.store_info.address_extended}}</span><span class=\"coming-soon-text\" ng-if=\"loc.open_or_closed === \'coming soon\' && locationListC.comingSoonText\">- {{locationListC.comingSoonText}}</span><span class=\"coming-soon-text\" ng-if=\"loc.open_or_closed === \'temp closed\'\">- Temporarily Closed</span></a></div></div></div></div></div></div>");
$templateCache.put("app/siteMap/locationListNewSitemap.directive.html","<div class=\"site-map-list push-top-lg\"><br><div><h1 ng-if=\"locationListNewSitemapC.worldwideh1\">{{locationListNewSitemapC.heading}}</h1></div><div ng-if=\"locationListNewSitemapC.position === \'country\'\"><h1>Locations in {{locationListNewSitemapC.stateParams.country}}</h1></div><div ng-if=\"locationListNewSitemapC.position === \'region\'\"><h1>Locations in {{locationListNewSitemapC.getRegion(locationListNewSitemapC.stateParams.country, locationListNewSitemapC.stateParams.region)}}</h1></div><div ng-if=\"locationListNewSitemapC.position === \'locality\'\"><h1>Locations in {{locationListNewSitemapC.stateParams.locality}}</h1></div><hr><div ng-if=\"locationListNewSitemapC.locations\"><div class=\"container\" ng-if=\"locationListNewSitemapC.position === \'global\'\" ng-repeat=\"(key, location) in locationListNewSitemapC.locations\"><div class=\"row push-top-md\"><a title=\"{{(location.name === \'Central American\') ? \'Central America\' : continent}}\"><h2 class=\"bold\">{{(location.na=== \'Central American\') ? \'Central America\' : continent}}</h2></a></div><div class=\"row\"><div class=\"col-lg-4 country-locations\" ng-if=\"location.name\"><a ng-click=\"locationListNewSitemapC.setContinent(location.name)\" title=\"{{location.name}}\" href=\"\"><h3>{{location.name}} ({{location.count}})</h3></a></div></div><br></div><div ng-if=\"locationListNewSitemapC.position === \'continent\'\" ng-repeat=\"(key, location) in locationListNewSitemapC.locations\"><div class=\"col-lg-4 continent-locations\" ng-if=\"location.name\"><a title=\"{{locationListNewSitemapC.getCountry(location.name)}}\" ui-sref=\"root.siteMapCountry({ country: location.name })\"><h2 class=\"bold\">{{location.name}} ({{location.count}})</h2></a></div></div><div ng-if=\"locationListNewSitemapC.position === \'country\'\" ng-repeat=\"(key, location) in locationListNewSitemapC.locations\"><div class=\"clearfix\" ng-if=\"$index % 3 == 0\"></div><div class=\"col-sm-4\"><a title=\"{{locationListNewSitemapC.getRegion(locationListNewSitemapC.stateParams.country, location.name)}}\" ui-sref=\"root.siteMapRegion({ country: locationListNewSitemapC.stateParams.country, region: location.name })\"><h2 class=\"bold\">{{locationListNewSitemapC.getRegion(locationListNewSitemapC.stateParams.country, location.name)}} ({{location.count}})</h2></a></div></div><div ng-if=\"locationListNewSitemapC.position === \'locality\'\" ng-repeat=\"(place, locations) in locationListNewSitemapC.locations\"><a title=\"{{place}}\" ui-sref=\"root.siteMapLocality({ country: locations[0].storeInfo.country, region: locations[0].storeInfo.region, locality: locations[0].storeInfo.locality})\"><h3 class=\"bold\">{{place}}</h3></a><div class=\"region-locations\"><div ng-repeat=\"loc in locations\" class=\"small\"><a class=\"sitemap-region\" ui-sref=\"root.siteMapLocality({ country: loc.storeInfo.country, region: loc.storeInfo.region, locality: loc.storeInfo.locality })\">{{loc.storeInfo.locality}}</a> - <a class=\"sitemap-location\" ng-href=\"{{locationListNewSitemapC.clientRoute}}{{loc.llpUrl}}\">{{loc.storeInfo.address}}<span ng-show=\"loc.storeInfo.addressExtended\">, {{loc.storeInfo.addressExtended}}</span></a></div></div></div><div ng-if=\"locationListNewSitemapC.position === \'region\'\"><div ng-if=\"locationListNewSitemapC.locations.length\" ng-repeat=\"location in locationListNewSitemapC.locations\"><div class=\"clearfix\" ng-if=\"$index % 3 == 0\"></div><div class=\"col-sm-4\"><a title=\"\" ui-sref=\"root.siteMapLocality({ country: locationListNewSitemapC.stateParams.country, region: locationListNewSitemapC.stateParams.region, locality: location.name })\"><h2 class=\"bold\">{{location.name}} ({{location.count}})</h2></a></div><div ng-if=\"!Object.keys(locationListNewSitemapC.featured).length === 0\"><h1 class=\"bold\">Featured</h1><div ng-repeat=\"(place, locations) in locationListNewSitemapC.featured\"><a title=\"{{place}}\" ui-sref=\"root.siteMapLocality({ country: locations[0].storeInfo.country, region: locations[0].storeInfo.region, locality: locations[0].storeInfo.locality})\"><h3 class=\"bold\">{{place}}</h3></a><div class=\"region-locations\"><div ng-repeat=\"loc in locations\" class=\"small\"><a class=\"sitemap-region\" ui-sref=\"root.siteMapLocality({ country: loc.storeInfo.country, region: loc.storeInfo.region, locality: loc.storeInfo.locality })\">{{loc.storeInfo.locality}}</a>- <a class=\"sitemap-location\" ng-href=\"{{locationListNewSitemapC.clientRoute}}{{loc.llpUrl}}\">{{loc.storeInfo.address}}<span ng-show=\"loc.storeInfo.addressExtended\">, {{loc.storeInfo.addressExtended}}</span></a></div></div></div></div></div><div class=\"container\" ng-if=\"locationListNewSitemapC.position === \'all\'\"><div ng-repeat=\"(region, locations) in locationListNewSitemapC.locations\" ng-if=\"locationListNewSitemapC.locations\"><a title=\"{{region}}\" ui-sref=\"root.siteMapRegion({ continent: \'US\', country: locations[0].storeInfo.country, region: locations[0].storeInfo.region })\"><h2 class=\"bold\">{{region}}</h2></a><div class=\"region-locations\"><div ng-repeat=\"location in locations track by $index\" class=\"small\"><a class=\"sitemap-region\" ui-sref=\"root.siteMapLocality({country: locations[0].storeInfo.country, region: locations[0].storeInfo.region, locality: location.storeInfo.locality})\">{{location.storeInfo.locality}}</a>- <a class=\"sitemap-location\" ng-href=\"{{locationListNewSitemapC.clientRoute}}{{location.llpUrl}}\">{{location.storeInfo.address}}<span ng-show=\"location.storeInfo.addressExtended\">, {{location.storeInfo.addressExtended}}</span></a></div></div></div></div></div></div></div>");
$templateCache.put("app/siteMap/siteMap.html","<div class=\"container site-map-container push-bottom-xl\"><div class=\"site-map\"><h1 class=\"bold\">{{siteMapC.client_name}} Locations</h1><div class=\"site-map-breadcrumb\"><div class=\"store-locator-breadcrumb\"><span><a href=\"{{siteMapC.client_route + \'/\'}}\"><span class=\"less-than\">&lt;</span> Back</a></span></div><div itemscope=\"\" itemtype=\"http://schema.org/BreadcrumbList\"><span ng-show=\"siteMapC.showBreadcrumb\" itemprop=\"itemListElement\" itemscope=\"\" itemtype=\"http://schema.org/ListItem\"><a itemprop=\"item\" ui-sref=\"root.siteMap\"><span itemprop=\"name\">All</span></a><meta itemprop=\"position\" content=\"1\"></span> <span ng-if=\"siteMapC.showBreadcrumb && siteMapC.continent\" itemprop=\"itemListElement\" itemscope=\"\" itemtype=\"http://schema.org/ListItem\">&nbsp;|&nbsp;<a itemprop=\"item\" ui-sref=\"root.siteMap\" ui-sref-opts=\"{reload: true}\"><span itemprop=\"name\">{{siteMapC.continent}}</span></a><meta itemprop=\"position\" content=\"2\"></span> <span ng-if=\"siteMapC.showBreadcrumb\" itemprop=\"itemListElement\" itemscope=\"\" itemtype=\"http://schema.org/ListItem\">&nbsp;|&nbsp;<a itemprop=\"item\" ng-class=\"{\'disabled\':!siteMapC.region}\" ui-sref=\"root.siteMapCountry({ country: siteMapC.country })\"><span itemprop=\"name\">{{siteMapC.country}}</span></a><meta itemprop=\"position\" content=\"3\"></span> <span ng-if=\"siteMapC.region\" itemprop=\"itemListElement\" itemscope=\"\" itemtype=\"http://schema.org/ListItem\">&nbsp;|&nbsp;<a itemprop=\"item\" ng-class=\"{\'disabled\':!siteMapC.locality}\" ui-sref=\"root.siteMapRegion({ country: siteMapC.country, region: siteMapC.region })\"><span itemprop=\"name\">{{siteMapC.region}}</span></a><meta itemprop=\"position\" content=\"4\"></span> <span ng-if=\"siteMapC.locality\" itemprop=\"itemListElement\" itemscope=\"\" itemtype=\"http://schema.org/ListItem\">&nbsp;|&nbsp;<a itemprop=\"item\" class=\"disabled\" ui-sref=\"root.siteMapRegion({ country: siteMapC.country, region: siteMapC.region })\"><span itemprop=\"name\">{{siteMapC.locality}}</span></a><meta itemprop=\"position\" content=\"5\"></span></div></div><div ng-show=\"!siteMapC.showPage\" class=\"push-top-xl\"><div class=\"mf-loader text-center mf-loading-list\"><i class=\"ico ico-spinner ico-spin\"></i></div></div><location-list ng-if=\"siteMapC.showPage && !siteMapC.use_new_site_map\" locations=\"siteMapC.locList\" client-route=\"siteMapC.client_route\" position=\"siteMapC.position\" featured=\"siteMapC.featuredList\" others=\"siteMapC.othersList\" get-by-country=\"siteMapC.getByCountryForContinent(locList)\"></location-list><location-list-new-sitemap ng-if=\"siteMapC.showPage && siteMapC.use_new_site_map\" locations=\"siteMapC.locList\" client-route=\"siteMapC.client_route\" position=\"siteMapC.position\" featured=\"siteMapC.featuredList\" others=\"siteMapC.othersList\" get-by-country=\"siteMapC.getByCountryForContinent(locList)\" selected-continent=\"siteMapC.selectedContinent\" show-breadcrumb=\"siteMapC.showBreadcrumb\"></location-list-new-sitemap><sitemap-error-card ng-if=\"siteMapC.showPage && !siteMapC.locList\"></sitemap-error-card></div></div>");
$templateCache.put("app/storeLocator/storeLocator.html","<div class=\"store-locator-container\"><div class=\"store-locator-title\"><h1>Store Locator</h1></div><div class=\"alert alert-danger\" role=\"alert\" data-ng-show=\"storeLocatorCtrl.locatorStates.errors\">{{storeLocatorCtrl.locatorStates.errors}}</div><div class=\"alert alert-info\" role=\"alert\" data-ng-show=\"storeLocatorCtrl.locatorStates.notifications\">{{storeLocatorCtrl.notifications}}</div><div id=\"js-breadcrumbs\" class=\"row breadcrumbs\"><div class=\"col-xs-8\"><div class=\"store-locator-crumbs section-breadcrumb\"><span id=\"locator-breadcrumb\" class=\"text-uppercase\"><a data-ui-sref=\"root.siteMap\" title=\"Site Map\" role=\"region\" aria-label=\"breadcrumbs\">Locations</a> | {{storeLocatorCtrl.storeLocatorText}}</span><h4>Find a Location by {{storeLocatorCtrl.searchLabel}}</h4></div></div><div class=\"col-xs-4\"><div class=\"clearfix text-right visible-xs\" id=\"filter-map-list\"><button type=\"button\" data-ng-click=\"storeLocatorCtrl.showList = !storeLocatorCtrl.showList\" class=\"btn btn-xs btn-text showList\"><span data-ng-show=\"storeLocatorCtrl.showList\"><i class=\"fa fa-map-o\" aria-hidden=\"true\" data-ng-show=\"storeLocatorCtrl.showIcons\"></i><span class=\"view-text\">{{storeLocatorCtrl.mapViewText}}</span></span> <span data-ng-show=\"!storeLocatorCtrl.showList\"><i class=\"fa fa-list\" aria-hidden=\"true\" data-ng-show=\"storeLocatorCtrl.showIcons\"></i><span class=\"view-text\">{{storeLocatorCtrl.listViewText}}</span></span></button></div></div></div><div class=\"clearfix push-bottom store-locator-content\"><div class=\"col-sm-6 locations-container\" data-ng-class=\"{\'show-list\': storeLocatorCtrl.showList}\"><search data-locator-states=\"storeLocatorCtrl.locatorStates\" data-map-obj=\"storeLocatorCtrl.mapObj\" data-is-google-maps-api-loaded=\"isGoogleMapsApiLoaded\"></search><tabs ng-if=\"storeLocatorCtrl.showTabs\" data-locator-states=\"storeLocatorCtrl.locatorStates\" data-map-obj=\"storeLocatorCtrl.mapObj\"></tabs><results ng-if=\"!storeLocatorCtrl.showTabs\" data-locator-states=\"storeLocatorCtrl.locatorStates\" data-map-obj=\"storeLocatorCtrl.mapObj\"></results></div><div id=\"global-locations-map-container\" class=\"col-sm-6 locations-map-container\" ng-class=\"{\'show-map\' : !storeLocatorCtrl.showList}\"><map data-locator-states=\"storeLocatorCtrl.locatorStates\" data-map-obj=\"storeLocatorCtrl.mapObj\" data-is-google-maps-api-loaded=\"isGoogleMapsApiLoaded\"></map></div></div></div>");
$templateCache.put("app/localLanding/cards/aboutCard.directive.html","<div class=\"push-bottom-xl text-center\"><h3 class=\"bold-500\" ng-if=\"aboutCardCtrl.hasTitle\">{{aboutCardCtrl.title}}</h3><h3 class=\"bold-500\" ng-if=\"!aboutCardCtrl.hasTitle\">About {{ aboutCardCtrl.location.store_info.name }}, {{ aboutCardCtrl.location.store_info.locality }}</h3><p data-ng-bind-html=\"aboutCardCtrl.description\" itemprop=\"description\"></p></div>");
$templateCache.put("app/localLanding/cards/aboutWithPictureCard.directive.html","<div class=\"push-bottom-xl\"><div class=\"border-bottom push-bottom\"><h3>About {{aboutWithPictureCardC.location.store_info.name}}</h3></div><div class=\"clearfix\"><div ng-if=\"aboutWithPictureCardC.location.location_photo\" class=\"col-sm-6 location-photo\"><img ng-src=\"{{aboutWithPictureCardC.location.location_photo}}\" width=\"100%\" title=\"{{aboutWithPictureCardC.location.store_info.name}} Photo\" alt=\"{{aboutWithPictureCardC.location.store_info.name}} Photo\"></div><div ng-class=\"location.location_photo ? \'col-sm-6\' : \'col-sm-12\'\"><p class=\"ng-binding\" data-ng-bind-html=\"aboutWithPictureCardC.location.description\" itemprop=\"description\"></p></div></div></div>");
$templateCache.put("app/localLanding/cards/activitiesCard.directive.html","<div class=\"jumbotron\"><h3>Activities</h3><div ng-repeat=\"activity in activities\"><img ng-src=\"{{ activity.review_detail.author_profile_image }}\"> rating - {{ activity.review_detail.rating }}<br>{{ activity.review_detail.text }}</div></div>");
$templateCache.put("app/localLanding/cards/addressBreadcrumbCard.directive.html","<div class=\"address-breadcrumb\" itemscope=\"\" itemtype=\"http://schema.org/BreadcrumbList\"><span itemprop=\"itemListElement\" itemscope=\"\" itemtype=\"http://schema.org/ListItem\"><a itemprop=\"item\" class=\"text-uppercase\" title=\"{{location.country}}\" ui-sref=\"root.siteMapCountry({ country: location.country })\" role=\"region\" aria-label=\"Location breadcrumbs\"><span itemprop=\"name\">{{ location.country }}</span></a><meta itemprop=\"position\" content=\"1\"></span> <span ng-if=\"location.region\" itemprop=\"itemListElement\" itemscope=\"\" itemtype=\"http://schema.org/ListItem\">&nbsp;|&nbsp;<a itemprop=\"item\" class=\"text-uppercase\" title=\"{{location.region}}\" ui-sref=\"root.siteMapRegion({ country: location.country, region: location.region })\" role=\"region\" aria-label=\"Location breadcrumbs\"><span itemprop=\"name\">{{ location.region}}</span></a><meta itemprop=\"position\" content=\"2\"></span> <span itemprop=\"itemListElement\" itemscope=\"\" itemtype=\"http://schema.org/ListItem\">&nbsp;|&nbsp;<a itemprop=\"item\" title=\"{{location.locality}}\" ui-sref=\"root.siteMapLocality({ country: location.country, region: location.region, locality: location.locality })\" role=\"region\" aria-label=\"Location breadcrumbs\"><span itemprop=\"name\">{{ location.locality }}</span></a><meta itemprop=\"position\" content=\"3\"></span></div>");
$templateCache.put("app/localLanding/cards/addressCard.directive.html","<div class=\"push-bottom-lg address-card\"><div ng-if=\"location.status.toLowerCase() === \'temp closed\'\" class=\"no-margin temp-closed\">This location is temporarily closed</div><meta itemprop=\"name\" content=\"{{addressCardC.storeSEOName}}\"><h1 data-ng-bind-html=\"addressCardC.storeName\" itemprop=\"storeName\" aria-live=\"polite\" class=\"no-margin\"></h1><h3 data-ng-if=\"addressCardC.nameExtendedConfig\" ng-repeat=\"item in addressCardC.nameExtendedConfig track by $index\">{{item}}</h3><h3 data-ng-if=\"addressCardC.nameExtended && !nameExtendedConfig\">{{addressCardC.nameExtended}}</h3><div itemprop=\"address\" itemscope=\"\" itemtype=\"http://schema.org/PostalAddress\"><div class=\"no-bold line-height-bump\" ng-show=\"!addressLink\"><span ng-if=\"addressCardC.addressExtended\" itemprop=\"streetAddress\">{{ location.store_info.address }}</span> <span ng-if=\"!addressCardC.addressExtended\" ng-style=\"{\'padding-top\':\'10px\',\'margin-bottom\':\'0px\',\'padding-bottom\':\'0px\'}\" itemprop=\"streetAddress\">{{ location.store_info.address }}</span><br><p ng-if=\"location.store_info.address_extended\" ng-style=\"{\'margin-bottom\':\'0px\'}\">{{ location.store_info.address_extended }}</p><span itemprop=\"addressLocality\">{{ location.store_info.locality }}</span>, <span itemprop=\"addressRegion\">{{ location.store_info.region }}</span> <span itemprop=\"postalCode\">{{ location.store_info.postcode }}</span></div><div class=\"no-bold line-height-bump\" ng-show=\"addressLink\"><a ng-href=\"{{addressLink}}\" title=\"{{addressLinkTitle}}\" rel=\"noopener\" target=\"_blank\"><span itemprop=\"streetAddress\">{{ location.store_info.address }}<br ng-if=\"location.store_info.address_extended\">{{ location.store_info.address_extended }}</span><br><span itemprop=\"addressLocality\">{{ location.store_info.locality }}</span>, <span itemprop=\"addressRegion\">{{ location.store_info.region }}</span> <span itemprop=\"postalCode\">{{ location.store_info.postcode }}</span></a></div><div class=\"visible-xs\"><a ng-href=\"tel:{{ location.store_info.phone }}\" analytics-event=\"Call\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" aria-label=\"telephone number\" title=\"Call\">{{ location.store_info.phone | telephone}}</a></div><div class=\"hidden-xs tel-number\" itemprop=\"telephone\"><span ng-if=\"addressCardC.mainPhoneTitle\">{{ addressCardC.mainPhoneTitle }}</span>{{ location.store_info.phone | telephone}}</div><div ng-if=\"addressCardC.altPhone\" class=\"visible-xs\"><a ng-href=\"tel:{{ addressCardC.altPhone }}\" analytics-event=\"Call\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" title=\"Call\">{{ addressCardC.altPhone | telephone}}</a></div><div class=\"hidden-xs tel-number\" itemprop=\"telephone\" ng-if=\"addressCardC.altPhoneTitle\"><span>{{ addressCardC.altPhoneTitle }}</span>{{ addressCardC.altPhone | telephone}}</div></div><span itemprop=\"geo\" itemscope=\"\" itemtype=\"http://schema.org/GeoCoordinates\"><meta itemprop=\"latitude\" content=\"{{ location.store_info.latitude }}\"><meta itemprop=\"longitude\" content=\"{{ location.store_info.longitude }}\"></span><partner-reviews-card location=\"location\" partnertype=\"custom\"></partner-reviews-card><div class=\"push-top flex-buttons-nap\"><a ng-if=\"addressCardC.showGetDirections\" href=\"{{addressCardC.directionsUrl}}\" rel=\"noopener\" target=\"_blank\" class=\"btn btn-primary get-directions\" analytics-event=\"Get Directions\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" title=\"Get Directions\">Get Directions</a> <a ng-show=\"addressCardC.menuLink\" ng-href=\"{{addressCardC.menuLink.data}}\" rel=\"noopener\" target=\"_blank\" title=\"View the Menu\" class=\"btn btn-primary push-left-xs\" analytics-event=\"View the Menu\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\">View the Menu</a><delivery-modal-card button-class=\"btn btn-primary delivery-modal\" location=\"location\" extended-delivery=\"deliveryModalExtendedDelivery\"></delivery-modal-card><a ng-show=\"addressCardC.customButtonLink\" ng-href=\"{{addressCardC.customButtonLink.data}}\" rel=\"noopener\" target=\"_blank\" class=\"btn btn-primary custom-button\" analytics-event=\"{{addressCardC.customButtonText}}\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" title=\"{{addressCardC.customButtonText}}\">{{addressCardC.customButtonText}}</a> <a ng-show=\"addressCardC.customButton2Link\" ng-href=\"{{addressCardC.customButton2Link.data}}\" rel=\"noopener\" target=\"_blank\" class=\"btn btn-primary custom-button\" analytics-event=\"{{addressCardC.customButton2Text}}\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" title=\"{{addressCardC.customButton2Text}}\">{{addressCardC.customButton2Text}}</a></div></div>");
$templateCache.put("app/localLanding/cards/amenitiesCard.directive.html","<div class=\"amenities-card\" ng-show=\"amenitiesCardController.hasAmenities\"><div class=\"push-bottom\" ng-show=\"!amenitiesCardController.displayInOneLine\"><h3 class=\"title\">{{amenitiesCardController.title}}</h3></div><div class=\"amenities-with-no-icons\" ng-show=\"!amenitiesCardController.displayInOneLine && amenitiesCardController.amenitiesWithNoIcons.length\"><ul class=\"amenities-list\"><li ng-repeat=\"amenity in amenitiesCardController.amenitiesWithNoIcons\" class=\"push-bottom amenity\"><div class=\"amenity-with-no-icon\"><span>&bull; <span data-ng-bind-html=\"amenity.nameAmenity\"></span></span></div></li></ul></div><div class=\"amenities-with-icons\" ng-show=\"!amenitiesCardController.displayInOneLine && amenitiesCardController.amenitiesWithIcons.length\"><ul class=\"amenities-list\"><li ng-repeat=\"amenity in amenitiesCardController.amenitiesWithIcons\" class=\"push-bottom amenity\"><div class=\"amenity-with-icon\"><div class=\"image-container\"><img ng-if=\"!amenitiesCardController.defaultImage\" ng-src=\"/assets/images/clients/{{amenitiesCardController.client}}/{{amenity.name}}.png\" alt=\"{{amenity.tooltip}}\" title=\"{{amenity.tooltip}}\" data-at2x=\"/assets/images/clients/{{amenitiesCardController.client}}/{{amenity.name}}@2x.png\"> <img ng-if=\"amenitiesCardController.defaultImage\" ng-src=\"/assets/images/clients/{{amenitiesCardController.client}}/service_default.png\" alt=\"{{amenity.tooltip}}\" title=\"{{amenity.tooltip}}\" data-at2x=\"/assets/images/clients/{{amenitiesCardController.client}}/service_default.png\"></div><span data-ng-bind-html=\"amenity.nameAmenity\"></span></div></li></ul></div><div ng-show=\"amenitiesCardController.displayInOneLine\"><span class=\"title\">{{amenitiesCardController.title}}:</span> <span data-ng-bind-html=\"amenity.nameAmenity\" class=\"amenity\" ng-repeat=\"amenity in amenitiesCardController.amenities\"></span></div></div>");
$templateCache.put("app/localLanding/cards/awardsCard.directive.html","<div class=\"awards-card\" ng-show=\"awardsCardController.awards.length > 0\"><ul class=\"awards-list\"><li ng-repeat=\"award in awardsCardController.awards\" class=\"push-bottom award\"><div class=\"image-container\"><img ng-src=\"/assets/images/clients/{{awardsCardController.client}}/{{award.name}}.jpg\" alt=\"{{award.data}}\" title=\"{{award.data}}\" data-at2x=\"/assets/images/clients/{{awardsCardController.client}}/{{award.name}}.jpg\"></div><div class=\"award-description\">{{award.data}}</div></li></ul></div>");
$templateCache.put("app/localLanding/cards/carouselMenu.directive.html","<div class=\"carousel-menu-container\"><uib-carousel><uib-slide ng-repeat=\"slide in carouselMenuC.slides\" active=\"slide.active\" index=\"$index\"><div class=\"carousel-title-container\"><h2 class=\"carousel-title\" ng-bind-html=\"slide.slide_title\"></h2></div><div ng-repeat=\"card in slide.items\"><div class=\"col-md-4\"><div class=\"carousel-card-title-container\"><h3 class=\"carousel-card-title\" ng-bind-html=\"card.title\"></h3></div><div class=\"carousel-card-img-container\"><img class=\"carousel-card-img\" ng-src=\"{{card.image_url}}\" alt=\"{{card.title}} Image\"></div><div class=\"carousel-card-text-container\"><p class=\"carousel-card-text\" ng-bind-html=\"card.text\"></p></div><div class=\"carousel-card-btn-wrapper\"><a ng-href=\"card.link_url\" class=\"btn btn-secondary\">{{card.link_text}}</a></div></div></div></uib-slide></uib-carousel></div>");
$templateCache.put("app/localLanding/cards/customDescriptionCard.directive.html","<div class=\"push-bottom-xl\"><div class=\"push-bottom\"><h3 ng-if=\"!customDescriptionCardC.customTitle\" aria-live=\"polite\">About {{ customDescriptionCardC.location.store_info.name }}</h3><h3 ng-if=\"customDescriptionCardC.customTitle\" aria-live=\"polite\">{{ customDescriptionCardC.customTitle}}</h3></div><p data-ng-bind-html=\"customDescriptionCardC.description\" itemprop=\"content\" aria-live=\"polite\"></p></div>");
$templateCache.put("app/localLanding/cards/customFieldsButton.directive.html","<a ng-href=\"{{customFieldsButtonC.link}}\" ng-show=\"customFieldsButtonC.link\" title=\"{{customFieldsButtonC.title}}\" rel=\"noopener\" target=\"{{customFieldsButtonC.buttonTarget}}\" class=\"btn btn-background dib\"><p class=\"bannerText\" data-ng-bind-html=\"customFieldsButtonC.buttonText\"></p></a>");
$templateCache.put("app/localLanding/cards/customServicesCard.directive.html","<div class=\"push-bottom-lg\" ng-show=\"customServicesCardC.services.length\"><div class=\"border-bottom push-bottom\"><h3 class=\"servicesTitle\">{{customServicesCardC.title}}</h3></div><div ng-repeat=\"service in customServicesCardC.services track by $index\" class=\"push-bottom text-capitalize\">{{service}}</div></div>");
$templateCache.put("app/localLanding/cards/delivery.modal.html","<div class=\"modal\" aria-model=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\" tabindex=\"-1\"><div class=\"modal-header\"><h4 class=\"modal-title\">{{ deliveryModalCardCtrl.modalTitle }}</h4></div><div class=\"modal-body\"><ul><li ng-repeat=\"link in links\"><div class=\"col-3-lg col-3-md col-3-sm col-3-xs text-center link delivery-links\"><a ng-href=\"{{link}}\" target=\"_blank\" analytics-event=\"Delivery Services - {{ labels[links.indexOf(link)] }}\" analytics-label=\"{{ deliveryModalCardCtrl.location | labelizeLocation }}\" analytics-category=\"{{deliveryModalCardCtrl.pageCategory}}\" analytics-value=\"1\" analytics-on=\"click\"><img ng-src=\"{{logos[links.indexOf(link)]}}\" id=\"{{ labels[links.indexOf(link)] }}\" alt=\"{{ labels[links.indexOf(link)] }}\"></a></div></li></ul></div><button role=\"button\" id=\"delivery-modal-close\" ng-keypress=\"deliveryModalCardCtrl.closeModal($event)\">Close</button></div></div></div>");
$templateCache.put("app/localLanding/cards/deliveryModalCard.directive.html","<span ng-show=\"deliveryModalCardCtrl.validDelivery\"><a ng-if=\"!deliveryModalCardCtrl.extendedDelivery\" ng-class=\"deliveryModalCardCtrl.buttonClass || \'btn btn-primary\'\" type=\"button\" rel=\"noopener\" title=\"Order Online\" target=\"_blank\" ng-href=\"{{deliveryModalCardCtrl.orderOnline}}\" analytics-event=\"Delivery Services Modal\" analytics-label=\"{{ deliveryModalCardCtrl.location | labelizeLocation }}\" analytics-category=\"{{deliveryModalCardCtrl.pageCategory}}\" analytics-value=\"1\" analytics-on=\"click\">{{deliveryModalCardCtrl.text}}</a> <a ng-if=\"deliveryModalCardCtrl.extendedDelivery\" ng-class=\"deliveryModalCardCtrl.buttonClass || \'btn btn-primary\'\" type=\"button\" title=\"Order Online\" role=\"button\" tabindex=\"0\" ng-click=\"deliveryModalCardCtrl.showModal()\" ng-keypress=\"deliveryModalCardCtrl.keypressShowModal($event)\" analytics-event=\"Delivery Services Modal\" analytics-label=\"{{ deliveryModalCardCtrl.location | labelizeLocation }}\" analytics-category=\"{{deliveryModalCardCtrl.pageCategory}}\" analytics-value=\"1\" analytics-on=\"click\">{{deliveryModalCardCtrl.text}}</a></span>");
$templateCache.put("app/localLanding/cards/errorCard.directive.html","<div class=\"container\"><div class=\"row\" ng-show=\"localLanding.error\"><div class=\"col-lg-12 col-md-12 col-sm-12\"><h2 id=\"errorPageh1\">{{errorCardC.errorHeading}}</h2><hr><div class=\"store-locator-breadcrumb\"><span><a href=\"{{errorCardC.indexURI || errorCardC.customLocator + \'/\'}}\"><span class=\"less-than\">&lt;</span> Back</a></span></div><br><br><h4>We were unable to find that location, it might have moved or closed.</h4><h4 ng-show=\"errorCardC.nearbyLocationsFlag\">Here are some links to other nearby locations :</h4><div data-ng-repeat=\"loc in errorCardC.location\"><a href=\"{{errorCardC.indexURI + loc.llp_url}}\">{{loc.store_info.address}}</a><span ng-if=\"errorCardC.auto_redirect\">( Re-directing to this location. . . . . )</span></div><br><br>Try <a style=\"font-style: italic;\" href=\"{{errorCardC.indexURI || errorCardC.customLocator + \'/\'}}\">searching</a> for the location.<hr></div></div><div class=\"row\"><div class=\"mf-route-loader mf-large-loader\" ng-show=\"!localLanding.error\"><i id=\"newLoaderIcon\" class=\"ico ico-spinner ico-spin\"></i></div></div></div>");
$templateCache.put("app/localLanding/cards/eventCard.directive.html","<section class=\"event-card\"><header><h3 class=\"cardTitle\">{{eventCardController.title}}</h3></header><div class=\"empty\" ng-show=\"eventCardController.indexes.length === 0\"><br><div class=\"text-center title\">No events.</div><br></div><div ng-repeat=\"index in eventCardController.indexes\" class=\"event\" itemprop=\"Event\" itemscope=\"\" itemtype=\"http://schema.org/Event\"><div class=\"row\"><div class=\"date-container col-sm-3 col-md-3 col-lg-3 col-xs-3\" itemprop=\"startDate\" itemtype=\"http://schema.org/DateTime\"><meta itemprop=\"startDate\" content=\"{{eventCardController.eventObject[index].StartDate.ISO}}\"><div class=\"day\">{{eventCardController.eventObject[index].StartDate.day}}</div><div class=\"month\">{{eventCardController.eventObject[index].StartDate.monthStr}}</div></div><div class=\"info-container col-sm-9 col-md-9 col-lg-9 col-xs-9\"><div class=\"eventTitle\" itemprop=\"name\">{{ eventCardController.eventObject[index].Title }}</div><div class=\"description\" ng-show=\"false\" itemprop=\"description\">{{ eventCardController.eventObject[index].Content }}</div><div class=\"location\" itemprop=\"location\" itemscope=\"\" itemtype=\"http://schema.org/Place\"><div class=\"day-time\">{{eventCardController.eventObject[index].StartDate.dayTime}}</div><span class=\"location-name\" itemprop=\"name\">{{eventCardController.eventObject[index].Location}}</span><div class=\"address\" itemprop=\"address\" itemtype=\"http://schema.org/PostalAddress\"><span itemprop=\"streetAddress\">{{ eventCardController.eventObject[index].Address.streetAddress }}</span> <span itemprop=\"addressLocality\">{{ eventCardController.eventObject[index].Address.locality }}</span>, <span itemprop=\"addressRegion\">{{ eventCardController.eventObject[index].Address.region }}</span> <span itemprop=\"postalCode\">{{ eventCardController.eventObject[index].Address.postcode }}</span><br><span itemprop=\"addressCountry\" ng-show=\"false\">{{eventCardController.eventObject[index].Address.country}}</span><br></div></div></div></div></div></section>");
$templateCache.put("app/localLanding/cards/eventCardOld.directive.html","<div ng-repeat=\"object in eventCardC.eventObject track by $index\" class=\"push-bottom-lg\"><h4>{{ object.Title }}</h4><h5>{{ object.Content }}</h5></div>");
$templateCache.put("app/localLanding/cards/fbCard.directive.html","<div><div class=\"border-bottom push-bottom clearfix\"><div class=\"pull-left\"><h3 id=\"facebook-heading\" tabindex=\"0\">Like us on Facebook</h3></div><div class=\"pull-right mf-social-icons single\"><a itemprop=\"sameAs\" class=\"btn btn-provider facebook-color\" ng-href=\"{{ posts[0].profile_url }}\" rel=\"noopener\" target=\"_blank\" ng-attr-title=\"{{clientName ? clientName : \'Like us\'}} on Facebook\" aria-label=\"Facebook Button\" tabindex=\"0\"><i class=\"ico ico-facebook\"></i></a></div></div><div class=\"push-bottom-lg\" ng-repeat=\"post in posts | limitTo: limit\"><div class=\"media\"><div class=\"media-left\"><a ng-href=\"{{post.user_url}}\" rel=\"noopener\" target=\"_blank\"><img ng-src=\"{{ post.pic_square }}\" width=\"30\" alt=\"Logo\"></a></div><div class=\"media-body\"><div class=\"media-heading\"><div class=\"bold-500\">{{ post.first_name }}</div><i class=\"small\">{{ post.post_date_formatted }}</i></div><div class=\"push-top\"><div ng-show=\"!!post.attachment_src\"><img ng-src=\"{{ post.attachment_src }}\" width=\"100%\" ng-show=\"post.graph_post_type != \'video\'\" alt=\"Facebook Post Image\"><div ng-show=\"fbCardC.isVideo && post.graph_post_type == \'video\'\"><iframe elem-ready=\"fbCardC.onLoad()\" id=\"video-post\" ng-src=\"{{fbCardC.videoUrl}}\" width=\"100%\" style=\"border:none;overflow:hidden\" scrolling=\"no\" frameborder=\"0\" allowtransparency=\"true\" allowfullscreen=\"true\"></iframe></div><div ng-if=\"!fbCardC.isVideo && post.graph_post_type == \'video\'\" elem-ready=\"fbCardC.onLoad()\" class=\"video-overlay\"><a href=\"{{fbCardC.videoUrl}}\"><img ng-src=\"{{ post.attachment_src }}\" width=\"100%\" alt=\"Facebook Post Image\"> <img class=\"mf-icon-play-circle-btm\" src=\"https://s3-us-west-1.amazonaws.com/mfeed-store-locator.momentfeed.com/icons/playbuttonblue.png\" alt=\"Play Button Blue\"></a></div></div><div class=\"push-top\" ng-if=\"!!post.content\">{{ post.content }}</div></div></div></div></div></div>");
$templateCache.put("app/localLanding/cards/fbReviewsCard.directive.html","<div class=\"push-bottom-lg\"><div class=\"border-bottom push-bottom clearfix\"><div class=\"pull-left\"><h3>Like us on Facebook</h3></div><div class=\"pull-right mf-social-icons single\"><a itemprop=\"sameAs\" class=\"btn btn-provider facebook-color\" ng-href=\"{{ page }}\" target=\"_blank\" rel=\"noopener\"><i class=\"ico ico-facebook\"></i></a></div></div><div ng-repeat=\"review in reviews\"><div class=\"media\"><div class=\"media-left\"><a ng-href=\"{{ review.user_url }}\" target=\"_blank\" rel=\"noopener\"><img ng-src=\"{{ review.pic_square }}\" width=\"30\"></a></div><div class=\"media-body\"><h5 class=\"media-heading\"><div class=\"bold-500\">{{ review.first_name }}</div><i class=\"small\">{{ review.post_date_formatted }}</i></h5><div class=\"push-top stars-{{review.rating}}\" ng-if=\"review.rating\"><i class=\"ico ico-star-review\"></i> <i class=\"ico ico-star-review\"></i> <i class=\"ico ico-star-review\"></i> <i class=\"ico ico-star-review\"></i> <i class=\"ico ico-star-review\"></i></div><div class=\"push-top\"><div ng-if=\"!!review.attachment_src\"><img ng-src=\"{{ review.attachment_src }}\" width=\"100%\"></div><div class=\"push-top\" ng-if=\"!!review.content\">{{ review.content }}</div></div></div></div></div></div>");
$templateCache.put("app/localLanding/cards/fbWidgetCard.directive.html","<div class=\"fb-widget-card\" ng-show=\"fbWidgetCardC.fbProviderUrl\"><div class=\"border-bottom push-bottom clearfix\"><div class=\"pull-left\"><h3 id=\"facebook-heading\" tabindex=\"0\">Like us on Facebook</h3></div><div class=\"pull-right mf-social-icons single\"><a itemprop=\"sameAs\" class=\"btn btn-provider facebook-color\" ng-href=\"{{fbWidgetCardC.fbProviderUrl}}\" target=\"_blank\" rel=\"noopener\" ng-attr-title=\"{{clientName ? clientName : \'Like us\'}} on Facebook\" aria-label=\"Facebook Button\" tabindex=\"0\"><i class=\"ico ico-facebook\"></i></a></div></div><div class=\"fb-widget-container push-bottom-lg\"><div class=\"fb-page\" data-href=\"{{fbWidgetCardC.fbProviderUrl}}\" data-tabs=\"timeline\" data-width=\"\" data-height=\"\" data-small-header=\"false\" data-adapt-container-width=\"true\" data-hide-cover=\"false\" data-show-facepile=\"true\"><blockquote cite=\"{{fbWidgetCardC.fbProviderUrl}}\" class=\"fb-xfbml-parse-ignore\"><a href=\"{{fbWidgetCardC.fbProviderUrl}}\" rel=\"noopener\">{{client_name}}</a></blockquote></div></div></div>");
$templateCache.put("app/localLanding/cards/foursquareCard.directive.html","<div class=\"push-bottom-lg\"><div class=\"border-bottom push-bottom clearfix\"><div class=\"pull-left\"><h3>Find us on Foursquare</h3></div><div class=\"pull-right mf-social-icons single\"><a itemprop=\"sameAs\" class=\"btn btn-provider foursquare-color\" href=\"{{ foursquareCardC.fsData.url }}\" target=\"_blank\" rel=\"noopener\" title=\"{{foursquareCardC.title}} on Foursquare\" aria-label=\"foursquare button\"><i class=\"ico ico-foursquare\"></i></a></div></div><ul ng-if=\"foursquareCardC.fsData\" class=\"list-unstyled\"><li ng-if=\"foursquareCardC.fsData.rating\" class=\"clearfix\" itemprop=\"aggregateRating\" itemscope=\"\" itemtype=\"http://schema.org/AggregateRating\"><div class=\"pull-left\">Rating</div><div class=\"pull-right\"><meta itemprop=\"bestRating\" content=\"10\"><meta itemprop=\"worstRating\" content=\"0\"><span itemprop=\"ratingValue\">{{foursquareCardC.fsData.rating}}/10</span></div></li><li class=\"clearfix\"><div class=\"pull-left\">Checkins</div><div class=\"pull-right\">{{foursquareCardC.fsData.checkins}}</div></li><li class=\"clearfix\"><div class=\"pull-left\">Tips</div><div class=\"pull-right\">{{foursquareCardC.fsData.tips}}</div></li><li class=\"clearfix\"><div class=\"pull-left\">Photos</div><div class=\"pull-right\">{{foursquareCardC.fsData.pics}}</div></li></ul></div>");
$templateCache.put("app/localLanding/cards/googleCard.directive.html","<div class=\"push-bottom-lg\"><div class=\"border-bottom push-bottom clearfix\"><div class=\"pull-left\"><h3>Find us on Google</h3></div><div class=\"pull-right mf-social-icons single\"><a itemprop=\"sameAs\" class=\"btn btn-provider google-color\" href=\"{{ googleCardC.googleData.url }}\" target=\"_blank\" rel=\"noopener\" title=\"{{googleCardC.title}} on google\" aria-label=\"google button\"><i class=\"ico ico-google\"></i></a></div></div><ul ng-if=\"googleCardC.googleData\" class=\"list-unstyled\"><li ng-if=\"googleCardC.googleData.rating\" class=\"clearfix\" itemprop=\"aggregateRating\" itemscope=\"\" itemtype=\"http://schema.org/AggregateRating\"><div class=\"pull-left\">Rating</div><div class=\"pull-right\"><meta itemprop=\"bestRating\" content=\"5\"><meta itemprop=\"worstRating\" content=\"0\"><span itemprop=\"ratingValue\">{{googleCardC.googleData.rating}}/5</span></div></li><li class=\"clearfix\"><div class=\"pull-left\">Checkins</div><div class=\"pull-right\">{{googleCardC.googleData.checkins}}</div></li></ul></div>");
$templateCache.put("app/localLanding/cards/hoursAdditionalCard.directive.html","<div class=\"hours-card hours-additional\"><h4 class=\"no-bold text-primary push-bottom\"><div ng-if=\"hoursAddCardC.hasPrimary || hoursAddCardC.hasPrimarySpecial\"><span>{{hoursAddCardC.titlePrimary}}:</span> <span ng-if=\"hoursAddCardC.closed24\"><span class=\"closed-store\">Closed Today</span></span> <span ng-if=\"!hoursAddCardC.closed24 && hoursAddCardC.closedNow\"><span class=\"closed-store\">Closed Now</span>Today\'s hours: <span>{{hoursAddCardC.openTimePeriod_0}}</span> - <span>{{hoursAddCardC.closeTimePeriod_0}}</span></span>&nbsp; <span ng-if=\"!hoursAddCardC.closed24 && hoursAddCardC.closedNow && hoursAddCardC.openTimeSecondPeriod\"><span>&&</span><span>{{hoursAddCardC.openTimePeriod_1}}</span> - <span>{{hoursAddCardC.closeTimePeriod_1}}</span></span> <span ng-if=\"!hoursAddCardC.closed24 && !hoursAddCardC.open24 && !hoursAddCardC.closedNow\" class=\"opened-store\">Open Until {{hoursAddCardC.closeToday}}</span> <span ng-if=\"!hoursAddCardC.closed24 && hoursAddCardC.open24\" class=\"opened-store\">Open 24 Hours</span></div></h4><h4 class=\"no-bold text-primary push-bottom\"><div ng-if=\"hoursAddCardC.hasAdditional || hoursAddCardC.hasAdditionalSpecial\"><span>{{hoursAddCardC.titleAdditional}}:</span> <span ng-if=\"hoursAddCardC.closed24Additional\"><span class=\"closed-store\">Closed Today</span></span> <span ng-if=\"!hoursAddCardC.closed24Additional && hoursAddCardC.closedNowAdditional\"><span class=\"closed-store\">Closed Now</span>Today\'s hours: <span>{{hoursAddCardC.openTodayAdditional}}</span> - <span>{{hoursAddCardC.closeTodayAdditional}}</span></span> <span ng-if=\"!hoursAddCardC.closed24Additional && !hoursAddCardC.open24Additional && !hoursAddCardC.closedNowAdditional\" class=\"opened-store\">Open Until {{hoursAddCardC.closeTodayAdditional}}</span> <span ng-if=\"!hoursAddCardC.closed24Additional && hoursAddCardC.open24Additional\" class=\"opened-store\">Open 24 Hours</span></div></h4><dl class=\"dl-horizontal\" itemprop=\"openingHours\" content=\"{{hoursAddCardC.openingHours}}\"><dt></dt><dd class=\"display-small\"><div ng-if=\"hoursAddCardC.hasPrimary && hoursAddCardC.hasAdditional\" class=\"hours-column dib push-right-xs bold-700\"><span>{{hoursAddCardC.titlePrimary}}</span></div><div ng-if=\"hoursAddCardC.hasAdditional\" class=\"hours-column dib bold-700 align-small-screen\"><span>{{hoursAddCardC.titleAdditional}}</span></div></dd><dt ng-repeat-start=\"(day,hours) in hoursAddCardC.regularHours\" ng-class=\"[hours.regular.highlightClass, hours.additional.highlightClass]\" class=\"text-overflow\">{{day}}</dt><dd ng-if=\"hours.regular.highlightClass || hours.additional.highlightClass\" class=\"display-small\"><div ng-if=\"hoursAddCardC.isUsedForPrimaryRegularHours && hours.regular\" class=\"hours-column dib push-right-xs open-close-align\"><span class=\"hours-column\" ng-class=\"hours.regular.highlightClass\" ng-if=\"!hours.regular.closed && !hours.regular.open24\">{{hoursAddCardC.getOpenTimePeriodDisplayMessage(hours.regular)}}</span> <span class=\"hours-column\" ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.regular.closed\">{{hours.regular.closedLabel}}</span> <span class=\"hours-column\" ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.regular.open24\">Open 24 Hours</span></div><div ng-if=\"hours.additional\" class=\"hours-column dib align-small-screen\"><span class=\"hours-column\" ng-class=\"hours.additional.highlightClass\">{{hoursAddCardC.getOpenTimePeriodDisplayMessage(hours.additional) || hours.additional.closedLabel}}</span></div></dd><dd ng-if=\"!hours.regular.highlightClass && !hours.additional.highlightClass\" ng-repeat-end=\"\" ng-repeat=\"i in hours.regular.numberOfTimeFragments track by $index\" class=\"display-small\"><div ng-if=\"hoursAddCardC.isUsedForPrimaryRegularHours && !hours.regular.highlightClass\" class=\"hours-column dib push-right-xs open-close-align\"><span ng-class=\"hours.regular.highlightClass\" ng-if=\"!hours.regular.closed && !hours.regular.open24\" itemprop=\"openingHours\" content=\"{{hoursAddCardC.getOpenTimePeriodDisplayMessage(hours.regular, $index)}}\">{{hoursAddCardC.getOpenTimePeriodDisplayMessage(hours.regular, $index)}}</span> <span ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.regular.open24\">Open 24 Hours</span> <span ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.regular.closed\">{{hours.regular.closedLabel}}</span></div><div ng-if=\"hours.additional && !hours.additional.highlightClass\" class=\"hours-column dib align-small-screen\"><span ng-class=\"hours.regular.highlightClass\" ng-if=\"!hours.additional.closed && !hours.additional.open24\" itemprop=\"openingHours\" content=\"{{hoursAddCardC.getOpenTimePeriodDisplayMessage(hours.additional, $index)}}\">{{hoursAddCardC.getOpenTimePeriodDisplayMessage(hours.additional, $index)}}</span> <span ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.additional.open24\">Open 24 Hours</span> <span ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.additional.closed\">{{hours.additional.closedLabel}}</span></div></dd></dl><h4 ng-if=\"hoursAddCardC.specialHours\" class=\"no-bold text-primary push-bottom\"><span>Special Hours</span></h4><dl ng-if=\"hoursAddCardC.specialHours\" class=\"dl-horizontal\" itemprop=\"openingHoursSpecification\" itemscope=\"\" itemtype=\"http://schema.org/OpeningHoursSpecification\"><dt></dt><dd><div ng-if=\"hoursAddCardC.hasPrimarySpecial\" class=\"hours-column dib push-right-xs bold-700\"><span>{{hoursAddCardC.titlePrimary}}</span></div><div ng-if=\"!hoursAddCardC.hasPrimarySpecial\" class=\"hours-column dib push-right-xs bold-700\"><span></span></div><div ng-if=\"hoursAddCardC.hasAdditionalSpecial\" class=\"hours-column dib bold-700\"><span>{{hoursAddCardC.titleAdditional}}</span></div></dd><dt ng-repeat-start=\"(day,hours) in hoursAddCardC.specialHours\" ng-class=\"[hours.regular.highlightClass, hours.additional.highlightClass]\" class=\"text-overflow\"><span itemprop=\"validFrom validThrough\" datetime=\"{{day}}\">{{day}}</span></dt><dd ng-repeat-end=\"\"><div ng-if=\"hours.regular || hours.additional\" class=\"hours-column dib push-right-xs\"><span ng-if=\"!hours.regular && hours.additional\">Regular Hours ({{hoursAddCardC.getStandardRegHours(hours.additional.dayOfTheWeek)}})</span> <span ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.regular && !hours.regular.open24 && !hours.regular.closed\" itemprop=\"openingHours\" content=\"{{hours.regular.openDisplayTime}}\">{{hours.regular.openDisplayTime}} - {{hours.regular.closeDisplayTime}}</span> <span ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.regular.open24\" itemprop=\"opens\" content=\"12:00 AM\">Open 24 Hours</span> <span ng-class=\"hours.regular.highlightClass\" ng-if=\"hours.regular.closed\" itemprop=\"closes\" content=\"12:00 AM\">{{hours.regular.closedLabel}}</span></div><div ng-if=\"hours.regular || hours.additional\" class=\"hours-column dib\"><span ng-if=\"hours.regular && !hours.additional\">Regular Hours ({{hoursAddCardC.getStandardAddtlHours(hours.regular.dayOfTheWeek)}})</span> <span ng-class=\"hours.additional.highlightClass\" ng-if=\"hours.additional && !hours.additional.closed && !hours.additional.open24\">{{hours.additional.openDisplayTime}} - {{hours.additional.closeDisplayTime}}</span> <span ng-class=\"hours.additional.highlightClass\" ng-if=\"hours.additional.open24\">Open 24 Hours</span> <span ng-class=\"hours.additional.highlightClass\" ng-if=\"hours.additional.closed\">{{hours.additional.closedLabel}}</span></div></dd></dl><div class=\"hours-note\" ng-if=\"hoursAddCardC.hoursNote\">* {{ hoursAddCardC.hoursNote.data }}</div></div>");
$templateCache.put("app/localLanding/cards/hoursCard.directive.html","<div class=\"hours-card\" ng-show=\"hoursCardC.locHours || hoursCardC.specialHours || hoursCardC.hoursNote\"><h3><i class=\"ico ico-clock\"></i>&nbsp;Hours</h3><p ng-if=\"hoursCardC.locHours || hoursCardC.specialHours\" class=\"bold-500 push-top push-bottom\"><i ng-class=\"{\'opened\': !hoursCardC.closedNow , \'closed\': hoursCardC.closedNow}\" class=\"ico ico-clock\"></i> <span ng-if=\"hoursCardC.comingSoon\"><span class=\"closed-store\">{{hoursCardC.comingSoon}}</span></span> <span ng-if=\"hoursCardC.closed24 && !hoursCardC.comingSoon\"><span class=\"closed-store\">Closed Today</span></span> <span ng-if=\"!hoursCardC.closed24 && hoursCardC.closedNow\"><span class=\"closed-store\">Closed Now</span>Today\'s hours: <span>{{hoursCardC.openTimePeriod_0}}</span> - <span>{{hoursCardC.closeTimePeriod_0}}</span></span>&nbsp; <span ng-if=\"!hoursCardC.closed24 && hoursCardC.closedNow && hoursCardC.openTimePeriod_1\"><span>{{hoursCardC.openTimePeriod_1}}</span> - <span>{{hoursCardC.closeTimePeriod_1}}</span></span> <span ng-if=\"!hoursCardC.closed24 && !hoursCardC.closedNow && !hoursCardC.open24 && !hoursCardC.customText && !hoursCardC.tempClosed\" class=\"opened-store\">Open Until {{hoursCardC.closeToday}}</span> <span ng-if=\"hoursCardC.customText\" class=\"hoursCardC-customText\">{{hoursCardC.customTextShow}}</span> <span ng-if=\"!hoursCardC.closed24 && hoursCardC.open24\" class=\"opened-store\">Open 24 Hours</span></p><div ng-if=\"hoursCardC.locHours\"><dl class=\"dl-horizontal\" ng-if=\"!hoursCardC.onlyToday\" itemprop=\"openingHours\" content=\"{{hoursCardC.openingHours}}\"><dt ng-repeat-start=\"(day,hours) in hoursCardC.locHours\" ng-class=\"hours.highlightClass\"><span>{{hours.dayName}}</span></dt><dd ng-if=\"hours.highlightClass\"><div class=\"hours-column margin-left-day-hours\"><span ng-class=\"hours.highlightClass\" ng-if=\"!hours.closed\">{{hoursCardC.getOpenTimePeriodDisplayMessage(hours)}}</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.closed\">{{hours.closedLabel}}</span></div></dd><dd ng-if=\"!hours.highlightClass\" ng-repeat-end=\"\" ng-repeat=\"i in hours.numberOfTimeFragments track by $index\" class=\"hours-location\"><div class=\"hours-column margin-left-day-hours\"><span ng-class=\"hours.highlightClass\" ng-if=\"!hours.closed && !hours.open24\">{{hoursCardC.getOpenTimePeriodDisplayMessage(hours, $index)}}</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.open24\">Open 24 Hours</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.closed\">{{hours.closedLabel}}</span></div></dd></dl></div><div class=\"hours-note\" ng-if=\"hoursCardC.hoursNote\">* {{ hoursCardC.hoursNote.data }}</div><div ng-if=\"hoursCardC.specialHours\" class=\"specialHours\"><p class=\"bold-500 push-top push-bottom\" id=\"specialHours\"><i ng-class=\"{\'opened\': !hoursCardC.closedNow , \'closed\': hoursCardC.closedNow}\" class=\"ico ico-clock\"></i> Special Hours</p><dl class=\"dl-horizontal\" itemprop=\"openingHoursSpecification\" itemscope=\"\" itemtype=\"http://schema.org/OpeningHoursSpecification\"><dt ng-repeat-start=\"(day,hours) in hoursCardC.specialHours\" ng-class=\"hours.highlightClass\"><span itemprop=\"validFrom validThrough\" datetime=\"{{hours.dayNameShort}}\">{{hours.dayNameShort}}</span></dt><dd ng-if=\"hours.highlightClass\"><span ng-class=\"hours.highlightClass\" ng-if=\"!hours.closed\">{{hoursCardC.getOpenTimePeriodDisplayMessage(hours)}}</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.closed\" itemprop=\"closes\">Closed</span></dd><dd ng-if=\"!hours.highlightClass\" ng-repeat-end=\"\" ng-repeat=\"i in hours.numberOfTimeFragments track by $index\"><span ng-class=\"hours.highlightClass\" ng-if=\"!hours.closed && !hours.open24\">{{hoursCardC.getOpenTimePeriodDisplayMessage(hours, $index)}}</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.open24\" itemprop=\"opens\" content=\"12:00 AM\">Open 24 Hours</span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.closed\" itemprop=\"closes\" content=\"12:00 AM\">Closed</span></dd></dl></div></div>");
$templateCache.put("app/localLanding/cards/hoursCollapseCard.directive.html","<div class=\"hours-card\"><div ng-if=\"hoursCardC.locHours\"><p class=\"bold-500 push-top push-bottom\"><i class=\"ico ico-clock\"></i> <span ng-if=\"hoursCardC.closedNow\">Closed Now<br>Today\'s hours: <span>{{hoursCardC.openToday}}</span> - <span>{{hoursCardC.closeToday}}</span></span> <span ng-if=\"!hoursCardC.closedNow\">Open Until {{hoursCardC.closeToday}}</span></p><dl class=\"dl-horizontal\" ng-if=\"!hoursCardC.onlyToday\"><div class=\"panel-group\" ng-model=\"panels.activePanel\" role=\"tablist\" aria-multiselectable=\"true\" bs-collapse=\"\"><div class=\"panel panel-default\"><div class=\"panel-heading\" role=\"tab\"><h4 class=\"panel-title\"><a bs-collapse-toggle=\"\"><span>View Hours <i class=\"ico ico-chevron-down ico-lg\"></i></span></a></h4></div><div class=\"panel-collapse\" role=\"tabpanel\" bs-collapse-target=\"\"><div class=\"panel-body\"><div class=\"dl-horizontal\" ng-if=\"!hoursCardC.onlyToday\" itemprop=\"openingHours\" content=\"{{hoursCardC.openingHours}}\"><dt ng-repeat-start=\"(day,hours) in hoursCardC.locHours\" ng-class=\"hours.highlightClass\"><span>{{hours.dayName}}</span></dt><dd ng-repeat-end=\"\"><span ng-class=\"hours.highlightClass\" ng-if=\"!hours.closedLabel\"><span>{{hours.openTime}}</span> - <span>{{hours.closeTime}}</span></span> <span ng-class=\"hours.highlightClass\" ng-if=\"hours.closedLabel\">{{hours.closedLabel}}</span></dd></div></div></div></div></div></dl></div><div class=\"hours-note\" ng-if=\"hoursCardC.hoursNote\">* {{ hoursCardC.hoursNote.data }}</div></div>");
$templateCache.put("app/localLanding/cards/htmlCard.directive.html","<div ng-show=\"htmlCardC.content.data\" class=\"html-container\"><div><p data-ng-bind-html=\"htmlCardC.content.data\" itemprop=\"content\" aria-live=\"polite\"></p></div></div>");
$templateCache.put("app/localLanding/cards/instagram9Card.directive.html","<div><div class=\"border-bottom push-bottom clearfix\"><div class=\"pull-left\"><h3 id=\"instagram-heading\" tabindex=\"0\">Find us on Instagram</h3></div><div class=\"pull-right mf-social-icons single\"><a class=\"btn btn-provider instagram-color\" href=\"{{ instagram9CardC.igData.url }}\" target=\"_blank\" rel=\"noopener\" title=\"{{instagram9CardC.title}} on Instagram\" aria-label=\"Instagram Button\"><i class=\"ico ico-instagram\"></i></a></div></div><div class=\"clearfix\"><div ng-repeat=\"photo in photos | limitTo:12\" class=\"instagram9grid\"><a ng-href=\"{{photo.permalink}}\" target=\"_blank\" rel=\"noopener\" class=\"instagram9\" title=\"{{photo.owner.username}} on Instagram\" analytics-event=\"Clicked Instagram Photo\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\"><img width=\"100%\" ng-src=\"{{photo.trust_url}}\" alt=\"Instagram Photo\" image-fallback=\"{{photo.fallback_url}}\"></a></div></div></div>");
$templateCache.put("app/localLanding/cards/instagramCard.directive.html","<div><div class=\"border-bottom push-bottom clearfix\"><div class=\"pull-left\"><h3>Find us on Instagram</h3></div><div class=\"pull-right mf-social-icons single\"><a class=\"btn btn-provider instagram-color\" href=\"{{ instagramCardC.igData.url }}\" target=\"_blank\" rel=\"noopener\" title=\"{{instagramCardC.title}} on Instagram\"><i class=\"ico ico-instagram\"></i></a></div></div><div class=\"clearfix ig-flex\"><div ng-repeat=\"photo in photos | limitTo:12\" class=\"ig-square\"><a ng-href=\"{{photo.permalink}}\" target=\"_blank\" class=\"photo-block\" title=\"{{photo.owner.username}} on Instagram\" analytics-event=\"Clicked Instagram Photo\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\"><img width=\"100%\" ng-src=\"{{photo.media_url}}\"></a></div></div></div>");
$templateCache.put("app/localLanding/cards/llpContentCard.directive.html","<div class=\"push-bottom-xl llp-card\"><div class=\"card-top\"><h3>From the Business</h3></div><div class=\"card-bottom clearfix\"><h5 class=\"media-heading\"><i class=\"small\">{{ llpContentCardC.published_date_tz }}</i></h5><div class=\"push-top\"><div ng-if=\"llpContentCardC.publishedContent.body.length\" class=\"push-top content-body\">{{ llpContentCardC.publishedContent.body }}</div><span ng-if=\"!llpContentCardC.publishedContent.image_url && llpContentCardC.publishedContent.link_url\"><a ng-href=\"{{llpContentCardC.filteredLink}}\" target=\"_blank\">{{llpContentCardC.publishedContent.link_url}}</a></span> <span ng-if=\"llpContentCardC.publishedContent.image_url\"><img ng-if=\"!llpContentCardC.publishedContent.link_url\" alt=\"{{ llpContentCardC.publishedContent.body }}\" ng-src=\"{{ llpContentCardC.publishedContent.image_url }}\" width=\"100%\" class=\"push-top\"> <a ng-if=\"llpContentCardC.publishedContent.link_url\" ng-href=\"{{llpContentCardC.filteredLink}}\" target=\"_blank\"><img ng-src=\"{{ llpContentCardC.publishedContent.image_url }}\" alt=\"{{ llpContentCardC.publishedContent.body }}\" width=\"100%\" class=\"push-top\"></a></span></div></div></div>");
$templateCache.put("app/localLanding/cards/managerCard.directive.html","<div class=\"manager-card\"><div class=\"manager-photo-container\"><img class=\"manager-photo\" ng-src=\"{{location.manager_photo ? location.manager_photo : \'/assets/images/default_manager_photo.png\'}}\" data-at2x=\"{{location.manager_photo ? location.manager_photo : \'/assets/images/default_manager_photo@2x.png\'}}\" width=\"100%\" alt=\"Manager photo\" ng-attr-title=\"{{location.manager_photo ? location.manager_name : \'Store Manager\'}} Photo\"></div><div class=\"text-left manager-info\"><h3>{{location.manager_name}}</h3><p>{{location.manager_notes}}</p></div></div>");
$templateCache.put("app/localLanding/cards/mapCard.directive.html","<div class=\"map-container push-bottom\" window-width=\"localLanding.windowWidth\"><img ng-if=\"!mapCardC.isGoogleMapsEnabled && mapCardC.height && mapCardC.windowWidth >= 768\" data-at2x=\"https://api.mapbox.com/styles/v1/momentfeed/ckekfnwp3079w19qmiwkaneut/static/{{mapCardC.mapPin}}({{mapCardC.location.store_info.longitude}},{{mapCardC.location.store_info.latitude}})/{{mapCardC.location.store_info.longitude}},{{mapCardC.location.store_info.latitude}},15/750x{{mapCardC.height}}@2x?access_token={{mapCardC.MAP_KEY}}\" ng-src=\"https://api.mapbox.com/styles/v1/momentfeed/ckekfnwp3079w19qmiwkaneut/static/{{mapCardC.mapPin}}({{mapCardC.location.store_info.longitude}},{{mapCardC.location.store_info.latitude}})/{{mapCardC.location.store_info.longitude}},{{mapCardC.location.store_info.latitude}},15/750x{{mapCardC.height}}?access_token={{mapCardC.MAP_KEY}}\" alt=\"Map to {{mapCardC.location.store_info.name}}\" class=\"hidden-xs\" property=\"og:image\"> <img ng-if=\"!mapCardC.isGoogleMapsEnabled && !mapCardC.height && mapCardC.windowWidth >= 768\" data-at2x=\"https://api.mapbox.com/styles/v1/momentfeed/ckekfnwp3079w19qmiwkaneut/static/{{mapCardC.mapPin}}({{mapCardC.location.store_info.longitude}},{{mapCardC.location.store_info.latitude}})/{{mapCardC.location.store_info.longitude}},{{mapCardC.location.store_info.latitude}},15/750x420@2x?access_token={{mapCardC.MAP_KEY}}\" ng-src=\"https://api.mapbox.com/styles/v1/momentfeed/ckekfnwp3079w19qmiwkaneut/static/{{mapCardC.mapPin}}({{mapCardC.location.store_info.longitude}},{{mapCardC.location.store_info.latitude}})/{{mapCardC.location.store_info.longitude}},{{mapCardC.location.store_info.latitude}},15/750x420?access_token={{mapCardC.MAP_KEY}}\" alt=\"Map to {{mapCardC.location.store_info.name}}\" class=\"hidden-xs\" property=\"og:image\"> <img ng-if=\"mapCardC.isGoogleMapsEnabled && mapCardC.height && mapCardC.windowWidth >= 768\" data-at2x=\"https://maps.googleapis.com/maps/api/staticmap?center={{mapCardC.location.store_info.latitude}},{{mapCardC.location.store_info.longitude}}&zoom=15&scale=2&size=750x{{mapCardC.height}}&markers={{mapCardC.mapPin}}{{mapCardC.location.store_info.latitude}},{{mapCardC.location.store_info.longitude}}&key={{mapCardC.MAP_KEY}}\" ng-src=\"https://maps.googleapis.com/maps/api/staticmap?center={{mapCardC.location.store_info.latitude}},{{mapCardC.location.store_info.longitude}}&zoom=15&size=750x{{mapCardC.height}}&markers={{mapCardC.mapPin}}{{mapCardC.location.store_info.latitude}},{{mapCardC.location.store_info.longitude}}&key={{mapCardC.MAP_KEY}}\" alt=\"Map to {{mapCardC.location.store_info.name}}\" class=\"hidden-xs\" property=\"og:image\"> <img ng-if=\"mapCardC.isGoogleMapsEnabled && !mapCardC.height && mapCardC.windowWidth >= 768\" data-at2x=\"https://maps.googleapis.com/maps/api/staticmap?center={{mapCardC.location.store_info.latitude}},{{mapCardC.location.store_info.longitude}}&zoom=15&scale=2&size=750x420&markers={{mapCardC.mapPin}}{{mapCardC.location.store_info.latitude}},{{mapCardC.location.store_info.longitude}}&key={{mapCardC.MAP_KEY}}\" ng-src=\"https://maps.googleapis.com/maps/api/staticmap?center={{mapCardC.location.store_info.latitude}},{{mapCardC.location.store_info.longitude}}&zoom=15&size=750x420&markers={{mapCardC.mapPin}}{{mapCardC.location.store_info.latitude}},{{mapCardC.location.store_info.longitude}}&key={{mapCardC.MAP_KEY}}\" alt=\"Map to {{mapCardC.location.store_info.name}}\" class=\"hidden-xs\" property=\"og:image\"><img ng-if=\"!mapCardC.isGoogleMapsEnabled && mapCardC.windowWidth < 768\" data-at2x=\"https://api.mapbox.com/styles/v1/momentfeed/ckekfnwp3079w19qmiwkaneut/static/{{mapCardC.mapPin}}({{mapCardC.location.store_info.longitude}},{{mapCardC.location.store_info.latitude}})/{{mapCardC.location.store_info.longitude}},{{mapCardC.location.store_info.latitude}},15/480x320@2x?access_token={{mapCardC.MAP_KEY}}\" ng-src=\"https://api.mapbox.com/styles/v1/momentfeed/ckekfnwp3079w19qmiwkaneut/static/{{mapCardC.mapPin}}({{mapCardC.location.store_info.longitude}},{{mapCardC.location.store_info.latitude}})/{{mapCardC.location.store_info.longitude}},{{mapCardC.location.store_info.latitude}},15/480x320?access_token={{mapCardC.MAP_KEY}}\" alt=\"Map to {{mapCardC.location.store_info.name}}\" class=\"visible-xs visible-map-xs\" property=\"og:image\"> <img ng-if=\"mapCardC.isGoogleMapsEnabled && mapCardC.windowWidth < 768\" data-at2x=\"https://maps.googleapis.com/maps/api/staticmap?center={{mapCardC.location.store_info.latitude}},{{mapCardC.location.store_info.longitude}}&zoom=15&scale=2&size=480x320&markers={{mapCardC.mapPin}}{{mapCardC.location.store_info.latitude}},{{mapCardC.location.store_info.longitude}}&key={{mapCardC.MAP_KEY}}\" ng-src=\"https://maps.googleapis.com/maps/api/staticmap?center={{mapCardC.location.store_info.latitude}},{{mapCardC.location.store_info.longitude}}&zoom=15&size=480x320&markers={{mapCardC.mapPin}}{{mapCardC.location.store_info.latitude}},{{mapCardC.location.store_info.longitude}}&key={{mapCardC.MAP_KEY}}\" alt=\"Map to {{mapCardC.location.store_info.name}}\" class=\"visible-xs visible-map-xs\" property=\"og:image\"></div>");
$templateCache.put("app/localLanding/cards/mapCardLocality.directive.html","<div class=\"map-container push-bottom\" window-width=\"siteMapC\"><img ng-if=\"!mapCardLocalityC.isGoogleMapsEnabled && mapCardLocalityC.height && mapCardLocalityC.windowWidth >= 768\" data-at2x=\"https://api.mapbox.com/v4/mapbox.streets/{{mapCardLocalityC.mapPins}}/{{mapCardLocalityC.origin.longitude}},{{mapCardLocalityC.origin.latitude}},{{mapCardLocalityC.zoom}}/750x{{mapCardLocalityC.height}}@2x.png?access_token={{mapCardLocalityC.MAPBOX_KEY}}\" ng-src=\"https://api.mapbox.com/v4/mapbox.streets/{{mapCardLocalityC.mapPins}}/{{mapCardLocalityC.origin.longitude}},{{mapCardLocalityC.origin.latitude}},{{mapCardLocalityC.zoom}}/750x{{mapCardLocalityC.height}}.png?access_token={{mapCardLocalityC.MAPBOX_KEY}}\" alt=\"{{mapCardLocalityC.location.store_info.name}}\" class=\"hidden-xs\" property=\"og:image\"> <img ng-if=\"!mapCardLocalityC.isGoogleMapsEnabled && !mapCardLocalityC.height && mapCardLocalityC.windowWidth >= 768\" data-at2x=\"https://api.mapbox.com/v4/mapbox.streets/{{mapCardLocalityC.mapPins}}/{{mapCardLocalityC.origin.longitude}},{{mapCardLocalityC.origin.latitude}},{{mapCardLocalityC.zoom}}/750x420@2x.png?access_token={{mapCardLocalityC.MAPBOX_KEY}}\" ng-src=\"https://api.mapbox.com/v4/mapbox.streets/{{mapCardLocalityC.mapPins}}/{{mapCardLocalityC.origin.longitude}},{{mapCardLocalityC.origin.latitude}},{{mapCardLocalityC.zoom}}/750x420.png?access_token={{mapCardLocalityC.MAPBOX_KEY}}\" alt=\"{{mapCardLocalityC.location.store_info.name}}\" class=\"hidden-xs\" property=\"og:image\"><img ng-if=\"!mapCardLocalityC.isGoogleMapsEnabled && mapCardLocalityC.windowWidth < 768\" data-at2x=\"https://api.mapbox.com/v4/mapbox.streets/{{mapCardLocalityC.mapPins}}/{{mapCardLocalityC.origin.longitude}},{{mapCardLocalityC.origin.latitude}},{{mapCardLocalityC.zoom}}/480x320@2x.png?access_token={{mapCardLocalityC.MAPBOX_KEY}}\" ng-src=\"https://api.mapbox.com/v4/mapbox.streets/{{mapCardLocalityC.mapPins}}/{{mapCardLocalityC.origin.longitude}},{{mapCardLocalityC.origin.latitude}},{{mapCardLocalityC.zoom}}/480x320.png?access_token={{mapCardLocalityC.MAPBOX_KEY}}\" alt=\"{{mapCardLocalityC.location.store_info.name}}\" class=\"visible-xs\" property=\"og:image\"><div ng-if=\"mapCardLocalityC.isGoogleMapsEnabled\" id=\"google_chart_map\"></div></div>");
$templateCache.put("app/localLanding/cards/menuCard.directive.html","<section class=\"menu-card\" ng-show=\"menuCardController.menu && menuCardController.menu.length > 0\"><header><h2>{{menuCardController.storeInfo.name + \' \' + menuCardController.storeInfo.locality}}</h2><span>{{menuCardController.address}}</span></header><div class=\"menu-content\" scrolling-tabs-wrapper=\"\" watch-tabs=\"menuCardController.menu\" elem-ready=\"menuCardController.menuLoaded()\" style=\"overflow:hidden;\"><tabset><tab ng-repeat=\"category in menuCardController.menu\" active=\"category.active\" heading=\"{{category.categoryName}}\"><div role=\"tabpanel\" class=\"content\"><ul class=\"menu-options\"><li ng-repeat=\"option in category.options\" class=\"option\"><div class=\"menu-option clearfix\"><div class=\"details\"><div class=\"price\"><span ng-if=\"option.price.amount && option.price.currencyCode == \'USD\'\">$</span>{{option.price.amount}}</div><div class=\"name\">{{option.name}}</div><div class=\"description\"><span>{{option.description.text}}</span><span ng-show=\"option.description.truncated\">...</span><a href=\"\" ng-click=\"option.description.truncated = false\" class=\"more\" ng-show=\"option.description.truncated\" title=\"More about {{ option.name }}\">More</a><span ng-show=\"!option.description.truncated\">{{option.description.truncatedText}}</span></div></div></div></li></ul></div></tab></tabset></div><div class=\"bottom-link\" ng-show=\"menuCardController.link\"><i class=\"fa fa-arrow-circle-right custom\"></i> <a ng-href=\"{{menuCardController.link}}\" title=\"{{menuCardController.linkText}}\" target=\"_blank\" rel=\"noopener\">{{menuCardController.linkText}}</a></div></section>");
$templateCache.put("app/localLanding/cards/menuCard2.directive.html","<section class=\"menu-card2\"><header><h2>{{menuCard2Controller.storeInfo.name + \' \' + menuCard2Controller.storeInfo.locality}} Menu</h2><span>{{menuCard2Controller.address}}</span></header><div class=\"menu-content\" scrolling-tabs-wrapper=\"\" watch-tabs=\"menuCard2Controller.menu\"><tabset><tab ng-repeat=\"category in menuCard2Controller.menu\" active=\"category.active\" heading=\"{{category.categoryName}}\"><div role=\"tabpanel\" class=\"content\"><ul class=\"menu-options\"><li ng-repeat=\"option in category.options\" class=\"option\"><div class=\"menu-option clearfix\"><div class=\"details\"><div class=\"name\">{{option.name}} {{option.price.amount ? \'| \' + option.price.amount : \'\'}}</div><div></div><div class=\"description\"><span>{{option.description.text}}</span><span>{{option.description.truncatedText}}</span></div></div></div></li></ul></div></tab></tabset></div><div class=\"bottom-link\" ng-show=\"menuCard2Controller.link\"><i class=\"fa fa-arrow-circle-right custom\"></i> <a ng-href=\"{{menuCard2Controller.link}}\" title=\"{{menuCard2Controller.linkText}}\" target=\"_blank\">{{menuCard2Controller.linkText}}</a></div></section>");
$templateCache.put("app/localLanding/cards/mfReviewsCard.directive.html","<div class=\"reviewCard\"><div class=\"row\"><div class=\"col-xs-12 form\" ng-if=\"RatingCtrl.enableForm\" ng-class=\"RatingCtrl.enableReviews?\'col-md-6\':\'col-md-12\'\"><div class=\"post-message animate-show-hide\" ng-show=\"RatingCtrl.postMessage\"><p>{{RatingCtrl.postMessage}}</p></div><div class=\"form-body animate-show-hide\" ng-show=\"!RatingCtrl.postMessage\"><h4>Please Leave Us A Rating!</h4><div class=\"card-rating text-center\"><ul class=\"star-rating\"><li data-ng-repeat=\"star in RatingCtrl.stars track by $index\" class=\"star\" data-ng-class=\"{\'filled\': $index <= RatingCtrl.activeIndex}\" aria-label=\"star_rating\" data-ng-click=\"RatingCtrl.toggle($index)\"><i class=\"ico ico-star\" aria-label=\"star_rating\"></i></li></ul><p class=\"help-block\" ng-show=\"RatingCtrl.activeIndex == null && RatingCtrl.isFormActive\">Please Rating</p></div><form name=\"reviewForm\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{\'has-error\': !RatingCtrl.isInfoValid()&& RatingCtrl.isFormActive}\"><ng-form name=\"userFieldForm\"><div class=\"name-field\"><input aria-label=\"first-name\" type=\"text\" class=\"form-control\" name=\"first-name\" required=\"\" maxlength=\"60\" placeholder=\"What\'s your first name?*\" data-form-field=\"Name\" ng-model=\"formData.first_name\"> <input aria-label=\"last-name\" type=\"text\" class=\"form-control\" name=\"last-name\" required=\"\" maxlength=\"60\" placeholder=\"What\'s your last name?*\" data-form-field=\"Name\" ng-model=\"formData.last_name\"></div><div class=\"text-count\"></div><p class=\"help-block\" ng-show=\"(!formData.first_name ||!formData.last_name) && RatingCtrl.isFormActive\">Please Enter A Valid Name</p><input aria-label=\"email\" type=\"email\" class=\"form-control\" name=\"email\" required=\"\" maxlength=\"60\" placeholder=\"What\'s your email address?*\" data-form-field=\"Email\" ng-model=\"formData.email\"><div class=\"text-count\"></div><p class=\"help-block\" ng-show=\"!formData.email && RatingCtrl.isFormActive\">Please Enter A Valid Email</p><input aria-label=\"title\" type=\"text\" class=\"form-control\" name=\"title\" placeholder=\"Review Title*\" data-form-field=\"Message\" maxlength=\"60\" ng-model=\"formData.title\"><div class=\"text-count pull-right\">{{formData.title.length}}/60</div><p class=\"help-block\" ng-show=\"!formData.title && RatingCtrl.isFormActive\">Please Enter A Valid Title</p><textarea aria-label=\"review\" class=\"form-control review\" name=\"review\" placeholder=\"Review*\" rows=\"7\" ng-model=\"formData.text\" maxlength=\"1700\" data-form-field=\"Message\"></textarea><div class=\"text-count pull-right\">{{formData.text.length}}/1700</div><p class=\"help-block\" ng-show=\"!formData.text && RatingCtrl.isFormActive\">Please Enter A Valid Review</p></ng-form><div class=\"review-submitBtn\"><button type=\"submit\" class=\"btn btn-md\" ng-click=\"RatingCtrl.onSubmitClick()\" value=\"Submit form\">Submit</button></div></div></form></div><div class=\"review-logo\"><div class=\"logo-text\">Powered by</div><div class=\"svg-logo\"><svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1\" viewbox=\"0 0 788 321\"><path d=\"M133 248v-38l-16 38h-12l-16-38v38H74v-66h19l18 45 20-45h17v66h-15zm49-50c14 0 25 8 25 25s-12 26-26 26c-15 0-25-8-25-25s11-26 26-26zm-1 38c6 0 9-3 9-12 0-10-3-13-9-13-5 0-9 4-9 13s4 12 9 12zm47-37v6c3-3 8-7 15-7 6 0 9 2 12 7 3-4 8-7 15-7 9 0 14 6 14 16v34h-16v-31c0-4-1-6-4-6s-6 2-7 3v34h-16v-30c0-4 0-7-4-7-3 0-6 2-7 4v33h-16v-49h14zm108 44c-6 4-12 6-20 6-16 0-25-9-25-25s10-26 25-26c14 0 22 8 22 23v7h-30c1 5 3 9 10 9 4 0 8-1 14-4l4 10zm-13-24c0-5-1-9-7-9s-8 5-8 8h15zm38-20v6c3-3 8-7 15-7 10 0 16 6 16 17v33h-16v-28c0-6-2-9-6-9s-7 3-8 4v33h-15v-49h14zm162 44c-6 4-13 6-21 6-15 0-24-9-24-25s9-26 24-26 23 8 23 23l-1 7h-30c1 5 4 9 10 9 5 0 9-1 15-4l4 10zm-13-24c0-5-2-9-7-9-6 0-9 5-9 8h16zm67 24c-6 4-13 6-21 6-15 0-24-9-24-25s9-26 24-26c14 0 22 8 22 23v7h-30c1 5 3 9 10 9 5 0 9-1 15-4l4 10zm-13-24c0-5-2-9-7-9-6 0-9 5-9 8h16zm56 23c-3 4-8 7-15 7-14 0-20-9-20-25 0-17 9-26 20-26 6 0 10 2 14 5v-21h15v66h-15l1-6zm-1-27c-2-2-5-4-9-4-5 0-9 4-9 13 0 7 3 12 9 12 4 0 7-2 9-4v-17zm-195 22c-3 0-4-1-4-3v-23h8v-12h-7v-14h-16v14h-7v12h7v26c0 7 4 12 12 12l12-2-1-10h-4zm14 11h15v-26h18v-12h-18v-15h28v-13h-43v66z\" class=\"st0\"></path><path d=\"M713 102l-13-23c-2-2-6-5-9-5H582l17 28c1 3 5 5 8 5h65c3 0 7 3 9 6l16 27 16-28c2-2 2-7 0-10z\" class=\"st1\"></path><path d=\"M675 121c-1-3-5-5-8-5h-71l16 28c2 3 6 5 9 5h27c3 0 7 2 8 5l16 28 17-28v-10l-14-23z\" class=\"st1\"></path></svg></div></div></div><div class=\"col-xs-12 reviews\" ng-if=\"RatingCtrl.enableReviews\" ng-class=\"RatingCtrl.enableForm?\'col-md-6\':\'col-md-12\'\"><div class=\"no-review\" ng-if=\"RatingCtrl.reviews.length == 0\"><div>No Reviews Collected yet...</div></div><ul class=\"review-ul\" ng-class=\"{\'review-mobile-hide\': !RatingCtrl.toggleExpand}\" ng-if=\"RatingCtrl.reviews.length != 0\"><li class=\"review-li\" ng-repeat=\"review in RatingCtrl.reviews\"><div class=\"review title\">{{review.title}}</div><ul class=\"star-rating\"><li data-ng-repeat=\"star in RatingCtrl.stars track by $index\" class=\"star\" data-ng-class=\"{\'filled\': $index < review.rating}\"><i class=\"ico ico-star\"></i></li></ul><div class=\"reviewer_name\">{{ review.first_name + \" \" + review.last_name }}</div><p>{{review.text}}</p><div class=\"response\"><p class=\"response_content\">{{review.owner_response.text}}</p></div></li></ul><div class=\"review-expand\" ng-click=\"RatingCtrl.loadMore()\" ng-if=\"RatingCtrl.reviews.length != 0\"><a>{{RatingCtrl.loadText}}</a></div></div></div></div>");
$templateCache.put("app/localLanding/cards/nearbyCard.directive.html","<div class=\"text-center push-top-xl push-bottom-xl\" ng-show=\"locations.length\"><h2>{{ nearbyCardC.title || \"Nearby Locations\" }}</h2><div class=\"text-center\"><div ng-repeat=\"location in locations\" class=\"dib width-third xs-full-width push-bottom\"><h4><span ng-if=\"!location.name.includes(\'®\')\" data-ng-bind-html=\"location.name\" itemprop=\"name\" aria-live=\"polite\"></span><span ng-if=\"location.name.includes(\'®\')\"><span data-ng-bind-html=\"location.name.slice(0, location.name.length - 1)\" itemprop=\"name\" aria-live=\"polite\"></span><sup>®</sup></span><span ng-if=\"nearbyCardC.includeLocality\">, {{ location.address_detail.locality }}</span></h4><h5 class=\"no-bold line-height-bump\">{{ location.address_detail.address }} {{ location.address_detail.address_extended }}<br>{{ location.address_detail.locality }}, {{ location.address_detail.region }} {{ location.address_detail.postcode }}<br></h5><h5 class=\"visible-xs\"><a ng-href=\"tel:{{ location.phone }}\" analytics-event=\"Call\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" title=\"Call\">{{ location.phone }}</a></h5><h5 class=\"hidden-xs\">{{ location.phone }}</h5><h5>{{location.distance | number:1 }} mi.</h5><div class=\"push-top-lg\"><a class=\"btn btn-primary\" title=\"Local Page\" ng-show=\"!location.hideLocalPageButton && location.local_landing_page\" href=\"{{ nearbyCardC.personNotLocation ? \'ll/\' + location.name + location.llp_url.slice(3, location.llp_url.length) : location.llp_url }}\">{{ nearbyCardC.localPageBtn || \"Local Page\"}}</a> <a href=\"{{ nearbyCardC.getDirectionsUrl(location.address_detail) }}\" target=\"_blank\" rel=\"noopener\" title=\"Get Directions\" class=\"btn btn-primary\">Get Directions</a></div></div></div></div>");
$templateCache.put("app/localLanding/cards/partnerReviewsCard.directive.html","<div class=\"partner-reviews-card\"><div ng-if=\"partnerReviewsCardC.pData.ratingFraction > partnerReviewsCardC.minRating\"><div class=\"row review-wrapper\"><div class=\"float-left icon-container col-sm-2 col-md-2 col-lg-2 col-xs-2\"><div class=\"btn-provider {{partnerReviewsCardC.partnerName | lowercase}}-color\"><a itemprop=\"sameAs\" href=\"{{ partnerReviewsCardC.pData.url }}\" target=\"_blank\" rel=\"external noopener\" title=\"{{partnerReviewsCardC.title}} on {{partnerReviewsCardC.partnerName}}\" aria-label=\"{{partnerReviewsCardC.partnerName}} button\"><i class=\"ico ico-{{partnerReviewsCardC.partnerName | lowercase}}\"></i></a></div></div><div class=\"float-left ratings-container col-sm-8 col-md-8 col-lg-8 col-xs-8\"><div class=\"row\"><div ng-if=\"partnerReviewsCardC.partnerName===\'Yelp\'\"><img ng-src=\"{{partnerReviewsCardC.pData.yelpStarUrl}}\" alt=\"\"></div><div ng-if=\"partnerReviewsCardC.partnerName === \'Foursquare\'\"><span class=\"foursquare-rating venue-score\" style=\"background-color: {{partnerReviewsCardC.ratingColor}}\"><span>{{partnerReviewsCardC.pData.rating}}</span> <sup>/<span>10</span></sup></span></div><div ng-if=\"partnerReviewsCardC.partnerName===\'Google\'\"><div star-rating=\"\" rating-value=\"partnerReviewsCardC.pData.roundedRating\" max=\"5\"></div></div><div ng-if=\"partnerReviewsCardC.partnerName===\'Facebook\'\"><div class=\"circle\">{{partnerReviewsCardC.pData.rating}}</div><span class=\"bold-text\">out of 5</span></div><a ng-if=\"partnerReviewsCardC.pData.reviewCount\" class=\"review-count\" href=\"{{ partnerReviewsCardC.pData.url }}\" target=\"_blank\" rel=\"external noopener\">View {{partnerReviewsCardC.pData.reviewCount}} {{partnerReviewsCardC.partnerName}} Reviews</a> <a ng-if=\"!partnerReviewsCardC.pData.reviewCount\" class=\"review-count\" href=\"{{ partnerReviewsCardC.pData.url }}\" target=\"_blank\" rel=\"external noopener\">View {{partnerReviewsCardC.partnerName}} Reviews</a></div></div></div></div></div>");
$templateCache.put("app/localLanding/cards/promoCard.directive.html","<div class=\"carousel-container\"><div uib-carousel=\"\" interval=\"promoCardC.myInterval\"><div uib-slide=\"\" ng-repeat=\"object in promoCardC.promoObject\" active=\"object.active\"><li><div ng-if=\"object.url\"><a href=\"{{ object.url }}\" target=\"_blank\" data-tag=\"{{ object.analytics_ }}\" analytics-event=\"Clicked Promo Photo\" analytics-label=\"{{ promoCardC.location | labelizeLocation }}\" rel=\"noopener\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\"><img cl-src=\"{{object.image}}\" type=\"fetch\" dpr=\"auto\" class=\"cld-responsive\" alt=\"Promo Image\"></a></div><div ng-if=\"!object.url\"><img cl-src=\"{{object.image}}\" type=\"fetch\" dpr=\"auto\" class=\"cld-responsive\" alt=\"Promo Image\"></div></li></div></div></div>");
$templateCache.put("app/localLanding/cards/promoCustomCard.directive.html","<div class=\"carousel-container\"><carousel interval=\"promoCustomCardC.myInterval\"><slide ng-repeat=\"object in promoCustomCardC.promoObject\" active=\"object.active\"><li><a ng-if=\"object.url\" href=\"{{ object.url }}\" target=\"_blank\" data-tag=\"{{ object.analytics_ }}\" analytics-event=\"Clicked Promo Photo\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\"><img cl-src=\"{{object.image}}\" type=\"fetch\" dpr=\"auto\" class=\"cld-responsive\" alt=\"Promo Photo\"></a> <span ng-if=\"!object.url\"><img cl-src=\"{{object.image}}\" type=\"fetch\" dpr=\"auto\" class=\"cld-responsive\" alt=\"Promo Photo\"></span></li></slide></carousel></div>");
$templateCache.put("app/localLanding/cards/reservationCard.directive.html","<div id=\"reservation\"><h5 class=\"reservationTitle\">Book A Car</h5><div class=\"container-fluid\"><form name=\"datepickerForm\" class=\"form-inline\" role=\"form\" method=\"GET\"><div class=\"location-box push-bottom-lg\" style=\"display: block;\" ng-show=\"reservationCardController.locationCallback\"><label class=\"control-label\">Pickup Location:</label><br><div class=\"form-group\"><input type=\"text\" size=\"10\" class=\"form-control\" ng-model=\"reservationCardController.locationSearch\" data-autoclose=\"1\" placeholder=\"Location\" data-typeahead=\"place as place.Name for place in reservationCardController.locationCallbackResults\"></div></div><div class=\"form-group push-bottom-lg\" style=\"display: block;\"><label class=\"control-label\">Pickup Date & Time:</label><br><div class=\"form-group\"><input type=\"text\" size=\"10\" class=\"form-control\" ng-model=\"reservationCardController.fromDate\" data-min-date=\"today\" data-autoclose=\"1\" placeholder=\"Date\" bs-datepicker=\"\"><i class=\"ico ico-calendar\"></i></div><div class=\"form-group\"><input type=\"text\" size=\"8\" class=\"form-control\" ng-model=\"reservationCardController.fromDate\" data-time-format=\"h:mm a\" placeholder=\"Time\" bs-timepicker=\"\"><i class=\"ico ico-clock\"></i></div></div><div class=\"form-group-return\" style=\"display: block;\"><label class=\"control-label\">Return Date & Time:</label><br><div class=\"form-group\"><input type=\"text\" size=\"10\" class=\"form-control\" ng-model=\"reservationCardController.untilDate\" data-min-date=\"{{reservationCardController.fromDate}}\" data-autoclose=\"1\" placeholder=\"Date\" bs-datepicker=\"\"><i class=\"ico ico-calendar\"></i></div><div class=\"form-group\"><input type=\"text\" size=\"8\" class=\"form-control\" ng-model=\"reservationCardController.untilDate\" data-time-format=\"h:mm a\" placeholder=\"Time\" bs-timepicker=\"\"><i class=\"ico ico-clock\"></i></div><button type=\"button\" class=\"submitButton\" ng-click=\"reservationCardController.setGAEventLabel(); reservationCardController.submitRequest()\" data-analytics-event=\"Book Now\" data-analytics-label=\"{{ reservationCardController.location | labelizeLocation }}\" data-analytics-category=\"{{ reservationCardController.location.momentfeed_venue_id == \'N/A\' ? \'Site Map\' : \'Local Landing Page\' }}\" data-analytics-value=\"1\" data-analytics-on=\"click\">Book Now</button></div></form></div></div>");
$templateCache.put("app/localLanding/cards/singleImageCard.directive.html","<div ng-show=\"singleImageCardC.hasData\" title=\"{{singleImageCardC.title}}\" class=\"text-center\"><a ng-if=\"singleImageCardC.findLink\" ng-href=\"{{singleImageCardC.link}}\" rel=\"noopener\" target=\"{{singleImageCardC.singleImageTarget}}\" analytics-event=\"Clicked Single Photo\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" class=\"db text-center\"><img ng-src=\"{{singleImageCardC.src}}\" data-at2x=\"{{singleImageCardC.src}}\" alt=\"{{singleImageCardC.title}}\" width=\"100%\"></a> <img ng-if=\"!singleImageCardC.findLink\" ng-src=\"{{singleImageCardC.src}}\" data-at2x=\"{{singleImageCardC.src}}\" alt=\"{{singleImageCardC.title}}\" width=\"100%\"></div>");
$templateCache.put("app/localLanding/cards/singleImageCardWithButton.directive.html","<div ng-show=\"singleImageCardWithButtonC.hasData\" title=\"{{singleImageCardWithButtonC.title}}\" class=\"text-center\"><a ng-if=\"singleImageCardWithButtonC.findLink\" ng-href=\"{{singleImageCardWithButtonC.link}}\" target=\"_blank\" analytics-event=\"Clicked Single Photo\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" class=\"db text-center\"><img ng-src=\"{{singleImageCardWithButtonC.src}}\" data-at2x=\"{{singleImageCardWithButtonC.src}}\" alt=\"{{singleImageCardWithButtonC.title}}\" width=\"100%\"></a> <a ng-if=\"singleImageCardWithButtonC.findLink && singleImageCardWithButtonC.customButtonText\" ng-href=\"{{singleImageCardWithButtonC.link}}\" target=\"_blank\" analytics-event=\"Clicked Single Photo\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" class=\"text-center btn btn-secondary push-bottom\">{{singleImageCardWithButtonC.customButtonText}}</a> <img ng-if=\"!singleImageCardWithButtonC.findLink\" ng-src=\"{{singleImageCardWithButtonC.src}}\" data-at2x=\"{{singleImageCardWithButtonC.src}}\" alt=\"{{singleImageCardWithButtonC.title}}\" width=\"100%\"></div>");
$templateCache.put("app/localLanding/cards/singleImageCardWithCaption.directive.html","<div ng-show=\"singleImageCardC.hasData\" title=\"{{singleImageCardC.title}}\" class=\"text-center\"><a ng-if=\"singleImageCardC.findLink\" ng-href=\"{{singleImageCardC.link}}\" target=\"_blank\" rel=\"noopener\" analytics-event=\"Clicked Single Photo\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" class=\"db text-center\" aria-describedby=\"image-caption\"><img ng-src=\"{{singleImageCardC.src}}\" data-at2x=\"{{singleImageCardC.src}}\" alt=\"{{singleImageCardC.title}}\" aria-hidden=\"true\" width=\"100%\"></a> <img ng-if=\"!singleImageCardC.findLink\" ng-src=\"{{singleImageCardC.src}}\" data-at2x=\"{{singleImageCardC.src}}\" alt=\"{{singleImageCardC.title}}\" aria-describedby=\"image-caption\" width=\"100%\"><p id=\"image-caption\" class=\"single-image-caption\">{{singleImageCardC.customCaptionText}}</p></div>");
$templateCache.put("app/localLanding/cards/singlePromoCard.directive.html","<div class=\"single-promo-card\"><div class=\"col-md-6 col-xs-12\"><div class=\"promo-image-container\"><img class=\"promo-image\" ng-src=\"{{singlePromoCardC.image_url}}\" alt=\"{{singlePromoCardC.title}}\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"promo-title-container\"><h2 class=\"promo-title\" ng-bind-html=\"singlePromoCardC.title\"></h2></div><div class=\"promo-text-container\"><div class=\"promo-text\" ng-bind-html=\"singlePromoCardC.text\"></div></div><div class=\"promo-btn-container\"><a ng-href=\"{{singlePromoCardC.btn_url}}\" class=\"btn btn-primary promo-btn\" ng-bind-html=\"singlePromoCardC.btn_text\"></a></div></div></div>");
$templateCache.put("app/localLanding/cards/singleRolloverImageCard.directive.html","<div title=\"{{singleRolloverImageCardC.title}}\" class=\"text-center rollover-image-card\"><a ng-if=\"singleRolloverImageCardC.findLink\" ng-href=\"{{singleRolloverImageCardC.link}}\" target=\"_blank\" rel=\"noopener\" analytics-event=\"Clicked Single Photo\" analytics-label=\"{{ singleRolloverImageCardC.location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" class=\"db text-center\"><img ng-src=\"{{singleRolloverImageCardC.src}}\" data-at2x=\"{{singleRolloverImageCardC.src}}\" alt=\"{{singleRolloverImageCardC.title}}\" width=\"100%\"> <img class=\"hover\" ng-src=\"{{singleRolloverImageCardC.hoverSrc}}\" alt=\"{{singleRolloverImageCardC.title}}\" data-at2x=\"{{singleRolloverImageCardC.hoverSrc}}\" width=\"100%\"></a> <img ng-if=\"!singleRolloverImageCardC.findLink\" ng-src=\"{{singleRolloverImageCardC.src}}\" data-at2x=\"{{singleRolloverImageCardC.src}}\" alt=\"{{singleRolloverImageCardC.title}}\" width=\"100%\"> <img class=\"hover\" ng-if=\"!singleRolloverImageCardC.findLink\" ng-src=\"{{singleRolloverImageCardC.hoverSrc}}\" data-at2x=\"{{singleRolloverImageCardC.hoverSrc}}\" alt=\"{{singleRolloverImageCardC.title}}\" width=\"100%\"></div>");
$templateCache.put("app/localLanding/cards/sitemapErrorCard.directive.html","<div class=\"sitemapErrorCard\"><div class=\"\"><h2>We were unable to find any location in this area, they might have moved or closed.</h2><p>Re-directing to the higher level...</p></div></div>");
$templateCache.put("app/localLanding/cards/socialCard.directive.html","<div class=\"mf-social-icons\">{{ socialCardC.provider.master }}<ul class=\"list-unstyled no-margin\"><li ng-repeat=\"provider in socialCardC.providers\" class=\"dib {{provider._type | lowercase}}\"><a ng-if=\"(provider._type != \'Twitter\' && provider._type != \'Instagram\' && provider._type != \'Google\') && provider.url\" itemprop=\"sameAs\" class=\"btn btn-provider {{provider._type | lowercase}}-color\" analytics-event=\"Clicked Social Link {{ provider._type }}\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" aria-label=\"{{provider._type}} Button\" href=\"{{ provider.url }}\" rel=\"noopener\" target=\"_blank\" alt=\"{{location.store_info.name}} on {{provider._type}}\" title=\"{{location.store_info.name}} on {{provider._type}}\"><i class=\"ico ico-{{provider._type | lowercase}}\"></i></a> <a ng-if=\"provider._type == \'Google\' && (provider.url || location.provider_venues[\'google_page_url\'])\" itemprop=\"sameAs\" class=\"btn btn-provider {{provider._type | lowercase}}-color\" analytics-event=\"Clicked Social Link {{ provider._type }}\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" aria-label=\"{{provider._type}} Button\" ng-href=\"{{provider.url || location.provider_venues[\'google_page_url\']}}\" rel=\"noopener\" target=\"_blank\" alt=\"{{location.store_info.name}} on {{provider._type}}\" title=\"{{location.store_info.name}} on {{provider._type}}\"><i class=\"ico\" ng-class=\"{ \'ico ico-{{provider._type | lowercase}}\' : provider.url, \'ico ico-{{provider._type | lowercase}}-plus\' : !provider.url }\"></i></a> <a ng-if=\"provider._type == \'Instagram\'\"></a> <a ng-if=\"provider._type == \'Twitter\'\" itemprop=\"sameAs\" class=\"btn btn-provider {{provider._type | lowercase}}-color\" analytics-event=\"Clicked Social Link {{ provider._type }}\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" aria-label=\"{{provider._type}} Button\" href=\"https://twitter.com/{{ location.twitter_handle }}\" rel=\"noopener\" target=\"_blank\" alt=\"{{location.store_info.name}} on {{provider._type}}\" title=\"{{location.store_info.name}} on {{provider._type}}\"><i class=\"ico ico-{{provider._type | lowercase}}\"></i></a></li><li class=\"dib instagram\"><a ng-if=\"socialCardC.instagramHandle\" itemprop=\"sameAs\" class=\"btn btn-provider instagram-color\" analytics-event=\"Clicked Social Link Instagram\" analytics-label=\"{{ location | labelizeLocation }}\" analytics-category=\"LLP\" analytics-value=\"1\" analytics-on=\"click\" aria-label=\"Instagram Button\" href=\"{{ socialCardC.instagramURL }}\" rel=\"noopener\" target=\"_blank\" alt=\"{{location.store_info.name}} on Instagram\" title=\"{{location.store_info.name}} on Instagram\"><i class=\"ico ico-instagram\"></i></a></li></ul></div>");
$templateCache.put("app/localLanding/cards/storeLocatorAmenitiesCard.directive.html","<div class=\"amenities\" ng-show=\"storeLocatorAmenitiesCardController.amenities.length > 0\"><h5>{{storeLocatorAmenitiesCardController.title}}</h5><ul><li ng-repeat=\"amenity in storeLocatorAmenitiesCardController.amenities\"><img ng-src=\"/assets/images/clients/{{storeLocatorAmenitiesCardController.client}}/{{amenity.name}}.png\" alt=\"{{amenity.tooltip}}\" data-at2x=\"/assets/images/clients/{{storeLocatorAmenitiesCardController.client}}/{{amenity.name}}@2x.png\" ng-mouseover=\"storeLocatorAmenitiesCardController.showTooltip(amenity)\" ng-mouseleave=\"storeLocatorAmenitiesCardController.hideTooltip(amenity)\"><div class=\"amenity-tooltip\" ng-show=\"amenity.showTooltip\">{{amenity.tooltip}}</div></li></ul></div>");
$templateCache.put("app/localLanding/cards/storeLocatorBreadcrumbCard.directive.html","<div class=\"store-locator-breadcrumb\"><a href=\"/\" ng-if=\"text\" title=\"{{text}}\">{{text}}</a> <a href=\"/\" ng-if=\"!text\" title=\"Back\"><span class=\"less-than\">&lt;</span> Back</a></div>");
$templateCache.put("app/localLanding/cards/testimonialCard.directive.html","<section class=\"testimonial-card\" id=\"testimonial\" ng-show=\"testimonialCardCtrl.areTestimonials\"><header ng-if=\"testimonialCardCtrl.title\"><h3>{{testimonialCardCtrl.title}}</h3></header><div class=\"carousel-container\"><carousel interval=\"testimonialCardCtrl.interval\"><slide ng-repeat=\"testimonial in testimonialCardCtrl.testimonials\" active=\"testimonial.active\"><h3 aria-label=\"Testimonial card\" ng-show=\"testimonial.Title\">What our customers are saying</h3><blockquote class=\"testimonial-content\"><p class=\"testimonial\" data-ng-bind-html=\"testimonial.Text\"></p><p class=\"author\" ng-show=\"testimonial.Author\">- {{testimonial.Author}}</p></blockquote></slide></carousel></div></section>");
$templateCache.put("app/localLanding/cards/trumpetWidgetCard.directive.html","<div class=\"trumpet-widget\"><div data-ng-bind-html=\"trumpetWidgetCardCtrl.widgetHtml\"></div></div>");
$templateCache.put("app/localLanding/cards/tweetsCard.directive.html","<div class=\"push-bottom-lg\"><div class=\"border-bottom push-bottom clearfix\"><div class=\"pull-left\"><h3 id=\"twitter-heading\" tabindex=\"0\">Follow us on Twitter</h3></div><div class=\"pull-right mf-social-icons single\"><a class=\"btn btn-provider twitter-color\" href=\"https://twitter.com/{{username}}\" target=\"_blank\" rel=\"noopener\" ng-attr-title=\"{{clientName ? clientName : \'Follow us\'}} on Twitter\" aria-label=\"Twitter Button\"><i class=\"ico ico-twitter\"></i></a></div></div><a class=\"twitter-timeline\" data-link-color=\"{{linkColor}}\" data-height=\"{{height}}\" data-chrome=\"nofooter noheader noborders\" href=\"https://twitter.com/{{username}}\"></a></div>");
$templateCache.put("app/localLanding/cards/videoEmbedCard.directive.html","<div class=\"video-card\"><div class=\"border-bottom push-bottom clearfix\"><div class=\"pull-left\"><h3>{{videoEmbedCardC.customHeaderText}}</h3></div><div class=\"pull-right mf-social-icons single\"><a ng-if=\"videoEmbedCardC.channel\" class=\"btn btn-provider youtube-color\" ng-href=\"{{videoEmbedCardC.channel}}\" title=\"Subscribe to YouTube channel\" target=\"_blank\" rel=\"noopener\"><i class=\"ico ico-youtube\"></i></a></div></div><div class=\"card-bottom clearfix\"><div class=\"push-top\"><iframe elem-ready=\"videoEmbedCardC.onLoad()\" id=\"video_url\" title=\"Video Player\" width=\"100%\" ng-src=\"{{videoEmbedCardC.link}}\" frameborder=\"0\" allowfullscreen=\"\"></iframe></div></div></div>");
$templateCache.put("app/localLanding/cards/weatherCard.directive.html","<div class=\"push-bottom-lg\"><div class=\"card-header border-bottom push-bottom\"><h3>Current Weather</h3><p>{{weatherCardC.location.store_info.locality}}, {{weatherCardC.location.store_info.region}}</p></div><div class=\"row\"><div class=\"col-xs-6 weather-icon text-right\"><i class=\"ico ico-{{weatherCardC.weather.icon}} v-align-middle\"></i></div><div class=\"col-xs-6\"><h1>{{weatherCardC.weather.temperature}}&deg;F</h1><p>Feels like {{weatherCardC.weather.feelsLike}}&deg;F</p></div></div><div class=\"text-center push-top\"><p class=\"text-capitalize\">{{weatherCardC.weather.summary}} with a {{weatherCardC.weather.precipPercent}}% chance of {{weatherCardC.weather.precipType}}</p></div><small class=\"text-right db\"><a href=\"http://forecast.io/\" class=\"gray-text\" target=\"_blank\" rel=\"noopener\">Powered by Forecast</a></small></div>");
$templateCache.put("app/localLanding/cards/yelpCard.directive.html","<div class=\"push-bottom-lg\"><div class=\"border-bottom push-bottom clearfix\"><div class=\"pull-left\"><h3>Find us on Yelp</h3></div><div class=\"pull-right mf-social-icons single\"><a itemprop=\"sameAs\" class=\"btn btn-provider yelp-color\" href=\"{{ yelpCardc.yelpData.url }}\" title=\"{{yelpCardc.title}} on Yelp\" aria-label=\"Yelp Button\"><i class=\"ico ico-yelp\"></i></a></div></div><ul ng-if=\"yelpCardc.yelpData._id\" class=\"list-unstyled\"><li ng-if=\"yelpCardc.yelpData.rating\" class=\"clearfix\" itemprop=\"aggregateRating\" itemscope=\"\" itemtype=\"http://schema.org/AggregateRating\"><div class=\"pull-left\">Rating</div><div class=\"pull-right\"><meta itemprop=\"bestRating\" content=\"10\"><meta itemprop=\"worstRating\" content=\"0\"><span itemprop=\"ratingValue\">{{yelpCardc.yelpData.rating}}/5</span></div></li><li class=\"clearfix\"><div class=\"pull-left\">Checkins</div><div class=\"pull-right\">{{yelpCardc.yelpData.total_checkins}}</div></li><li class=\"clearfix\"><div class=\"pull-left\">Total Reviews</div><div class=\"pull-right\">{{yelpCardc.yelpData.total_reviews}}</div></li></ul></div>");
$templateCache.put("app/storeLocator/directives/map.directive.html","<div class=\"store-locator-map\" window-resize=\"\"><mapbox data-ng-if=\"!mapCtrl.isGoogleMapsEnabled\" data-callback=\"mapCtrl.showMap\"></mapbox><div ng-if=\"isGoogleMapsApiLoaded\"><google-map data-ng-if=\"mapCtrl.isGoogleMapsEnabled\" data-callback=\"mapCtrl.showMap\"></google-map></div><div data-ng-show=\"mapCtrl.locatorStates.showSearchAreaBtn\" class=\"map-overlay\"><button id=\"searchAreaBtn\" type=\"button\" class=\"btn btn-primary\" data-ng-click=\"mapCtrl.searchArea($event)\" aria-hidden=\"true\" alt=\"Search this Area\" title=\"Search this Area\" data-analytics-event=\"Search Area\" data-analytics-label=\"Store Locator\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\">Search this Area</button></div></div>");
$templateCache.put("app/storeLocator/directives/results.directive.html","<div class=\"results\"><div data-ng-show=\"resultsCtrl.locatorStates.isLoading\" class=\"text-center push-top-lg\"><div class=\"mf-loader text-center mf-loading-list push-top\"><i class=\"ico ico-spinner ico-spin\"></i></div><h5 data-ng-if=\"angular.equals({}, resultsCtrl.locatorStates.message)\">{{resultsCtrl.locatorStates.message}}</h5></div><div id=\"js-total\" class=\"results-total\" data-ng-show=\"resultsCtrl.locatorStates.current && !resultsCtrl.locatorStates.isLoading && resultsCtrl.showMessage\" role=\"alert\"><span>{{resultsCtrl.GetMessage()}}</span></div><ul id=\"js-results\" class=\"results-list list-unstyled\" data-ng-show=\"resultsCtrl.locatorStates.locations.length\"><results-li data-ng-repeat=\"location in resultsCtrl.locatorStates.locations\" locator-states=\"resultsCtrl.locatorStates\" location=\"location\" map-obj=\"resultsCtrl.mapObj\"></results-li></ul></div>");
$templateCache.put("app/storeLocator/directives/search.directive.html","<div id=\"js-search\"><div class=\"search-container\" ng-class=\"{\'show-filters\': searchCtrl.showFilters}\"><form name=\"search\"><div id=\"search_box\" class=\"clearfix\"><div class=\"input-group\"><div class=\"input-group-btn v-align-top\"><button id=\"geoLocationBtn\" type=\"button\" class=\"btn btn-primary custom-client\" aria-label=\"Geo Locate Button\" data-ng-show=\"searchCtrl.locatorStates.geoEnabled != null\" data-ng-disabled=\"!searchCtrl.locatorStates.geoEnabled\" data-ng-click=\"searchCtrl.userLatLngSearch($event)\" aria-hidden=\"false\" title=\"Find Locations Near You\" alt=\"Find Locations Near You\" data-analytics-event=\"Get Geo Location\" data-analytics-label=\"Store Locator\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\"><i class=\"ico ico-location-arrow custom-client\" value=\"image\"></i></button></div><input id=\"searchField\" name=\"\" title=\"search\" role=\"combobox\" class=\"form-control v-align-top\" placeholder=\"{{searchCtrl.placeholder}}\" data-typeahead-on-select=\"searchCtrl.autoCompleteSelect(searchCtrl.locatorStates.searchInput)\" data-ng-model=\"searchCtrl.locatorStates.searchInput\" data-typeahead=\"place as place.name for place in searchCtrl.autoCompleteLocations($viewValue)\" autocomplete=\"off\" data-container=\"#js-search\" data-min-length=\"2\" maxlength=\"256\" ng-if=\"!searchCtrl.isGoogleMapsEnabled\"><div ng-if=\"isGoogleMapsApiLoaded\"><google-autocomplete place-changed-callback=\"searchCtrl.googlePlaceChanged\" data-ng-model=\"searchCtrl.locatorStates.searchInput\" ng-if=\"searchCtrl.isGoogleMapsEnabled\"></google-autocomplete></div><div class=\"input-group-btn v-align-top\"><button id=\"searchBtn\" title=\"search button\" ng-attr-type=\"{{searchCtrl.isGoogleMapsEnabled ? \'button\' : \'submit\'}}\" class=\"btn btn-primary pull-right\" aria-label=\"Search\" role=\"button\" data-ng-click=\"searchCtrl.hitSearchBtn()\" aria-hidden=\"false\" data-analytics-event=\"Search\" data-analytics-label=\"Store Locator\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\"><i class=\"ico ico-search\"></i></button></div><div ng-if=\"searchCtrl.hasFilters\" ng-show=\"searchCtrl.showFiltersForActiveTab()\" class=\"input-group-btn filter-btn\"><button id=\"toggleFiltersBtn\" type=\"button\" class=\"btn btn-filter\" data-ng-click=\"searchCtrl.showFilters = !searchCtrl.showFilters\" title=\"Toggle Filters Menu\" alt=\"Toggle Filters Menu\" aria-label=\"filter button\" aria-expanded=\"{{searchCtrl.showFilters}}\" data-analytics-event=\"Toggle Filters Menu\" data-analytics-label=\"Store Locator\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\">Filter <i class=\"ico ico-chevron-down v-align-middle\" data-ng-hide=\"searchCtrl.locatorStates.selectedFilters.length\"></i><i class=\"ico ico-checkbox-marked-circle text-brand v-align-middle\" ng-show=\"searchCtrl.locatorStates.selectedFilters.length\"></i></button></div></div></div><div ng-show=\"searchCtrl.showFilters && searchCtrl.showFiltersForActiveTab()\" class=\"search-filters\"><div data-ng-repeat=\"filterType in searchCtrl.availableFilterTypes\" class=\"filter-type\"><h6>{{filterType}}</h6><ul class=\"list-unstyled\"><li data-ng-repeat=\"filter in searchCtrl.availableFilters | filter: {type: filterType} track by $index\" data-ng-attr-id=\"filterRow{{$index}}\" data-ng-class=\"{active: filter.active}\"><button ng-if=\"searchCtrl.locatorStates.locations[0].entire_location.store_info.account_id !== \'5367f3a1ef070044f1418f27\'\" data-ng-attr-id=\"filterBtn{{$index}}\" type=\"button\" aria-label=\"{{filterType}} button {{filter.label}}\" class=\"btn btn-ul\" data-ng-click=\"searchCtrl.addFilter(filter.label);\" role=\"checkbox\" aria-checked=\"{{filter.active}}\" data-analytics-event=\"Filter Drop Down\" data-analytics-label=\"{{ filter.label }}\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\"><i class=\"ico ico-checkbox-blank-circle-outline\"></i> <i class=\"ico ico-checkbox-marked-circle\"></i> {{filter.label}}</button><button ng-if=\"searchCtrl.locatorStates.locations[0].entire_location.store_info.account_id == \'5367f3a1ef070044f1418f27\'\" onclick=\"filterDropDown(this)\" data-ng-attr-id=\"filterBtn{{$index}}\" type=\"button\" aria-label=\"{{filterType}} button {{filter.label}}\" class=\"btn btn-ul\" data-ng-click=\"searchCtrl.addFilter(filter.label);\" role=\"checkbox\" aria-checked=\"{{filter.active}}\" data-analytics-event=\"Filter Drop Down\" data-analytics-label=\"{{ filter.label }}\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\"><i class=\"ico ico-checkbox-blank-circle-outline\"></i> <i class=\"ico ico-checkbox-marked-circle\"></i> {{filter.label}}</button></li></ul></div></div></form></div></div>");
$templateCache.put("app/storeLocator/directives/tabs.directive.html","<div class=\"tabs\"><div class=\"show-desktop\"><ul class=\"nav nav-tabs\"><li ng-class=\"{active: tab.active}\" ng-repeat=\"tab in tabsCtrl.locatorStates.tabs track by $index\" ng-disabled=\"tabsCtrl.locatorStates.isLoading\"><a data-toggle=\"tab\" ng-click=\"tabsCtrl.loadData(tab)\" href=\"\"><span>{{tab.name}}</span></a></li></ul></div><div class=\"show-mobile clearfix\"><a ng-if=\"tabsCtrl.collapseForMobile\" href=\"\" ng-click=\"tabsCtrl.collapse = !tabsCtrl.collapse\" ng-attr-title=\"{{tabsCtrl.collapse ? \'Show\' : \'Hide\'}}\" class=\"toggle-tabs\"><i class=\"fa fa-filter\" aria-hidden=\"true\"></i> <span ng-show=\"tabsCtrl.collapse\">{{tabsCtrl.collapsedText}}</span></a><ul class=\"nav nav-tabs\" ng-show=\"!tabsCtrl.collapseForMobile || !tabsCtrl.collapse\"><li ng-class=\"{active: tab.active}\" ng-repeat=\"tab in tabsCtrl.locatorStates.tabs track by $index\" ng-disabled=\"tabsCtrl.locatorStates.isLoading\"><input aria-label=\"{{tab.shortName}}\" type=\"radio\" data-ng-value=\"true\" data-ng-model=\"tab.active\" name=\"tabs\" ng-click=\"tabsCtrl.loadData(tab)\"> <a data-toggle=\"tab\" ng-click=\"tabsCtrl.loadData(tab)\" href=\"\"><span>{{tab.shortName}}</span></a></li></ul></div><div class=\"tab-content\"><results data-locator-states=\"tabsCtrl.locatorStates\" data-map-obj=\"tabsCtrl.mapObj\"></results></div></div>");
$templateCache.put("app/storeLocator/templates/mapPopup.template.html","<div class=\"mf-popup-content\" data-ng-attr-id=\"loc_{{mapPopupCtrl.location.number}}\"><h4>{{mapPopupCtrl.location.name}}</h4><div>{{mapPopupCtrl.location.address}}<br><span ng-if=\"mapPopupCtrl.location.address_extended\">{{mapPopupCtrl.location.address_extended}}<br></span> {{mapPopupCtrl.location.locality}}, {{mapPopupCtrl.location.region}} {{mapPopupCtrl.location.postcode}}<br><span class=\"hidden-xs\">{{ mapPopupCtrl.location.phone | telephone}}</span> <a class=\"visible-xs\" analytics-event=\"Call\" analytics-label=\"{{ mapPopupCtrl.location.entire_location | labelizeLocation }}\" analytics-category=\"Store Locator\" analytics-value=\"1\" analytics-on=\"click\" title=\"Call\" ng-href=\"tel:{{ mapPopupCtrl.location.phone }}\">{{ mapPopupCtrl.location.phone | telephone}}</a></div><div class=\"push-top clearfix\"><a data-ng-attr-id=\"localPageMapBtn{{mapPopupCtrl.location.number}}\" data-ng-show=\"mapPopupCtrl.location.local_landing_page\" data-ng-href=\"{{mapPopupCtrl.client_route}}{{mapPopupCtrl.location.link}}\" class=\"btn btn-primary btn-sm push-right-xs\" role=\"button\" alt=\"Go to Local Page\" title=\"Go to Local Page\" data-analytics-event=\"Map Pin Local Page\" data-analytics-label=\"{{ mapPopupCtrl.location.entire_location | labelizeLocation }}\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\" onclick=\"closeNav()\">View Local Page</a> <a data-ng-attr-id=\"callMapBtn{{mapPopupCtrl.location.number}}\" data-ng-href=\"tel:{{mapPopupCtrl.location.phone}}\" class=\"btn btn-primary btn-sm push-right-xs visible-xs-inline-block\" role=\"button\" ng-show=\"mapPopupCtrl.location.phone\" alt=\"Call this Location\" title=\"Call this Location\" data-analytics-event=\"Map Pin Call\" data-analytics-label=\"{{ mapPopupCtrl.location.entire_location | labelizeLocation }}\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\">Call</a> <a data-ng-attr-id=\"getDirectionsMapBtn{{mapPopupCtrl.location.number}}\" data-ng-href=\"{{mapPopupCtrl.location.directionsUrl}}\" class=\"btn btn-primary btn-sm\" rel=\"noopener\" target=\"_blank\" role=\"button\" alt=\"Get Directions to this Location\" title=\"Get Directions to this Location\" data-analytics-event=\"Map Pin Get Directions\" data-analytics-label=\"{{ mapPopupCtrl.location.entire_location | labelizeLocation }}\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\">Get Directions</a></div></div>");
$templateCache.put("app/storeLocator/templates/resultsLi.template.html","<li data-ng-attr-id=\"{{resultsLiCtrl.location.id}}\" data-ng-click=\"resultsLiCtrl.showLocationPopup(resultsLiCtrl.location.number)\" class=\"location-li\"><div class=\"clearfix\"><div class=\"col-xs-2\"><div class=\"pr\"><div class=\"location-pin\"></div><div class=\"location-number\">{{resultsLiCtrl.location.number}}</div><div class=\"location-distance\">{{resultsLiCtrl.location.entire_location.distance | number:1 }} mi.</div></div></div><div class=\"col-xs-10\"><div class=\"h3\">{{resultsLiCtrl.location.name}}</div><p>{{resultsLiCtrl.location.address}}</p><p data-ng-if=\"resultsLiCtrl.location.address_extended\">{{resultsLiCtrl.location.address_extended}}</p><p>{{resultsLiCtrl.location.locality}}, {{resultsLiCtrl.location.region}} {{resultsLiCtrl.location.postcode}}</p><p class=\"hidden-xs\">{{resultsLiCtrl.location.phone}}</p><p class=\"visible-xs\"><a ng-href=\"tel:{{ resultsLiCtrl.location.phone }}\" analytics-event=\"Call\" analytics-label=\"{{ resultsLiCtrl.location.entire_location | labelizeLocation }}\" analytics-category=\"Store Locator\" analytics-value=\"1\" analytics-on=\"click\" title=\"Call\">{{ resultsLiCtrl.location.phone }}</a></p><hours-card data-location=\"resultsLiCtrl.location.entire_location\" data-only-today=\"true\"></hours-card><div class=\"push-top clearfix store-buttons\"><a data-ng-show=\"resultsLiCtrl.location.local_landing_page\" data-ng-attr-id=\"localPageBtn{{resultsLiCtrl.location.number}}\" data-ng-href=\"{{resultsLiCtrl.client_route}}{{resultsLiCtrl.location.link}}\" class=\"btn btn-sm btn-primary\" role=\"button\" alt=\"Go to Local Page\" title=\"Go to Local Page\" data-analytics-event=\"Local Page\" data-analytics-label=\"{{ resultsLiCtrl.location.entire_location | labelizeLocation }}\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\">Local Page</a> <a data-ng-attr-id=\"callBtn{{resultsLiCtrl.location.number}}\" data-ng-href=\"tel:{{ resultsLiCtrl.location.phone }}\" class=\"btn btn-sm btn-primary visible-xs-inline-block\" role=\"button\" ng-show=\"resultsLiCtrl.location.phone\" alt=\"Call this Location\" title=\"Call this Location\" data-analytics-event=\"Call\" data-analytics-label=\"{{ resultsLiCtrl.location.entire_location | labelizeLocation }}\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\">Call</a> <a data-ng-attr-id=\"getDirectionsBtn{{resultsLiCtrl.location.number}}\" data-ng-href=\"{{resultsLiCtrl.location.directionsUrl}}\" rel=\"noopener\" target=\"_blank\" class=\"btn btn-sm btn-primary\" role=\"button\" alt=\"Get Directions to this Location\" title=\"Get Directions to this Location\" data-analytics-event=\"Get Directions\" data-analytics-label=\"{{ resultsLiCtrl.location.entire_location | labelizeLocation }}\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\">Get Directions</a></div></div></div></li>");
$templateCache.put("app/custom/clients/losaltosranchmarket/layout.html","<div ng-controller=\"templateController as controller\" itemscope=\"\" itemtype=\"http://schema.org/GroceryStore\"><header><span class=\"logo\"><a href=\"https://cardenasmarkets.com/\"><img alt=\"Los Altos Ranch\" src=\"https://s3-us-west-1.amazonaws.com/mfeed-store-locator.momentfeed.com/Los%20Altos%20Ranch%20Markets/LosAltos_RanchMarket_Logo_3Colors-01_CardenasMarket.png\"></a></span><div id=\"sideNav\" class=\"sidenav\" ng-if=\"controller.hamNavToggle\"><ul><li><a href=\"javascript:void(0)\" class=\"closebtn\" onclick=\"closeNav()\">&times;</a></li><li ng-repeat=\"hamItem in controller.hamNavData\"><a href=\"{{hamItem.link}}\" target=\"_blank\">{{hamItem.text}}</a><div ng-if=\"hamItem.sub\" class=\"tabbed\" ng-repeat=\"hamSubItem in hamItem.sub\"><a href=\"{{hamSubItem.link}}\" class=\"hamSub\" target=\"_blank\">{{hamSubItem.text}}</a></div></li></ul></div><div id=\"main\" ng-if=\"controller.hamNavToggle\"><span id=\"hamburger\" style=\"font-size:30px;cursor:pointer;\" onclick=\"openNav()\"><div class=\"hamIcon\"></div><div class=\"hamIcon\"></div><div class=\"hamIcon\"></div></span></div></header><div class=\"mf-style\" id=\"customContainer\"><div ui-view=\"\"></div></div><footer class=\"main-footer\"><span class=\"logo\"><a href=\"https://cardenasmarkets.com/\"><img alt=\"Los Altos Ranch\" class=\"footer-logo\" src=\"https://s3-us-west-1.amazonaws.com/mfeed-store-locator.momentfeed.com/Los%20Altos%20Ranch%20Markets/white-cardenas-flower.png\"></a></span></footer></div>");
$templateCache.put("app/custom/clients/losaltosranchmarket/localLanding.html","<div class=\"local-landing\"><div ng-if=\"localLanding.error\" class=\"mf-loading-container\"><error-card location-error=\"localLanding.error\"></error-card></div><div ng-show=\"!localLanding.error\"><div ng-if=\"localLanding.location.store_info\"><div class=\"container\" id=\"sectionTop\"><div class=\"row\"><div class=\"row section-breadcrumb\"><div class=\"col-sm-6 padding-bootstrap\"><address-breadcrumb-card location=\"localLanding.location.store_info\"></address-breadcrumb-card></div></div><div class=\"col-lg-8 col-lg-push-4 col-md-6 col-md-push-6 col-sm-7 col-sm-push-5\"><div class=\"text-right hidden-xs\"><social-card location=\"localLanding.location\"></social-card></div><map-card location=\"localLanding.location\"></map-card><amenities-card class=\"hidden-xs hidden-sm\" display-in-one-line=\"true\" custom-fields=\"localLanding.location.custom_fields\" custom-content=\"availableService\" title=\"Amenities\"></amenities-card></div><div class=\"col-lg-4 col-lg-pull-8 col-md-6 col-md-pull-6 col-sm-5 col-sm-pull-7\"><address-card class=\"customButtons\" location=\"localLanding.location\"></address-card><hours-card location=\"localLanding.location\"></hours-card></div></div></div><div id=\"sectionCTAs\"><div class=\"container\"><div class=\"text-center row custom-buttons\"><div ng-class=\"{1:\'col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left\', 2:\'col-lg-6 col-md-6 col-sm-6 col-xs-12 text-left\', 3:\'col-lg-4 col-md-4 col-sm-4 col-xs-12 text-left\', 4:\'col-lg-3 col-md-3 col-sm-3 col-xs-12 text-left\'}[controller.getCustomButtonCount(localLanding.location.custom_fields)]\"><custom-fields-button custom-fields=\"localLanding.location.custom_fields\" custom-field-name=\"button1\"></custom-fields-button></div><div ng-class=\"{1:\'col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left\', 2:\'col-lg-6 col-md-6 col-sm-6 col-xs-12 text-left\', 3:\'col-lg-4 col-md-4 col-sm-4 col-xs-12 text-left\', 4:\'col-lg-3 col-md-3 col-sm-3 col-xs-12 text-left\'}[controller.getCustomButtonCount(localLanding.location.custom_fields)]\"><custom-fields-button custom-fields=\"localLanding.location.custom_fields\" custom-field-name=\"button2\"></custom-fields-button></div><div ng-class=\"{1:\'col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left\', 2:\'col-lg-6 col-md-6 col-sm-6 col-xs-12 text-left\', 3:\'col-lg-4 col-md-4 col-sm-4 col-xs-12 text-left\', 4:\'col-lg-3 col-md-3 col-sm-3 col-xs-12 text-left\'}[controller.getCustomButtonCount(localLanding.location.custom_fields)]\"><custom-fields-button custom-fields=\"localLanding.location.custom_fields\" custom-field-name=\"button3\"></custom-fields-button></div><div ng-class=\"{1:\'col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left\', 2:\'col-lg-6 col-md-6 col-sm-6 col-xs-12 text-left\', 3:\'col-lg-4 col-md-4 col-sm-4 col-xs-12 text-left\', 4:\'col-lg-3 col-md-3 col-sm-3 col-xs-12 text-left\'}[controller.getCustomButtonCount(localLanding.location.custom_fields)]\"><custom-fields-button custom-fields=\"localLanding.location.custom_fields\" custom-field-name=\"button4\"></custom-fields-button></div></div></div></div><div class=\"hidden-sm hidden-md hidden-lg\"><social-card location=\"localLanding.location\"></social-card></div><div class=\"container\" id=\"sectionPromos\"><div class=\"row\"><div ng-class=\"{1:\'col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left\', 2:\'col-lg-6 col-md-6 col-sm-6 col-xs-12 text-left\', 3:\'col-lg-4 col-md-4 col-sm-4 col-xs-12 text-left\', 4:\'col-lg-3 col-md-3 col-sm-3 col-xs-12 text-left\'}[controller.getCustomImageCount(localLanding.location.custom_fields)]\"><single-image-card location=\"localLanding.location\" single-image-number=\"1\" class=\"push-bottom\"></single-image-card></div><div ng-class=\"{1:\'col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left\', 2:\'col-lg-6 col-md-6 col-sm-6 col-xs-12 text-left\', 3:\'col-lg-4 col-md-4 col-sm-4 col-xs-12 text-left\', 4:\'col-lg-3 col-md-3 col-sm-3 col-xs-12 text-left\'}[controller.getCustomImageCount(localLanding.location.custom_fields)]\"><single-image-card location=\"localLanding.location\" single-image-number=\"2\" class=\"push-bottom\"></single-image-card></div><div ng-class=\"{1:\'col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left\', 2:\'col-lg-6 col-md-6 col-sm-6 col-xs-12 text-left\', 3:\'col-lg-4 col-md-4 col-sm-4 col-xs-12 text-left\', 4:\'col-lg-3 col-md-3 col-sm-3 col-xs-12 text-left\'}[controller.getCustomImageCount(localLanding.location.custom_fields)]\"><single-image-card location=\"localLanding.location\" single-image-number=\"3\" class=\"push-bottom\"></single-image-card></div><div ng-class=\"{1:\'col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left\', 2:\'col-lg-6 col-md-6 col-sm-6 col-xs-12 text-left\', 3:\'col-lg-4 col-md-4 col-sm-4 col-xs-12 text-left\', 4:\'col-lg-3 col-md-3 col-sm-3 col-xs-12 text-left\'}[controller.getCustomImageCount(localLanding.location.custom_fields)]\"><single-image-card location=\"localLanding.location\" single-image-number=\"4\" class=\"push-bottom\"></single-image-card></div></div></div><div class=\"parallaxWrap\"><section><div ng-style=\"controller.hasCustomFieldValue(localLanding.location.custom_fields, \'about_background\') && {\'background-image\': \'url(\' + controller.getCustomFieldValueByName(localLanding.location.custom_fields, \'about_background\') + \')\'}\" class=\"image\" data-type=\"background\" data-speed=\"2\"></div><div class=\"aboutContainer\" data-type=\"content\"><div class=\"container\"><div class=\"col-lg-12\"><p><custom-description-card class=\"description-card\" location=\"localLanding.location\"></custom-description-card></p></div></div></div></section><div class=\"container\" id=\"sectionSocial\"><div class=\"row\"><div class=\"col-lg-4\"><instagram-9-card location=\"localLanding.location\" photos=\"localLanding.photos\" ng-if=\"localLanding.photos.length>0\"></instagram-9-card></div><div class=\"col-lg-4\"><fb-card ng-if=\"localLanding.posts.length\" posts=\"localLanding.posts\" limit=\"1\"></fb-card></div><div class=\"col-lg-4\"><div ng-if=\"localLanding.account.twitter_subscriptions.user.length>0\"><tweets-card username=\"localLanding.account.twitter_subscriptions.user[0]\" link-color=\"#FF0066\" height=\"450\"></tweets-card></div></div></div></div><section class=\"review-section\"><div class=\"container\"><h2 class=\"section-title\">WE WOULD LOVE TO HEAR FROM YOU. CHECK OUT OUR REVIEW SITES BELOW.</h2><div class=\"row inner-container\"><div class=\"foursquare-card white-card col-md-6 hide-mobile\"><foursquare-card location=\"localLanding.location\"></foursquare-card></div><div class=\"white-card yelp-card col-md-6\"><yelp-card location=\"localLanding.location\"></yelp-card></div></div><h4 ng-show=\"{{ controller.hasCustomFieldValue(localLanding.location.custom_fields, \'contact\') }}\" class=\"section-title\">WE DIDN’T MEET YOUR EXPECTATIONS?&nbsp;<br><a href=\"{{ controller.getCustomFieldValueByName(localLanding.location.custom_fields, \'contact_link\') }}\">Contact us</a> so we can make it better.</h4></div></section></div></div></div></div>");
$templateCache.put("app/custom/clients/losaltosranchmarket/templates/resultsLi.template.html","<li data-ng-attr-id=\"{{resultsLiCtrl.location.id}}\" data-ng-click=\"resultsLiCtrl.showLocationPopup(resultsLiCtrl.location.number)\" class=\"location-li\"><div class=\"clearfix\"><div class=\"col-xs-2\"><div class=\"pr\"><div class=\"location-pin\"></div><div class=\"location-number\">{{resultsLiCtrl.location.number}}</div><div class=\"location-distance\">{{resultsLiCtrl.location.entire_location.distance | number:1 }} mi.</div></div></div><div class=\"col-xs-10\"><div class=\"h3\">{{resultsLiCtrl.location.name}}</div><p>{{resultsLiCtrl.location.address}}</p><p data-ng-if=\"resultsLiCtrl.location.address_extended\">{{resultsLiCtrl.location.address_extended}}</p><p>{{resultsLiCtrl.location.locality}}, {{resultsLiCtrl.location.region}} {{resultsLiCtrl.location.postcode}}</p><p class=\"hidden-xs\">{{resultsLiCtrl.location.phone}}</p><p class=\"visible-xs\"><a ng-href=\"tel:{{ resultsLiCtrl.location.phone }}\" analytics-event=\"Call\" analytics-label=\"{{ resultsLiCtrl.location.entire_location | labelizeLocation }}\" analytics-category=\"Store Locator\" analytics-value=\"1\" analytics-on=\"click\" title=\"Call\">{{ resultsLiCtrl.location.phone }}</a></p><hours-card data-location=\"resultsLiCtrl.location.entire_location\" data-only-today=\"true\"></hours-card><div class=\"push-top clearfix store-buttons\"><a data-ng-show=\"resultsLiCtrl.location.local_landing_page\" data-ng-attr-id=\"localPageBtn{{resultsLiCtrl.location.number}}\" data-ng-href=\"{{resultsLiCtrl.location.link}}\" class=\"btn btn-sm btn-primary\" role=\"button\" alt=\"Go to Local Page\" title=\"Go to Local Page\" data-analytics-event=\"Local Page\" data-analytics-label=\"{{ resultsLiCtrl.location.entire_location | labelizeLocation }}\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\">Local Page</a> <a data-ng-attr-id=\"callBtn{{resultsLiCtrl.location.number}}\" data-ng-href=\"tel:{{ resultsLiCtrl.location.phone }}\" class=\"btn btn-sm btn-primary visible-xs-inline-block\" role=\"button\" ng-show=\"resultsLiCtrl.location.phone\" alt=\"Call this Location\" title=\"Call this Location\" data-analytics-event=\"Call\" data-analytics-label=\"{{ resultsLiCtrl.location.entire_location | labelizeLocation }}\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\">Call</a> <a data-ng-attr-id=\"getDirectionsBtn{{resultsLiCtrl.location.number}}\" data-ng-href=\"https://www.google.com/maps/dir/Current+Location/{{ resultsLiCtrl.location.latitude }} ,{{ resultsLiCtrl.location.longitude }}\" target=\"_blank\" class=\"btn btn-sm btn-primary\" role=\"button\" alt=\"Get Directions to this Location\" title=\"Get Directions to this Location\" data-analytics-event=\"Get Directions\" data-analytics-label=\"{{ resultsLiCtrl.location.entire_location | labelizeLocation }}\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\">Get Directions</a> <a data-ng-attr-id=\"customBtn{{resultsLiCtrl.location.number}}\" data-ng-show=\"resultsLiCtrl.getCustomFieldValue(\'weekly_specials_link\')\" data-ng-href=\"{{resultsLiCtrl.getCustomFieldValue(\'weekly_specials_link\')}}\" target=\"_blank\" class=\"btn btn-sm btn-primary\" role=\"button\" alt=\"{{ resultsLiCtrl.getCustomFieldValue(\'weekly_specials_text\') }} for this location\" title=\"{{ resultsLiCtrl.getCustomFieldValue(\'weekly_specials_text\') }} for this location\" data-analytics-event=\"{{ resultsLiCtrl.getCustomFieldValue(\'weekly_specials_text\') }}\" data-analytics-label=\"{{ resultsLiCtrl.location.entire_location | labelizeLocation }}\" data-analytics-category=\"Store Locator\" data-analytics-value=\"1\" data-analytics-on=\"click\">{{ resultsLiCtrl.getCustomFieldValue(\'weekly_specials_text\') }}</a><delivery-modal-card button-class=\"btn btn-sm btn-primary\" location=\"resultsLiCtrl.location.entire_location\"></delivery-modal-card></div></div></div><script type=\"text/javascript\">\n    </script></li>");}]);